import btPayments from './btPayments'
import platformMenuImport from './platformMenuImport'
import marketplace from '../components/Dashboard/Views/Integrations/marketplaceLabels'
import enLocale from 'element-ui/lib/locale/lang/en'
import roLocale from 'element-ui/lib/locale/lang/ro'
import elLocale from 'element-ui/lib/locale/lang/el'
import nlLocale from 'element-ui/lib/locale/lang/nl'
import itLocale from 'element-ui/lib/locale/lang/it'
import deLocale from 'element-ui/lib/locale/lang/de'
// import BalanceReport from '../components/Dashboard/Views/Management/Reports/BalanceReport.vue'

const messages = {
  en: {
    btPayments: btPayments.en,
    zoneAvailability: {
      title: 'Zone availability',
      active: 'Active zone',
      activeHelp: 'An inactive zone is not available for delivery (addresses inside it are treated as outside the delivery area).',
      inactive: 'Inactive',
      activeColumn: 'Active',
      scheduleEnabled: 'Enable hour schedule',
      scheduleEnabledHelp: 'When off, the zone works as before (available whenever the location delivers). When on, the zone is available only in the intervals below.',
      withSchedule: 'Schedule',
      column: 'Availability',
      hoursRequired: 'Set the start and end hour for every interval of the open days.',
      hoursOrder: 'The start hour must be earlier than the end hour.',
      overlap: 'The intervals of a day must not overlap.',
      noOpenDay: 'Select at least one open day for the schedule (or make the zone inactive).',
      zoneLabel: 'Zone'
    },
    marketplace: marketplace.en,
    platformMenuImport: platformMenuImport.en,
    deliveryPreferences: {
      deliveryTypeTitle: 'Delivery preferences',
      zonesTitle: 'Zones',
      slotsTitle: 'Slots',
      preferencesTitle: 'Delivery type',
      name: 'External name (shown in app)',
      numeAdmin: 'Internal name',
      numeAdminPlaceholder: 'e.g. Standard delivery for location X',
      add: 'Add',
      edit: 'Edit',
      clone: 'Clone',
      back: 'Back',
      noData: 'No records yet',
      saved: 'Saved',
      deleteConfirm: 'Are you sure you want to delete this record?',
      // validation
      drawShapeRequired: 'Draw a zone on the map before saving.',
      seatsRequired: 'Fill in all the seats rows (count and price).',
      duplicateZone: 'This zone is already added.',
      zoneRequired: 'Add at least one delivery zone.',
      hoursRequired: 'Set the start and end hours for the active days/rows.',
      hoursOrder: 'The start time must be earlier than the end time.',
      slotRequired: 'Select a slot for the active rows.',
      // slots
      slotAdd: 'Add slot',
      slotSingle: 'slot',
      costPerParte: 'Cost per part (optional urgency fee)',
      costPerParteHelp: 'If set, the customer can pick which part of the slot to be served in (first / last) for this extra fee.',
      seats: 'Seats',
      seatsCount: 'Number of seats (0 = unlimited)',
      seatCost: 'Price',
      addSeatTier: 'Add seats row',
      seatsHelp: 'Seats are taken cheapest first; the later a customer books, the higher the price.',
      // zones
      zoneAdd: 'Add zone',
      zoneSingle: 'zone',
      companyZone: 'Company zone',
      locationZone: 'Location zone',
      legacyReadonly: 'Legacy location zone — read-only. Clone it to use it in the new system.',
      cloneName: 'New zone name',
      showOtherZones: 'Show other zones on the map',
      showOtherZonesPlaceholder: 'Pick zones to display for reference',
      shippingCost: 'Shipping cost',
      minOrderValue: 'Minimum order value',
      extraDeliveryTime: 'Extra delivery time (min)',
      // preferences
      preferenceAdd: 'Add delivery type',
      preferenceSingle: 'preference',
      type: 'Type',
      typeClassic: 'Classic',
      typeSlot: 'Slot',
      typeClassicHelp: 'The customer can pick — based on the options below — an exact date/time, or the variant without date and time.',
      typeSlotHelp: 'Several slots are shown and the customer picks the one that fits.',
      enabled: 'Enabled',
      hourMode: 'Hours & date',
      hourModeHourDate: 'Hour and date',
      hourModeDateOnly: 'Date only',
      hourModeDisabled: 'Disable hour and date',
      hourModeHourDateHelp: 'The customer picks the time and date (date only when offset and period are not 0 and 1).',
      hourModeDateOnlyHelp: 'The customer picks only the date.',
      hourModeDisabledHelp: "The customer picks nothing — delivery follows the restaurant's delivery schedule. In this mode the schedule isn't available either: the customer places the order and is notified when it will arrive.",
      offsetPeriodHelp: 'Offset = number of working (open) days from now until the customer is allowed to order. Period = number of working (open) days after the offset ends during which the customer can order. E.g. offset 1, period 2 → today they can only order for tomorrow and the day after; if today is closed, counting starts from the next open day.',
      availableDays: 'Available days',
      noPreorders: 'Accept orders only during working hours',
      isAlwaysOpen: 'Non-stop working hours',
      minimumOrderValue: 'Minimum order value',
      defaultWaitingTime: 'Minimum interval before closing (prep + delivery time)',
      autoAssignFirstSlot: "Don't let the customer pick the slot, assign the first available one",
      delayHours: 'Delay (hours)',
      delayHoursHelp: 'Customers can only pick slots that start at least this many hours from now.',
      schedule: 'Weekly schedule',
      addScheduleRow: 'Add slot',
      slot: 'Slot',
      selectSlot: 'Select slot',
      startTime: 'Start',
      endTime: 'End',
      active: 'Active',
      closedDates: 'Calendar override of the delivery schedule',
      closedDatesHelp: 'For a specific date you can stop deliveries for the whole day or replace the weekly schedule with a schedule of its own (slots and hours, just like the weekly one), e.g. holidays.',
      closedAllDay: 'Closed all day',
      closedOverrideSchedule: 'Override schedule',
      closedNoDelivery: 'No delivery on this day',
      closedEmpty: 'No calendar overrides added.',
      closedScheduleEmpty: 'No slots added for this day yet.',
      closedScheduleRequired: 'Add at least one slot to every overridden day (or choose "Closed all day").',
      closedCopyWeekly: 'Copy the {day} schedule',
      closedCopyConfirm: 'Replace this day\'s slots with the weekly {day} schedule?',
      closedDateDuplicate: 'The same date is added more than once in the calendar override.',
      addClosedDate: 'Add date',
      zones: 'Delivery zones',
      selectZone: 'Select zone',
      noZone: 'No zone',
      methods: 'Delivery methods',
      // days
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday',
      // method integration
      useMultiplePreferences: 'Use multiple delivery types',
      useMultiplePreferencesHelp: 'When enabled, this method uses the new delivery types below instead of the classic settings.',
      selectPreferences: 'Delivery type'
    },
    general: {
      noAccessRaport: 'Permission for reports is required!',
      noAccessUsers: 'Only administrators have access to users',
      contactAdmin: 'Contact the administrator',
      tips_department_id: 'Department Id',
      addConversion: 'Add Conversion',
      selectUnit: 'Select Unit',
      download: 'Download',
      see: 'Look',
      visualize: 'View',
      search: 'Search',
      home: 'Home',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      remove: 'Remove',
      save: 'Save',
      saveAndSend: 'Save & Send',
      fillRequiredFields: 'Fill required fields',
      update: 'Update',
      cancel: 'Cancel',
      copy: 'Copy',
      close: 'Close',
      details: 'Details',
      cancel2: 'Cancel',
      continue: 'Continue',
      activate: 'Activate',
      deactivate: 'Deactivate',
      active: 'active',
      inactive: 'inactive',
      specialPrice: 'Special Price',
      removePhoto: 'Too many images uploaded',
      download_xls: 'export to xls',
      download_pdf: 'export to pdf',
      detail: 'Detail',
      yes: 'Yes',
      no: 'No',
      success: 'Success',
      required: 'Required',
      back: 'Back',
      next: 'Next',
      finish: 'Finish',
      duplicate: 'Duplicate',
      select: 'Select',
      all: 'All',
      alls: 'All',
      reset: 'Reset',
      export: 'Export',
      loadMore: 'Load More',
      viewDetails: 'View Details',
      showing: 'Showing {length} result(s)',
      action: 'Action',
      enable: 'activate',
      disable: 'deactivate',
      generalLoader: 'Please wait...',
      no_data: 'Not Found',
      product: 'product',
      logout: 'Logout',
      from: 'from ',
      to: 'to ',
      cancelCourier: 'Cancel courier',
      agree: 'Agree',
      agreePopupMessage: 'To allow the browser to play audio you need to click "Agree". This will play a test sound in order to activate sound play.',
      orderLocaionNoDriverLocation: 'Careful! The order location does not correspond to the driver\'s location',
      day: 'day',
      notCompleted: 'not completed',
      saveChanges: 'Save Changes',
      doYouWantToLogout: 'Do you want to logout?',
      minutes: 'minutes',
      hour: 'hour',
      hours: 'hours',
      customSort: 'Company use custom sort',
      deliveryMethod: 'Delivery Methods',
      none: 'None',
      unset: 'Unset',
      included: 'Included',
      error: 'Error',
      logo: 'Logo',
      appImage: 'App image',
      copyToClipboard: 'Copy to Clipboard',
      copyUrlToClipboard: 'Copy URL',
      start: 'Start',
      actions: 'Actions',
      leavePageQuestion: 'Unsaved changes will be lost. Are you sure you want to leave the page?',
      sortOrder: 'Sort',
      sortCreatedAscending: 'Order Placed: Oldest First',
      sortCreatedDescending: 'Order Placed: Newest First',
      sortPickupAscending: 'Expected Delivery: Earliest First',
      sortPickupDescending: 'Expected Delivery: Latest First',
      wallet: 'Load wallet',
      walletAdd: 'Add amount to wallet',
      walletRemove: 'Unload wallet',
      walletAddFor: 'Add the amount for',
      walletRemoveFor: 'Remove the amount for',
      walletPlaceholder: 'Enter the amount:',
      walletSuccess: 'The amount has been added to your wallet!',
      walletRemoved: 'The amount has been removed to your wallet!',
      walletError: 'An error occurred while adding the amount.',
      invalidAmount: 'Please enter a valid number',
      amountExceedsBalance: 'The amount exceeds the current wallet balance',
      changeOrderLocationSuccess: 'The location has been successfully updated!',
      changeOrderLocationFailed: 'Failed to update the location. Please try again.',
      generalAreYouSure: 'Are you sure?',
      set: 'Set',
      regenerateQr: 'Regenerate QR Code',
      noProduct: 'There are no products',
      noProductPos: 'Select an item from the menu to begin.',
      applyPoints: 'Use Loyalty Points',
      loyaltyPoints: 'Loyalty Points:',
      apply: 'Apply',
      load: 'Load',
      reload: 'Reload',
      retry: 'Retry',
      normal: 'Normal',
      big: 'Big',
      registrationDate: 'Registration Date',
      accept: 'Accept',
      deny: 'Deny',
      accepted: 'Accepted',
      denied: 'Denied',
      pending: 'Pending',
      completed: 'Completed',
      contactSuportFeature: 'Contact support for this feature',
      administration: 'Inventory',
      noAdministrationsAvailable: 'No Inventory available',
      setAdministration: 'Press "Add" to set an Inventory',
      loading: 'Please wait',
      justMoment: 'It may take a moment',
      orderId: 'Order ID',
      year: 'Year',
      month: 'Month',
      segment: 'Current Segment',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      confirm: 'Confirm',
      ok: 'OK',
      validate: 'Validate',
      noResults: 'No results.',
      clearSelection: 'Clear selection',
      associateTables: 'Associate tables',
      associateChooseUsers: '1) Choose users',
      associateChooseTables: '2) Choose tables',
      selected: 'Selected',
      emDash: '\u2014',
      idHash: '#{id}',
      breadcrumbSeparator: ' \u00bb ',
      statusUnknown: 'Unknown status',
      modulesActivate: 'Active modules',
      ecosystem: 'TAPTASTY ECOSYSTEM',
      ecosystem_more_than_you_use: 'Taptasty is more than what you are currently using.',
      how_much_you_use: 'How much you use',
      only_this_much_you_use: 'Is this all you use?',
      you_use_full_system: 'You are using the full system',
      all_taptasty_modules: 'All TapTasty modules',
      modules_reservations: 'Reservations',
      modules_tables: 'Tables',
      modules_dispatch: 'Dispatch',
      modules_kds: 'KDS',
      modules_pms: 'PMS',
      modules_catalog: 'Catalog',
      modules_screens: 'Screens',
      modules_pos: 'POS',
      modules_inventory: 'Inventory',
      modules_clients: 'Clients',
      modules_orders: 'Orders',
      modules_add_order: 'Add order',
      modules_marketing: 'Marketing',
      modules_marketing_gift: 'Gift Card',
      modules_kiosk: 'Kiosk',
      modules_website: 'Website',
      modules_app: 'App',
      modules_qr_ordering: 'QR Ordering',
      modules_active: 'Active modules',
      modules_inactive_hint: 'Missed using these?',
      modules_website_title: 'Website Module',
      modules_website_message: 'The Website module is not enabled for this company.',
      modules_website_hint: 'Enable it from company settings.',
      modules_marketing_title: 'Marketing module is disabled',
      modules_marketing_message: 'This module is not included in your current plan or is not enabled for this company.',
      modules_marketing_hint: 'Contact your administrator or upgrade your plan to enable marketing features.',
      modules_gift_card_title: 'Gift Card module is disabled',
      modules_gift_card_message: 'This module is not enabled for your company or is not included in your current plan.',
      modules_gift_card_hint: 'Contact your administrator or enable the Gift Card module to continue.'
    },
    pos: {
      default_interval_raport: 'Select the report range',
      default_intervals_raport0: '00:00 from 23:59',
      default_intervals_raport1: 'from the last Z',
      default_intervals_raport2: '05:00 la 05:00'
    },
    giftCard: {
      errorTotalNumberMax: 'The total number cannot be greater than 10000',
      errorExpirationTimeMax: 'Expiration time cannot be greater than 700',
      addgift: '+ Add Gift Card Base',
      value: 'Value',
      exp: 'Expiration (months)',
      type: 'Type',
      generatedCards: 'Generated Cards',
      active: 'Active',
      online: 'ONLINE',
      offline: 'OFFLINE',
      yes: 'Yes',
      no: 'No',
      modalTitle: 'Add Gift Card Base',
      typeLabel: 'Type',
      selectType: 'Select type',
      valueLabel: 'Value',
      expLabel: 'Expiration Time (months)',
      totalCards: 'Total Cards (Offline)',
      cancel: 'Cancel',
      save: 'Save',
      errorTitle: 'Error!',
      errorRequired: 'Type and Value are required.',
      errorOffline: 'Total cards required for OFFLINE.',
      successTitle: 'Success!',
      successMessage: 'Gift Card Base created.',
      errorCreate: 'Error creating base.',
      ok: 'OK',
      baseTitle: 'Gift Card Base',
      inactive: 'Inactive',
      fromDate: 'From',
      toDate: 'To',
      cardsListTitle: 'Gift Cards List',
      allStatus: 'All Status',
      used: 'Used',
      unused: 'Unused',
      allPayments: 'All Payments',
      payed: 'Payed',
      unpayed: 'Unpayed',
      export: 'Export',
      qr: 'QR',
      status: 'Status',
      payment: 'Payment',
      assignedTo: 'Assigned To',
      created: 'Created',
      copyLink: 'Copy Link',
      notAssigned: 'Not assigned',
      showingRecords: 'Showing {from} to {to} of {total} records',
      confirmDeleteTitle: 'Are you sure?',
      confirmDeleteText: 'All unused cards will be deleted too!',
      yesButton: 'Yes',
      noButton: 'No',
      deleteSuccess: 'Gift card base deleted successfully',
      deleteError: 'Error deleting gift card base',
      linkCopied: 'Link copied to clipboard!',
      updateSuccess: 'Updated successfully',
      updateError: 'Error updating',
      notAvailable: 'N/A',
      user: 'User'
    },
    txtForColors: {
      sideBarBg: {
        title: 'Sidebar Background',
        msg: 'Change the background color of the sidebar'
      },
      mainPageBg: {
        title: 'Menu Content Background',
        msg: 'Change the background color of the menu content'
      },
      addBtnColor: {
        title: 'Main Buttons Background',
        msg: 'Change the background color of the main buttons'
      },
      addBtnColorInv: {
        title: 'Main Buttons Text Background',
        msg: 'Change the text background of the main buttons'
      },
      iconsColor1: {
        title: 'Icons/Buttons Background Color',
        msg: 'Change the background color of all icons and buttons'
      },
      iconsColor2: {
        title: 'Text Background',
        msg: 'Change the background color of some texts'
      },
      secundarColor: {
        title: 'Start Page',
        msg: 'Change the background color when the kiosk is idle'
      },
      principalColor: {
        title: 'Primary Color',
        msg: 'Primary color for background and tools'
      }
    },
    stock: {
      saving: 'Se salvează...',
      saveStocks: 'Salvează Stockuri',
      title: 'Configurare Stock',
      subtitle: 'Setează stockul pentru fiecare produs per locație',
      searchByName: 'Caută după nume',
      productNamePlaceholder: 'Nume produs...',
      searchById: 'Caută după ID',
      productIdPlaceholder: 'ID produs...',
      allCategories: 'Toate categoriile',
      resetFilters: 'Reset filters',
      loadingProducts: 'Se încarcă produsele...',
      product: 'Produs',
      idLabel: 'ID: {id}',
      currency: 'RON',
      notAvailable: 'Nu e disponibil',
      active: 'Activ',
      stock: 'Stock',
      stockPlaceholder: '0',
      reservation: 'Rezervare (buc)',
      reservationPlaceholder: '0',
      reservationError: 'Rezervarea nu poate depăși stockul',
      allowNegative: 'Permite Negativ',
      activateForSources: 'Activează pentru sursele:',
      pos: 'POS',
      app: 'App',
      website: 'Website',
      qr: 'QR',
      kiosk: 'Kiosk',
      page: 'Pagina {page} din {totalPages}',
      productsCount: '({totalRecords} produse)',
      previous: 'Anterior',
      next: 'Următor',
      noProductsAvailable: 'Nu există produse disponibile',
      stocksSavedSuccess: 'Stocurile au fost salvate cu succes!'
    },
    pricesFor: {
      1: 'Price Website',
      2: 'Price QR',
      3: 'Price Kiosk',
      4: 'Price POS',
      5: 'Price GLOVO',
      6: 'Price BOLT',
      7: 'Price Wolt'
    },
    dispath: {
      reset_map: 'Reset Map',
      dispatch: 'Dispatch',
      drivers: 'Drivers',
      driverID: 'Driver ID',
      driverName: 'Driver Name',
      value: 'Value',
      from: 'From',
      orders: 'Orders',
      reports: 'Reports',
      totalActive: 'Total active',
      totalInactive: 'Total inactive',
      walletReport: 'Wallet',
      programReport: 'Timesheet',
      activityReport: 'Active time',
      mapReport: 'Map',
      selectDriver: 'Select drivers',
      addGroupOrder: 'Order batch',
      unassigned: 'Unassigned',
      batched: 'Batched',
      grouped: 'Grouped',
      posibleGrouped: 'Posibile grouped',
      sugestion: 'Sugestion',
      createOrderGroupSuccess: 'The order group has been created successfully.',
      createOrderGroupError: 'Failed to create order group',
      addOrderGroupPosibileSuccess: 'The order has been added to the group.',
      addOrderGroupPosibileError: 'Failed to add the order to the group.',
      assign: 'Assigned',
      legend: 'Legend',
      driverWithOrder: 'Driver with order',
      driverWithoutOrder: 'Driver without order',
      movementDirection: 'Movement direction',
      stopWithDelivery: 'Stop with order',
      stopWithoutDelivery: 'Stop without order',
      general: 'General',
      users: 'Users',
      dispatchers: 'Dispatchers',
      walletSettings: 'Cash payment wallet / Payment on order',
      disableUndeliveredOrder: 'Disable undelivered order',
      downloadApp: 'Download the delivery app',
      settings: 'Settings',
      addNewOrder: 'Add new order',
      zone: 'Areas'
    },
    kds: {
      importTitle: 'Set selected section to all products from selected category',
      section: 'Section',
      status: 'Status',
      location: 'Location',
      name: 'Name',
      deliveryMethods: 'Delivery Methods',
      noData: 'Click +Add for a custom status',
      areYouSureDelete: 'Are you sure you want to delete this KDS?',
      kitchenDisplayScreen: 'Kitchen Display Screen',
      kds: 'KDS',
      kdsSections: 'Sections',
      settings: 'Settings',
      general: 'General',
      useStartTimerForAllItems: 'Use start timer for all items',
      startTimer: 'Start timer',
      orderAveragePrepTime: 'Order average prep time',
      users: 'Users',
      sections: 'Sections',
      ods: 'ODS',
      report: 'Report',
      orderDisplayScreen: 'Order Display Screen',
      kdsCode: 'Kds Code',
      loginCode: 'Login Code (unique 4 digits code)',
      loginCodeNotUnique: 'Login Code is not unique',
      useOrderLanes: 'Display orders on 2 columns (Eat In / Delivery)',
      lane_1_color: 'Background color for Eat In orders',
      lane_2_color: 'Background color for Delivery orders',
      allowOptionTimer: 'Allow start timer for options',
      allowOptionTimerInfo: 'You need to set sections on options',
      allowCourseTimer: 'Allow start timer per course',
      timeProcessingStatus: 'Time order spent in processing',
      displayStartedOrdersFirst: 'Display started orders first',
      groupProductsByCategory: 'Group products by category',
      hidePreparedItems: 'Hide prepared items',
      displayWaiterName: 'Display waiter name',
      displayDeliveryTime: 'Display delivery time',
      useAutoCloseOrders: 'Section KDS can close order when last item is prepared',
      useAutoCloseOrdersInfo: 'When this setting is off, the central KDS has to close the order',
      autoPrint: 'Auto print',
      displayOrdersGrid: 'Display orders as grid',
      displayOrdersMode: 'Display orders mode',
      displayOrdersModeVertical: 'Vertical',
      displayOrdersModeCompactColumns: 'Compact columns',
      displayOrdersModeHorizontal: 'Horizontal',
      ordersSortColumn: 'Sort orders by',
      ordersSortColumnPickup: 'Order pickup time',
      ordersSortColumnCreated: 'Order placement time',
      productSorting: 'Product sorting',
      productSortingChronologic: 'Chronologic',
      productSortingPrepTime: 'Prep time',
      notificationSound: 'Notification sound',
      sound1: 'Sound 1',
      sound2: 'Sound 2',
      sound3: 'Sound 3',
      playSound: 'Play'
    },
    printer: {
      title: 'Printer',
      subtitle: 'Configure printer settings',
      deleteConfirm: 'Are you sure you want to delete this printer?',
      sectionGeneral: 'General information',
      sectionType: 'Type settings',
      sectionConnectivity: 'Connectivity',
      sectionVersion: 'Version and connection type',
      sectionOptions: 'Options and integrations',
      location: 'Location',
      section: 'Section',
      printerReceipt: 'Printer for receipts',
      printOptions: 'Print product\'s options',
      printProductClientComments: 'Print clients\' comments on products',
      printHotelFields: 'Print hotel fields',
      mergeItems: 'Merge products',
      groupItemsByCategoryOnReceipt: 'Group items by category on receipt',
      correspondingPos: 'Corresponding POS',
      fontSize: 'Font size',
      paymentMethodsPrintTwice: 'Print the receipt twice for following payment methods',
      none: 'None',
      printAddress: 'Print address',
      hideSingleOptionQty: 'Hide option quantity of 1',
      displayPricesAndTotals: 'Display prices and totals',
      orderLabelPrintMode: 'Order label printing',
      orderLabelGrouped: 'Print as before (7 lines on the first label, then 13 per label)',
      orderLabelPerProduct: 'Print each product on its own label',
      orderLabelPerProductHint: 'To print a product, enable order label printing in its Product catalog > Label settings.',
      isLan: 'LAN connection',
      printerIpHost: 'Printer IP/Host',
      printerPortName: 'Printer port'
    },
    invoice: {
      number: 'Number',
      vatPercent: 'VAT %',
      storno: 'Storno',
      proforma: 'Proforma',
      addProforma: 'Add Proforma',
      invoiced: 'Invoiced',
      addSeries: 'Add series',
      type: 'Type',
      invoices: 'Invoices',
      invoiceSupplier: 'Invoices supplier',
      reports: 'Reports',
      settings: 'Settings',
      addInvoice: 'Add Invoice',
      invoice: 'Invoice',
      client: 'Client',
      clientName: 'Client Name',
      clientCUI: 'CUI',
      clientEmail: 'Email',
      clientPhone: 'Phone',
      clientAddress: 'Address',
      clientCountry: 'Country',
      clientCounty: 'County',
      selectCounty: 'Select county',
      clientCity: 'City',
      clientSector: 'Sector',
      selectSector: 'Select sector',
      clientStreet: 'Street',
      clientStreetNumber: 'No.',
      clientPostalCode: 'Postal code',
      issueDate: 'Issue Date',
      dueDate: 'Due Date',
      seriesNumber: 'Series and Number',
      seriesDocument: 'Series and Document',
      series: 'Series',
      currency: 'Currency',
      language: 'Language',
      valueNoVAT: 'Excl. VAT',
      vatValue: 'VAT Value',
      lineExtensionAmount: 'Line Extension Amount',
      totalValue: 'Total',
      status: 'Status',
      spvStatus: 'SPV Status',
      spvStatusNotSent: 'Not sent',
      spvStatusSent: 'Sent',
      spvStatusError: 'Error',
      spvStatusPending: 'Processing',
      spvUploadIndex: 'Upload ID',
      invoiceDetails: 'Invoice Details',
      supplierDetails: 'Supplier Details',
      clientDetails: 'Client Details',
      proformaDetails: 'Proforma Details',
      otherDetails: 'Other Details',
      productName: 'Product/Service Name',
      unitMeasure: 'UM',
      quantity: 'Quantity',
      priceRON: 'Price (RON)',
      vatRate: 'VAT Rate',
      includeVAT: 'Does the price include VAT?',
      yes: 'Yes',
      no: 'No',
      download: 'Download PDF',
      filter: 'Filter',
      startNumber: 'Start Number',
      endNumber: 'End Number',
      selectSeries: 'Select Series',
      vatPayer: 'VAT Payer',
      legalStatus: 'Legal Status',
      statusLegal: {
        fizica: 'Individual',
        juridicaRo: 'Romanian Legal Entity',
        juridicaEu: 'European Legal Entity'
      }
    },
    gestiune: {
      autoActive: 'Auto Asign',
      changeProduct: 'Change product management',
      searchProduct: 'Search for product...',
      productManagement: 'Product management links',
      prodLoading: 'Loading product...',
      noGestion: 'There is no connection',
      change: 'Schimbă',
      removeLink: 'Delete Link (no sales will be made if this product appears)',
      city: 'City',
      countries: 'Countries',
      addInvoiceSupplier: 'Add Invoice Supplier',
      sendToSPV: 'Send to SPV',
      checkSpvStatus: 'Check SPV status',
      downloadEfacturaXml: 'Download SPV XML',
      viewSpvPdf: 'View SPV PDF',
      taxRate: 'Tax Rate (%)',
      customer: 'Customer',
      fetchInvoice: 'Fetch Invoices E-Factura',
      fetchSpvMessages: 'Fetch SPV messages',
      downloadSpvMessage: 'Download',
      viewSpvMessage: 'View SPV message',
      fetchInvoiceDaysLabel: 'For how many days?',
      fetchInvoiceDaysInvalid: 'Select a valid number of days.',
      identificationCode: 'Identification Code',
      purchase: 'Purchase',
      productMix: 'Product Mix',
      codContabil: 'Code Contabil',
      salesMarkup: 'Sales Markup',
      analitic: 'Analitic',
      casare: 'Wasted',
      category: 'Category',
      categoriesSettings: 'Categories / Accounts',
      addCasare: 'Add wasted',
      downloadExcel: 'Download XLS',
      activeProducts: 'Activate product',
      lineTotal: 'Line Total',
      seePDF: 'See PDF',
      exportDocument: 'Export Document SPV',
      number: 'Number',
      validity: 'Validity',
      stocLaZi: 'Current Stock',
      reportStock: 'Warehouse sheet',
      reportInventory: 'Inventory inputs–outputs',
      copyProduct: 'Copy Product',
      addProductInCasare: 'Add product(s) in wasted',
      addProductInInvoice: 'Add product(s) in invoice',
      addProductInProforma: 'Add product(s) in proforma',
      addProductInAviz: 'Add product(s) in aviz',
      addProductInNir: 'Add product(s) in reception note',
      addProductInBonConsum: 'Add product(s) in consumption receipt',
      addProductInBonTransfer: 'Add product(s) in transfer note',
      addProductInBonProductie: 'Add product(s) in production note',
      addProductInOrder: 'Add product(s) in order',
      addBonProduction: 'Adaugă bon de producție',
      addInitialStock: 'Adaugă stoc inițial',
      initialStock: 'Initial Stock',
      operations: 'General Operations',
      orderErrors: 'Order sending errors',
      integrations: 'Integrations',
      integrationsIntegration: 'Integration',
      integrationsLocation: 'Location',
      integrationsConfig: 'Config (read-only)',
      integrationsData: 'Integration fields',
      integrationsJsonHint: 'Tip: you can paste JSON here (array/object).',
      integrationsUpdateById: 'Update by row id (POST /integrations/upsert)',
      integrationsPutById: 'Update by row id (PUT /integrations/{id})',
      integrationsNoteTitle: 'How it works',
      integrationsNoteBody: 'Select an integration, optionally a location, then Search. Results appear as a table; open a row to edit. Save creates or updates the integration row.',
      integrationsAllLocations: 'All locations',
      integrationsOptional: 'optional',
      integrationsOpenRow: 'Open',
      integrationsBackToList: 'Back to list',
      integrationsSelectRowHint: 'Choose a row to edit the integration, or add a new one.',
      integrationsSelectIntegrationHint: 'Choose an integration (or All) and optionally a location, then Search.',
      integrationsEmptyTableHint: 'No data available. Use the Add button above to create a new integration.',
      integrationsDeleteConfirm: 'Are you sure you want to delete this integration?',
      integrationsDeleteSuccess: 'Integration deleted successfully.',
      integrationsDeleteError: 'Could not delete the integration. Please try again.',
      integrationsLocationOccupied: 'integration exists',
      integrationsCreateSuccess: 'Integration created successfully.',
      integrationsUpdateSuccess: 'Integration updated successfully.',
      integrationsSaveError: 'Could not save the integration. Please try again.',
      integrationsMenuActivateConfirm: 'This will save the integration, validate and push the menu, then activate the location. Continue?',
      integrationsMenuActivateStepValidateMenu: 'Validating menu',
      integrationsMenuActivateStepDeactivateLocation: 'Deactivating location',
      integrationsMenuActivateStepPushMenu: 'Pushing menu',
      integrationsMenuActivateStepCheckExportStatus: 'Waiting for menu export to complete',
      integrationsMenuActivateStepActivateLocation: 'Activating location',
      integrationsActivateConfirm: 'Are you sure the credentials, location address and coordinates are correct?',
      integrationsActivateProgressStay: 'Please stay on this screen until activation is complete.',
      integrationsActivateStepSave: 'Saving the new integration',
      integrationsActivateStepTest: 'Testing credentials',
      integrationsActivateStepWebhook: 'Registering webhook',
      integrationsActivateTitle: 'Activation',
      integrationsValidateConfirm: 'Are you sure the credentials, location address and coordinates are correct?',
      integrationsValidateProgressStay: 'Please stay on this screen until validation is complete.',
      integrationsValidateStepSave: 'Updating integration',
      integrationsValidateStepTest: 'Testing credentials',
      integrationsValidateStepWebhook: 'Registering webhook',
      integrationsValidateTitle: 'Validation',
      integrationsWebhookStatusLabel: 'Webhook',
      integrationsWebhookRegistered: 'Registered',
      integrationsWebhookNotRegistered: 'Not registered',
      integrationsWebhookRegisterHint: 'Click Validate to register the webhook.',
      integrationsWebhookRegisterError: 'Could not register the webhook. Please try again.',
      integrationsCredentialsTestError: 'Credentials test failed.',
      integrationsCredentialsTestRetryHint: 'After addressing the issues, you can test again using the Validate button.',
      integrationsCredentialErrorCodes: {
        glovo_laas_missing_api_url: 'Glovo API URL is not set.',
        glovo_laas_missing_client_id: 'Client ID is missing.',
        glovo_laas_missing_client_secret: 'Client secret is missing.',
        glovo_laas_missing_location_id: 'No location is linked.',
        wolt_drive_missing_api_url: 'Wolt Drive API URL is not set.',
        wolt_drive_missing_client_id: 'Client ID is missing.',
        wolt_drive_missing_client_secret: 'Client secret is missing.',
        wolt_drive_missing_access_token: 'Access token is missing.',
        wolt_drive_missing_merchant_id: 'Merchant ID is missing.',
        wolt_drive_missing_venue_id: 'Venue ID is missing.',
        wolt_drive_missing_location_id: 'No location is linked.',
        delivery_hero_missing_api_url: 'Delivery Hero API URL is not set.',
        delivery_hero_missing_client_id: 'Client ID is missing.',
        delivery_hero_missing_key_id: 'Key ID is missing.',
        delivery_hero_missing_scope: 'Scope is missing.',
        delivery_hero_missing_private_key: 'Private key is missing. Save the integration to generate keys.',
        delivery_hero_missing_location_id: 'No location is linked.',
        laas_location_not_found: 'The selected location ID is invalid.',
        laas_location_missing_address: 'The location is missing city, street, or street number.',
        laas_location_missing_coordinates: 'The location is missing latitude or longitude.',
        laas_location_missing_phone: 'The location is missing a phone number.',
        laas_no_user_email: 'No company user with an email address was found.',
        laas_invalid_credentials: 'Invalid credentials (401 / invalid token from partner).',
        laas_call_courier_failed: 'Test courier scheduling failed.',
        laas_cancel_courier_failed: 'Test courier cancellation failed.',
        laas_no_partner_response: 'No response was received from the partner API.',
        wolt_drive_reference_not_found: 'Wolt reference is missing after create.'
      },
      integrationsGlovoLaasSetupTitle: 'Complete these steps before creating the integration:',
      integrationsGlovoLaasSetupStep1: 'Get client ID and client secret from',
      integrationsGlovoLaasSetupStep2: 'Create a brand at',
      integrationsDeliveryHeroSetupTitle: 'Complete these steps to onboard Delivery Hero ODR:',
      integrationsDeliveryHeroSetupStep1: 'Select a location and API URL, then Save — we generate a PKCS#8 RSA key pair on the server.',
      integrationsDeliveryHeroSetupStep2: 'Download the .pub public key and send it to Delivery Hero to receive a Key ID.',
      integrationsDeliveryHeroSetupStep3: 'Enter the Client ID, Key ID, and Scope provided by Delivery Hero.',
      integrationsDeliveryHeroSetupStep4: 'Click Validate to test credentials, then register the callback URLs with Delivery Hero ops.',
      integrationsDeliveryHeroKeysTitle: 'RSA keys',
      integrationsDeliveryHeroKeysPending: 'Save the integration to generate the public/private key pair.',
      integrationsDeliveryHeroCopyPublicKey: 'Copy public key',
      integrationsDeliveryHeroDownloadPublicKey: 'Download .pub',
      integrationsDeliveryHeroRegenerateKeys: 'Regenerate keys',
      integrationsDeliveryHeroRegenerateKeysConfirm: 'Regenerating keys invalidates the previous public key. You must send the new .pub file to Delivery Hero again. Continue?',
      integrationsDeliveryHeroRegenerateKeysSuccess: 'New RSA key pair generated.',
      integrationsDeliveryHeroCredentialsTitle: 'Credentials from Delivery Hero',
      integrationsDeliveryHeroCredentialsHint: 'Fill these in after Delivery Hero returns your Key ID for the public key you shared.',
      integrationsDeliveryHeroScopePlaceholder: 'e.g. pandago.api.ro.*',
      integrationsDeliveryHeroPublicKeyHint: 'Share this public key (.pub) with Delivery Hero so they can issue a Key ID. Private key stays on the server (PKCS#8, 2048-bit).',
      integrationsDeliveryHeroCallbacksTitle: 'Callback URLs (register with Delivery Hero)',
      integrationsDeliveryHeroStatusCallback: 'Status callback URL',
      integrationsDeliveryHeroRefundCallback: 'Refund callback URL',
      integrationsDeliveryHeroCallbacksHint: 'These URLs are fixed for your company. Provide them to Delivery Hero ops when onboarding.',
      integrationsActionsTitle: 'Actions',
      integrationsSyncMenu: 'Sync menu',
      integrationsMenuUploadCampaignsHint: 'Uploading the menu will remove campaigns from the platform.',
      integrationsGlovoMenuSyncDailyLimitHint: 'The Glovo platform does not allow more than 5 menu synchronizations per day.',
      integrationsActionError: 'Action failed. Please try again.',
      integrationsPlatformErrors: {
        unauthorized: 'The platform rejected the request because the credentials are invalid or expired.',
        unauthorized_bolt: 'Bolt rejected the request (401). Check {secretKey}, {integratorId}, and {providerId} in the integration settings.',
        unauthorized_glovo: 'Glovo rejected the request (401). Check {apiKey} and {storeId} in the integration settings.',
        unauthorized_wolt: 'Wolt rejected the request (401). Check {apiKey}, {clientId}, and {venueId}, then try again.',
        forbidden: 'The platform refused this action. Your account may not have permission for this location.',
        forbidden_bolt: 'Bolt refused this action. Verify that the {providerId} matches the store configured in Bolt.',
        forbidden_glovo: 'Glovo refused this action. Verify {storeId} and that the store is linked to your account.',
        forbidden_wolt: 'Wolt refused this action. Verify {venueId} and that the venue is linked to your account.',
        not_found: 'The platform could not find the store or venue. Check the integration identifiers.',
        not_found_bolt: 'Bolt could not find this provider. Check {providerId} and {apiUrl}.',
        not_found_glovo: 'Glovo could not find this store. Check {storeId} and {apiUrl}.',
        not_found_wolt: 'Wolt could not find this venue. Check {venueId} and {apiUrl}.',
        rate_limited: 'The platform is rate-limiting requests. Please wait a few minutes and try again.',
        network: 'Could not reach the platform. Check your network connection and try again.',
        unavailable: 'The platform is temporarily unavailable. Please try again later.',
        toggleLocation_failed: 'Could not update whether the location accepts orders on the platform.',
        pushMenu_failed: 'Could not publish the menu to the platform.',
        syncSchedule_failed: 'Could not sync the opening schedule with the platform.',
        generic_failed: 'The platform action failed. Please try again.'
      },
      integrationsMenuTopCategoriesPlaceholder: 'All top categories',
      integrationsMenuTopCategoriesHint: 'Leave empty to export the full menu.',
      integrationsMenuTopCategoriesExportNote: 'Filtering applies on the next menu export.',
      integrationsGlovoValidateMenu: 'Validate menu',
      integrationsGlovoPushMenu: 'Push menu',
      integrationsValidateAndPushMenu: 'Validate and push menu',
      integrationsMenuPreviewOpen: 'Open menu',
      integrationsMenuPreviewLoading: 'Loading menu…',
      integrationsMenuPreviewOrder: 'Order',
      integrationsMenuPreviewAdd: 'Add',
      integrationsMenuPreviewAddFor: 'Add {qty} for {price}',
      integrationsMenuPreviewRequiredShort: 'Required',
      integrationsMenuPreviewChooseOne: 'Choose 1 item',
      integrationsMenuPreviewTitle: '{platform} menu preview',
      integrationsMenuPreviewSubtitle: 'Browse categories, products, and options as they will appear on the platform.',
      integrationsMenuPreviewImport: 'Import',
      integrationsMenuPreviewImporting: 'Importing…',
      integrationsMenuPreviewSearchPlaceholder: 'Search products, options, ids…',
      integrationsMenuPreviewSearchEmpty: 'No products match your search.',
      integrationsMenuPreviewSearchClear: 'Clear',
      integrationsMenuPreviewImportConfirmTitle: 'Import menu?',
      integrationsMenuPreviewImportConfirmText: 'This will validate and push the menu to the platform.',
      integrationsMenuPreviewBack: 'Back to menu',
      integrationsMenuPreviewOutOfStock: 'Out of stock',
      integrationsMenuPreviewOptionRequired: 'Required',
      integrationsMenuPreviewOptionOptional: 'Optional',
      integrationsMenuPreviewOptionRange: 'Choose {min}–{max}',
      integrationsGlovoCheckStatus: 'Check export status',
      integrationsGlovoExportsToday: 'Exports today',
      integrationsGlovoLastExport: 'Last export',
      integrationsGlovoExportStatus: 'Status',
      integrationsGlovoNoExport: 'No export yet',
      integrationsGlovoExportPending: 'Pending — check status',
      integrationsGlovoExportInProgress: 'In progress',
      integrationsGlovoExportSuccess: 'Successful',
      integrationsGlovoExportFailed: 'Failed',
      integrationsGlovoValidationResult: 'Validation result',
      integrationsGlovoStatusResult: 'Export status',
      integrationsGlovoValidateSuccess: 'Menu validation completed.',
      integrationsGlovoValidateSuccessTitle: 'Menu validation',
      integrationsGlovoValidationFailedTitle: 'Menu validation failed',
      integrationsGlovoShowMore: 'Show more',
      integrationsGlovoShowLess: 'Show less',
      integrationsGlovoValidationErrors: 'Errors',
      integrationsGlovoValidationWarnings: 'Warnings',
      integrationsMenuValidationExpandHint: 'Open the details below to see the affected categories, products, and options.',
      integrationsMenuValidationEditEntity: 'Edit',
      integrationsMenuValidationEditEntityHint: 'Opens in a new tab',
      integrationsMenuValidationTryAgain: 'Try again',
      integrationsMenuValidationProceedAnyway: 'Proceed anyway',
      integrationsMenuValidationProceedAnywayHint: 'Validation reported issues. If these are false positives, you can proceed with the menu export.',
      integrationsMenuValidationProceedingAnyway: 'Proceeding despite validation issues.',
      integrationsMenuValidationEditPageHint: 'After saving, close this tab and try again.',
      integrationsMenuValidationErrorCodes: {
        CATEGORY_EMPTY: 'Categories with no exportable products',
        PRODUCT_INVALID_PRICE: 'Products with a price of zero or less',
        OPTION_MISSING_VALUES: 'Options with missing values',
        OPTION_INVALID_MIN: 'Options with an invalid minimum selection',
        MENU_EMPTY: 'Menu is empty',
        MENU_NO_MATCHING_CATEGORIES: 'No categories match the selected menu filter'
      },
      integrationsMenuValidationItemCategory: 'Category',
      integrationsMenuValidationItemProduct: 'Product',
      integrationsMenuValidationItemOption: 'Option',
      integrationsMenuValidationCategoriesEmpty: 'Categories with no exportable products',
      integrationsMenuValidationProductsInvalidPrice: 'Products with invalid price',
      integrationsMenuValidationOptionsMissingValues: 'Options with missing values',
      integrationsMenuValidationOptionsInvalidMin: 'Options with invalid minimum',
      integrationsGlovoCheckStatusDisabledHint: 'Push a menu first, or open an integration that already has an export.',
      integrationsGlovoStatusUpdated: 'Export status updated.',
      integrationsGlovoPushAccepted: 'Menu push accepted by Glovo.',
      integrationsGlovoMenuEmpty: 'No products to export.',
      integrationsGlovoActivateTitle: 'Activation',
      integrationsGlovoActivateConfirm: 'This will save the integration, validate and push the menu to Glovo, then activate the location. Continue?',
      integrationsGlovoActivateProgressStay: 'Please stay on this screen until activation is complete.',
      integrationsGlovoActivateStepSave: 'Saving the new integration',
      integrationsGlovoActivateStepValidateMenu: 'Validating menu',
      integrationsGlovoActivateStepDeactivateLocation: 'Deactivating Glovo location',
      integrationsGlovoActivateStepPushMenu: 'Pushing menu to Glovo',
      integrationsGlovoActivateStepCheckExportStatus: 'Waiting for menu export to complete',
      integrationsGlovoActivateStepActivateLocation: 'Activating Glovo location',
      integrationsGlovoActivateExportTimeout: 'Menu export is still in progress after several minutes.',
      integrationsGlovoActivateExportFailedHint: 'Review the export errors above, fix the menu, then use Push menu and Check export status in Actions.',
      integrationsGlovoActivateValidationFailedHint: 'Fix the menu issues above, then try Activate again.',
      integrationsGlovoActivateMenuEmptyHint: 'Add products to the menu for this location, then try Activate again.',
      integrationsGlovoActivatePushFailedHint: 'Fix the issue above, then try Activate again.',
      integrationsGlovoActivateNoTransactionId: 'Glovo did not return an export transaction ID. Try Push menu from Actions.',
      integrationsSyncSchedule: 'Sync schedule',
      integrationsColActive: 'Active',
      integrationsColActions: 'Actions',
      integrationsColIsMenuLocation: 'Menu location',
      integrationsColIsUsingPricelist: 'Menu and orders location',
      integrationsFields: {
        id: 'ID',
        location_id: 'Location',
        orders_location_id: 'Orders location',
        active: 'Active',
        api_url: 'API URL',
        api_key: 'API key',
        client_id: 'Client ID',
        client_secret: 'Client secret',
        venue_id: 'Venue ID',
        is_integrated: 'Integrated',
        is_using_pricelist: 'Menu and orders location',
        is_auto_accept: 'Auto accept orders',
        platform_status_polling_enabled: 'Monitor platform availability',
        schedule: 'Schedule',
        is_menu_location: 'Menu location',
        created_at: 'Created at',
        updated_at: 'Updated at',
        access_token: 'Access token',
        merchant_id: 'Merchant ID',
        auto_send_at_status: 'Auto send at status',
        auto_send_time: 'Auto send time',
        order_total_handshake: 'Require code for orders above',
        feedback_emails: 'Feedback emails',
        integrator_id: 'Integrator ID',
        provider_id: 'Provider ID',
        secret_key: 'Secret key',
        emails: 'Emails',
        user: 'User',
        password: 'Password',
        menu_language: 'Menu language',
        has_own_delivery: 'Own delivery',
        prep_time_buffer_in_minutes: 'Prep time buffer (minutes)',
        pos_implementation_name: 'POS implementation name',
        brand_name: 'Brand name',
        brand_code: 'Brand code',
        store_id: 'Store ID',
        laas_client_id: 'Client ID',
        laas_client_secret: 'Client secret',
        menu_top_categories: 'Menu top categories',
        key_id: 'Key ID',
        scope: 'Scope',
        webhook_secret: 'Webhook secret',
        public_key: 'Public key'
      },
      integrationsFeedbackEmailsHint: 'Enter email addresses separated by commas, semicolons, or new lines',
      woltDriveAutoSendStatus_manual: 'Manual',
      woltDriveAutoSendStatus_processing: 'Processing',
      woltDriveAutoSendStatus_prepared: 'Prepared',
      integrationsTypes: {
        glovo: 'Glovo',
        glovo_laas: 'Glovo LaaS',
        bolt: 'Bolt',
        wolt: 'Wolt',
        wolt_drive: 'Wolt Drive',
        delivery_hero: 'Delivery Hero',
        nexus: 'Nexus',
        charisma: 'Charisma',
        clock_pms: 'Clock PMS',
        ebriza: 'Ebriza',
        rkeeper: 'rKeeper',
        rsystem: 'R-System',
        ep_restaurant: 'eP Restaurant',
        freya_on_premise: 'Freya (on-premise)',
        freya_cloud: 'Freya Cloud',
        grandchef: 'GrandChef'
      },
      notaTransfer: 'Transfer note',
      dataStart: 'Start Date',
      dataEnd: 'End Date',
      updateStockScriptic: 'Update scriptic stock',
      printInventorySheet: 'Inventory sheet',
      saveDraft: 'Save draft',
      saveAndValidate: 'Save and apply modifications',
      cost: 'Cost',
      gestiune_descarcare: 'Download management',
      noteEntries: 'Entrance note at reception',
      receptionOrder: 'Reception Order',
      validateOrder: 'Validate Order',
      processingOrder: 'Processing Order',
      forLocation: 'For Location',
      toLocation: 'To Location',
      stockNameTable: 'Item name',
      stockUm: 'MU',
      stockPrice: 'Unit price',
      stockStocMinim: 'Minimum stock',
      stockQuantity: 'Current stock',
      stockValue: 'Stock value',
      stockStatus: 'Status',
      stockStatus1: '✅ OK',
      stockStatus2: '⚠️ Below minimum stock',
      stockStatus3: '❗ Critical',
      stocksHistory: 'Stock History',
      nirs: 'Nir',
      stockDate: 'Data',
      stockDocumentId: 'Nr. doc',
      stockDocumentType: 'Tip Document',
      stockIntrare: 'Intrare',
      stockIesire: 'Iesire',
      stockStocFinal: 'Stock Final',
      stockPret: 'Pret',
      stockValoareStoc: 'Valoare stoc',
      stockObservatii: 'Observatii',
      noSeries: 'No series available',
      noGestiuni: 'No Inventory available',
      default: 'Sales management default',
      quantityScriptic: 'Scriptic Quantity',
      quantityFaptic: 'Faptic Quantity',
      procesata: 'Processed',
      nrProduse: 'Number of products',
      fiscalizate: 'Fiscalized',
      tipVanzare: 'Type of sale',
      email: 'Email',
      process: 'Process',
      invoice: 'Invoice',
      sendOrder: 'Send Order',
      reception: 'Reception',
      validate: 'Validate',
      generateNir: 'Generate Nir',
      ore: 'Hours',
      zile: 'Days',
      searchClientsWithCUI: 'Search client with CUI',
      searchClients: 'Search client',
      addClient: 'Add client',
      clientName: 'Client name',
      termenValabilitate: 'Validity Term',
      scazamant: 'Shrinkage',
      addBonConsum: 'Add consumption receipt',
      addNoteTransfer: 'Add transfer note',
      procent: 'Procent',
      stocScriptic: 'Scriptic Stock',
      stocFaptic: 'Faptic Stock',
      difference: 'Difference',
      status: 'Status',
      inventoryNumber: 'Inventory #',
      differences: 'Differences',
      users: 'Utilizatori',
      note: 'Note',
      inventar: 'Inventory',
      reports: 'Reports',
      myOrders: 'My orders',
      forOrders: 'Orders received',
      bankAccounts: 'Bank accounts',
      costPerUnit: 'Cost per unit',
      pricePerUnit: 'Price per unit',
      totalCost: 'Total cost',
      editPrice: 'Edit price',
      stocK: 'Stock',
      pretVanzare: 'Selling price (VAT INCLUDE)',
      stocMinim: 'Minimum stock',
      docFurnizori: 'Reception entry notes',
      clients: 'Clients',
      lot: 'Lot',
      dataProductie: 'Production date',
      dataExpirare: 'Expiration date',
      aviz: 'Notice',
      pretPerUnitate: 'Price per unit',
      cantitateNecesara: 'Required quantity',
      cantitateConsumata: 'Consumed quantity',
      addAviz: 'Add notice',
      products: 'Products',
      bonFiscal: 'Fiscal Receipt',
      sales: 'Sales',
      addOrder: 'Add Order',
      outputs: 'Outputs',
      commandProject: 'Command/Project',
      production: 'Production',
      preview: 'Preview',
      manager: 'Manager',
      receiver: 'Receiver',
      internalNote: 'Internal Note',
      isBonProductie: 'Production Receipt',
      fromGestiune: 'From Warehouse',
      toGestiune: 'To Warehouse',
      transfer: 'Transfer Receipt',
      cui: 'CUI',
      dashboard: 'Dashboard',
      numeGestionar: 'Name administrator',
      numeGestiune: 'Name management',
      gestiuni: 'Managment',
      categorii: 'Categories',
      contContabil: 'Accounting Account',
      currentNumber: 'Current Number',
      codGestiune: 'Code managment',
      consumption: 'Consumption',
      addManagment: 'Add managment',
      tipGestiune: 'Management type',
      cantitativValoric: 'Quantitative Valuation (Recommended)',
      cantitativValoricDesc: 'Products appear on the NIR at Acquisition Cost. Used by stores and warehouses. Suitable for any type of product: Merchandise, Raw Materials, Consumable Materials, etc.',
      globalValoric: 'Global Valuation',
      globalValoricDesc: 'Products appear on the NIR at Sale Price. Used by small stores. Only for Merchandise and Packaging products. You will not be able to issue consumption receipts from this management, for example.',
      terti: 'Third Parties',
      tertiDesc: 'When your products are sent to Third Parties for storage or processing.',
      workPoint: 'Work Point',
      adresaPunctLucru: 'Work Point Address',
      administrator: 'Administrator',
      stocks: 'Stocks / Consumables',
      priceAchizitie: 'Purchase price',
      reteta: 'Nomenclature',
      emptyData: 'There is no data',
      noData: 'There is no data, use the filters for selection and press the "SEARCH" button',
      addReteta: 'Add product to recipe',
      history: 'History',
      entries: 'Entries',
      suppliers: 'Suppliers',
      bonTransfer: 'Bon Transer',
      supplierOrders: 'Supplier Orders',
      generateAvizNIR: 'Generate Aviz & NIR',
      avizGestiuneaPredatoare: 'Aviz (in the supplying warehouse)',
      dataAviz: 'Aviz Date',
      nirGestiuneaPrimitoare: 'NIR (in the receiving warehouse)',
      dataNIR: 'NIR Date',
      nomenclatorProducts: 'Product Products',
      addProduct: 'Add product',
      product: 'Product',
      codeProduct: 'Code Product',
      code: 'Code',
      name: 'Name',
      price: 'Price',
      gestiune: 'Inventory',
      nr: 'No.',
      categoria: 'Category',
      tva: 'VAT %',
      pretFaraTva: 'Price(without VAT)',
      currency: 'Currency',
      settings: 'Settings',
      productName: 'Product Name',
      productDescription: 'Product Description',
      type: 'Type',
      gestiuneDefault: 'Gestiune',
      codeFiscalFurnizor: 'Fiscal Code of the supplier',
      dataDocument: 'Document date',
      dataInStoc: 'Date in stock',
      dataScadenta: 'Due date',
      tipDocument: 'Document type',
      nrDocument: 'Document number',
      valoare: 'Value',
      valoareTaxable: 'Taxable base',
      valoareTva: 'VAT',
      valoareTotal: 'Total',
      valoarePayable: 'Payable',
      precizie: 'Precision',
      prețAchiziție: 'Purchase Price',
      nirsProduct: 'Product NIRs:',
      BalanceReport: 'Centralized balance',
      exports: 'Exports',
      inboundInvoices: 'Accounting Inbound Invoices',
      accountingSales: 'Accounting Sales',
      download_xml: 'Export arhive SAGA XML',
      exportAccounting: {
        infoText: 'To generate the accounting export, select a location and a date and time range. Then choose the desired format (XML or XLS) and wait for the generation process to complete. Depending on the data volume, the export may take a few seconds.'
      },
      exportAccountingSales: {
        infoText: 'To generate the sales accounting export, select a location and a date and time range. Then choose the desired format (XML or XLS) and wait for the generation process to complete. Depending on the data volume, the export may take a few seconds.'
      },
      miscareStoc: {
        vanzare: 'STOCK MOVEMENT: SALE',
        intrare: 'STOCK MOVEMENT: ENTRY',
        resetare: 'STOCK MOVEMENT: RESET',
        inventar: 'STOCK MOVEMENT: INVENTORY',
        intrareTransfer: 'STOCK MOVEMENT: TRANSFER IN',
        iesireTransfer: 'STOCK MOVEMENT: TRANSFER OUT',
        bonConsum: 'STOCK MOVEMENT: CONSUMPTION NOTE',
        intrareProductie: 'STOCK MOVEMENT: PRODUCTION IN',
        iesireProduse: 'STOCK MOVEMENT: PRODUCTS OUT',
        bonAnulat: 'STOCK MOVEMENT: CANCELED NOTE',
        protocol: 'STOCK MOVEMENT: PROTOCOL',
        donatie: 'STOCK MOVEMENT: DONATION'
      },
      stoc: {
        checkbox: '',
        nume: 'Name',
        tag: 'Tag',
        tva: 'VAT',
        um: 'Unit Measure',
        cantitateRamasa: 'Remaining Quantity',
        costMediuAchizitie: 'Average Purchase Cost',
        valoareTotala: 'Total Value',

        action: {
          editareMultipla: 'Bulk Edit',
          bonConsum: 'Consumption Voucher',
          transferStoc: 'Stock Transfer',
          resetareStoc: 'Reset Stock',
          exporta: 'Export All'
        }
      },
      locatie: 'Location',
      nume: 'Name',
      cantitate: 'Quantity',
      cantitateHint: 'Enter quantity with a dot (.), not a comma (,)',
      umTaptastyInfo: 'The unit of measure for products managed from Taptasty can be changed from CATALOG -> Products!',
      modifCantRamasa: 'Remaining Qty',
      pretUnitar: 'Unit Price',
      costMediuAchizitie: 'Average Purchase Cost',
      costTotal: 'Total Cost',
      data: 'Date',
      detalii: 'Details',
      schimbaCotaTVA: 'Change VAT Rate',
      schimbaTag: 'Change Tag',
      stergeTot: 'Delete All',
      motiv: 'Reason',
      cantitateDeConsum: 'Consumption Quantity',
      um: 'UM',
      pretUnitarFaraTVA: 'Unit Price (Excl. VAT)',
      pretTotal: 'Total Price',
      furnizor: 'Supplier',
      nrFactura: 'Invoice Number',
      scadenta: 'Due Date',
      dataEmitere: 'Issue Date',
      dataIntrare: 'Entry Date',
      adaugaIntrare: 'Add Entry',
      nirInfoNote: '⚠️ <strong>Attention!</strong> The Reception Entry Note (NIR) is intended exclusively for recording the reception and entry of products into warehouse management. For managing supplier invoices, go to <strong>Entries → Supplier Invoices</strong>.'
    },
    menuLink: {
      alias: 'Alias',
      title: 'Title',
      updated: 'Updated',
      areYouSure: 'Are you sure to {label} menu link ?',
      deleted: 'Deleted',
      couldNotUpdate: 'Not updated',
      cancel: 'cancel',
      delete: 'delete',
      added: 'Menu link added',
      promotions: 'Promotions',
      history: 'History',
      orders: 'Orders',
      reservations: 'Reservations',
      tables: 'Tables',
      orderspos: 'Add New Order',
      dispatch: 'Dispatch',
      favorite_orders: 'Favorite orders',
      tutorial: 'Tutorial',
      personal_info: 'Personal informations',
      single: 'Menu link',
      cancelCourier: 'Cancel courier',
      logout: 'Logout',
      from: 'from',
      to: 'to',
      linkFor: 'Link for',
      externUrl: 'External URL',
      custom: 'Custom',
      day: 'day',
      couldNotSave: 'Menu link could not be saved'
    },
    pages: {
      allModules: 'See all modules',
      automationMarketing: 'Automatic marketing',
      stock: 'Stock',
      supportTicket: 'Support Ticket',
      supportWidgetTokenUnavailable: 'Support widget token is not available for this location',
      login: 'Login',
      register: 'Register',
      recoverPassword: 'Recover Password',
      resetPassword: 'Reset Password',
      programTitle: 'Program',
      dashboard: 'Dashboard',
      orderingManagement: 'Ordering Management',
      customerDetails: 'Customer Details',
      customers: 'Customers',
      approvals: 'Registration approvals',
      giftCard: 'Gift Card',
      customersGroups: 'Customer groups',
      orders: 'Orders',
      reservations: 'Reservations',
      tables: 'Tables',
      orderspos: 'Add New Order',
      dispatch: 'Dispatch',
      screens: 'Screens',
      transfer: 'Trasnfer',
      pos: 'Pos',
      tableMaps: 'Table Maps',
      products: 'Products',
      isPriceList: 'Price List',
      catalog: 'Catalog',
      categories: 'Categories',
      productOptions: 'Product Options',
      groupOptions: 'Group Options',
      marketing: 'Marketing',
      campaigns: 'Campaigns',
      pushCampaigns: 'Push notification campaigns',
      coupons: 'Coupons',
      subscriptions: 'Subscriptions',
      referralCampaigns: 'Referral campaigns',
      loyaltyStoreCampaigns: 'Loyalty Store',
      ambassadorRequests: 'Ambassador requests',
      raffleCampaigns: 'Raffle Campaigns',
      donationCampaigns: 'Donation Campaigns',
      spinningWheelCampaigns: 'Spinning Wheel',
      discountCampaigns: 'Discount Campaigns',
      challengeCampaigns: 'Challenges',
      offersSlider: 'Offers Slider',
      reports: 'Reports',
      feedback: 'Feedback',
      settings: 'Settings',
      logout: 'Logout',
      fidelities: 'Fidelities',
      topCategory: 'Top Category',
      infoPagesCustom: 'Custom Pages',
      menuLinks: 'Menu Links',
      infoPages: 'Info Pages',
      productFilters: 'Product Filters',
      promos: 'Fidelity Card',
      menus: 'QR Menus',
      menuSubscriptions: 'Menu subscriptions',
      orderScreen: 'Order Screen',
      clientOrderView: 'Display PickUp',
      payment: 'Payment',
      newsletter: 'Newsletter',
      support: 'Support',
      scanner: 'Scan',
      gestiune: 'Inventory',
      stocuri: 'Stocks',
      intrari: 'Entries',
      kds: 'KDS',
      ods: 'ODS',
      posScreen: 'Pos Screen',
      digitalSignage: 'Digital Signage Screen',
      orderDisplayScreen: 'Display Screens',
      online: 'Online',
      invoice: 'Invoice',
      kiosk: 'Kiosk',
      qr: 'Qr'
    },
    infoPages: {
      single: 'page',
      title: 'Title',
      shortDescription: 'Short Description',
      updated: 'Updated',
      areYouSure: 'Are you sure to delete this page?',
      deleted: 'Deleted',
      couldNotUpdate: 'Could not updated',
      added: 'Custom info page added',
      changeLinkTab: 'In case if is added an link change the text box with TAB for next and SHIFT + TAB for previous',
      infoPages: 'Info Pages'
    },
    ordersStatus: {
      bill: 'Bill',
      AWAITING_TRANSPORT: 'Awaiting Transport',
      CANCELED: 'Canceled',
      DELIVERED: 'Delivered',
      DRAFT: 'Draft',
      OPEN_DRAFT: 'Open order',
      NEW: 'New',
      ON_HOLD: 'On Hold',
      POSTPONED: 'Postponed',
      NOT_DELIVERED: 'Not Delivered',
      PICKED_UP_BY_DELIVERY: 'Picked up for delivery',
      PROCESSING: 'Processing',
      PREPARED: 'Prepared',
      TRANSPORT: 'In transport',
      RESERVED: 'Reserved',
      COMPLETED: 'Completed',
      FINISH: 'Finish',
      DRAFT_AWAITING_PAYMENT: 'Awaiting Payment',
      reservedReady: 'Reserved / Ready',
      completedReady: 'Completed / Ready',
      deliveredReady: 'Delivered / Ready',
      canceledForever: 'canceled? This action is irreversible!',
      checkIn: 'Checked-in'
    },
    ordersTypes: {
      GROUP: 'Group',
      SINGLE: 'Single'
    },
    paymentTypes: {
      CASH: 'Cash',
      CARD: 'Online Card',
      POS: 'POS for delivery (NOT paid)',
      CARD_POS: 'Physical POS terminal (PAID)',
      CASH_MACHINE: 'Cash machine (PAID)',
      POS_KIOSK: 'POS Kiosk (NOT paid)',
      VIVA_INTENT: 'VIVA App',
      VIRAMENT: 'VIRAMENT',
      SPLIT: 'Split payment',
      ROOM: 'Room Charge',
      FOLIO: 'Folio Charge',
      EVENT: 'Event Charge',
      MANCARE_PERSONAL: 'Staff Food',
      PROTOCOL: 'Protocol',
      ONLINE: 'Online',
      Online: 'Online', // Atunci cand punem metode de plata dupa cum de fata capul
      GLOVO: 'GLOVO',
      GLOVO_CARD: 'GLOVO CARD',
      GLOVO_CASH: 'GLOVO CASH',
      BOLT: 'BOLT',
      BOLT_CASH: 'BOLT CASH',
      BOLT_CARD: 'BOLT CARD',
      WOLT: 'WOLT',
      WOLT_CASH: 'WOLT CASH',
      WOLT_CARD: 'WOLT CARD',
      VOUCHER: 'Voucher',
      GIFT_CARD: 'Gift card',
      null: 'Not Paid'
    },
    paymentStatus: {
      notPaid: 'Authorized (Amount blocked)',
      notPaidDetails: 'The amount will be charged once the order is marked as Delivered.',
      paid: 'Paid',
      notOk: 'Declined'
    },
    campaignsModes: {
      AUTO: 'Automatic',
      MANUAL: 'Manual'
    },
    campaignsNotificationTypes: {
      EMAIL: 'E-mail',
      PUSH: 'Push Notification'
    },
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday'
    },
    daysShort: {
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
      Sun: 'Sun'
    },
    months: {
      1: 'January',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
      10: 'October',
      11: 'November',
      12: 'December'
    },
    gender: {
      selectGender: 'Select Gender',
      male: 'male',
      female: 'female',
      Male: 'Male',
      Female: 'Female',
      Other: 'Other'
    },
    reportsAgesGroups: {
      selectAge: 'Select Age',
      '20': 'Under 20',
      'Under 20': 'Under 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      '50+': '50+',
      Unspecified: 'Unspecified'
    },
    deliveryTypes: {
      SELF_ORDERING: 'Table Or Kiosk',
      DELIVERY: 'Delivery',
      EAT_LOCATION: 'Table Order',
      MEET_HALF: 'Meet me half way',
      PICK_UP: 'Pick-up'
    },
    couponsTypes: {
      FIXED: 'Fixed',
      PERCENTAGE: 'Percentage',
      FREE_PRODUCT: 'Free product'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Fixed (included)',
      PERCENTAGE_INCLUDED: 'Percentage (included)',
      FIXED_EXCLUDED: 'Fixed',
      PERCENTAGE_EXCLUDED: 'Percentage'
    },
    productOptions: {
      checkbox: 'Allows selecting multiple options on the product',
      radio: 'Allows selecting only one option on the product',
      upload: 'Option with image upload',
      hidePrices: 'Hide prices',
      hasDefaultValue: 'Select first value by default'
    },
    validations: {
      success: 'Success',
      priceUpdated: 'Price updated successfully',
      areYouSureYouWantTo: 'Are you sure you want to ',
      areYouSure: 'Are you sure you want to update the status to ',
      wentWrong: 'Something went wrong, please try again later...',
      pictureSize2MB: 'jpg/png files with a size less than 2MB ',
      pictureSizeExceed2MB: 'Picture size can not exceed 2MB!',
      pictureSize: 'jpg/png files with a size less than 5MB ',
      pictureLogo: 'jpg/png/svg files with a size less than 5MB ',
      pictureSizeExceed: 'Picture size can not exceed 5MB!',
      pdfSize: 'Files with a size less than 25MB ',
      pdfSizeExceed: 'File size can not exceed 25MB!',
      archiveSizeExceed: 'File size can not exceed 500MB!',
      wrongFormat: 'Wrong format',
      removePhoto: 'Please remove the current file in order to be able to add a new one',
      dataCouldNotBeSaved: 'Data could not be saved, please try again later.',
      passReq: 'Password field id required.',
      passMin: 'Password must be at least 6 characters.',
      passConf: 'Password and password confirmation do not match.',
      validPoinsNo: 'Please add a valid money amount and a comment.',
      imageResolution: ', recommanded resolution 300px height and 820px width.',
      imageResolutionWeb: ', recommanded resolution 300px height and 1920px width.',
      doYouWantTo: 'Do you want to ',
      hourIsSmallerThanCreated: 'The selected hour is smaller then the placed hour for the order',
      cancelReason: 'Cancellation reason is required.',
      requiredField: 'This field is required',
      invalidEnteredData: 'The entered data is not valid.',
      vatPrinterIdRange: '0–10 only.',
      vatPrinterIdNumeric: 'Numbers only.',
      chooseDay: 'Choose at least one day for the product to be available!',
      chooseLocation: 'Choose at least one location for the product to be available!',
      chooseLocationAndDeliveryMethod: 'Choose at least one location and delivery method for the product to be available!',
      timeInterval: 'Wrong time interval!',
      noOverrideIntervals: 'Override delivery is enabled but no intervals have been added. Please add at least one interval.',
      overrideIntervalMissingHours: 'All intervals must have both "From" and "To" times set.',
      overrideIntervalMissingDay: 'All intervals must have at least one day selected.',
      subtractPoints: 'Are you sure you want to consume'
    },
    upload: {
      uploadLabel: 'Upload Menu',
      uploadMenuTemplateLabel: 'Upload Menu Form',
      browse: 'Browse',
      download: 'Download QR Code',
      dynamicMenu: 'Dynamic Menu',
      staticMenu: 'PDF Menu',
      downloadImportProductsTemplate: 'Download Menu Form',
      upload: 'Upload',
      downloadButton: 'Download',
      uploadImagesArchive: 'Upload Images Archive',
      file: 'File'
    },
    productImport: {
      import: 'Import',
      importHistory: 'Import History',
      batch: 'Batch',
      date: 'Date',
      file: 'File',
      products: 'Products',
      status: 'Status',
      review: 'Review',
      confirm: 'Confirm',
      cancel: 'Cancel batch',
      remove: 'Remove',
      removeConfirm: 'Remove this row from the import? It will not be applied.',
      editRow: 'Edit import row',
      product: 'Product',
      action: 'Action',
      actionType: 'Type',
      actionCreate: 'Create',
      actionUpdate: 'Update',
      actionPriceListUpdate: 'Price list update',
      price: 'Price',
      category: 'Category',
      errors: 'Errors',
      pending: 'Pending',
      confirmed: 'Successful',
      removed: 'Removed',
      uploadSuccess: 'Import uploaded. Review and confirm changes.',
      confirmSuccess: 'Import applied successfully',
      statusPending: 'Pending',
      statusConfirmed: 'Confirmed',
      statusSuccessful: 'Successful',
      statusPartiallyConfirmed: 'Partially Confirmed',
      statusPartiallySuccessful: 'Partially successful',
      statusCanceled: 'Canceled',
      statusError: 'Error',
      statusRemoved: 'Removed',
      exportProducts: 'Export products',
      exportImages: 'Download images',
      selectPriceProfile: 'Price profile',
      priceProfileRequired: 'Select a price profile before confirming',
      confirmTitle: 'Confirm import',
      confirmPriceHint: 'Choose the price profile where channel prices will be applied.',
      step1Title: 'Download / export',
      step1Intro: 'Choose one option: start from an empty form, or export the products already on this location.',
      optionEmptyTitle: 'Empty form',
      optionEmptyDesc: 'Download a blank CSV template and fill it offline.',
      downloadEmptyForm: 'Download empty form',
      optionExportTitle: 'Export existing products',
      optionExportDesc: 'Export current location products into the menu CSV (requires a price list).',
      defaultPriceListHint: 'If this location has no price list, we automatically create one named “<location name> default”.',
      noProductsForExport: 'This location has no products yet, so export is disabled.',
      step2Title: 'Fill in the form',
      step2Body: 'Open the CSV in Excel or Google Sheets. Fill PRODUCT ID, PREȚ, and channel prices offline, then save as CSV.',
      step3Title: 'Images (.zip)',
      step3Hint: 'Upload a .zip with product images',
      step4Title: 'Menu (.csv)',
      step4Hint: 'Upload the completed CSV. You will review and confirm the import in the preview before changes are applied.',
      sectionIdentity: 'Product identity',
      sectionCategories: 'Categories',
      sectionBase: 'Base details',
      sectionDescription: 'Description & labels',
      sectionPrices: 'Channel prices',
      searchProduct: 'Match existing product',
      searchProductPlaceholder: 'Search by name…',
      productMatchNew: 'Empty PRODUCT ID — a new product will be created on confirm.',
      productMatchFound: 'Matched: {name}',
      productMatchUnknown: 'Unknown product — search and select an existing product, or clear the ID to create new.',
      topCategory: 'Top category',
      secCategory: 'Secondary categories',
      active: 'Active',
      activeHint: '1 / 0 / yes / no',
      posId: 'POS ID',
      vat: 'VAT',
      section: 'Section',
      weight: 'Weight',
      imageFilename: 'Image filename',
      imageFilenameHint: 'Filename from the uploaded zip',
      desc: 'Description',
      nutritional: 'Nutritional',
      allergenic: 'Allergens',
      ingredients: 'Ingredients',
      legacyTitle: 'Legacy import',
      legacyHint: 'Applies the CSV immediately without review. Uses the classic template (creates products only — no PRODUCT ID / channel prices). Upload images as .zip here before importing the CSV.',
      legacyDownloadLabel: 'Download menu form',
      legacyDownload: 'Download',
      legacyUpload: 'Upload',
      legacyUploadSuccess: 'Legacy import completed'
    },
    dashboard: {
      selectLocation: 'Select location:',
      selectZone: 'Zone:',
      selectMethod: 'Method:',
      selectDriver: 'Driver:',
      selectUsers: 'User/Admins:',
      selectClient: 'Client',
      selectedOrderFormFlags: 'Pentru comenzile din:',
      selectedPaymentMethods: 'For orders with:',
      serchCoupon: 'Search(Cupon)',
      tile1Title: 'New Orders',
      tile2Title: 'Total Orders',
      tile3Title: 'Revenue',
      tile4Title: 'Average Order',
      today: 'Today',
      orderChart: 'Orders',
      completed: 'Number of orders',
      canceled: 'Canceled',
      salesChart: 'Sales',
      salesIn: 'Sales in',
      top5Chart: 'Top 5 products',
      orderingChart: 'Ordering types',
      nrOfOrders: 'Number of orders',
      nrOfEmails: 'Number of emails'
    },
    customers: {
      addCustomerToGroup: 'Add customer to group...',
      noApprovalRequired: 'No approval required',
      searchPlaceholder: 'Search by name, phone or email...',
      myGroups: 'My Groups',
      pendingApproval: 'pending',
      noGroups: 'Not part of any group',
      approvalStatus: 'Status',
      approved: 'Approved',
      approve: 'Approve',
      clientApproved: 'Client approved successfully!',
      membersRequireApproval: 'Members require approval',
      totalSales: 'Total sales',
      settings: 'User settings',
      allow_virament: 'Allow virament',
      singleTotal: 'Total customer: ',
      noCustomer: 'No Customer Selected',
      single: 'customer',
      plural: 'customers',
      deliveryOrders: 'Customer Delivery Orders',
      pickupOrders: 'Customer Pick-Up Orders',
      meetHalfwayOrders: 'Customer Meet Halfway Orders',
      customerReservations: 'Customer Reservations',
      title: 'Customer Details',
      pointsTitle: 'Customer Loyalty Points',
      currentPoints: 'Current Points',
      pointsAddTitle: 'Add Points',
      pay: 'Pay Type',
      id: 'ID',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      use_calling_phone: 'Pick up phone number',
      gender: 'Gender',
      birth: 'Birth Day',
      location: 'Location',
      address: 'Address',
      number: 'Number',
      dateCreated: 'Date Created',
      delivery: 'Delivery',
      type: 'Type',
      status: 'Status',
      fidelities: 'Label',
      total: 'Total',
      allTimeSale: 'All time sale',
      none: 'None',
      pointsLabel: 'Money spent',
      pointsLabelInPoints: 'Points earned',
      pointsAdjustmentHelp: 'Enter a positive value to add points or a negative value (e.g. -100) to subtract points from the customer’s balance.',
      points: 'points',
      point: 'point',
      clientCanUse: 'Customer can use',
      commentsLabel: 'Comment',
      pointsSuccess: 'Loyalty points added successfully.',
      pointsError: 'We could not add the points to the customer.',
      addCommentPerClient: 'Add comment per client',
      newCommentAdded: 'The comment has been updated',
      clientNotification: 'Would you like to use the comment in order notify the customer?',
      filters: {
        withOrders: 'With Orders',
        withoutOrders: 'Without Orders'
      },
      addGroup: 'Add Group',
      deleteGroup: 'Group successfully deleted.',
      saveGroup: 'Group was successfully added.',
      updateGroup: 'Group was successfully updated.'
    },
    orders: {
      cancel_order_reason: 'Cancel Reason',
      counterPerCustomer: 'Number of Orders',
      noOrders: 'No Order Selected',
      single: 'Order',
      the_order: 'Order',
      category: 'Category',
      plural: 'orders',
      status: 'Status',
      location: 'Location',
      updateStatus: 'Update Status',
      editOrder: 'Edit Order',
      ordDetails: 'Order Details',
      date: 'Date',
      madeAt: 'Order made at',
      pickupTime: 'Delivery / Pick-up at',
      preorder: 'PREORDER',
      preorderFilter: 'Preorders',
      allOrders: 'All orders',
      pendingPreorders: 'Pending preorders',
      withoutPendingPreorders: 'Without pending preorders',
      reservationTime: 'Reservation Time',
      expresoftStatus: 'Expresoft Status',
      expresoftQueue: 'In Queue',
      expresoftError: 'Sending error',
      expresoftSuccess: 'Sent',
      rating: 'Rating',
      meetupLocation: 'Meet-up Location',
      ordLocation: 'Location',
      delivery: 'Delivery',
      type: 'Type',
      payment: 'Payment',
      name: 'Name',
      qty: 'Qty',
      unit: 'Unit Price',
      unit_price: 'Unit Price',
      final_price: 'Final Price',
      total: 'Total',
      totals_subtotals: 'Subtotal',
      totals_discount: 'Discount',
      totals_discount_loyalty_points: 'Discount from loyalty points',
      totals_grandtotal: 'Total',
      totals_shipping: 'Shipping',
      totals_extras: 'Shopping Bag',
      totals_extras_27: 'Packing Tax',
      totals_extras_30: 'Shopping Bag',
      totals_extras_38: 'Shopping Bag',
      totals_extras_40: 'Shopping Bag',
      totals_extras_50: 'Shopping Bag',
      totals_tip: 'Tips',
      totals_donation: 'Donation',
      app: 'Aplication',
      custComments: 'Customer Comment',
      adminComments: 'Admin Comment',
      pos_response_title: 'POS response',
      fiscal_response_title: 'Fiscal response',
      custDetails: 'Customer Details',
      shipping: 'Shipping Address',
      billing: 'Billing Address',
      orderStatusSuccess: 'Order status updated successfully',
      orderPrinterError: ', but there was an error to the connection with the printer.',
      orderCommnetSuccess: 'Order comment updated successfully',
      orderHourSuccess: 'Order delivery / pick-up time updated successfully',
      orderHourError: 'Please provide a valid hour.',
      none: 'No Comment',
      at: 'at',
      filtersApplied: 'Filters applied - click on filter button to see more',
      filtersList: 'Filters applied',
      customFilters: 'Custom filters applied',
      resetFilters: 'click here to reset and see live data',
      noFiltersApplied: 'No filters applied',
      filtersAndSort: 'Filters & Sort',
      filters: 'Filters',
      pickupDatetime: 'Order Pickup - Datetime',
      placedDatetime: 'When Order Was Placed - Datetime',
      orderId: 'Order ID',
      orderNumber: 'Order Number',
      orderTotal: 'Order Total',
      enterOrderId: 'Enter order ID',
      enterOrderNumber: 'Enter order number',
      selectDateRange: 'Select date range',
      min: 'Min',
      max: 'Max',
      operator: 'Operator',
      source: 'Source',
      note: 'Note',
      orderNoArticulate: 'Order',
      print: 'Print (A4)',
      print2: 'Print (A4 Concise)',
      printerPrint: 'Print (80mm)',
      printFiscal: 'Collect',
      receipt: 'Receipt',
      printedReceipt: 'The order has been collected',
      notPrintedReceipt: 'The order has not been collected',
      rePrintFiscal: 'Re-Print receipt',
      printerSuccess: 'Order successfully printed.',
      printerErrror: 'There was an error to the connection with the printer.',
      callCourier: 'Call courier',
      callHioCourier: 'Hio',
      callTazzLaasCourier: 'Tazz Direct',
      callCourierCancel: 'Are you sure to cancel courier call?',
      orderSentSuccess: 'Call courier was sent with success',
      orderCancelSuccess: 'Call courier was cancelled',
      packageDetails: 'Select package details',
      packageSize: 'Package size: ',
      courierTime: 'Courier pickup time: ',
      sameStatus: 'Order is already ',
      now: 'Now',
      addTime: 'Add time',
      amountRefunded: 'Amount Refunded',
      amountIntegralRefunded: 'Amount was refunded integral to customer',
      refundSuccess: 'Amount refunded with success',
      refundManual: 'The amount will be returned from the paylike manual',
      refundAutomat: 'Do you want to refund amount automatically?',
      refundOrder: 'Refund',
      refundAlreadyDone: 'Already refunded',
      refundConfirmTitle: 'Refund order?',
      refundConfirmText: 'The paid amount will be returned to the customer through EuPlatesc. This action cannot be undone.',
      refundAskCancel: 'Refund done. Do you want to cancel the order as well?',
      refundError: 'An error occurred while processing the refund.',
      orderCloseToDelivery: 'Order with delivery hour closer',
      erorrPaylike: 'Error from Paylike, log was made with error',
      sendToGrandchef: 'Send order to Grandchef?',
      grandchefError: 'Error from Grandchef',
      grandchefWait: 'You can only try once in 30 minutes',
      cancelReason: 'Enter the reason...',
      orderCountryPrefix: 'Prefix',
      contactPakageez: 'Error! Please contact pakageez!',
      seeImage: 'See Image',
      freyaStatus: 'Freya Status',
      freyaStatus1: 'Sending',
      freyaStatus2: 'Sent successfully',
      freyaStatus3: 'Couldn\'t send',
      freyaStatus4: 'Cancelled',
      freyaSendAgain: 'Introduce the order manually or try again',
      legalPerson: 'Company',
      individual: 'Individual',
      billingInfo: 'Billing info',
      callDriver: 'Call delivery driver?',
      virament: 'Virament',
      cash: 'Cash',
      card: 'Card',
      online: 'Online',
      BOLT: 'BOLT',
      GLOVO: 'GLOVO',
      WOLT: 'WOLT',
      card_no_pos: 'Pos mobil',
      cancel: 'Cancel',
      cui: 'Tax number(optional)',
      glovoStatus: 'Glovo Status',
      glovoLaasEvents: 'Glovo LaaS logs',
      glovoLaasEventsEvent: 'Action',
      glovoLaasEventsTime: 'Time',
      glovoLaasTrackCourier: 'Track Courier',
      glovoLaasLogResponse: 'Response',
      glovoLaasLogAction_Create_delivery: 'Create delivery',
      glovoLaasLogAction_Create_delivery_failed: 'Create delivery failed',
      glovoLaasLogAction_Cancel_delivery: 'Cancel delivery',
      glovoLaasLogAction_Cron_callCourier: 'Automatic courier call (cron)',
      glovoLaasLogAction_Webhook_event_received: 'Webhook event received',
      tazzStatus: 'Tazz Status',
      tazzDirectStatus: 'Tazz Direct Status',
      courierStatus1: 'The courier was not called',
      courierStatus2: 'The courier was called',
      courierStatus3: 'The courier was not called',
      courierStatus4: 'The courier was canceled',
      courierStatus5: 'The delivery is managed by glovo',
      courierStatus6: 'An error occurred',
      courier: 'Courier',
      courierDeliveryError: 'Error',
      courierDeliverySuccess: 'Success',
      courierNoCall: 'The courier not was called',
      packageNumber: 'Package count: ',
      zone: 'Zone',
      roomNumber: 'Room Number',
      pagerNumber: 'Pager Number',
      woltDriveStatus: 'Wolt Drive Status',
      deliveryHeroStatus: 'Delivery Hero Status',
      deliveryHeroAreYouSure: 'Call Delivery Hero courier?',
      deliveryHeroEvents: 'Delivery Hero logs',
      deliveryHeroEventsEvent: 'Action',
      deliveryHeroEventsTime: 'Time',
      deliveryHeroLogResponse: 'Response',
      deliveryHeroLogAction_Create_order: 'Create order',
      deliveryHeroLogAction_Create_order_failed: 'Create order failed',
      deliveryHeroLogAction_Cancel_order: 'Cancel order',
      deliveryHeroLogAction_Cancel_order_failed: 'Cancel order failed',
      deliveryHeroLogAction_OAuth_token: 'OAuth token',
      deliveryHeroLogAction_Status_webhook: 'Status webhook',
      deliveryHeroLogAction_Refund_webhook: 'Refund webhook',
      deliveryHeroLogAction_Autopilot_skip: 'Autopilot skip',
      noShipmentPromises: 'No shipment promises available for the selected time.',
      selectShipmentPromise: 'Select Shipment Promise',
      pleaseSelectPromise: 'Please select a shipment promise.',
      confirmDeliveryDetails: 'Confirm delivery details',
      woltDriveEvents: 'Wolt Drive logs',
      woltDriveEventsEvent: 'Action',
      woltDriveEventsTime: 'Time',
      woltDriveTrackCourier: 'Track Courier',
      woltDriveLogResponse: 'Response',
      woltDriveLogResponse_success: 'Success',
      woltDriveLogAction_Get_shipment_promise: 'Get shipment promise',
      woltDriveLogAction_Get_shipment_promise_failed: 'Get shipment promise failed',
      woltDriveLogAction_Create_delivery: 'Create delivery',
      woltDriveLogAction_Create_delivery_failed: 'Create delivery failed',
      woltDriveLogAction_Cron_callCourier: 'Automatic courier call (cron)',
      woltDriveLogAction_No_binding_shipment_promise: 'No binding shipment promise',
      woltDriveLogAction_Autopilot_No_valid_promises: 'Autopilot - No valid promises',
      woltDriveLogAction_Skip_create_delivery_autopilot_gate: 'Skip create delivery (autopilot gate)',
      woltDriveLogAction_Skip_callCourierAndRetry: 'Skip callCourierAndRetry',
      woltDriveLogAction_Cancel_courier: 'Cancel courier',
      woltDriveLogAction_Cancel_delivery_by_order: 'Cancel delivery by order',
      woltDriveLogAction_Cancel_delivery: 'Cancel delivery',
      woltDriveLogAction_Webhook_event_received: 'Webhook event received',
      woltDriveEventType_order_received: 'Order received',
      woltDriveEventType_order_rejected: 'Order rejected',
      woltDriveEventType_order_pickup_eta_updated: 'Pickup ETA updated',
      woltDriveEventType_order_pickup_started: 'Pickup started',
      woltDriveEventType_order_picked_up: 'Order picked up',
      woltDriveEventType_order_pickup_arrival: 'Courier arriving to pickup',
      woltDriveEventType_order_dropoff_started: 'Dropoff started',
      woltDriveEventType_order_dropoff_arrival: 'Courier arriving to dropoff',
      woltDriveEventType_order_dropoff_completed: 'Dropoff completed',
      woltDriveEventType_order_delivered: 'Order delivered',
      woltDriveEventType_order_customer_no_show: 'Customer no-show',
      woltDriveEventType_order_location_updated: 'Courier location updated',
      woltDriveEventType_order_dropoff_eta_updated: 'Dropoff ETA updated',
      woltDriveEventType_order_handshake_delivery: 'Handshake delivery',
      woltDriveEventType_order_status_updated: 'Order status updated',
      woltDriveCancelErrorCode_INVALID_ORDER_STATE_TRANSITION: 'Cannot cancel this delivery: order is not in a cancelable state. Please contact support.',
      woltDriveShipmentPromisesErrorCode_DROPOFF_OUTSIDE_OF_DELIVERY_AREA: 'Dropoff location is outside the delivery area.',
      woltDriveCreateDeliveryErrorCode_CASH_ON_DELIVERY_DISABLED: 'Cash on delivery is not available for Wolt Drive. Please contact Wolt Drive support.'
    },
    ordersSource: {
      1: 'Kiosk',
      2: 'Qr',
      3: 'Pos',
      4: 'App',
      5: 'Website',
      6: 'Glovo',
      7: 'Wolt',
      8: 'Bolt'
    },
    boogit: {
      boogitStatus: 'Boogit Status',
      boogitStatus1: 'Not sent',
      boogitStatus2: 'Sent successfully',
      boogitStatus3: 'Couldn\'t send',
      boogitStatus4: 'Cancelled'
    },
    charisma: {
      location: 'Location',
      posIds: 'POS IDs',
      partnerCode: 'Partner Code',
      tipsItemId: 'Tips Item ID',
      createDate: 'Create Date',
      updateDate: 'Update Date',
      orderOptionId: 'Order Option ID',
      companyOptionId: 'Company Option ID',
      optionName: 'Option Name',
      optionValueName: 'Option Value Name',
      categoryAdministration: 'Administration',
      charismaInventory: 'Charisma Inventory',
      logRvc: 'RVC',
      dataFrom: 'Data From',
      dataTo: 'Data To',
      enterPosId: 'Enter POS ID',
      enterExternalId: 'Enter External ID',
      options: 'Options #',
      itemCode: 'Item Code',
      itemId: 'Item ID',
      enterItemCode: 'Enter Item Code if empty',
      sendAll: 'Send selection',
      sendAllMessage: 'Orders were marked and will be sent to Charisma in a matter of minutes depending on the number of orders',
      bill: 'Bill',
      invoice: 'Invoice',
      documentType: 'Document Type',
      charisma0: '-',
      charisma1: 'Not sent',
      charisma2: 'Sending',
      charisma20: 'Sending',
      charisma3: 'Sent',
      charisma4: 'Error',
      sendOnlyProform: 'Send only Bill',
      sendOnlyInvoice: 'Send only Invoice',
      orderItems: 'Order items',
      sendHistory: 'Send history',
      document: 'Document',
      resultCharisma: 'Charisma result',
      verdict: 'Verdict',
      logStatus: 'Status',
      logVerdictSuccess: 'Sent successfully',
      logVerdictError: 'Error sending to Charisma',
      logVerdictCharismaError: 'Charisma error',
      logVerdictAwaitingResponse: 'Sent, awaiting response',
      logVerdictNoPayload: 'No data recorded',
      logVerdictUnknown: 'Unknown status',
      logVerdictMissingPosIds: 'Validation error, missing Charisma IDs. Please complete the fields above and send again.',
      logVerdictMissingCategoryAdministration: 'Missing category administration. Please complete the fields above and send again.',
      logVerdictConnectionError: 'Charisma server connection error',
      logVerdictOrderNotDelivered: 'Order is not delivered yet.',
      resendConfirm: 'The order has been sent already, are you sure you want to send the order again?'
    },
    fiscalZ: {
      id: 'ID',
      zNumber: 'Number',
      zTimestamp: 'Timestamp',
      totalSalesA: 'Total Sales A',
      totalSalesB: 'Total Sales B',
      totalSalesC: 'Total Sales C',
      totalSalesD: 'Total Sales D',
      totalSalesE: 'Total Sales E',
      totalOtherTaxes: 'Total Other Taxes',
      totalVatExempt: 'Total VAT Exempt',
      totalSales: 'Total Sales',
      totalVatA: 'Total VAT A',
      totalVatB: 'Total VAT B',
      totalVatC: 'Total VAT C',
      totalVatD: 'Total VAT D',
      totalVatE: 'Total VAT E',
      totalVat: 'Total VAT'
    },
    companyOptions: {
      id: 'Id',
      name: 'Name',
      image: 'Image',
      prod_image: 'Product Image (just custom app)',
      info: 'Info',
      type: 'Type',
      print_with_product_label: 'Print with product label (for label printers)',
      product_id: 'The option is the Product',
      deleteQues: 'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',
      deleteVal: 'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',
      active: 'Active',
      quantitySettings: 'Quantity Settings',
      allowQuantity: 'Allow quantity',
      minQuantity: 'Minimum quantity',
      maxQuantity: 'Maximum quantity',
      quantityMinMaxError: 'Minimum quantity cannot be greater than maximum quantity'
    },
    catalogProd: {
      prod_desc: 'Description',
      prod_general: 'General',
      prod_price: 'Price',
      prod_loc: 'Location',
      prod_opt: 'Options',
      prod_mark: 'Markenting',
      prod_lab: 'Label',
      prod_set: 'Settings',
      same_name_are_you_shore: 'This name is also found on another product, Are you sure you want to save?',
      max_purchases_per_customer: 'Max Purchases Per Customer',
      preparation_time_in_minutes: 'Preparation time (minutes)',
      category_preparation_time_hint: 'Category preparation time: {minutes} min',
      label_type: 'Type',
      orderLabelSettings: 'Order label printing',
      printOnOrderLabel: 'Print this product on order labels',
      printOnOrderLabelHint: 'This product prints when enabled here and an Order Label printer is set to “Print each product on its own label”.',
      label_name: 'Product name on label',
      label_ingredients: 'Ingredients on Label',
      label_allergens: 'Allergens on Label',
      label_exp_txt: 'Expiration text (eg: Expires within 2 hours of opening)',
      sold_with_menu_suggestion: 'With Menu Suggestion',
      sold_with_menu_suggestion_pos: 'Activate this functionality on POS!',
      noProducts: 'No Product Selected',
      single: 'product',
      plural: 'products',
      generalDetails: 'General Details',
      aditionalInfo: 'Additional Info',
      id: 'ID',
      name: 'Name',
      desc: 'Description',
      image: 'Image',
      image_size: 'Image Size',
      video_thumbnail: 'Video Thumbnail',
      imageMore: 'More images',
      video: 'Video',
      category: 'Category',
      topCategory: 'Top Category',
      partialPay: 'With partialal pay',
      isDeposit: 'Is Deposit',
      isAgeRestrict: 'Age restricted',
      limitQuantityKioskQr: 'Quantity 1 for Kiosk/Qr',
      secondaryCategory: 'Secondary categories',
      coursesType: 'Course type',
      coursesTypeMaxAllowed: 'Maximum value allowed by location: {max}',
      coursesTypeLocationNotPermitted: 'The location does not permit courses',
      price: 'Price',
      usePriceToShow: 'Use price to show',
      priceToShow: 'Price to show',
      oldPrice: 'Old price',
      newPrice: 'New price',
      deliveryMethod: 'Delivery Method',
      useDiscountPrice: 'Use discounted price',
      taxes: 'Applied taxes',
      status: 'Status',
      posid: 'POS ID',
      allowUserComments: 'Allow user comments',
      availableInStore: 'Available only in store',
      validFromTo: 'Valid from - to',
      prodType: 'Product Type',
      singleType: 'single',
      groupType: 'group',
      rewardPoints: 'Reward points',
      moneySpent: 'Money to Points',
      numberOfYouNeedToSpend: 'Number of {currency} that the customer needs to spend to get a point.',
      points: 'points',
      soldWith: 'Sold with',
      pickAnOption: 'Pick an option',
      minNoSelected: 'Min no. selected',
      maxNoSelected: 'Max no. selected',
      optVal: 'Value',
      leaveEmpty: 'Leave empty or put 0 if option does not cost extra',
      prodDeleted: 'Product deleted successfully',
      prodAdded: 'Product added successfully',
      prodUpdated: 'Product updated successfully',
      prodPhotoError: 'We could not save the product photo, please try again later.',
      rewardPossibelValue: 'Possible values',
      errorOptions: 'Please make sure that all product fields are filled in correctly.',
      productOptionError: 'Please make sure that all option fields are filled in correctly.',
      minNoNegative: 'Min no. can\'t be less than 0',
      maxNoNegative: 'Max no. can\'t be less than 0',
      minNoTooHigh: 'Min no. can\'t be greater than max no.',
      maxNoTooHigh: 'Max no. can\'t be greater than the values no.',
      optionInUse: 'This option is used by some products. Remove it first from the products that use it.',
      locationSettings: 'Locations Settings',
      availableIn: 'Available in',
      availableInLocation: 'Available in location',
      availableFor: 'Available for',
      availableForSource: 'Available for source',
      groupOption: 'Options group',
      deliveryMethodsandHours: 'Delivery Methods and Hours',
      overrideSettings: 'Override Settings',
      addLocationValidation: 'Some product options are not compatible with the selected locations, if you continue, the options will be removed, if not, the location will not be added.',
      productAvailableIn: 'Product is available in',
      particularLocationSettings: 'Custom settings by location',
      activateParticularSettings: 'Activate custom settings',
      withoutThisOptionDefault: '*without activating this option default settings will be used',
      highlightsProduct: 'Highlights product',
      search: 'Search',
      availability: 'Availability',
      setLimitedAvailability: 'Set limited availability',
      leaveEmptyAvailability: 'Leave empty for unlimited.',
      timeOptions: 'Date Time Options',
      picktimeOptions: 'Pick an option:',
      timeOptionsValues: {
        none: 'None',
        dateTimePicker: 'Date Time Picker',
        dateRangePicker: 'Date Range Picker'
      },
      maxQuantityIn: 'Maxim quantity in',
      unitOfTime: 'unit of time',
      youChoose: 'You choose',
      isUsedFor: '*Is used just for location which is set.',
      isHiddenFromListing: 'Hide from products listing',
      isHiddenFromSearch: 'Hide from products search',
      isHiddenFromQrMenu: 'Hide from Qr menu',
      isHiddenFromPOS: 'Hide from POS',
      isHiddenFromKiosk: 'Hide from Kiosk and Meniu Qr',
      Monday: 'Mon',
      Tuesday: 'Tue',
      Wednesday: 'Wed',
      Thursday: 'Thu',
      Friday: 'Fri',
      Saturday: 'Sat',
      Sunday: 'Sun',
      accesRestricted: 'Sorry, you do not have access to this product',
      disableProductUsedByBanner: 'Disabling this product will disable the related banner. Are you sure?',
      deleteProductUsedByBanner: 'Deleting this product will disable the related banner. Are you sure?',
      availabilityTitle: 'Product availability',
      fromTime: 'From',
      toTime: 'to',
      timePlaceholder: 'Select time',
      productNotAvailable: 'Product unavailable',
      productNotAvailableError: 'Please fill these two fields.',
      swalTitleChangeStatus: 'Please set the product status to "active" first.',
      externalProductId: 'External product ID',
      minQuantity: 'Minimum quantity',
      hideFromPlatforms: 'Hide from platforms',
      changeLocations: 'Change locations',
      includeAllLocationsProducts: 'Include also the products available in all locations',
      bulkLocationsMode: 'Action',
      bulkModeAdd: 'Add',
      bulkModeRemove: 'Remove',
      bulkModeReplace: 'Replace',
      massUpdate: 'Mass update',
      massUpdateSubtitle: 'You are about to update {count} products',
      bulkActionActive: 'Active / Inactive',
      bulkActionPrice: 'Price',
      bulkActionVat: 'VAT',
      bulkActionSection: 'Section',
      bulkActionOptionGroups: 'Option groups',
      bulkActionDelete: 'Delete',
      bulkOverrideDeliveryHint: 'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',
      bulkOverrideLocationsHint: 'Leave empty to use all company locations. Only locations that already belong to each product are applied.',
      bulkOverrideAddIntervalHint: 'Click + to add a schedule interval for this method.',
      bulkPriceDirection: 'Direction',
      bulkPriceIncrease: 'Increase',
      bulkPriceDecrease: 'Decrease',
      bulkPriceMode: 'Type',
      bulkPriceFlat: 'Flat amount',
      bulkPricePercent: 'Percentage (%)',
      bulkPriceAmount: 'Amount',
      bulkPriceBaseOnlyHint: 'Only the base price is changed. The new price will never go below 0.',
      bulkOptionGroupsMode: 'Association mode',
      bulkOptionGroupsModeHint: 'Add keeps existing groups. Replace overwrites them with the selected ones.',
      bulkDeleteWarning: 'This will permanently delete {count} products. This action cannot be undone easily.',
      bulkDeleteEnableLabel: 'Yes, delete the selected products (other mass actions will be ignored)',
      confirmBulkMultiple: 'Apply these changes to {count} {products}:',
      bulkProductSingular: 'product',
      bulkProductPlural: 'products',
      confirmBulkAreYouSure: 'Are you sure?',
      bulkSummaryAddLocations: 'add locations ({value}) to {count} {products}',
      bulkSummaryRemoveLocations: 'remove locations ({value}) from {count} {products}',
      bulkSummarySetActive: 'set {count} {products} as active',
      bulkSummarySetInactive: 'set {count} {products} as inactive',
      bulkSummaryIncreasePriceFlat: 'increase the base price of {count} {products} by {amount} {currency}',
      bulkSummaryIncreasePricePercent: 'increase the base price of {count} {products} by {amount}%',
      bulkSummaryDecreasePriceFlat: 'decrease the base price of {count} {products} by {amount} {currency}',
      bulkSummaryDecreasePricePercent: 'decrease the base price of {count} {products} by {amount}%',
      bulkSummaryAddOptionGroups: 'add option groups ({value}) to {count} {products}',
      bulkSummaryReplaceOptionGroups: 'replace option groups on {count} {products} with ({value})',
      bulkSummarySetVat: 'set VAT {value} on {count} {products}',
      bulkSummarySetSection: 'set section {value} on {count} {products}',
      bulkSummaryEnableOverride: 'enable override settings on {count} {products}',
      bulkSummaryEnableOverrideWithSchedule: 'replace override schedules on {count} {products}',
      bulkSummaryDisableOverride: 'disable override settings on {count} {products}',
      bulkSummaryDelete: 'delete {count} {products}',
      bulkSummaryGeneric: 'update {count} {products}',
      confirmBulkAddLocations: 'Are you sure you want to add locations to {count} products?',
      confirmBulkRemoveLocations: 'Are you sure you want to remove locations from {count} products?',
      confirmBulkSetActive: 'Are you sure you want to set {count} products as active?',
      confirmBulkSetInactive: 'Are you sure you want to set {count} products as inactive?',
      confirmBulkIncreasePriceFlat: 'Are you sure you want to increase the base price of {count} products by {amount}?',
      confirmBulkIncreasePricePercent: 'Are you sure you want to increase the base price of {count} products by {amount}%?',
      confirmBulkDecreasePriceFlat: 'Are you sure you want to decrease the base price of {count} products by {amount}?',
      confirmBulkDecreasePricePercent: 'Are you sure you want to decrease the base price of {count} products by {amount}%?',
      confirmBulkAddOptionGroups: 'Are you sure you want to add option groups to {count} products?',
      confirmBulkReplaceOptionGroups: 'Are you sure you want to replace option groups on {count} products?',
      confirmBulkSetVat: 'Are you sure you want to set VAT on {count} products?',
      confirmBulkSetSection: 'Are you sure you want to set the section on {count} products?',
      confirmBulkDelete: 'Are you sure you want to delete {count} products?',
      confirmBulkGeneric: 'Are you sure you want to update {count} products?',
      bulkLocationsUpdated: 'Updated locations for {updated} products',
      bulkMassUpdated: 'Updated {updated} products',
      couldNotFetchProductOptions: 'Could not fetch product options. Please contact support.'
    },
    vat: {
      selectVat: 'VAT %',
      generalTaxes: 'General Taxes',
      deleteVatSuccess: 'VAT deleted successfully',
      deleteVatError: 'Error occured while deleting VAT'
    },
    magister: {
      syncLabel: 'Magister Menu Sync',
      syncPrices: 'Products Prices Sync',
      syncStocks: 'Stocks Prices Sync',
      magisterStatus: 'Magister Status',
      magisterStatus1: 'Sending',
      magisterStatus2: 'Sent successfully',
      magisterStatus3: 'Couldn\'t send',
      magisterStatus4: 'Order has been cancelled'
    },
    catalogProdRewardsHints: {
      hint1: 'Leave empty to apply default value from settings',
      hint2: 'Put 0 to not apply reward program on this product',
      hint3: 'Add a positive value to override default value from settings'
    },
    catalogCateg: {
      no_discount_allowed: 'Do not accept discounts on this category at the pos!',
      disabledOrderSources: 'Disable the category for sources',
      disabledOrderSourcesHelp: 'The category will not be available on the selected sources.',
      isAgeRestrict: 'Age restricted',
      notification_email: 'E-mail Notification',
      single: 'category',
      plural: 'categories',
      color: 'Color',
      name: 'Name',
      image: 'Image',
      displayType: 'Display Type',
      shortDescription: 'Short Description',
      validFromTo: 'Valid from - to',
      areYouSure: 'Are you sure you want to {label} this category?',
      categAdded: 'Category added successfully',
      categUpdated: 'Category updated successfully',
      categDeleted: 'Category deleted successfully',
      prodDeleted: 'Products deleted successfully',
      couldNotSave: 'We could not save the category photo, please try again later.',
      List: 'List',
      Grid: 'Grid',
      assignTopCategory: 'Assign top category',
      pleaseSelect: 'Please select / Not applicable',
      categoriesWithoutParent: 'Categories without parent',
      topCategory: 'Top Category',
      forceMethod: 'Force delivery method',
      selectMethod: 'Select Methods',
      enableMethod: '(To enable remove top category)',
      vat: 'VAT %',
      vatTitle: 'VAT',
      included: 'included',
      preparation_time_in_minutes: 'Preparation time (minutes)',
      areYouSureDeleteProducts: 'Are you sure you want to delete all products from this category?',
      deleteProducts: 'Delete all product from this category',
      overrideSettingsHelp: 'When enabled, this category only appears in the menu for the selected location, delivery method, day and time window.',
      userLabelings: 'User labelings',
      userLabelingsHelp: 'This category will be visible only for users with one of these labels',
      schedule: 'Schedule',
      useSchedule: 'Use schedule',
      scheduleActive: 'Schedule active',
      scheduleHelp: 'One schedule for this top category across all locations. Outside these hours, ordering from this category is unavailable in the app.',
      secondaryMember: 'secondary'
    },
    catalogProdOpt: {
      addNewOptionValue: 'Add New Option',
      active: 'Option Value Status',
      image: 'Option Image',
      generalInformation: 'General Info',
      settings: 'Settings',
      optionType: 'Option Type',
      info: 'Optional (nutritional) information',
      infoPlaceholder: 'This information will appear under the kiosk/qr option',
      single: 'Option',
      plural: 'options',
      new: 'New Option',
      name: 'Name',
      option_name: 'Option Name',
      label: 'Label (visible only in Inventory panel)',
      type: 'Type',
      show_type: 'Displayed in app',
      show_type_kiosk: 'Displayed on Kiosk/Table',
      vat: 'Cota TVA optiune',
      vatSGR: 'Cota TVA SGR',
      section: 'Option Section',
      value: 'Value',
      values: 'Values',
      posid: 'POS ID 1 (integration)',
      posid2: 'POS ID 2 (integration)',
      variants_id: 'Pos ID Variants (integration)',
      optionSaved: 'Product options saved successfully.',
      areyouSure: 'Are you sure you want to delete this option?',
      optLocationError: '{opt_name} option needs to include {loc_name} for available locations',
      menuQr: 'QR Menu',
      displayInMenu: 'Display in QR menu',
      alsoSaveProduct: 'After changing and saving the options, you must also save the products to which they are applied. Visit the page of',
      sgrName: 'SGR Name',
      sgrPos: 'SGR POS ID',
      sgrPrice: 'SGR Price',
      isModifier: 'Plus/No/Side in POS',
      isProduct: 'Option is a product',
      isProductDesc: 'e.g.: cola, whipped cream, bacon, mushrooms, large, small, etc...',
      isModifier2: 'Option is a modifier',
      isModifierDesc: 'e.g.: hot, cold, well done, etc... (DOES NOT AFFECT INVENTORY)',
      productIdRequired: 'Product ID is required for all values when the option is set as product!'
    },
    marketingSubscriptions: {
      single: 'subscription',
      refundPayment: 'Give the money back',
      reason: 'Reason (required)',
      reasonRequired: 'Write the reason',
      cancelSubscription: 'Cancel the subscription',
      cancelHint: 'The subscription ends now and is not renewed. No money is given back (use the button of each payment for that).',
      cancelAreYouSure: 'Cancel the subscription now?',
      cancelDone: 'The subscription was cancelled',
      downgrade: 'Downgrade',
      downgradeTo: 'Move to the level',
      downgradeHint: 'The customer moves now to a lower level; the next renewal is at that level\'s price. No money is moved.',
      downgradeAreYouSure: 'Move the customer to {name} now?',
      downgradeDone: 'The subscription was moved to the lower level',
      history: 'History of actions',
      noHistory: 'No operator action yet.',
      eventCancel: 'Cancelled',
      eventDowngrade: 'Downgraded',
      eventRefund: 'Money given back',
      payRefunded: 'Refunded',
      refundAndCancel: 'Refund and cancel the subscription',
      refundHint: 'The {amount} of this payment goes back to the customer (reversal if the transaction is not captured yet, refund if it is). The subscription is NOT changed: use Cancel / Downgrade above for that.',
      refundComment: 'Reason (required)',
      refundCommentRequired: 'Write the reason of the refund',
      refundConfirm: 'Confirm refund',
      refundAreYouSure: 'Give {amount} back to the customer? The subscription is not changed.',
      refundDone: 'The payment was given back',
      refundTypeRefund: 'Refund',
      refundTypeReversal: 'Reversal',
      dateFrom: 'From',
      dateTo: 'To',
      renewalCancelledAt: 'Renewal cancelled on',
      customerActiveSubscriptions: 'Active subscriptions',
      customerNoSubscriptions: 'No active subscription',
      until: 'until',
      newCoupon: 'New coupon',
      newCouponTitle: 'New subscription coupon',
      inheritedFromLevel: 'From level {level} - {name}',
      ownCouponsTitle: '+ Coupons of this level',
      inheritedIncluded: 'included from level {level} - {name}',
      details: 'Details',
      name: 'Name',
      price: 'Price',
      description: 'Description (how it works)',
      image: 'Image',
      imageHint: 'jpg / png, max 5MB',
      active: 'Active',
      status: 'Status',
      coupons: 'Coupons',
      couponsHint: 'Only coupons ticked as "Subscription coupon". The customer also gets the coupons of the lower levels.',
      selectedCount: '{count} selected',
      searchCoupons: 'Search coupon by name or code',
      noCoupons: 'There are no subscription coupons yet. Create one with "New coupon".',
      noCouponsFound: 'No coupon matches the search.',
      multipleCodes: 'Multiple codes',
      freeProduct: 'Free product',
      inactive: 'inactive',
      noneAssigned: 'No coupons',
      actions: 'Actions',
      saved: 'The subscription was saved',
      deleted: 'The subscription was deleted',
      areYouSureDelete: 'Are you sure you want to delete the subscription',
      deleteLastLevelWarning: 'It is the only level, so the family is deleted too.',
      nameRequired: 'The name is required',
      priceRequired: 'The price is required (0 or more)',
      noSubscriptions: 'There are no subscriptions yet. Add the first one.',
      levelsCount: '{count} levels',
      oneLevel: '1 level',
      activeSubscribersCount: '{count} active subscribers',
      paymentAccount: 'Payment account',
      editFamily: 'Edit family',
      allSubscribers: 'All subscribers',
      subscribers: 'Subscribers',
      addLevelOnTop: 'Add a level on top of {name}',
      level: 'Level',
      benefits: 'Benefits',
      inheritedCount: '+{count} from lower levels',
      inheritedTitle: 'Inherited from the lower levels',
      lockedDelete: 'It has subscribers (active or awaiting payment), you can only deactivate it.',
      notTopDelete: 'Only the top level of a family can be deleted.',
      inactiveHint: 'Inactive = can no longer be bought. Customers who have it keep it and renew.',
      family: 'Family',
      familyName: 'Family name',
      familyNew: 'New family',
      familyExisting: 'Add to an existing family',
      familyNameHint: 'Defaults to the subscription name',
      selectFamily: 'Choose the family',
      familyRequired: 'Choose the family',
      willBeLevel: 'It will be level {level}, on top of {name} ({price})',
      levelOf: 'Level {level} of the family {family}',
      priceHintBelow: 'Level below: {name} - {price}. Upgrade difference: {diff}',
      priceHintAbove: 'Level above: {name} - {price}',
      priceTooLow: 'The price must be higher than the level below ({price})',
      priceTooHigh: 'The price must be lower than the level above ({price})',
      inheritedCoupons: 'Inherited benefits',
      noInherited: 'No inherited benefits (base level).',
      paymentProcessor: 'Payment processor',
      paymentRequired: 'Choose the payment processor',
      noPaymentAccounts: 'There is no euPlatesc payment processor on the company. Add one in Settings > Payments.',
      paymentLockedHint: 'The payment processor can\'t change while the family has active subscribers.',
      familySaved: 'The family was saved',
      familyNameRequired: 'The family name is required',
      subscribersTitle: 'Subscribers',
      stateAll: 'All',
      stateActive: 'Active',
      stateExpiring: 'Expiring in 5 days',
      stateUnpaid: 'Unpaid',
      stateExpired: 'Expired',
      stateCancelled: 'Cancelled',
      statePending: 'Awaiting first payment',
      stateAbandoned: 'Abandoned (never paid)',
      customer: 'Customer',
      activeFrom: 'Active from',
      activeUntil: 'Active until',
      activeUntilRange: 'Active until (interval)',
      autoRenew: 'Auto renew',
      autoRenewAll: 'Auto renew: all',
      yes: 'Yes',
      no: 'No',
      totalPaid: 'Total paid',
      lastPayment: 'Last payment',
      searchSubscribers: 'Search by name, email or phone',
      allLevels: 'All levels',
      noSubscribers: 'No subscribers for the selected filters.',
      backToList: 'Back to the list',
      periods: 'Periods',
      kindFirst: 'First payment',
      kindRenewal: 'Renewal',
      kindUpgrade: 'Upgrade',
      periodPaid: 'Paid',
      periodUnpaid: 'Unpaid',
      periodCancelled: 'Cancelled',
      paymentAttempts: 'Payment attempts',
      methodLink: 'Payment link',
      methodSavedCard: 'Saved card',
      payCreated: 'Created',
      payPending: 'Pending',
      paySuccess: 'Successful',
      payFailed: 'Failed',
      payExpired: 'Expired',
      payCancelled: 'Cancelled',
      showLogs: 'Processor logs',
      request: 'Request',
      response: 'Response',
      noPeriods: 'No periods yet.',
      noPayments: 'No payment attempts.',
      card: 'Card',
      currentLevel: 'Current level',
      renewalPrice: 'Renewal price',
      subscriberSince: 'Subscriber since',
      autoChargeAttempts: 'Automatic charge attempts',
      notifiedAt: 'Expiry notification sent'
    },
    marketingAutomation: {
      single: 'automatic campaign',
      details: 'Automatic campaign details',
      name: 'Name',
      type: 'Campaign type',
      period: 'Running period',
      active: 'Active',
      status: 'Status',
      notifications: 'Notifications',
      coupons: 'Coupons',
      state_running: 'Running',
      state_scheduled: 'Scheduled',
      state_ended: 'Ended',
      typeBirthday: 'Birthday',
      typeGeofencing: 'Geofencing (in range)',
      typeAbandonedCart: 'Forgotten items in the cart',
      typeProductViews: 'Product viewed several times',
      comingSoon: 'coming soon',
      typeLocked: 'The type can not be changed after the campaign is created.',
      birthdayRule: 'The coupons are applied automatically only on the customer\'s birthday, once per year. A customer who already benefited this year is not notified again.',
      announceTitleBox: 'Announcement before the birthday',
      announceDaysBefore: 'Send it',
      daysBeforeBirthday: 'days before the birthday',
      announceOffHint: 'No announcement: the customer gets only the notification on the day.',
      announceDaysBeforeShort: 'Announcement {days} days before',
      announceDaysInvalid: 'Between 1 and {max} days.',
      dayTitleBox: 'Notification on the birthday',
      onTheDayShort: 'On the birthday',
      sentAt: 'sent at {time}',
      endsIn: 'ends in {days} days',
      endsToday: 'ends today',
      startsIn: 'starts in {days} days',
      pushTitle: 'Notification title',
      pushMessage: 'Notification text',
      sendTime: 'Sending hour',
      sendTimeHint: 'The notifications are sent at this hour (company timezone).',
      preview: 'Preview',
      placeholdersHint: 'You can use in the text (click to add):',
      clickToInsert: 'Click to add it to the text',
      placeholderName: 'customer first name',
      placeholderDays: 'days left until the birthday',
      placeholderCode: 'the coupon code (informative)',
      codeNeedsCoupon: 'available after you select a coupon (below)',
      codeNotInNoCoupon: 'not used in the notification without coupon',
      codeWithoutCoupon: 'The campaign has no coupon: {cod} is sent empty (the text goes out without a code).',
      exampleAnnounceNoCouponTitle: 'Your birthday is coming! Only {zile} days left 🎉',
      exampleAnnounceNoCouponMessage: 'Hi {nume}! We are happy to be part of this special moment. Come with your friends or order from the app and let\'s celebrate together!',
      exampleDayNoCouponTitle: 'Happy birthday, {nume}! 🎂',
      exampleDayNoCouponMessage: 'We wish you a wonderful day, full of joy and dear people around you. We are waiting for you to celebrate together!',
      optional: 'optional',
      cartRule: 'Only app carts of logged customers, created after the campaign and less than 5 days old, not empty. Notification 1 comes X minutes after the last cart change (with the coupon, valid 24h, once, on any order). Notification 2 only if notification 1 was sent and the cart did not change since. Max 2 notifications per cart; a new cart = new notifications.',
      cartFirstBox: 'Notification 1',
      variantWithCoupon: 'with coupon',
      variantNoCampaignCoupon: 'reminder (the campaign has no coupon)',
      variantNoCoupon: 'without coupon',
      noCouponNeedsCoupon: 'available after you select a coupon (below); without coupons everybody gets the notification above',
      cartFirstDelay: 'Send it',
      minutesAfterChange: 'minutes after the last cart change',
      cartNoCouponBox: 'Notification 1 without coupon',
      cartNoCouponHint: 'Goes instead of the one above to the customers who get no coupon this time (they already got one in the last X days - see "Coupon recurrence" - or the coupon is no longer valid). Do not promise a discount here.',
      cartSecondBox: 'Notification 2',
      cartSecondDelay: 'Send it',
      minutesAfterFirst: 'minutes after notification 1',
      cartSecondHint: 'Only if notification 1 was sent and the customer did not change the cart since. It also goes to the customers without coupon, so keep it general (or use {cod}, empty for them).',
      cartSecondOffHint: 'Only notification 1 is sent.',
      quietBox: 'Quiet hours (no notifications at night)',
      quietFrom: 'from',
      quietTo: 'to',
      quietHint: 'A notification due in this interval is sent when it ends (company timezone). Notification 2 counts from the moment notification 1 was really sent.',
      quietOffHint: 'Notifications are sent at any hour.',
      cooldownBox: 'Coupon recurrence',
      cooldownLabel: 'The coupon again only after',
      cooldownNeedsCoupon: 'available after you select a coupon (above)',
      cooldownDays: 'days (0 = with every forgotten cart)',
      cooldownHint: 'After a customer got a cart coupon, the next forgotten carts in this interval get only the reminder (the text without coupon).',
      cartFirstWhen: '{time} after the last change',
      cartSecondWhen: '{time} after notification 1',
      unitDay: 'd',
      delayInvalid: 'Between {min} and {max} minutes.',
      cooldownInvalid: 'Between 0 and {max} days.',
      quietInvalid: 'The start and the end of the quiet hours must be different.',
      exampleCartFirstTitle: '{nume}, you forgot something in your cart 🛒',
      exampleCartFirstMessage: 'Your products are waiting for you! Finish the order in the next 24 hours and get 10% off with the code {cod} - it is applied automatically.',
      exampleCartNoCouponTitle: '{nume}, your cart is waiting for you 🛒',
      exampleCartNoCouponMessage: 'The products you picked are still in your cart. Finish the order in a few seconds, from the app.',
      exampleCartSecondTitle: 'Last chance, {nume}!',
      exampleCartSecondMessage: 'Your cart is still here. Do not miss what you picked - order now from the app.',
      statusAllSent: 'Notified',
      status_notified: 'Reminder only',
      status_converted: 'Cart ordered',
      cartStatusGranted: 'Coupon active',
      cartStatusUsed: 'Used the coupon',
      validUntil: 'until {time}',
      cart: 'Cart',
      cartPush1Short: 'Notif. 1',
      cartPush2Short: 'Notif. 2',
      cartPlaced: 'ordered',
      beneficiaries: 'Beneficiaries',
      beneficiariesTitle: 'Beneficiaries',
      viewBeneficiaries: 'See the list',
      statusAll: 'All',
      status_granted: 'Granted',
      status_used: 'Benefited',
      status_expired: 'Expired (not used)',
      customer: 'Customer',
      birthday: 'Birthday',
      yearLabel: 'year {year}',
      order: 'Order',
      searchCustomer: 'Search name, phone, email...',
      allYears: 'All years',
      noBeneficiaries: 'Nobody yet.',
      announcePushShort: 'Announcement',
      dayPushShort: 'On the day',
      pushNotSent: 'not sent',
      push_sent: 'sent',
      push_nodevice: 'no notifications',
      push_failed: 'failed',
      useExample: 'Use the example',
      useExampleConfirm: 'Replace the current title and text with the example?',
      previewExampleNote: 'Empty fields: the preview shows the example text.',
      codeMissing: 'The text uses {cod}, but none of the selected coupons has a code.',
      exampleAnnounceTitle: 'Your birthday is coming! Only {zile} days left 🎉',
      exampleAnnounceMessage: 'Hi {nume}! We are happy to be part of this special moment, so on your birthday you get 20% off an order of at least 100 lei with the code {cod}. Come with your friends or order from the app and let\'s celebrate together!',
      exampleDayTitle: 'Happy birthday, {nume}! 🎂',
      exampleDayMessage: 'Today is your day and our gift is waiting: 20% off all dishes on an order of at least 100 lei. Your code {cod} is applied automatically. Enjoy it now!',
      couponsHint: 'Optional: without coupon the campaign sends only the notifications. Only the coupons ticked "Used in automatic marketing" are listed; the customer gets all the selected coupons.',
      selectedCount: '{count} selected',
      newCoupon: 'New coupon',
      newCouponTitle: 'New automatic marketing coupon',
      noCoupons: 'There is no coupon used in automatic marketing yet. Create one with "New coupon".',
      searchCoupons: 'Search coupon...',
      noCouponsFound: 'No coupon found.',
      couponsRequired: 'Select at least one coupon.',
      couponInactive: 'Inactive coupon',
      inactive: 'inactive',
      expired: 'expired',
      saved: 'The campaign was saved.',
      deleted: 'The campaign was deleted.',
      areYouSureDelete: 'Are you sure you want to delete the campaign {name}?'
    },
    marketingCoupons: {
      single: 'coupon',
      isAutomation: 'Used in automatic marketing',
      isAutomationHint: 'The coupon is not applied to everybody and its code can not be typed in: it is applied automatically only to the customers an automatic campaign gives it to (e.g. on their birthday).',
      automationCampaigns: 'Automatic campaigns',
      automationLockedUsed: 'Given by automatic campaigns: remove it from them first.',
      automationLockedCampaign: 'Announced by push campaigns: it can not be used in automatic marketing.',
      automationInfoCode: 'Automatic marketing coupon: the code is only informative (it can be shown in the notifications with {cod}). It can not be typed in anywhere: the discount is applied automatically to the customers who meet the campaign conditions.',
      automationCodeLabel: 'Informative code (optional)',
      automationCodePlaceholder: 'e.g. BIRTHDAY20',
      automationBadge: 'Automatic',
      subscriptionAutomationExclusive: 'A coupon can not be both a subscription and an automatic marketing coupon.',
      isSubscription: 'Subscription coupon',
      isSubscriptionHint: 'Applies only to customers with an active subscription that includes it: no code, never applied automatically, no usage limits.',
      subscriptionBadge: 'Subscription',
      subscriptionLevels: 'Given by the subscriptions',
      subscriptionLockedUsed: 'Subscriptions give this coupon: remove it from them before unticking.',
      subscriptionLockedCampaign: 'Push campaigns announce this coupon, so it can not become a subscription coupon.',
      subscriptionNoCode: 'A subscription coupon has no code: it applies only to customers with an active subscription.',
      name: 'Name',
      code: 'Code',
      multipleCodes: 'Multiple codes',
      discount: 'Discount',
      freeProduct: 'Free product',
      validFromTo: 'Valid from - to',
      daysLeft: 'Days left',
      status: 'Status',
      active: 'Active',
      pushCampaigns: 'Push campaigns',
      notAssigned: 'Not assigned',
      couponDetails: 'Coupon details',
      couponSaved: 'The coupon was saved.',
      couponDeleted: 'The coupon was deleted.',
      areYouSureDelete: 'Are you sure you want to delete the coupon',
      deleteAssignedWarning: 'This coupon is announced by the push campaigns: {campaigns}. They will remain without a coupon.',
      selectCoupon: 'Coupon announced by this campaign',
      selectCouponHelp: 'The discount is applied by the coupon (its own validity and conditions). The campaign only announces it. Coupons are managed in the Coupons tab.',
      noCoupon: 'No coupon',
      couponInactive: 'The selected coupon is inactive.',
      couponOutsideCampaign: 'The campaign period is outside the coupon validity.',
      deleteCampaignCouponQuestion: 'This campaign announces the coupon {coupon}. The coupon is not deleted together with the campaign. What do you want to do with it?',
      keepCouponActive: 'Keep the coupon as it is',
      deactivateCoupon: 'Deactivate the coupon',
      export: 'Export',
      openQr: 'Open the QR image',
      qrLink: 'QR image link',
      used: 'Used',
      sources: 'Order sources',
      allSources: 'All',
      noCategories: 'No categories / products',
      generatorTitle: 'Generate codes',
      generatorCount: 'Number of codes (max 1000)',
      generatorLength: 'Length of the random part',
      generatorCharset: 'Characters',
      generatorCharsetAlnum: 'Letters + digits (without 0/O, 1/I/L)',
      generatorCharsetLetters: 'Letters only',
      generatorCharsetDigits: 'Digits only',
      generatorPrefix: 'Prefix (in front)',
      generatorSuffix: 'Suffix (at the end)',
      generatorGroup: 'Group with "-"',
      generatorGroupNone: 'No grouping',
      generatorExample: 'Example',
      generate: 'Generate',
      generatedCodes: '{count} codes were generated. Save the coupon to keep them.',
      deleteAllCodes: 'Delete all',
      deleteAllCodesConfirm: 'Delete all {count} codes? Saved codes are removed when you save the coupon.',
      codeStatus_available: 'Available',
      codeStatus_used: 'Used',
      codeStatus_new: 'New (not saved)'
    },
    marketingCampaigns: {
      intern: 'Intern',
      extern: 'Extern',
      url: 'URL',
      category: 'Category',
      product: 'Product',
      single: 'campaign',
      plural: 'campaigns',
      name: 'Name',
      nameHelper: 'This name will be used as a subject for the e-mail notifications sent for this campaign.',
      image: 'Image',
      startEnd: 'Start - End Date',
      daysLeft: 'Days Left',
      timesUsed: 'Times used',
      status: 'Status',
      actions: 'Actions',
      send: 'Send',
      stopSending: 'Stop sending',
      campaignStoppedSuccessfuly: 'Sending the campaign has been stopped',
      areYouSureCancelSending: 'Are you sure you want to cancel sending',
      notBeingSending: 'is not being sent',
      cannotDelete: 'Campaign cannot be deleted while being sent',
      cannotModify: 'Campaign cannot be modified while being sent',
      off: 'from',
      sentData: 'Submission data',
      sent: 'Total sent',
      notif_sent: 'Notification',
      email_sent: 'E-mail',
      areYouSureNotif: 'Are you sure you want to send out the notifications?',
      notifSent: 'Notifications have been queued and are about to be sent!',
      campaignDeleted: 'Campaign deleted successfully.',
      areYouSureDelete: 'Are you sure you want to delete ',
      campaignAdded: 'Campaign added successfully',
      campaignUpdated: 'Campaign updated successfully',
      campaignPhotoError: 'We could not save the campaign photo, please try again later.',
      campaignDetails: 'Campaign Details',
      description: 'Notification text',
      maxDescription: '(max. 400 characters)',
      characters: 'characters',
      validFromTo: 'Valid from - to',
      notif: 'Notifications',
      mode: 'Mode',
      setHours: 'Set Hours',
      selectTime: 'Select time',
      chooseTarget: 'Choose target audience',
      gender: 'Gender',
      age: 'Age',
      donation_points: 'Donation points',
      city: 'City',
      locations: 'Locations',
      visibleInLocations: 'Visible in the following locations',
      visibleInLocationsInfo: 'This functionality is available only on Application',
      ordersAbove: 'Orders above',
      ordersBelow: 'Orders below',
      ordersAboveNr: 'Nr of orders above',
      ordersBelowNr: 'Nr of Orders below',
      addCoupon: 'Add Coupon',
      applyTo: 'Apply to',
      value: 'Value',
      code: 'Code',
      addValue: 'Add Value',
      minValue: 'Minimum amount',
      counter_max_usage: 'How many times a person can use this coupon?',
      counter_max_usage_total: 'How many times can this coupon be used in total?',
      counter_max_usage_example: 'Type in a number for the max number of usages per person. Type 0 for unlimited.',
      counter_max_usage_total_example: 'Type in a number for the max number of usage. Type 0 for unlimited.',
      generateCode: 'Generate Code',
      Products: 'Products',
      Shipping: 'Shipping',
      Tax: 'Taxes',
      chooseCategProduct: 'Choose categories or products on which the coupon will apply:',
      delivery_methods: 'On which delivery methods should the coupon be applied?',
      order_source_ids: 'Order sources',
      order_source_ids_all: 'All sources',
      order_source_ids_help: 'Leave empty to apply on all order sources.',
      location_ids: 'On which location should the coupon be applied?',
      sendNotificationTo: 'Send notification to',
      chooseDayForInterval: 'Choose day for interval',
      chooseHoursForInterval: 'Choose hours for interval',
      useInterval: 'Use interval',
      isCumulativeCheck: 'This coupon applies cumulatively',
      isAutoApplyCheck: 'This coupon applies directly',
      doesApplyOnPromotionalItems: 'This coupon applies only on promotional products',
      intervalMustBeSet: 'Interval must be set',
      campaignWasSent: 'Campaign was sent in last 30 min',
      isSecondUseCheck: 'This coupon applies directly after first use',
      couponHasMultipleCodes: 'Use multiple coupons codes',
      withOrdersLabel: 'With/out Orders',
      withOrders: 'with orders',
      withoutOrders: 'without orders',
      withLoyaltyPointsLabel: 'With/out Loyalty Points',
      withLoyaltyPointsAll: 'All',
      withLoyaltyPoints: 'with loyalty points',
      withoutLoyaltyPoints: 'without loyalty points',
      loyaltyPointsColumn: 'Loyalty Points',
      groups: 'Client Groups',
      exclude_groups: 'Excluding Client Groups',
      chooseImage: 'Choose an image',
      template: 'Template',
      useEmailTemplate: 'Use this text for both push notification AND email',
      productTreeError: 'Check at least one product',
      checkAll: 'Check all',
      freeProduct: 'Free product to add to cart',
      freeProductPlaceholder: 'Type the product name to search...',
      freeProductRequired: 'Please select a free product',
      freeProductSelectTypeHint: 'Select the "Free product" coupon type above to choose which product is added to the cart.',
      freeProductHelp: 'This is the product automatically added to the customer\'s cart. The list on the right defines which products/categories qualify for the coupon.',
      freeProductSearchHint: 'Start typing the product name to find and select it.',
      minOrderValue: 'Minimum order subtotal',
      minOrderValuePlaceholder: '0 = no minimum',
      minOrderValueHelp: 'Free product is applied only when order subtotal (products + extras) is at least this amount. Leave empty or 0 for no minimum.',
      registeredAfter: 'Registered after',
      period: 'From date - to date',
      location: 'Location',
      open: 'Open'
    },
    loyaltyStore: {
      campaignName: 'Campaign name',
      description: 'Description',
      generalSettings: 'General settings',
      active: 'Active',
      availability: 'Availability',
      locations: 'Locations',
      locationsInfo: 'Leave empty for all locations',
      rewards: 'Rewards',
      rewardsCount: 'Rewards',
      addReward: 'Add reward',
      editReward: 'Edit reward',
      reward: 'Reward',
      rewardType: 'Type',
      typeProduct: 'Product',
      typeGiftCard: 'Gift card',
      product: 'Product',
      category: 'Category',
      searchCategory: 'Search category',
      searchProduct: 'Search product',
      giftCardValue: 'Gift card value',
      pointsCost: 'Loyalty points cost',
      deleteConfirmation: 'Are you sure you want to delete?',
      rewardsSaveFailed: 'The campaign was saved, but some rewards could not be saved. Your remaining rewards are still here. Click Save to retry.',
      nameRequired: 'Campaign name is required',
      pointsCostRequired: 'Loyalty points cost is required',
      productRequired: 'Product is required',
      giftValueRequired: 'Gift card value is required',
      giftCardsModuleRequired: 'Enable marketing gift cards on the company to use gift card rewards.',
      timesSold: 'Times sold',
      totalPointsSpent: 'Total points spent',
      totalGiftValue: 'Gift value issued',
      purchases: 'Purchases',
      user: 'User',
      orderId: 'Order ID',
      giftCardId: 'Gift card ID',
      datetime: 'Date & time',
      campaign: 'Campaign'
    },
    donationCampaigns: {
      single: 'donation campaign',
      plural: 'donation campaigns',
      id: 'ID',
      search: 'Search',
      name: 'Name',
      beneficiary: 'Beneficiary',
      description: 'Description',
      image: 'Image',
      startEnd: 'Start - End Date',
      daysLeft: 'Days Left',
      targetAmount: 'Target Amount',
      suggestedAmount: 'Suggested Amount',
      collectedAmount: 'Collected Amount',
      progress: 'Progress',
      donorsCount: 'Donors',
      donationsCount: 'Donations',
      details: 'Donation Campaign Details',
      stats: 'Statistics',
      active: 'Active',
      location: 'Locations',
      locationInfo: 'Leave empty to make available in all locations',
      allCampaigns: 'All Campaigns',
      areYouSureDelete: 'Are you sure you want to delete',
      campaignDeleted: 'Donation campaign deleted successfully.',
      campaignAdded: 'Donation campaign added successfully.',
      campaignUpdated: 'Donation campaign updated successfully.',
      removeCurrentImage: 'Please remove the current image before adding a new one',
      fundingMode: 'Funding Mode',
      fundingModeClientOptional: 'Customer chooses donation at checkout',
      fundingModeRestaurantFlat: 'Restaurant pays a fixed amount per order',
      fundingModeRestaurantPercent: 'Restaurant pays % of order subtotal',
      restaurantFlatAmount: 'Amount per order',
      restaurantPercent: 'Percentage of order subtotal (0–100)',
      allLocations: 'All locations',
      onlyOneActivePerLocation: 'There can be only 1 active donation campaign per location.',
      fiscalizationInfoPrefix: 'To configure how donations are fiscalized, open ',
      fiscalizationInfoLink: 'Locations,',
      fiscalizationInfoSuffix: ' edit a location, go to Other Settings → Pos Settings, and set "{field}".',
      activeCampaignExistsTitle: 'Campaign saved',
      activeCampaignExistsMessage: 'The campaign was saved successfully, but there is another active campaign ({name}). Do you want to activate this one instead?',
      activeCampaignExistsActivateMessage: 'There is another active campaign ({name}). Do you want to activate this one instead?',
      activeCampaignExistsWarning: 'Warning: this means the other campaign will not be visible for users!'
    },
    raffleCampaigns: {
      single: 'raffle campaign',
      plural: 'raffle campaigns',
      id: 'ID',
      name: 'Name',
      search: 'Search',
      searchParticipants: 'Search email or name',
      userId: 'User ID',
      description: 'Description',
      winnersDescription: 'Winners list',
      winnersPlaceholder: 'Use this field to let users know who won the raffle',
      image: 'Image',
      startEnd: 'Start - End',
      details: 'Raffle Campaign Details',
      active: 'Active',
      type: 'Type',
      typeOrderCount: 'Raffle',
      typeOrderTotal: 'Hero',
      typeOrderCountHint: 'Based on number of orders. A random winner is picked with a third-party tool.',
      typeOrderTotalHint: 'The winner is determined by the amount spent in the app.',
      typeLocked: 'Type cannot be changed after creation.',
      typeRequired: 'Type is required.',
      minOrderValue: 'Minimum order value',
      pdf: 'PDF',
      periodRequired: 'Start and end dates are required.',
      areYouSureDelete: 'Are you sure you want to delete',
      campaignDeleted: 'Raffle campaign deleted successfully.',
      campaignAdded: 'Raffle campaign added successfully.',
      campaignUpdated: 'Raffle campaign updated successfully.',
      removeCurrentImage: 'Please remove the current image before adding a new one',
      removeCurrentPdf: 'Please remove the current PDF before adding a new one',
      usersJoined: 'Users joined',
      ordersCount: 'Orders count',
      ordersTotal: 'Orders total',
      participants: 'Participants',
      exportEntries: 'Export entries',
      joinedAt: 'Joined at',
      score: 'Score',
      orderNumber: 'Order number',
      orderCreatedAt: 'Order created at',
      registeredAt: 'Registered at'
    },
    challengeCampaigns: {
      single: 'challenge',
      plural: 'challenges',
      id: 'ID',
      search: 'Search',
      searchByTitle: 'Search by title',
      title: 'Title',
      titlePlaceholder: 'e.g. Early Bird',
      description: 'Description',
      descriptionPlaceholder: 'e.g. Order 5 coffees before 9 AM',
      image: 'Image',
      details: 'Challenge Details',
      target: 'Target',
      minOrderValue: 'Minimum order value',
      periodOfTimeDays: 'Membership period (days)',
      periodOfTimeDaysHint: 'e.g. 365 = client for 1 year from first order',
      distinctOrder: 'Distinct order',
      distinctOrderHint: 'When enabled, each qualifying order counts as 1 step regardless of product quantity.',
      timePeriod: 'Challenge period',
      orderTimeFrom: 'Order time from',
      orderTimeTo: 'Order time to',
      conditions: 'Conditions (AND)',
      conditionsAndInfo: 'Configured conditions are combined with AND. Leave a condition empty to ignore it.',
      deliveredOnlyInfo: 'Only orders in Delivered status count toward progress.',
      goalGroup: 'Goal',
      orderFiltersGroup: 'Order filters',
      scheduleGroup: 'Schedule',
      catalogGroup: 'Products & categories',
      locations: 'Locations',
      deliveryMethods: 'Delivery methods',
      sources: 'Order sources',
      days: 'Days of week',
      products: 'Products',
      categories: 'Categories',
      leaveEmptyAll: 'Leave empty for all',
      daySun: 'Sunday',
      dayMon: 'Monday',
      dayTue: 'Tuesday',
      dayWed: 'Wednesday',
      dayThu: 'Thursday',
      dayFri: 'Friday',
      daySat: 'Saturday',
      summaryMembership: 'User must be a client for at least {days} days (target {target}).',
      summaryOrders: 'Complete {target} orders.',
      summaryProductQty: 'Reach a total quantity of {target} from the selected products/categories.',
      summaryMinOrder: 'Only orders with a minimum value of {amount} {currency}.',
      summaryLocations: 'Only at: {list}.',
      summaryDelivery: 'Only delivery methods: {list}.',
      summarySources: 'Only order sources: {list}.',
      summaryDays: 'Only on: {list}.',
      summaryOrderTime: 'Only between {from} and {to}.',
      summaryPeriod: 'Challenge available from {from} to {to}.',
      summaryProducts: 'Products: {list}.',
      summaryCategories: 'Categories: {list}.',
      summaryWithinDays: 'Progress must be completed within {days} days.',
      areYouSureDelete: 'Are you sure you want to delete',
      campaignDeleted: 'Challenge deleted successfully.',
      campaignAdded: 'Challenge added successfully.',
      campaignUpdated: 'Challenge updated successfully.',
      removeCurrentImage: 'Please remove the current image before adding a new one',
      dateFrom: 'Date from',
      dateTo: 'Date to',
      reportDateHint: 'Completion stats use completion date. In-progress stats use last progress date.',
      completedUsers: 'Completed',
      inProgressUsers: 'In progress',
      startedUsers: 'Started',
      completionRate: 'Completion rate',
      allUsers: 'All',
      status_COMPLETED: 'Completed',
      status_IN_PROGRESS: 'In progress',
      status_NOT_STARTED: 'Not started',
      user: 'User',
      progress: 'Progress',
      startedAt: 'First progress',
      lastProgressAt: 'Last progress',
      completedAt: 'Completed at',
      userProgress: 'User progress',
      dateTime: 'Date / time',
      orderId: 'Order ID',
      progressGenerated: 'Progress'
    },

    spinningWheel: {
      confirmDelete: 'Are you sure you want to delete this record?',
      percentageOverflow: 'Active reward probabilities cannot exceed 100%. The change was not saved.',
      campaignTitle: 'Campaign title',
      description: 'Description',
      availability: 'Availability',
      minOrderValue: 'Minimum order value',
      locations: 'Locations',
      locationsInfo: 'Leave empty to apply to all locations.',
      rewardsCount: 'Rewards',
      percentages: 'Winning % total',
      active: 'Active',
      generalSettings: 'General settings',
      activeRequires100: 'Campaign can be activated only when active rewards total exactly 100%.',
      mustTotal100: 'must total 100%',
      rewards: 'Rewards',
      addReward: 'Add reward',
      editReward: 'Edit reward',
      reward: 'Reward',
      rewardType: 'Reward type',
      winningPercentage: 'Winning %',
      displayTitle: 'Display title',
      displayDescription: 'Display description',
      loyaltyPoints: 'Loyalty points',
      couponType: 'Discount type',
      couponAppliesTo: 'Coupon applies to',
      couponProducts: 'Products',
      couponDelivery: 'Delivery',
      couponTaxes: 'Taxes',
      couponPercentage: 'Percentage',
      couponFixed: 'Fixed amount',
      discount: 'Discount',
      product: 'Product',
      searchProduct: 'Search product',
      sortOrder: 'Display order',
      sortOrderHelp: 'This controls the display order on the wheel, not the order of winning. Each prize is selected randomly according to its winning probability.',
      freeProductCouponHelp: 'This free product is the prize won on the spinning wheel. No additional categories or products need to be selected.',
      actions: 'Actions',
      openCampaign: 'Open Campaign',
      duplicate: 'Duplicate',
      datesRequired: 'Availability from and to dates are required.',
      autoGenerateNotice: 'A campaign and coupon will be automatically created for this reward. You can modify the generated campaign and configure notifications later.',
      typeNothing: 'Nothing',
      typeLoyaltyPoints: 'Loyalty points',
      typeDiscountCoupon: 'Discount coupon',
      typeFreeProduct: 'Free product coupon',
      titleRequired: 'Campaign title is required.',
      percentageRequired: 'Winning percentage must be greater than 0.',
      loyaltyPointsRequired: 'Loyalty points are required.',
      discountRequired: 'Discount is required.',
      productRequired: 'Product is required.',
      spins: 'Spins',
      usersWhoSpun: 'Users who spun',
      rewardsWon: 'Rewards won',
      rewardsRedeemed: 'Rewards redeemed',
      redemptionRate: 'Redemption rate',
      wins: 'Wins',
      usersWhoWon: 'Users who won',
      redeemed: 'Redeemed',
      remaining: 'Remaining',
      users: 'Users',
      user: 'User',
      used: 'Used',
      available: 'Available',
      spinId: 'Spin ID',
      dateWon: 'Date won',
      status: 'Status',
      dateRedeemed: 'Date redeemed',
      qualifyingOrder: 'Qualifying order'
    },

    discountCampaigns: {
      single: 'discount campaign',
      plural: 'discount campaigns',
      id: 'ID',
      search: 'Search',
      name: 'Name',
      description: 'Description',
      image: 'Image',
      details: 'Discount Campaign Details',
      startEnd: 'Start - End',
      active: 'Active',
      discount: 'Discount',
      discountType: 'Discount type',
      discountType_flat: 'Flat amount',
      discountType_percent: 'Percent',
      priceProfile: 'Price profile',
      source: 'Channel',
      sourceMethodCombos: 'Channels / methods',
      productStandardPrice: 'Product (standard price)',
      pageInfo: 'Page {page} of {total} ({count} products)',
      topCategory: 'Top category',
      topCategories: 'Top categories',
      categories: 'Categories',
      numberOfUnits: 'Units cap',
      numberOfUnitsPlaceholder: 'Leave empty for unlimited',
      numberOfUnitsHint: 'Maximum discounted units. How the limit is shared is controlled by the settings below.',
      unitsSoldScope: 'Unit limit by channel',
      unitsSoldScope_perLine: 'Per line (source + method)',
      unitsSoldScope_perSource: 'Per source (methods share)',
      unitsSoldScopeHint: 'Per line: Eat-in and Takeout each have their own cap. Per source: all methods under the same channel share one cap.',
      unitsSoldPool: 'Unit limit by product',
      unitsSoldPool_perProduct: 'Per product',
      unitsSoldPool_absolute: 'Absolute (all products share)',
      unitsSoldPoolHint: 'Per product: each product has its own cap. Absolute: all products in the campaign share the same cap.',
      useIntervals: 'Limit to time windows',
      useIntervalsHint: 'When off, the campaign is active all day within the date range.',
      intervalDay: 'Day',
      addInterval: 'Add time window',
      intervalOverlap: 'Time windows overlap or one includes another. Use different days/times, or remove the redundant window.',
      intervalInvalidRange: 'Enter valid, different start and end times. An earlier end time means the window ends the following day.',
      previewTitle: 'Affected products',
      previewCount: '{count} products match',
      searchProduct: 'Search by product name',
      searchProductId: 'Product ID',
      product: 'Product',
      pricingType: 'Pricing',
      pricingProfile: 'Profile',
      pricingCatalog: 'Catalog',
      method: 'Method',
      originalPrice: 'Original price',
      discountAmount: 'Discount',
      discountedPrice: 'Discounted price',
      cap: 'Cap',
      unitsSold: 'Units sold',
      productsCount: 'Products',
      regenerateWarning: 'Product lines will be regenerated. Continue?',
      areYouSureDelete: 'Are you sure you want to delete',
      campaignDeleted: 'Discount campaign deleted successfully.',
      campaignAdded: 'Discount campaign added successfully.',
      campaignUpdated: 'Discount campaign updated successfully.',
      removeCurrentImage: 'Please remove the current image before adding a new one',
      products: 'Products',
      productsIncluded: 'Included products',
      createCampaign: 'Create campaign',
      campaignButton: 'Discount campaign',
      applyDiscount: 'Apply discount',
      clearSelection: 'Clear selection',
      selectionSummary: '{cells} cells selected · {products} products',
      selectForCampaign: 'Select for campaign',
      noPriceConfigured: 'No price configured',
      viewEditDiscount: 'View / edit discount',
      discShort: 'Disc.',
      newCampaignModal: 'New discount campaign',
      newCampaignSubtitle: 'Price list: {name} · {cells} cells selected',
      priceProfileLocked: 'Locked to current price profile',
      period: 'Period',
      listPrice: 'List price',
      invalidDiscount: 'Invalid discount',
      discountExceedsPrice: 'Discount cannot exceed list price',
      confirmDeleteLine: 'Remove this discount and the product from the campaign?'
    },
    donationReport: {
      campaign: 'Campaign',
      client: 'Client',
      amount: 'Amount',
      date: 'Date',
      totalAmount: 'Total Amount',
      totalDonations: 'Total Donations',
      totalDonors: 'Total Donors',
      campaignOrders: 'Orders'
    },
    marketingOffers: {
      single: 'offer banner',
      plural: 'offer banners',
      title: 'Title',
      status: 'Status',
      image: 'Image',
      imageWeb: 'Web Image',
      imageBanner: 'Imagine Banner',
      imageLanding: 'Imagine Landing',
      linkType: 'Link Type',
      startEndDate: 'Start - End Date',
      actions: 'Actions',
      offerAdded: 'Offer banner added successfully.',
      offerUpdated: 'Offer banner updated successfully.',
      offerDeleted: 'Offer banner deleted successfully.',
      weCouldNot: 'We could not save the slider photo, please try again later.',
      validImg: 'Please add a valid image.',
      areYouSure: 'Are you sure you want to {label} this offer banner?',
      pageText: 'Page Text',
      pickCateg: 'Pick Category',
      pickProd: 'Pick Product',
      pickLoc: 'Pick Location',
      groupClients: 'Choose the customer group',
      none: 'None',
      banners: 'Banner',
      offers: 'Offers',
      display: 'Display',
      addGroup: 'Add group',
      offerSuccess: 'Group offer succesfully added',
      categoryBanner: 'Categories to be displayed in',
      dispalyBannerInCategory: 'Display banner in category'
    },
    marketingOffersTypes: {
      category: 'category',
      product: 'product',
      page: 'page'
    },
    marketingFidelities: {
      fidelities: 'Fidelities',
      loyalityPoint: 'Loyality Points',
      referal: 'Referal',
      userLabeling: 'Customer segmentation',
      name: 'Name',
      ordersValue: 'Orders Value',
      ordersNumber: 'Orders number',
      MOR: 'Average Orders Period (MOR)',
      MORCalcComenzi: 'Yearly orders number',
      MORInfo: `
        <div class="info" style="font-size: 12px;">
          <p><b>What do you enter here?</b></p>

          <p>
            You enter the <b>average number of orders</b> you want a client to place
            <b>per month</b>, calculated on an annual basis.
          </p>

          <p><b>System formula:</b></p>

          <p>
            <i>MOR average = Number of orders per year ÷ 12 months</i>
          </p>

          <p><b>Practical example (Silver rank):</b></p>

          <p>
            If you want a client to have <b>6 orders per year</b>,
            you enter <b>0.5</b> (because 6 ÷ 12 = 0.5).
          </p>
        </div>
      `,
      color: 'Color',
      notification: 'Notification',
      userNotification: 'User Notification',
      userNotificationPlaceholder: 'Congratulations! You reached {level}!',
      userNotificationInfo: 'Notification sent to user when reaches the label',
      coupon: 'Coupon',
      product: 'Free Product',
      recurrenceInfo: 'Free Product/ Coupon applies once every {recurrence}',
      description: 'Description',
      descriptionPlaceholder: 'add free desert to order',
      descriptionInfo: 'Description available only in admin panel',
      nameLabel: 'Label name',
      addLabel: 'Add Label',
      noData: 'No Data',
      updateUserLabeling: 'Updated User Labeling',
      createdUserLabeling: 'Created User Labeling',
      areYouSureDelete: 'Are you sure to delete this label',
      labelDeleted: 'Label Deleted',
      orderNumberRequired: 'This field or order numbers is required',
      orderValueRequired: 'This field or order value is required',
      yes: 'Yes',
      applyCupon: 'Apply coupon',
      applyproduct: 'Apply product',
      badgeColor: 'Badge Color',
      badgeName: 'Badge Name',
      value: 'Value',
      number: 'Number',
      appliedForLastMonth: 'Labels are applied only for orders from last 30 days',
      checkTermsAndConditionFidelities: 'Check fidelities promotions from info pages',
      labelingPrimaryOption: 'Select the primary option for labels',
      labelingSuccess: 'The settings for labels was updated successfully!',
      updatePrimaryOption: 'Update option',
      showLabelOnUser: 'Display labels to users in mobile app',
      sentUserLabelNotification: 'Allow sending user label update notifications',
      infoAboutShowUserLabelUpdated: 'Info about show user label was updated',
      labelingInterval: 'Select applicability interval',
      '0': 'Lifetime',
      '30': '30 days',
      '60': '60 days',
      '90': '90 days',
      '120': '120 days',
      '150': '150 days',
      '180': '180 days',
      recurrence: 'Recurrence',
      noReccurence: 'None',
      oneDay: '1 Day',
      threeDays: '3 Days',
      fiveDays: '5 Days',
      sevenDays: '7 Days',
      tenDays: '10 Days',
      fifteenDays: '15 Days',
      twentyDays: '20 Days',
      twentyFiveDays: '25 Days',
      updatePoints: 'Update points',
      availableProducts: 'Products must be available in all locations'
    },
    marketingPromos: {
      to_receive: 'To receive',
      multiple: 'Can be redeemed multiple times per order',
      redeemFromNextOrder: 'Can be redeemed only from next order',
      addFreeProductAutomatically: 'Add free product automatically to order',
      allowOnePointPerOrder: 'Allow one point per order',
      expiryInfo: 'Set 0 to allow points only for the current order',
      to_order: 'To order',
      toOrderError: 'Please select products that can be ordered',
      toReceiverError: 'Please select products that can redeemed',
      location: 'Location',
      title: 'Title',
      treshold: 'Treshold n',
      category: 'Category',
      product: 'Product',
      products: 'Products',
      expiry: 'Point expiry(days)',
      none: 'None',
      marketingPromos: 'Promo',
      generateQrCode: 'Generate Qr Code',
      code: 'Code',
      promoDeleted: 'Promotion deleted',
      areYouSureDelete: 'Are you sure you want to delete this promotion',
      promoAdded: 'Promo updated',
      promoUpdated: 'Promotion updated successfully.',
      weCouldNot: 'We could not save the  data, please try again later.',
      startEndDate: 'Start - End Date',
      image: 'Image',
      validImg: 'Please add a valid image.',
      print: 'Print',
      firstname: 'First Name',
      lastname: 'Last Name',
      points: 'Points',
      email: 'Email',
      description: 'Description',
      descriptionPlaceholder: 'The description will be displayed in the application',
      notificationText: 'Notification text',
      notificationTextPlaceholder: 'This message will be sent to user when earning enough points for a free product (Leave empty to omit the notification)',
      send: 'Send'
    },
    referralProgram: {
      v2: {
        ambassador_1: 'Ambassador 1',
        ambassador_2: 'Ambassador',
        referee: 'Referee',
        none: 'No reward',
        coupon: 'Coupon',
        rewardKind: 'Reward option',
        selectCoupon: 'Select coupon',
        campaignDefault: 'Campaign default',
        legacyCombined: 'Existing fixed amount + percentage',
        unavailableCoupon: 'Unavailable coupon (#{id})',
        loadingCoupons: 'Loading coupons…',
        noCoupons: 'No active coupons available.',
        couponsLoadFailed: 'Could not load coupons.',
        retry: 'Retry',
        couponRequired: 'Select a coupon.',
        couponUnavailable: 'Select an available coupon.',
        percentInvalid: 'Enter a percentage between 0 and 100.',
        amountInvalid: 'Enter a non-negative reward amount.',
        maxOrdersInvalid: 'Enter a positive whole number or leave empty for unlimited orders.',
        visibleInApp: 'Show in application',
        hierarchyTitle: 'Ambassador referrals',
        hierarchy: 'Ambassador → Affiliate',
        purchaseFlow: 'Affiliate orders reward the affiliate and their direct ambassador. Ambassador orders do not generate referral rewards.',
        cashbackTitle: 'Rewards on every order',
        cashbackHelp: 'These rewards continue after the first-order limit is reached. Configure each recipient independently.',
        order_reward: 'First-order reward',
        cashback: 'Every-order reward',
        couponsAwarded: 'Coupons awarded'
      },
      generalSettings: 'General settings',
      campaignName: 'Campaign name',
      active: 'Active',
      availableBetween: 'Availability (dates)',
      optionalAvailability: 'Optional — leave empty for no date limits.',
      tableAvailability: 'Availability',
      orderRewardsSection: 'Rewards on first orders',
      orderRewardsActive: 'Order rewards enabled',
      refereeRewardFlat: 'Referee reward',
      ambassadorOrderRewardFlat: 'Ambassador reward',
      maxOrdersForOrderRewards: 'Max counted orders',
      unlimitedPlaceholder: 'Leave empty for unlimited',
      cashbackSection: 'Ambassador cashback from referee orders',
      cashbackFlatOrPercent: 'Choose whether cashback is a percent of the order total or a fixed amount per order.',
      ambassadorCashbackActive: 'Cashback enabled',
      cashbackAmountType: 'Cashback type',
      cashbackTypePercent: 'Percent (%)',
      cashbackTypeFlat: 'Fixed amount',
      cashbackPercentValue: 'Percent of order total (%)',
      cashbackFlatValue: 'Fixed amount per order',
      cashbackHintPercent: 'Percentage of the referee order total paid to the ambassador.',
      cashbackHintFlat: 'Fixed monetary amount per delivered order for the ambassador.',
      nameRequired: 'Please enter a campaign name.',
      cashbackPercentRequired: 'Enter a cashback percentage when cashback is enabled.',
      cashbackFlatRequired: 'Enter a fixed cashback amount when cashback is enabled.',
      notificationEmailsTitle: 'Referral notification emails',
      notificationEmailsHelp: 'Addresses that receive new ambassador-request notifications (comma or newline separated).',
      notificationEmailsPlaceholder: 'team@company.com',
      orderRewards: 'Order rewards',
      cashback: 'Cashback',
      requestStatus: 'Status',
      desiredCode: 'Desired code',
      createdAt: 'Requested at',
      approveRequest: 'Approve ambassador',
      selectCampaign: 'Referral campaign',
      selectCampaignRequired: 'Please select a referral campaign.',
      rewardSummaryDisabled: 'Disabled',
      approvedCodeOptional: 'Approved referral code (optional)',
      denyReason: 'Denial reason (optional)',
      ambassadorId: 'Ambassador',
      refereesCount: 'Referees',
      totalRewards: 'Total rewards',
      totalCashbackPercent: 'Cashback total',
      refereeId: 'Referee',
      refereeTotals: 'Referee orders total',
      ambassadorEarnings: 'Ambassador earnings',
      refereeReward: 'Referee reward',
      ambassadorOrderReward: 'Ambassador order reward',
      ambassadorCashback: 'Ambassador cashback',
      rewardType: 'Reward type',
      rewardTypeLoyaltyPoints: 'Loyalty points',
      rewardTypeWallet: 'Wallet credit',
      loyaltyPointsModuleRequired: 'To choose loyalty points as reward, you need to set up the loyalty points module first.',
      loyaltyPointsModuleLink: 'Go to loyalty points settings',
      orderRewardsSummaryIncomplete: 'Configure referee and/or ambassador fixed rewards.',
      cashbackSummaryIncomplete: 'Configure the cashback amount to see a summary.',
      cannotDeleteHasEnrolledUsers: 'This campaign cannot be deleted because users are already enrolled. Deactivate it instead to stop new enrollments.',
      deactivateCampaign: 'Deactivate campaign',
      filterByCampaign: 'By campaign',
      filterByAmbassador: 'By ambassador'
    },
    reports: {
      labelEvolution: 'Label Evolution',
      items: 'Items',
      wallet_id: 'ID',
      wallet_firstname: 'Firstname',
      wallet_lastname: 'Lastname',
      wallet_email: 'Email',
      wallet_phone: 'Phone',
      wallet_loyalty_points: 'Loyalty Points',
      wallet_donation_points: 'Donation Points',
      wallet_value: 'Wallet',
      wallet_driver_wallet: 'Driver Wallet',
      salesPaymentMethod: 'Sales Report',
      paymentTypes: 'Payment Types',
      giftCardsSoldTotal: 'Total gift cards sold',
      giftCardsSoldAmount: 'Gift cards sold',
      orderedProducts: 'Ordered Products',
      number: 'Order nr',
      trends: 'Performance',
      clients: 'Clients',
      products: 'Products',
      marketing: 'Marketing',
      today: 'Today',
      orderChart: 'Orders',
      clientsChart: 'Clients',
      completed: 'Completed',
      canceled: 'Canceled',
      salesChart: 'Sales',
      salesIn: 'Sales in',
      customersChart: 'Customers',
      appInstalls: 'App Installs',
      custWithAcc: 'Customers with account',
      top10Chart: 'Top 10 products',
      top5Chart: 'Top 5 products',
      orderingChart: 'Ordering types',
      nrOfOrders: 'Number of orders',
      periodExceeds6Months: 'Please select a period smaller than 6 months',
      timerApp: 'Timer app',
      customersAge: 'Customers Age',
      customersGender: 'Customers Gender',
      name: 'Name',
      appInstalled: 'App Installed',
      gender: 'Gender',
      location: 'Location',
      partnerCode: 'Partner code',
      email: 'Email',
      phone: 'Phone',
      age: 'Age',
      donation_points: 'Puncte donatie',
      filter: 'Filter',
      label: 'Label',
      userDetails: 'Customer Details',
      salesDetails: 'Sales Details',
      salesProductNr: 'Product sales number',
      totalAmount: 'Total Amount',
      totalProducts: 'Total Products',
      ordersNumber: 'Orders',
      minAmount: 'Minimum Total Amount',
      minOrders: 'Minimum Orders',
      maxOrders: 'Maximum Orders',
      itemsSold: 'Items Sold',
      campaign: 'Campaign',
      couponsTimesUsed: 'Coupons Times Used',
      revenue: 'Sales',
      total: 'Total',
      paymentType: 'Payment type',
      date: 'Date',
      closingOrder: 'Closing Order',
      dateColumnCreate: 'Create',
      dateColumnClose: 'Close',
      dateColumnFiscalize: 'Fiscalize',
      salesReport: 'Sales Report',
      salesReportBeta: 'Sales Report BETA',
      accountingReport: 'Accounting Report',
      order: 'Order',
      export: 'Export',
      cash: 'Cash',
      card: 'Online (App)',
      cardPayment: 'Card',
      pos: 'Delivery POS',
      cardPos: 'Bank POS',
      splitCardPos: 'Split Card',
      splitCash: 'Split Cash',
      virament: 'Bank Transfer',
      online: 'Online',
      protocol: 'Protocol',
      staffFood: 'Staff Food',
      room: 'Room Transfer',
      event: 'Event Transfer',
      folio: 'Folio Transfer',
      tips: 'Tips',
      splitVoucher: 'Split Voucher',
      unpaid: 'Unpaid',
      orderPaidStatus: 'Paid status',
      boltCard: 'Bolt Card',
      boltCash: 'Bolt Cash',
      glovoCard: 'Glovo Card',
      glovoCash: 'Glovo Cash',
      woltCard: 'Wolt Card',
      woltCash: 'Wolt Cash',
      woltOtherMethods: 'Wolt Other Methods',
      totalPayFromWallet: 'Total Wallet Pay',
      totalSum: 'Total Amount',
      totalSales: 'Total Sales',
      totalCash: 'Total Cash',
      totalOnline: 'Total Online',
      totalCard: 'Total Card',
      totalCredit: 'Total Credit',
      totalNonFiscal: 'Total Non-Fiscal',
      unfiscalTotal: 'Total Unfiscalized',
      unfiscalCash: 'Unfiscalized Cash',
      unfiscalOnline: 'Unfiscalized Online',
      unfiscalCard: 'Unfiscalized Card',
      unfiscalCredit: 'Unfiscalized Credit',
      search: 'Search',
      searchFilter: 'Search(name, email, phone)',
      noRawData: 'No data available',
      rawDataTvaA: 'TVA A',
      rawDataTvaB: 'TVA B',
      rawDataTvaC: 'TVA C',
      rawDataTvaD: 'TVA D',
      rawDataTvaE: 'TVA E',
      rawDataTvaS: 'SCUTIT TVA S',
      rawDataAlteTaxe: 'ALTE TAXE #',
      rawDataNrAnulariNefiscale: 'NR. ANULARI NEFISCALE',
      rawDataValAnulariNefiscale: 'VAL. ANULARI NEFISCALE',
      rawDataNumerarInSertar: 'NUMERAR IN SERTAR LEI',
      rawDataNumerar: 'NUMERAR',
      rawDataCard: 'CARD',
      rawDataCredit: 'CREDIT',
      rawDataTicheteMasa: 'TICHETE MASA',
      rawDataTicheteValorice: 'TICHETE VALORICE',
      rawDataVoucher: 'VOUCHER',
      rawDataPlataModerna: 'PLATA MODERNA',
      rawDataAvansInNumerar: 'AVANS IN NUMERAR',
      rawDataAlteMetode: 'ALTE METODE',
      rawDataValTotalVanzA: 'VAL. TOTAL VANZ - A',
      rawDataValTotalVanzB: 'VAL. TOTAL VANZ - B',
      rawDataValTotalVanzC: 'VAL. TOTAL VANZ - C',
      rawDataValTotalVanzD: 'VAL. TOTAL VANZ - D',
      rawDataValTotalVanzE: 'VAL. TOTAL VANZ - E',
      rawDataValTotalAlteTaxe: 'VAL. TOTAL ALTE TAXE #',
      rawDataValTotalScutitTvaS: 'VAL. TOTAL SCUTIT DE TVA - S',
      rawDataValTotalVanzari: 'VAL. TOTAL VANZARI',
      rawDataTotalTvaA: 'TOTAL TVA A 21%',
      rawDataTotalTvaB: 'TOTAL TVA B 11%',
      rawDataTotalTvaC: 'TOTAL TVA C 0%',
      rawDataTotalTvaD: 'TOTAL TVA D 0%',
      rawDataTotalTvaE: 'TOTAL TVA E 0%',
      rawDataTotalTva: 'TOTAL TVA',
      rawDataClientiCodFiscalTotalTva: 'CLIENTI COD FISCAL - TOTAL TVA',
      rawDataClientiCodFiscalTotalSumar: 'CLIENTI COD FISCAL - TOTAL SUMAR',
      rawDataNrBonuriClientiCodFiscal: 'NR. BONURI CLIENTI COD FISCAL',
      rawDataNumarBonuriFiscale: 'NUMAR BONURI FISCALE',
      rawDataNumarBonuriNefiscale: 'NUMAR BONURI NEFISCALE',
      rawDataNrDmje01: 'NR. DMJE 01',
      rawDataDmjeCapacitate: 'DMJE CAPACITATE',
      rawDataSpatiuLiberDmje: 'SPATIU LIBER DMJE',
      rawDataSpatiuOcupat: 'SPATIU OCUPAT',
      rawDataNrAmef: 'NR.AMEF',
      rawDataTd: 'TD',
      rawDataData: 'DATA',
      rawDataOra: 'ORA',
      rawDataSN: 'S/N',
      rawDataLogo: '{LOGO}',
      rawDataSha256: 'SHA-256 PENTRU Z',
      discount: 'Discount',
      tax: 'Tax',
      shipping: 'Shipping',
      delivery_type: 'Delivery method',
      zone: 'Zone',
      totalDiscount: 'Total Discount',
      ordersWithDiscount: 'Orders with Discount',
      ordersWithFidelity: 'Orders with Fidelity',
      totalFidelityDiscount: 'Total Fidelity Discount',
      newCustomers: 'New Customers',
      totalTax: 'Total Taxes',
      slotTax: 'Slot Fee',
      slotPartTax: 'Slot Part Fee',
      avarageOrderValue: 'Avarage Order Value',
      clientsWOrders: 'Clients with orders',
      emailSend: 'Emails sent in last 6 months',
      emailTotal: 'Total emails sent: ',
      newCustomersChart: 'New Customers',
      productsSalesReport: 'Product sales report',
      productsSalesReport2: 'Product sales',
      productSaleTrendsReport: 'Product sale Trends',
      salesTrendsReport: 'Sales Trends',
      topProductsReport: 'Top Products',
      topCategoriesReport: 'Top Categories',
      orderFromReport: 'Vertical Sales',
      productsAndOptionsReport: 'Products and Options Report',
      options: 'Options',
      netValue: 'Net Value',
      stornoReport: 'User Storno',
      operatorSalesReport: 'Operator Protocol Sales',
      waiterTipsReport: 'Waiter Tips',
      waiterTipsUserName: 'User name',
      waiterTipsValue: 'Value',
      waiterTipsZRange: 'Z range',
      waiterTipsMode: 'Mode',
      waiterTipsModeWaiter: 'Waiters',
      waiterTipsModeDelivery: 'Delivery',
      waiterTipsSelectWaiters: 'Waiters',
      waiterTipsSelectDrivers: 'Drivers',
      masterReport: 'Master Report',
      masterReportBeta: 'Master Report (Beta)',
      fiscalZReport: 'Fiscal Z Report',
      withoutOptions: 'without options, without sgr',
      customerLifetimeValueReport: 'Customer Lifetime Value',
      referralProgramReport: 'Referral program',
      raffleCampaignsReport: 'Raffle Campaigns Report',
      pricePerUnit: 'Price per unit',
      quantity: 'Quantity',
      average: 'Average',
      productName: 'Product Name',
      orderStatus: 'Order status report',
      pdfRaport: 'Order report for delivery',
      couponCode: 'Coupon',
      checkOrder: 'Use order',
      loyaltyPoints: 'Loyalty Points',
      donationReport: 'Donation Report',
      donationCampaignsReport: 'Donation Campaigns Report',
      loyaltyStoreReport: 'Loyalty Store',
      challengeCampaignsReport: 'Challenges Report',
      spinningWheelReport: 'Spinning Wheel Report',
      ocr: 'Ocr',
      stockMovements: 'Product Stock Movements',
      reorderPopupResponses: 'Reorder Popup Responses',
      dateTime: 'Date & Time',
      reorderResponse: 'Response',
      reorderResponseYes: 'Yes',
      reorderResponseNo: 'No',
      dateInterval: 'Date interval',
      allLocations: 'All locations',
      stockMovementType: 'Movement Type',
      stockMovementUserRole: 'User Role',
      stockMovementOrderPlaced: 'Order placed',
      stockMovementManualAdjustment: 'Manual adjustment',
      wallet: 'Wallet',
      clientLoyalty: 'Clinet points report',
      requestReport: 'Request Report',
      requestSuccess: 'Request Sent',
      requestInfo: 'The report would be available for download tomorrow',
      requestConfirm: 'I understand',
      reportRequestTab: 'Report Requests',
      charismaReport: 'Report Charisma',
      charismaLocationReceipt: 'Report Z Charisma',
      nexusReport: 'Report Nexus',
      nexusItems: 'Order Log',
      nexusOrderLogs: 'Nexus Order Logs',
      sendReceipts: 'Send Receipts',
      dashboardReport: 'Dashboard Report',
      reportTypePlaceholder: 'Report',
      pointsReport: 'Points Report',
      fromUppercase: 'From',
      toUppercase: 'To',
      availableUntil: 'Available until',
      pdfRaportDeliveryOrders: 'Delivery Orders',
      statusReport: 'Processing Orders Time',
      taxation: 'Taxation',
      withReceipt: 'Taxed',
      withoutReceipt: 'Untaxed',
      receiptNumber: 'Receipt No',
      zet: 'Zet',
      noDataAvailable: 'No data available',
      topCategory: 'Top Category',
      orderId: 'Order ID',
      posId: 'Pos ID',
      productId: 'Product ID',
      itemPosId: 'Pos ID Item',
      menuItemPosId: 'Pos ID Menu Item',
      orderCreatedAt: 'Order Opening Time',
      orderNumber: 'Order Number',
      tableNumber: 'Table Number',
      orderItemCreatedAt: 'Product Opening Time',
      orderItemMarkingTime: 'Product Marking Time',
      category: 'Category',
      product: 'Product',
      operation: 'Operation',
      operator: 'Operator',
      section: 'Section',
      fullPrice: 'Gross Price',
      grossPrice: 'Gross Price per Product',
      orderItemDiscount: 'Product Discount',
      orderDiscount: 'Order Discount',
      orderLoyaltyDiscount: 'Order Loyalty Discount',
      orderItemValueCollected: 'Collected Amount',
      vatAmount: 'VAT Amount',
      orderItemNetPrice: 'Net Price',
      paymentMethod: 'Payment Method',
      fiscalization: 'Fiscalization',
      roomNumber: 'Room Number',
      folioId: 'Folio ID',
      interval: 'Interval',
      split: 'Split',
      orderComments: 'Order comments',
      productComments: 'Product comments',
      tableOpenOrders: 'Table Open Orders',
      orderSeriesNumber: 'Series / order no.',
      posDeviceName: 'POS',
      waiterName: 'Waiter',
      orderTransfersCount: 'Transfers',
      orderStornosCount: 'Storno',
      posOrderActionTypes: {
        openOrder: 'Open order',
        markProduct: 'Mark product',
        preNote: 'Pre note',
        closeOrder: 'Close order',
        storno: 'Storno',
        transferOut: 'Transfer OUT',
        transferIn: 'Transfer IN'
      },
      posOrderActionMarkProduct: 'Mark "{name}"',
      posOrderActionMarkProductGeneric: 'Mark product',
      orderProductsCount: 'Order products count',
      transferTable: 'Transfer table',
      initialItems: 'Initial items',
      transferredTag: 'Transferred',
      transferOut: 'Transferred items',
      remainingItems: 'Remaining items',
      itemsReceived: 'Items received',
      posOrderActionsReport: 'POS Order Actions Report',
      zNumber: 'Z Number',
      deviceName: 'Device Name',
      zTimestamp: 'Z Timestamp',
      credit: 'Credit',
      mealTickets: 'Meal Tickets',
      valueTickets: 'Value Tickets',
      voucher: 'Voucher',
      modernPayment: 'Modern Payment',
      advanceInCash: 'Advance in Cash',
      otherMethods: 'Other Methods',
      cashInDrawer: 'Cash in Drawer',
      nrFiscalReceipts: 'Nr. Fiscal Receipts',
      nrNonFiscalReceipts: 'Nr. Non-Fiscal Receipts',
      fiscalReceiptsAmount: 'Fiscal receipts amount',
      nonFiscalReceiptsAmount: 'Non-fiscal receipts amount',
      paymentMethodsStandard: 'Standard payment methods',
      paymentMethodsOther: 'Other payment methods',
      paymentMethodsIntegration: 'Integration payment methods',
      totalSalesA: 'Total Sales A',
      totalSalesB: 'Total Sales B',
      totalSalesC: 'Total Sales C',
      totalSalesD: 'Total Sales D',
      totalSalesE: 'Total Sales E',
      totalVat: 'Total VAT',
      totalVatA: 'Total VAT A',
      totalVatB: 'Total VAT B',
      totalVatC: 'Total VAT C',
      totalVatD: 'Total VAT D',
      totalVatE: 'Total VAT E',
      totalOtherTaxes: 'Total Other Taxes',
      totalVatExempt: 'Total VAT Exempt',
      nrFiscalCodeClientReceipts: 'Nr. Fiscal Code Client Receipts',
      fiscalCodeClientsTotalSum: 'Fiscal Code Clients Total Sum',
      fiscalCodeClientsTotalVat: 'Fiscal Code Clients Total VAT',
      productCount: 'Product Counter',
      lastSearch: 'Last search',
      duration: 'Order duration',
      tables: 'Tables',
      quantityUnit: 'Quantity Unit',
      singleUnit: 'Unit',
      clientId: 'Client ID',
      clientName: 'Client Name',
      registrationDate: 'Registration Date',
      firstOrderDate: 'First Order Date',
      lastOrderDate: 'Last Order Date',
      monthlyOrderCount: 'Total Order Count',
      monthlyOrderValueTotal: 'Monthly Order Value (Total)',
      averageOrderValue: 'Average Order Value',
      // monthlyOrderAverage: 'Monthly Average Order Value',
      monthlyOrderAverage: 'Monthly frequency',
      isNewClient: 'New Client',
      isInactiveClient: 'Inactive Client',
      daysSinceLastOrder: 'Days Since Last Order',
      acquisitionChannel: 'Acquisition Channel',
      estimatedCLV: 'CLV 12 Months',
      churnRate: 'Churn Rate',
      option: 'Option',
      item: 'Product',
      type: 'Type',
      searchProducts: 'Search',
      orderCounter: 'Orders Count',
      preordersItems: 'Preorders Items',
      itemName: 'Item Name',
      saleWeek: 'Week',
      filteredData: 'The data displayed is from period:',
      source: 'Source',
      withStorno: 'Storno',
      withoutStorno: 'Without Storno',
      orderTotal: 'Order Total',
      old: 'Old',
      custom: 'Custom',
      salesProtocol: 'Total Sales Protocol',
      salesStaff: 'Total Sales Staff',
      countProtocol: 'Orders Staff',
      countStaff: 'Orders Staff',
      salesProtocolStaff: 'Total Sales Protocol + Staff',
      countProtocolStaff: 'Orders Protocol + Personal',
      salesReportSearch: 'Search by Product, Category, Waiter',
      id: 'ID',
      sold: 'Sold',
      eatIn: 'Eat In',
      takeOut: 'Take Out',
      other: 'Other',
      waste: 'Waste',
      employee: 'Employee',
      refund: 'Refund',
      usage: 'Usage',
      unitQty: 'Unit Qty',
      unitPrice: 'Unit Price',
      sales: 'Sales',
      netSales: 'Net Sales',
      grandTotal: 'Grand Total',
      mixReport: 'Mix Report',
      noData: 'No Data',
      uncategorized: 'Uncategorized'
    },
    orderFrom: {
      unknown: 'Unknown',
      kiosk: 'Kiosk',
      qr: 'QR',
      pos: 'POS',
      app: 'Application',
      website: 'Website',
      glovo: 'Glovo',
      wolt: 'Wolt',
      bolt: 'Bolt',
      POS: 'POS',
      application: 'Application',
      online: 'Website',
      table: 'Table',
      tazz: 'Tazz',
      phone: 'Phone',
      inlocation: 'Reservation'
    },
    feedback: {
      sigle: 'feedback',
      type: 'Type',
      sentBy: 'Sent By',
      text: 'Text',
      seen: 'Seen',
      sentAt: 'Sent At',
      search: 'Search',
      comment: 'Comment',
      response: 'Response',
      send: 'The answer will be sent to the user by notification and email at the time of saving'
    },
    orderScreen: {
      typeKitchen: 'Kitchen',
      typeClient: 'Client',
      selectLocation: 'Select a location in order to select the Client mode',
      excludeSections: 'Exclude sections',
      includeTableOrders: 'Include table orders',
      posIds: 'POS',
      odsBackgroundColor: 'Background color',
      odsTextColor: 'Text color',
      odsStatus1Color: 'Processing orders color',
      odsStatus2Color: 'Preparing orders color',
      odsStatus3Color: 'Prepared colors color',
      odsColumn1Text: 'Text header 1',
      odsColumn2Text: 'Text header 2',
      odsOffline: 'ODS offline',
      ipServer: 'Server IP',
      odsCode: 'ODS code',
      connectivity: 'Connectivity',
      offline: 'Offline',
      online: 'Online'
    },
    feedbackTypes: {
      feedback: 'Feedback',
      issue: 'Issue',
      suggestion: 'Suggestion'
    },
    settings: {},
    blogPage: {
      categories: 'Categories',
      categoriesHint: 'Optional — articles can also have no category.',
      categoryName: 'Category name',
      noCategories: 'No categories yet.',
      articles: 'Articles',
      addArticle: 'Add article',
      editArticle: 'Edit article',
      allCategories: 'All categories',
      noCategory: 'No category',
      allStatuses: 'All statuses',
      searchByTitle: 'Search by title',
      noArticles: 'No articles found.',
      cover: 'Cover',
      coverHint: 'recommended 1200x630px, max 5MB',
      imageAlt: 'Image alt text (SEO)',
      title: 'Title',
      slug: 'Article link (slug)',
      slugHint: 'Generated from the title if left empty.',
      shortDescription: 'Short description (under the title)',
      content: 'Content',
      category: 'Category',
      author: 'Author',
      publishedAt: 'Publish date',
      publishedAtHint: 'If empty, the current date is used when publishing.',
      status: 'Status',
      published: 'Published',
      draft: 'Draft',
      scheduled: 'Scheduled',
      seo: 'SEO',
      metaTitle: 'Meta title',
      metaDescription: 'Meta description',
      metaKeywords: 'Keywords (comma separated)',
      titleRequired: 'The title is required.',
      deleteCategoryConfirm: 'Delete category "{name}"? {count} article(s) will remain without a category.',
      deleteArticleConfirm: 'Delete article "{name}"?'
    },
    settingsPages: {
      homepageSections: 'Homepage Sections',
      interactiveTour: 'Interactive Tour',
      blog: 'Blog',
      interactiveTourFirstLogin: 'Use interactive tour on first login',
      interactiveTourAlways: 'Use interactive tour always',
      interactiveTourDisplayMode: 'Image display mode',
      interactiveTourDisplayContain: 'Contain',
      interactiveTourDisplayCover: 'Cover',
      interactiveTourDisplayFullPage: 'Full page',
      searchNameEmail: 'Search by Name or Email',
      ordersFilter: 'With Orders / Without Orders',
      userSettings: 'User Settings',
      generalSettings: 'General Settings',
      moduleManager: 'Module Manager',
      locationSettings: 'Location Settings',
      myProfile: 'My Profile',
      users: 'Users',
      general: 'General',
      companyDetails: 'Company Details',
      printers: 'Printers',
      fiscalPrinter: 'Fiscal Printer',
      tableManager: 'Table Manager',
      tableZones: 'Zone Manager',
      measurementsUnits: 'Measurements Manager',
      kdsSections: 'Sections',
      paymentGroups: 'Payment Groups',
      companyLocations: 'Locations',
      dateTime: 'Date & Time',
      currency: 'Currency',
      accounting: 'Accounting',
      tax: 'Tax',
      payment: 'Payment',
      orderingMng: 'Ordering Management',
      loyalty: 'Loyalty Program',
      push: 'Push Notifications',
      tips: 'Tips',
      kioskModule: 'Kiosk',
      qrModule: 'Qr',
      app: 'Aplication',
      locationGroups: 'Location groups',
      locationGroupsName: 'Name',
      locationGroupsDescription: 'Description',
      locationGroupsPhoto: 'Photo',
      locationGroupsAdded: 'New location groups added successfully',
      locationGroupsUpdated: 'Location groups updated successfully',
      locationGroupsPicError: 'We could not save the location groups photo, please try again later.',
      locationGroupsDelete: 'Delete Location Group',
      locationGroupsAreYouSure: 'Are you sure you want to delete this location group?',
      locationGroupsSelect: 'Select the location group to which it belongs:',
      subscription: 'Subscription',
      myPlan: 'My Plan',
      infoPages: 'Info Pages',
      taxLabeling: 'Tax Labelling',
      deliveryMethods: 'Delivery methods',
      filters: 'Filters',
      filterProducts: 'Filters Products',
      companyWeb: 'Company website',
      services: 'Services',
      scanner: 'Client Scanner',
      settings: 'Settings',
      integrations: 'Integrations'
    },
    permission: {
      // GENERAL
      general_can_access_dashboard: 'Allow access to Dashboard',
      general_can_access_clients: 'Allow access to Clients',
      general_can_access_orders: 'Allow access to Orders',
      general_can_access_tables: 'Allow access to Tables',
      general_can_access_reservations: 'Allow access to Reservations',
      general_can_access_add_order: 'Allow access to Add Order',
      general_can_access_dispatch: 'Allow access to Dispatch',
      general_can_access_kds: 'Allow access to KDS',
      general_can_access_screens: 'Allow access to Screens',
      general_can_access_pos: 'Allow access to POS',
      general_can_access_inventory: 'Allow access to Inventory',
      general_can_access_catalog: 'Allow access to Catalog',
      general_can_access_marketing: 'Allow access to Marketing',
      general_can_access_scan: 'Allow access to Scan',
      general_can_access_reports: 'Allow access to Reports',
      general_can_access_feedback: 'Allow access to Feedback',
      general_can_access_setings: 'Allow access to Settings',
      general_can_access_pay: 'Allow access to Payments',
      general_can_access_suport: 'Allow access to Support',
      general_can_access_price_lists: 'Allow viewing price lists',
      // GESTIUNE
      can_access_supplier_orders: 'Inventory - Access to Supplier Orders',
      can_create_supplier_order: 'Inventory - Create Supplier Orders',
      can_send_supplier_order: 'Inventory - Send Supplier Orders',
      can_receive_supplier_order: 'Inventory - Receive Supplier Orders',
      can_validate_supplier_order: 'Inventory - Validate Supplier Orders',
      can_generate_nir: 'Inventory - Generate NIR',
      can_process_supplier_order: 'Inventory - Process Supplier Orders',
      can_generate_aviz: 'Inventory - Can Generate Delivery Note',
      can_generate_invoice: 'Inventory - Can Generate Invoices',
      can_access_dashboard: 'Inventory - Access to Dashboard',
      can_access_gestiune: 'Inventory - Access to Inventory',
      can_access_reports: 'Inventory - Access to Reports',
      can_access_settings: 'Inventory - Access to Settings'
    },
    settingUsers: {
      permissions: 'Permissions:',
      permissionsGestiune: 'Permissions Management',
      permissionsGeneral: 'Generale Permissions',
      single: 'user',
      fn: 'First Name',
      ln: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      active: 'Active Schedule',
      scheduleStatus: 'The schedule is:',
      scheduleActive: 'active',
      scheduleInactive: 'inactive',
      username: 'Username',
      program: 'Choose schedule',
      lang: 'Interface language',
      langMsg: 'This is the language in which you will see the Inventory area.',
      avatar: 'Avatar',
      role: 'Role',
      locations: 'Access Orders from Locations',
      locations_helptext: 'Important: If no location is selected this user will have access to all locations.',
      resetPass: 'Reset Password',
      password: 'Password',
      pass: 'Password',
      confPass: 'Confirm Password',
      userAdded: 'New user added successfully',
      userUpdated: 'User updated successfully',
      userPicError: 'We could not save the user avatar, please try again later.',
      USER: 'USER',
      OWNER: 'OWNER',
      DRIVER: 'DRIVER',
      LOCATION_ADMIN: 'LOCATION ADMIN',
      LOCATION_STORE_ADMIN: 'LOCATION STORE ADMIN',
      MARKETER: 'MARKETER',
      OPERATOR: 'OPERATOR',
      KDS_OPERATOR: 'KDS OPERATOR',
      USER_CUSTOM: 'Custom User',
      DISPATCHER: 'DISPATCHER'
    },
    settingTable: {
      'use_tips': 'Use Tips',
      'yumm_integration_external_ip': 'Yumm integration external ip',
      onlineQrTitle: 'Online ordering QR',
      onlineQrDesc: 'QR code that opens online ordering for this table.',
      onlineQrEmpty: 'No online QR generated yet.',
      onlineQrGenerate: 'Generate QR',
      onlineQrRegenerate: 'Regenerate QR',
      onlineQrCopy: 'Copy link',
      'all': 'All',
      'activ': 'Active',
      'inactiv': 'Inactive',
      'as_useer': 'As User',
      'series': 'Order Series',
      'start_number': 'Start nr order',
      'allow_maps': 'Table Maps',
      'use_table_maps': 'Use table maps',
      disable_eat_in: 'Disable Eat In',
      disable_delivery: 'Disable Delivery',
      disable_pick_up: 'Disable Pick Up',
      disable_drive_in: 'Disable Drive In',
      allDeliveryMethodsDisabled: 'At least one delivery method must remain enabled (Eat In, Delivery, Pick Up or Drive In).',
      default_method: 'Default Method',
      default_sort_checkout_buttons: 'Sort the first 4 buttons in checkout',
      disable_tips: 'Disable Tips',
      disable_ballance: 'Disable Balance',
      auto_print_receipt: 'Print the receipt automatically',
      auto_print_receipt_on_metods: 'Print the receipt automatically for metods',
      auto_print_receipt_on_status: 'Print the receipt automatically for statuses',
      allowClosingOrdersWithoutReceipt: 'Allow closing orders without a fiscal receipt',
      'allow_close_order_without_receipt': 'Allow closing orders without a fiscal receipt',
      'allow_closing_orders_without_driver': 'Allow closing orders without a driver',
      'comment_for_virament': 'Comment for virament',
      'stop_print_section': 'Stop print serction',
      'close_order': 'Close Orders with status delivered all the time',
      'set_logged_user_in_reports': 'Filter reports by logged user',
      'disable_seats': 'Disable the popup with the number of seats at the table',
      'disable_pager': 'Disable the pager number popup',
      'block_z_until_all_orders_fiscalized': 'Block Z until all orders are fiscalized',
      'allowed_fiscal_payment_methods': 'Allowed fiscal payment methods',
      'allow_fiscal': 'Allow fiscal',
      'allow_change_payment_type_on_fiscalization': 'Allow changing payment type on fiscalization',
      'use_block_actions_after_print': 'Block actions after print',
      'auto_print_fiscal_on_status': 'Select the statuses for which you want self-taxation',
      'auto_print_fiscal_on_source': 'Select the sources for which you want self-taxation',
      'auto_print_fiscal_on_payment_methods': 'Select the payment methods for automatic fiscalization',
      'auto_print_fiscal_on_payment_methods_help': 'Automatic fiscalization requires at least one source and one status to be selected. An order must match both selections. No payment methods selected means all methods for those sources and statuses. The current POS does not yet apply the payment-method filter.',
      disable_required_options: 'Disable Option Validation',
      'is_manager': 'Is Manager',
      'table_for_one_user': 'Table is assigned to the first user',
      'pos_allow_order_change_status': 'Allows status changes on orders',
      'pos_allow_reports': 'Allow filter reports',
      'pos_allow_approvals': 'Allow approving actions',
      'pos_allow_advanced_settings': 'Allow advanced settings',
      'pos_allow_advanced_settings_info': 'example: deleting orders older than 2 days',
      'pos_allow_access_reports': 'Allow access reports',
      'bank_terminal': 'Bank terminal',
      'has_bank_terminal': 'Bank terminal is connected (FiscalNet)',
      'has_integrated_bank_terminal': 'Integrated bank terminal is connected',
      'sound_new_order': 'Play sound for new orders',
      'sound_notification': 'Play sound for notifications',
      'sync_products_from_all_locations': 'Sync products from all locations',
      'sync_location_ids': 'Locations to sync',
      'is_dispatch': 'Dispatch mode',
      'menu_orientation': 'Menu orientation',
      'vertical': 'Vertical',
      'horizontal': 'Horizontal',
      'allow_tables_access_only_if_assigned': 'Table cannot be used without an assigned user',
      'use_fiscal_net_at_modern_payment': 'Use FiscalNet at Modern Payment',
      'allow_bank_transfer': 'Allow payment via Bank Transfer',
      'pos_allow_transfer': 'Allow Transfer',
      'pos_allow_waiter_transfer': 'Allow waiter transfer',
      'pos_allow_table_transfer': 'Allow table transfer',
      'pos_allow_staff_food': 'Allow payment Staff Food',
      'allow_some_top_categories': 'Allow just some top categories for this user',
      'allow_some_top_categories_map': 'Allow just some top categories for this map',
      'staff_food_daily_budget': 'Staff food daily budget',
      'pos_allow_discount': 'Allow Discount',
      'pos_allow_storno': 'Allow Storno',
      'pos_allow_refund': 'Allow Refund',
      'allow_access_all_tables': 'Allow access to all tables',
      'allow_change_driver': 'Allow change driver',
      'allow_print_note': 'Allow payment notes',
      'not_allowed_order_statuses': 'Not allowed order statuses',
      'pos_allow_mobile_pos': 'Allow Mobil Pos',
      'pos_allow_plata_moderna': 'Allow Modern Payment',
      'pos_allow_protocol': 'Allow Protocol',
      'pos_allow_glovo': 'Allow Glovo',
      'pos_allow_bolt': 'Allow Bolt',
      'pos_allow_wolt': 'Allow Wolt',
      'pos_allow_tips': 'Allow Tips',
      'pos_disable_cancel_order': 'Disable Cancel Order',
      'pos_filter_status_orders': 'Choose the statuses you want to be selected by default for orders',
      'email': 'Email',
      'lastname': 'Lastname',
      'firstname': 'Firstname',
      'login_code': 'Login Code (unique 4 digits)',
      'login_code_already_used': 'This login code is already in use.',
      'lock_screen_timeout_min': 'Screen lock timeout (minutes)',
      'round': 'Round',
      'squere': 'Squere',
      'table_shape': 'Shape',
      'deleteZoneTitle': 'Are you sure?',
      'deleteZoneTxt': 'This action will delete all tables and kiosks belonging to this area along with their availability settings!',
      'app_available': 'Available for booking',
      'min_pers': 'Minimum number of people',
      'max_pers': 'Maximum number of people',
      'with_open_order': 'Open Order',
      'with_split_pay': 'Pay separately',
      'tableSave': 'Save successfully',
      'short_spv': 'SPV value',
      'short': 'Shortening',
      'name': 'Name',
      'number': 'Identifier',
      'kioskName': 'Kiosk name',
      'offlineLoginCode': 'Login code:',
      'location': 'Location',
      'type': 'Type',
      'zone': 'Zone',
      'maps': 'Table Maps',
      'loginCode': 'Login Code:',
      'printOrder': 'Print order',
      'posSet': 'Pos Settings',
      'fiscalSet': 'Fiscal Settings',
      'use_pager': 'With Pager',
      'use_methods': 'Activate kiosk methods (Pickup, eat in)',
      'kiosk_offline': 'Offline kiosk',
      'kioskVideo': 'Kiosk video (plays on the start screen)',
      'kioskVideoHint': 'MP4 or WEBM, max 50MB. Save the kiosk after the upload.',
      'kioskVideoTooBig': 'The video must be at most 50MB',
      'kioskVideoUploaded': 'Video uploaded. Save the kiosk to apply it.',
      'kioskVideoRemove': 'Remove',
      'kioskVideoHintAuto': 'MP4 or WEBM, max 50MB. The video is saved on the kiosk automatically after the upload.',
      'kioskVideoSaved': 'Video uploaded and saved on the kiosk.',
      'kioskVideoRemoved': 'Video deleted.',
      'qr_offline': 'Offline QR',
      'qrSettings': 'QR settings',
      'qrGeneralSettings': 'General details',
      'qrConnectionSettings': 'Offline connection',
      'qrServiceSettings': 'Service settings',
      'qrCapacitySettings': 'Capacity and availability',
      'qrNumberingSettings': 'Document numbering',
      'qrPaymentMethods': 'QR payment methods',
      'qrPaymentMobilePos': 'Mobile POS',
      'qrPaymentCard': 'Card',
      'qrPaymentBankTerminal': 'Bank terminal',
      'qrPaymentDirectConnection': 'Direct connection',
      'qrPaymentMode_online': 'Online QR',
      'qrPaymentMode_offline': 'Offline QR',
      'qrPaymentType_CASH': 'Cash',
      'qrPaymentType_POS': 'Mobile POS — without terminal trigger',
      'qrPaymentType_CARD_POS': 'Mobile POS — trigger terminal',
      'qrServiceCode': 'Service-mode code',
      'reloadAllKiosks': 'Reload all kiosks',
      'reload': 'Reload',
      'reloadPending': 'Reload pending',
      'kiosksWillReloadNextOrder': 'The kiosks will reload at the next order!',
      'use_cash_machine': 'With Cash Machine',
      'disable_cash_payment': 'Disable cash payment',
      'kiosk_is_using_fiscal_receipt_for_sections': 'Kiosk is using fiscal receipt for sections',
      'without_OrderFormFlags': 'Without',
      'use_fiscal_net': 'With FiscalNet',
      'use_fiscal_net_with_pos': 'Pos with FiscalNet',
      'printerSet': 'Printer Settings',
      'server_ip': 'Server IP',
      'server_port': 'Server Port',
      'terminal_port': 'Terminal Port',
      'ip': 'Ip',
      'port': 'Port',
      'host': 'Host',
      'p1': 'Adr1',
      'p2': 'Adr2',
      'kioskUrl': 'Download Kiosk Installer',
      'disableAuth': 'Disable POS',
      'disableAuthInfo': 'The POS will be disabled untill performing a new setup',
      'disableAuthScreen': 'Disable Screen',
      'disableAuthScreenInfo': 'The screen will be disabled untill performing a new setup',
      'printerIp': 'Printer IP and Port',
      'printerIpExample': 'ex. 127.0.0.1:8080',
      'serverIp': 'Server Ip',
      'serverIpExample': 'eg. 192.168.1.100',
      'waiters': 'Waiers',
      'dispalyProductsImage': 'Display products image',
      'assignWaiter': 'Assign waiters',
      'allowPosUseCoupons': 'Verify active coupons in real time',
      'posSetClientOnOrder': 'Always ask for client details',
      'pos_confirm_order_close_on_method_select': 'Confirm order closure and fiscalization when selecting payment method',
      'posDisplayAllProductOptions': 'Display all product options at once',
      'forceCreditForIntegrationCashOrders': 'Force "Credit" for integration orders paid in "Cash"',
      'posUseYummVoucher': 'Use YUMM voucher',
      'posUseStock': 'Use stock on POS',
      'posAskStornoBackInStock': 'Ask to put products back in stock on storno',
      'pos_keep_first_waiter_id_order_split': 'Keep first waiter ID on order split',
      'posDisplayTipsOnOrder': 'Display tips on order',
      'posDefaultCourseCount': 'Number of courses',
      'searchTable': 'Search table by name',
      externalId: 'External ID',
      externalIdPlaceholder: 'External reference (e.g. POS or integration)',
      group_tables_users: 'Tables & users',
      group_order_types: 'Order types',
      group_closing_orders: 'Closing orders',
      group_payments: 'Payments & terminals',
      group_fiscal_printing: 'Fiscal & printing',
      group_display: 'Display & interface',
      group_reports: 'Reports',
      fiscalPrinter: 'Fiscal printer',
      cantar: 'Scale'
    },
    referalSettings: {
      'inactive_loyalty': 'Please activate loyalty points',
      'points_handle': 'How points should be added',
      'only_referal': 'Only referal points',
      'only_fidelity': 'Only fidelity points',
      'both_points': 'Both points are added',
      'higher_point': 'Only higher points are added',
      'initial_parent_percentage': 'Parent initial order value percentage points',
      'initial_order_percentage': 'percent ar first order',
      'initial_child_percentage': 'Child initial order value percentage points',
      'order_count': 'How many orders after first points can be received',
      'order_count_info': 'How many other orders beside first we will give them points, if blank, no limit',
      'order_values': 'Values after initial order',
      'parent_order_percentage': 'Parent order value percentage points',
      'parent_order_percentage_info': 'Beside first order what percentage of order value will added as points',
      'child_order_percentage': 'Child order value percentage points',
      'parent_receive_points': 'Rewards for the person who is recommended'
    },
    addOrder: {
      toGo: 'To Go',
      commentTitle: 'Add comment',
      choosePay: 'Choose payment method',
      'areYouSureDelete': 'Are you sure you want to delete?',
      'adressDeleted': 'Deleted successfully',
      'titleClient': 'Customer',
      'titleMethod': 'Delivery method',
      'titleLocation': 'Location',
      'titleAdress': 'Delivery address',
      'titleStatus': 'Status',
      'done': 'Done',
      'datepicker': 'Pick a date',
      'hourpicker': 'Pick a hour',
      'how_many': 'For how many people the reservation is made',
      'tags': 'Order from',
      'fromTable': 'For: ',
      'titlePopupTip': 'Add Value',
      'btnPopup': 'Add',
      'titlePopupPriceModify': 'Edit product price',
      'titlePopupCoupon': 'Add coupon',
      'errorPopupCoupon': 'Wrong coupon',
      'freeCouponProductAdded': 'Free product added to cart: {products}',
      'errorProduct1': 'The products are no longer available and have been deleted from the cart',
      'errorProduct2': 'One or more products are no longer available and have been deleted from the cart',
      'errorProduct3': 'You must have products in your cart to be able to order!',
      'errorProduct4': 'Please select the method and location',
      'errorProduct5': 'Please add a customer',
      'errorProduct6': 'Payment method not selected',
      'errorProduct7': 'Please add an adress',
      'errorProduct8': 'ERROR, Please check the fiscal printer and banking POS device!',
      'add': 'Add',
      'edit': 'Edit',
      'total': 'TOTAL',
      'infosup': 'Add additional information',
      'state': 'County',
      'city': 'Town',
      'adress': 'Block, staircase, floor, apartment',
      'number': 'Number',
      'street': 'Street',
      'adressname': 'Address Name',
      'sexf': 'Female',
      'sexm': 'Male',
      'sex': 'Sex',
      'birthdate': 'Date of birth',
      'contactperson': 'Contact person',
      'newclient': 'Add or choose client',
      'newadress': 'Add or choose the address',
      'save1': 'Choose and save changes',
      'deliveryAdress': 'Add address',
      'deliveryAdressEdit': 'Edit adresa',
      'prodId': 'ID / Client Code',
      'firstName': 'First name',
      'lastName': 'Last name',
      'contactPers': 'Contact person',
      'clientSelected': 'Selected customer',
      'clearFields': 'Clear the fields',
      'addAdress': '+ Add the address',
      'existingClient': 'Order from',
      'orderNow': 'Place order',
      'editOrderNow': 'Finish the edit',
      'POS': 'Pos',
      'pos': 'Pos',
      'cash': 'Cash',
      'free': 'Free',
      'protocol': 'Protocol',
      'coment': 'Comment Order',
      'client_notif': 'This text will be sent to the customer',
      'addTip': 'Add tip',
      'removeTip': 'Remove tip',
      'addCoupon': 'Add discount coupon',
      'removeCoupon': 'Delete discount coupon',
      'modif': 'modify',
      'freeProd': 'Free Product',
      'partialPay': 'Edit Price',
      'info': 'Info',
      'orderDet': 'Order Details',
      'cartDet': 'Order summary',
      'fast': 'As soon as possible',
      'selectHour': 'Select the time',
      'selectPayment': 'Select the payment method',
      'pleaseSelectMethodAndLoc': 'Please select the method and location!',
      'locSelect': 'Select a location',
      'searchProduct': 'search products',
      'phone': 'Phone',
      'email': 'E-mail',
      'inlocation': 'In Location',
      'glovo': 'Glovo',
      'tazz': 'Tazz',
      'bolt': 'Bolt',
      'wolt': 'Wolt',
      'application': 'Application',
      'online': 'Online',
      'adressNotInRange': 'Not in range, please change the adress!',
      'adressNotCorect': 'Adress is not correct',
      'noClient': 'Order without client',
      'other': 'Others'
    },
    settingCompany: {
      authAppCode: 'Location authentication code',
      generateAuthAppCode: 'Generete code',
      purchase_limit_interval_hours: 'Disponibility purchase limit interval hours',
      integrators_department: 'Integrators Tax',
      integrators_tax_vat_printer_id: 'Vat Printer Id',
      other_taxes_vat_printer_id: 'Printer id for corrections',
      donation_vat_printer_id: 'Printer id for donations',
      vatPrinterIdColumn: 'Printer ID',
      integrators_tax_vat_amount: 'Tax Vat Amount',
      integrators_department_id: 'Department Id',
      title: 'Company',
      location: 'Location',
      name: 'Name',
      selfOrderDomain: 'Self Ordering Domain',
      appLink: 'Link aplication',
      appLinkAndroid: 'Android link aplication',
      appLinkIos: 'Ios link aplication',
      lang: 'Application language',
      bussLoc: 'Business Location',
      deliveryLabels: 'Delivery methods labels',
      deliveryType: 'Delivery method',
      pick_up: 'Pick-up',
      meet_half: 'Meet me half way',
      delivery: 'Delivery',
      eat_location: 'Reserve a table',
      self_ordering: 'Self Ordering',
      phone: 'Phone',
      street: 'Street',
      number: 'No.',
      latitude: 'Latitude',
      longitude: 'Longitude',
      email: 'Email',
      city: 'City',
      country: 'Country',
      state: 'State',
      availableDaysHrs: 'AVAILABLE DAYS AND HOURS',
      from: 'from',
      to: 'to',
      preOrder: 'pre-order from',
      allowPreOrder: 'Allow Pre-order',
      cardPaymentDetails: 'Card Payment Settings',
      paylikeKeys: 'Paylike used keys',
      posDiscount: 'POS id for discount',
      userTaxes: 'USED TAXES',
      noTaxMsg: 'Info: You have made changes on taxes, don\'t forget to save them.',
      areYouSureDelete: 'Are you sure you want to delete this location? This action will also delete the ordering settings for this location.',
      pickLocationToCopy: 'Pick a location from where you want to copy the products',
      areYouSureTax: 'Are you sure you want to remove this tax from taxes list? Don\'t forget to save the changes!',
      areYouSureVat: 'Are you sure you want to remove this VAT from the list?',
      companyUpdated: 'Company data updated successfully',
      locationUpdated: 'Location data updated successfully',
      updateError: 'The data have not been saved. Please check again and retry!',
      companyProdCopied: 'Products copied successfully.',
      companyProdAddLoc: 'Location added to products successfully.',
      copyBtn: 'Add location to Products',
      companyProdDeleted: 'Products deleted successfully.',
      areYouSureDeleteProd: 'Are you sure you want to delete all product from this location?',
      wrongAddress: 'The address of "{location}" location is not correct.',
      deleteLocationValidation: 'This location is in use. You may not delete it. You have to remove it first from the products where it is in use.',
      email_feedback: 'E-mails for receiving feedbacks from the mobile apps',
      email_feedback_helptext: 'You may use multiple e-mail addresses separated by commas.',
      printSettings: 'Print settings',
      automatPrintOrder: 'A4 Web print order automatically',
      autoSendOrderToPrinter: '80 mm print order',
      autoPrintLocalServer: 'Auto-print section receipt from local server (new or processing orders)',
      printerIp: 'Printer IP/Host',
      printerPort: 'Printer Port',
      hostname: 'Hostname (pc)',
      printerName: 'Printer Name (from windows)',
      printer_is_usb: 'Is USB concted',
      copyProductsFrom: 'Copy products from ',
      deleteProducts: 'Delete all product from this location',
      menuActions: 'Menu actions',
      overEighteen: 'Restricting users under 18 (required to sell alcohol through the application)',
      setRadiusArea: 'Set Radius Area',
      setDrawArea: 'Set Draw Area',
      jump_to_menu: 'Jump to menu',
      jump_to_categories_menu: 'Allows direct access to the menu in the application, before delivery methods.',
      allow_fiscal_print: 'Allow printing receipt',
      payment_btns_v2: 'Btns V2',
      pos: 'POS',
      use_pos_notifications: 'Use POS notifications',
      use_clients_offline: 'Use clients offline',
      use_gift_card_on_pos: 'Use gift card on POS',
      app: 'App',
      use_interactive_tour_always: 'Use interactive tour always',
      use_interactive_tour_first_login: 'Use interactive tour on first login',
      force_location_from_deeplink: 'Force location from deeplinks',
      just_card_txt_to_kiosk: 'Text just card to Kiosk',
      table_scroll_menu_horizontal: 'Scroll menu horizontally',
      add_packing_method_to_comment: 'Add packing method (eat in / take away) to the Kiosk order comment',
      useProdTimeOpt: 'Use time options for products (on Reserve/Book method only)',
      allowPlaceUntilCloseHour: 'Allow place orders until close hour',
      sortProductsMethods: 'Sort products method',
      alphabetic_asc: 'After name ascendent',
      alphabetic_desc: 'After name descendent',
      price: 'After Price',
      custom: 'Custom',
      infoCustomSort: '(custom sort is made in each category edit section)',
      filters: 'Filters',
      allowSoundAtStatusNew: 'Allow sound at orders status NEW',
      addStatusOnHold: 'Allow On Hold status',
      addStatusPostponed: 'Allow Postponed status',
      removeTotalsExtrasFromDiscount: 'Do not apply discount on taxes',
      useGrandTotalForDeliveryZoneShippingCost: 'Apply shipping discounts based on final order value',
      allowSoundAtStatusProcessing: 'Allow sound at orders status PROCESSING',
      allowSoundAtStatusProcessingV1: 'Allows sound according to the default waiting time',
      allowSoundAtStatusProcessingV2: 'Allows sound according to 1/4 of the default waiting time',
      allowSoundAtStatusProcessingV3: 'Allows sound based on 1/2 of the default waiting time',
      allowSoundAtStatusProcessingV0: 'No sound',
      allowToOrderUnderMinValueWithCoupon: 'Allow to place order under min value when apply coupon',
      flagFastOrderFromAdmin: 'Fast location order',
      allowSoundForMehods: 'Allow sound for following delivery methods',
      generateQrMenu: 'In order to generate QR codes update the',
      generateClientViewLink: 'In order to generate the access links update the',
      generateQrMenuSettings: 'company locations',
      email_transport: 'Transport e-mail',
      lateOrders: 'Late orders',
      tipSuggestion: 'Tip Suggestion',
      reorderPopupTitle: 'Reorder popup (QR menu)',
      reorderPopupMinutes: 'Inactivity minutes before showing the popup',
      reorderPopupHelp: '0 or empty disables the popup. Not shown on kiosk. Only appears if there is at least one product in the cart.',
      kioskQrSettingsTab: 'Kiosk/QR settings',
      kioskSettingsTitle: 'Kiosk/QR settings',
      kioskUsingTopCategoryLabel: 'Uses top categories',
      kioskUsingTopCategoryHelp: 'When enabled, the menu is grouped by top categories in details, kiosk and QR.',
      kioskFiscalReceiptForCashLabel: 'Kiosk uses fiscal receipt for cash',
      kioskNonFiscalReceiptForCardLabel: 'Kiosk uses non-fiscal receipt for card',
      kioskAddToCartNotificationPositionLabel: 'Notification position when adding a product to cart',
      kioskAddToCartNotificationPositionPopup: 'Popup',
      kioskAddToCartNotificationPositionSidebar: 'Sidebar',
      tipSuggestionType: 'Type',
      tipSuggestionSuggestion: 'Suggestion',
      discountSuggestion: 'Discount Suggestion',
      discountSuggestionType: 'Type',
      discountSuggestionSuggestion: 'Suggestion',
      discountSuggestionFix: 'Fix',
      discountSuggestionProc: 'Percent',
      twilio_call: 'Remind me of late orders via phone call',
      twilio_call_early_mark: 'Remind me in the first 5 minutes',
      transport_setings: 'Transport settings',
      google_maps_api_key: 'Google key API',
      deliveryMethodsReflect: 'Delivery methods updates must refelct on the',
      locationGroups: 'location groups',
      automatedProcessedStatus: 'Set automated status from "New" to "Processed"',
      donationPointValue: 'Parity donation points',
      donationPointValueNr: '(loyalty points * this value = donation points)',
      alertMultipleOrders: 'Hourly order alert',
      alertMultipleOrdersNr: 'Number of orders per hour',
      smsoToken: 'Token',
      smsoSender: 'User ID',
      smsoTokenExtern: 'Token Extern',
      smsoSenderExtern: 'User ID Extern',
      locationImage: 'Location\'s image',
      holidayTitle: 'Holiday schedule',
      holidayAlert: 'Delivery days automatically deactivate/reactivate depending on the holiday schedule interval.',
      holidayEnabled: 'Enabled',
      holidayValidFromTo: 'Valid from - to',
      apiKey: 'API Key',
      cif: 'CIF',
      addToCC: 'Add me to CC',
      automatedInvoice: 'Emit invoice automatically',
      invoicePerOrder: 'Emit Invoice per Order',
      series: 'Invoice Series',
      sendInvoice: 'Send Invoice',
      openInvoice: 'Open Invoice',
      use_auto_dispatch: 'Automatic mode',
      newOrdersProcessing: 'Process new orders',
      autoGroupingByZone: 'Auto grouping by zone',
      preparedStatus: 'Prepared status',
      autoModeText: 'The system is now operating in automatic mode. Orders will be automatically received, processed, and organized into batches based on geographical zones. Once batched, the system will allocate deliveries to the nearest available driver, ensuring efficient and timely distribution of orders.',
      manualModeText: 'The system is now operating in manual mode. Orders will be processed individually by a human operator. This includes receiving orders, organizing them into batches based on geographical zones, and manually assigning deliveries to the nearest available driver to ensure optimal distribution.',
      assignOrderToDriver: 'Assign the order to a driver',
      drivers: 'Drivers',
      unavailableRestaurantTitle: 'Unavailable Mobile App',
      unavailableRestaurantText: 'Message',
      unavailableRestaurantImage: 'Image',
      unavailableRestaurantTextPlaceHolder: 'This message will be displayed to users when no location has at least 1 delivery method enabled',
      digitalWaiter: 'Digital Waiter',
      invoices: 'Invoices',
      printer: 'Printer',
      menuIntegration: 'Integration',
      orderStatus: 'Order status',
      smsoIntegration: 'SMSO Integration',
      languages: 'Languages',
      preferences: 'Preferences',
      appQRCode: 'Mobile App QR Code',
      digitalWaiterMode: 'QR Menu Mode',
      allowOpenOrderLabel: 'Open order mode',
      allowOpenOrderHelp: 'Enables open order mode on the QR menu, letting guests keep adding to the same order across multiple rounds.',
      paymentGroup: 'Payment Group',
      createLocationCost: 'Creating a new location implies additional costs. Do you want to proceed?',
      activateLocationCost: 'Activating a new location implies additional costs. Do you want to proceed?',
      closeOrders: 'Close all {deliveryMethod} orders',
      closeOrdersAfter: 'after x hours',
      closeOrdersAt: 'at selected hour',
      autoChangeStatus: 'Auto change Status for all {deliveryMethod} orders',
      otherSettings: 'Other Settings',
      accessAndVisibility: 'Access and visibility',
      measurements_units_id: 'Measurement unit',
      quantitative_unit: 'Quantitative unit',
      reportProductOptionTitle: 'Products and Options Report',
      email__prod_opt_report: 'Email address where the report will be sent',
      time__prod_opt_report: 'Time the report will be sent',
      inv_company_name: 'Company Name',
      inv_fiscal_code: 'Fiscal Code',
      inv_trade_register: 'Trade Register',
      inv_phone: 'Phone',
      inv_email: 'Email',
      inv_country: 'Country',
      inv_address: 'Street',
      inv_street_number: 'Number',
      inv_county: 'County',
      inv_city: 'City',
      inv_additional_data: 'Additional Data',
      inv_is_vat_payer: 'VAT state',
      inv_is_vat_payer_0: 'He is NOT a VAT payer',
      inv_is_vat_payer_1: 'IS a VAT payer',
      inv_bank_account: 'Bank account',
      inv_bank: 'Bank',
      inv_bank_branch: 'Branch',
      initalOrderStatusKiosk: 'Initial status for Kiosk orders',
      initalOrderStatusApp: 'Initial status for Mobile and Web orders'
    },
    menuSubscriptions: {
      single: 'menu subscription',
      newTitle: 'New menu subscription',
      noSubscriptions: 'There are no menu subscriptions. Add the first one.',
      perDayShort: 'day',
      durationDays: '{days} days',
      menusCount: '{count} menus',
      defaultMenuShort: 'default',
      zonesCount: '{count} zones',
      notReady: 'Can not be sold yet, missing',
      notReadyHint: 'Complete what is missing to activate it',
      readyActive: 'The subscription is complete and active (it can be bought).',
      readyInactive: 'The subscription is complete. Activate it so it can be bought.',
      saveFirst: 'Save the subscription first',
      active: 'Active',
      activeAfterMenus: 'Can be activated after you add at least one menu.',
      saved: 'The subscription was saved.',
      deleted: 'The subscription was deleted.',
      areYouSureDelete: 'Are you sure you want to delete the subscription {name}?',
      tabGeneral: 'General',
      tabDelivery: 'Delivery',
      tabMenus: 'Menus',
      tabCalendar: 'Calendar',
      name: 'Name',
      namePlaceholder: 'e.g. Vegan - Lunch',
      nameRequired: 'The name is required.',
      location: 'Location that prepares the orders',
      locationPlaceholder: 'Choose the location',
      locationHint: 'The daily orders are created on this location; the products are picked from its menu.',
      locationRequired: 'Choose the location.',
      pricePerDay: 'Price per day',
      pricePerDayHint: 'One portion for one day. Every menu must add up exactly to it.',
      priceRequired: 'The price per day is required.',
      duration: 'Duration (calendar days)',
      durationHint: 'The customer picks the start date (at most {days} days ahead) and gets a delivery on every delivery day in this period.',
      durationWeekendHint: 'If we set 30 days but do not deliver at the weekend, there will actually be about 21 delivery days (depending on how the non-delivery days fall).',
      durationEstimate: 'With the delivery days ticked now: {range} delivery days out of {days} calendar days.',
      maxSubscribers: 'Max active subscribers',
      unlimited: 'Unlimited',
      maxSubscribersHint: 'Empty = unlimited.',
      minQuantity: 'Min quantity',
      maxQuantity: 'Max quantity',
      quantityHint: 'How many portions the customer can buy (e.g. 2 = double food every day).',
      description: 'Description',
      image: 'Image',
      imageHint: 'jpg/png, max 5MB',
      deliveryDays: 'Delivery days',
      deliveryDaysHint: 'On these days an order is created for every subscriber.',
      deliveryHours: 'Delivery intervals',
      deliveryHoursHint: 'The customer picks one of the intervals when buying.',
      hoursInvalid: 'Every delivery interval needs a start and an end (start before end).',
      from: 'From',
      to: 'To',
      addInterval: 'Add interval',
      orderLead: 'Create the order',
      minutes: 'minutes before',
      orderLeadExample: 'E.g. for the {from} delivery the order enters the system (POS/kitchen) at {time}.',
      orderLeadExampleDayBefore: 'E.g. for the {from} delivery the order enters the system (POS/kitchen) at {time} the day before.',
      zones: 'Delivery zones',
      zonesPickLocation: 'Choose the location first (General tab).',
      noZones: 'There are no delivery zones for the company or for this location.',
      zone: 'Zone',
      zoneDefaultFee: 'Zone fee',
      zoneFee: 'Fee per delivery',
      companyZone: 'company zone',
      locationZone: 'location zone',
      zoneInactive: 'inactive',
      zonesHint: 'The fee is paid for every delivery. Empty = the zone fee; 0 = free delivery.',
      fixErrors: 'Complete the marked fields',
      rescaleQuestion: 'The price per day changed. Adjust the product prices of the {count} menus proportionally so they add up to {price}?',
      rescaleYes: 'Yes, adjust',
      rescaleNo: 'No, I will adjust them',
      dayShort: {
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        sunday: 'Su'
      },
      months: {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December'
      },
      issues: {
        no_location: 'the location',
        no_price: 'the price per day',
        no_delivery_days: 'the delivery days',
        no_delivery_hours: 'the delivery intervals',
        no_zones: 'the delivery zones',
        no_menu: 'at least one menu',
        menu_price_mismatch: 'menus whose total differs from the price per day ({menus})'
      },
      menusTitle: 'Menus',
      menusHint: 'The default menu is delivered on every day without another menu in the calendar. Every menu must add up to {price}.',
      newMenu: 'New menu',
      editMenu: 'Edit menu',
      noMenus: 'There are no menus. The first menu added becomes the default menu.',
      defaultMenu: 'Default',
      makeDefault: 'Make it the default menu',
      duplicate: 'Duplicate',
      totalMismatch: 'total {total} - does not match the price per day',
      upcomingDays: '{count} days in the calendar',
      willAssignDates: 'After saving, the menu will be set on: {dates}',
      menuName: 'Menu name',
      menuNamePlaceholder: 'e.g. Monday - week 1',
      menuNameRequired: 'The menu name is required.',
      addProducts: 'Add products',
      searchProducts: 'Search product by name or ID',
      allCategories: 'All categories',
      noProductsFound: 'No products found.',
      catalogPrice: 'catalog price',
      catalogPriceHint: 'Catalog price (hint)',
      vat: 'VAT',
      course: 'Course',
      product: 'Product',
      quantity: 'Quantity',
      unitPrice: 'Price in menu',
      lineTotal: 'Total',
      noItems: 'Add at least one product to the menu.',
      productMissing: 'The product no longer exists. Replace it.',
      putDifferenceHere: 'Put the difference on this product',
      cannotPutDifference: 'The difference can not be split exactly by this product quantity. Pick a product with quantity 1.',
      cannotRescale: 'The total can not be reached exactly with these quantities. Add a product with quantity 1 or adjust manually.',
      menuTotal: 'Menu total',
      difference: 'Difference',
      adjustProportionally: 'Adjust proportionally to {price}',
      priceRuleHint: 'The menu prices are the ones on the order and on the fiscal receipt. The catalog price is only a hint.',
      totalMustMatch: 'The menu total ({total}) must be equal to the price per day ({price}).',
      deleteMenuQuestion: 'Are you sure you want to delete the menu {name}?',
      deleteMenuDays: 'Its {count} calendar days will get the default menu.',
      deleteMenuDefault: 'The next menu becomes the default menu.',
      menuSaved: 'The menu was saved.',
      menuSavedAssigned: 'The menu was saved and set on the selected days.',
      courses: {
        1: 'Course 1',
        2: 'Course 2',
        3: 'Course 3',
        4: 'Dessert',
        5: 'Breakfast',
        6: 'Lunch',
        7: 'Dinner',
        8: 'Snack'
      },
      calendarHint: 'Select delivery days and choose their menu. Days without a chosen menu get the default menu.',
      calendarCustom: 'Chosen menu',
      calendarDefault: 'Default menu',
      calendarNoDelivery: 'No delivery',
      calendarNoDeliveryShort: 'no delivery',
      calendarNoMenus: 'Add a menu first (Menus tab).',
      calendarNoMenu: 'no menu',
      calendarSaved: 'The calendar was saved.',
      selectMonth: 'Select the whole month',
      clearSelection: 'Clear selection',
      selectedDays: '{count} days selected',
      chooseMenu: 'Choose the menu',
      applyMenu: 'Set menu',
      resetToDefault: 'Back to the default menu',
      newMenuForDays: 'New menu for these days'
    },
    menuSubscribers: {
      title: 'Subscribers',
      offer: 'Subscription',
      allOffers: 'All subscriptions',
      customer: 'Customer',
      searchPlaceholder: 'Name, email, phone or ID',
      statusLabel: 'Status',
      status: {
        all: 'All',
        paid: 'Paid',
        active: 'Active',
        pending: 'Only tried',
        abandoned: 'Abandoned',
        stopped: 'Stopped',
        finished: 'Finished'
      },
      empty: 'There are no subscribers.',
      period: 'Period',
      portions: '{count} portions',
      portionsLabel: 'Portions',
      deliveries: 'Deliveries',
      deliveriesHint: 'delivered / orders created / total',
      scheduledCount: '{count} scheduled',
      cancelledCount: '{count} cancelled',
      errorsCount: '{count} with error',
      orderedCount: '{count} orders created',
      deliveredOf: '{delivered} delivered of {total}',
      money: 'Money',
      total: 'Total',
      paid: 'Paid',
      refunded: 'Refunded',
      refundable: 'Can still be refunded',
      valueDelivered: 'Delivered value',
      valueNotDelivered: 'Not delivered value',
      details: 'Details',
      stop: 'Stop subscription',
      stopHint: 'No more orders are created: the {count} remaining deliveries are cancelled. Money is not refunded automatically (use Refund).',
      stopConfirm: 'Stop',
      stopQuestion: 'Are you sure you want to stop the subscription of {name}?',
      stopped: 'The subscription was stopped.',
      refund: 'Refund',
      refundHint: 'At most {max} can be refunded. The value of the deliveries not made is {notDelivered} (a hint - you choose the amount).',
      amount: 'Amount',
      useSuggested: 'use {amount}',
      refundProcessorHint: 'If the payment is not settled at euPlatesc yet (usually the same day), it can only be cancelled in full; a partial amount can be refunded after settlement.',
      refundConfirm: 'Refund',
      refundQuestion: 'Are you sure you want to refund {amount} to the customer?',
      refundDone: 'The amount was refunded.',
      reason: 'Reason',
      reasonPlaceholder: 'The reason (kept in the history)',
      interval: 'Delivery interval',
      day: 'day',
      deliveryFee: 'delivery fee',
      source: 'Bought from',
      address: 'Address',
      zone: 'Zone',
      phone: 'Phone',
      comments: 'Comments',
      stoppedInfo: 'Stopped on {date} by {user}',
      noDeliveries: 'There are no deliveries (the subscription was not paid).',
      date: 'Date',
      menu: 'Menu',
      deliveryStatus: 'Delivery',
      deliveryStatuses: {
        scheduled: 'Scheduled',
        order_created: 'Order created',
        cancelled: 'Cancelled',
        error: 'Error'
      },
      orderAt: 'order at {date}',
      order: 'Order',
      value: 'Value',
      note: 'Note',
      payments: 'Payments',
      noPayments: 'No payment.',
      paymentStatuses: {
        created: 'Created',
        pending: 'Link generated',
        success: 'Paid',
        failed: 'Failed',
        expired: 'Link expired',
        cancelled: 'Cancelled',
        refunded: 'Fully refunded'
      },
      refundStatuses: {
        pending: 'in progress',
        success: 'refunded',
        failed: 'failed'
      },
      history: 'Action history',
      noHistory: 'No action.',
      events: {
        stop: 'Stopped',
        refund: 'Refunded'
      }
    },
    crossSell: {
      posSettingsTab: 'POS settings',
      title: 'Cross-sell / upsell products',
      help: 'The selected products will be suggested to the POS operator at checkout.',
      selectedTitle: 'Selected products',
      noneSelected: 'No products selected yet.',
      searchPlaceholder: 'Search products...',
      allCategories: 'All categories',
      loading: 'Loading...',
      noResults: 'No products found.',
      maxReached: 'You can select at most {max} products.',
      pageInfo: 'Page {page} of {pages} ({total} products)'
    },
    scanner: {
      notFound: 'Client was not found',
      notEnoughFunds: 'Wrong Value! Please check again',
      expired: 'Code has expired',
      confirm: 'Confirm',
      wrongInput: 'Wrong Value! Please check again',
      scanCode: 'Scan clients\' QR code'
    },
    settingDateTime: {
      timezone: 'Timezone',
      timeFormat: 'Time format',
      dateFormat: 'Date format',
      saveMsg: 'Date & Time settings saved successfully'
    },
    settingCurrency: {
      currency: 'Shop currency',
      saveMsg: 'Currency data saved successfully'
    },
    settingTaxes: {
      single: 'Tax',
      name: 'Name',
      type: 'Type',
      amount: 'Amount',
      notice: 'In this section you only define a label name for the tax to be applied. To define the tax details such as value or type you need to go to',
      notice2: 'company details',
      singleTaxLabel: 'Tax Label',
      notice3: 'In this section you define the taxes which are applied, details such as value or type, to create other tax labels go to',
      notice4: 'tax labeling',
      notice5: 'In this section you define your quota, to create other VAT lables go to'
    },
    settingsPayment: {
      publicKey: 'Public key',
      privateKey: 'Private key'
    },
    settingsWeb: {
      header_color: 'Color background header',
      header_text_color: 'Color text header',
      success: 'Details updated succesfully',
      fbLink: 'Facebook Link',
      igLink: 'Instagram Link',
      trpLink: 'Tripadvisor Link',
      twitterLink: 'Twitter Link',
      tiktokLink: 'Tiktok Link',
      linkedinLink: 'LinkedIn Link',
      websitePrezentareLink: 'Website Prezentation Link',
      whatsapp: 'WhatsApp Chat',
      gpLink: 'Google Play',
      asLink: 'Apple Store',
      fbPixel: 'Facebook Pixel',
      fbapid: 'Facebook App ID',
      interCol: 'Interface color',
      g4a: 'GA4 integration',
      site: 'Website link',
      category_proportion: 'Image category',
      product_proportion: 'Image product',
      display_mode: 'Display mode',
      background_color: 'Background color',
      font_product_title: 'Product/Category title font',
      font_product_description: 'Product description font',
      display_image_category: 'Display image category',
      social_media: 'Social media links',
      link_app: 'App links',
      tracking: 'Analytics',
      design: 'App design',
      structure: 'App structure'
    },
    settingsOrdering: {
      shipping_department_id: 'Shipping Department Id',
      reservation_pay_per_person: 'Pay per person',
      extraCostRange: 'Extra Cost Range',
      panaLa: 'Up to: ',
      distanceInKm: 'Distance in km',
      showTheRestOfTheZones: 'Show the other areas on the map',
      copyRangesFromLocation: 'Copy ranges from location',
      selectLocationToLoadRanges: 'Select a location to load the ranges.',
      location: 'Location',
      selectLocation: 'Select location',
      ranges: 'Ranges',
      min_interval_reservations: 'The number of minutes for interval reservation',
      min_standard_reservations: 'The number of hours allocated to the reservation',
      min_between_reservations: 'The number of minutes between bookings',
      available_days: 'Orar',
      reservation_available_in_app: 'Accept table reservations in the app',
      max_number_seats: 'Maximum seat capacity at the location',
      reservationWidgetTitle: 'Website reservation widget',
      reservationWidgetHint: 'Copy this script to your website. Company ID, method ID and location token are filled in automatically.',
      reservationWidgetPosition: 'Position',
      reservationWidgetLanguage: 'Language',
      reservationWidgetHoursToStay: 'Hours to stay',
      reservationWidgetDefaultPersons: 'Default guests',
      reservationWidgetTableZone: 'Table zone',
      reservationWidgetCountryPrefix: 'Country code prefix',
      reservationWidgetRestaurantName: 'Restaurant name',
      reservationWidgetScript: 'Embed script',
      reservationWidgetCopy: 'Copy script',
      reservationWidgetCopied: 'Copied',
      reservationWidgetPreview: 'Preview',
      reservationWidgetPosBottomRight: 'Bottom right',
      reservationWidgetPosBottomLeft: 'Bottom left',
      reservationWidgetPosTopRight: 'Top right',
      reservationWidgetPosTopLeft: 'Top left',
      offnoPreorders: 'You must have offset 0 and period 1 to work',
      noPreorders: 'We do not accept pre-orders',
      isAlwaysOpen: 'Always open',
      isAlwaysOpenPreorderHours: 'Preorder hours',
      reservationTaxesTitle: 'Adauga program mese',
      reservationTaxesTitleEmpty: 'Niciun program adaugat',
      reservationTaxAdvanceConsumption: 'Acest preț reprezintă avans în consumație',
      infoBoxTitle: 'Add extra information',
      infoBoxRadioCheck: 'Change the option',
      infoBoxRadio: 'Only one option allowed',
      infoBoxCheck: 'Multiple options allowed',
      enabled: 'Enabled',
      allow_fidelities: 'Allow fidelities',
      allow_fidelitiesHelp: 'Required fidelities active',
      allow_sms_notifications: 'Allows sms to notify the customer of the prepared status (*required smso integration active)',
      paymentOptions: 'Payment Options',
      paymentOptionsErr: 'The payment option field is required.',
      closeOrderAfterHours: 'This value must be between 0 and 23.',
      waitingTime: 'Default waiting time',
      count_orders_starts_from_hour: 'The time from which the order number starts',
      maxDistanceInMeter: 'Distance in meters for the table access radius:',
      minimumOrderValue: 'Minimum order value',
      extraDeliveryTime: 'EXTRA time',
      minutes: 'min',
      hours: 'hours',
      shippingCost: 'Shipping cost',
      deliveryRange: 'Delivery Range',
      deliveryRangeUnit: 'm',
      posId: 'Shipping cost POS ID',
      shippingTax: 'Shipping tax',
      locations: 'Locations',
      selectLocations: 'Select or leave blank for all',
      street: 'Street',
      city: 'City',
      country: 'Country',
      state: 'State',
      availableDays: 'Available days and hours',
      availableDaysErr: 'The available days and hours option field is required.',
      notice: 'Please check for empty fields in the enabled ordering methods',
      saveSuccess: 'Ordering details data saved successfully',
      deliveryRules: 'Delivery rules',
      addRange: 'Add rule',
      shippingCities: 'Cities / Villages',
      shippingNeighborhoods: 'Neighborhoods',
      citiesValidationError: 'Please make sure cities values are unique for each delivery range.',
      errorAutoChangeStatusAfterMin: 'This value must be between 0 and 360.',
      hourAndDate: 'Hour and Date',
      justDate: 'Just date',
      deactivateDeliveryHours: 'Deactivate hour and date',
      offset: 'Offset',
      period: 'Period',
      chooseZone: 'Choose zone',
      addZone: 'Add Zone',
      newZone: 'New Zone'
    },
    settingsZone: {
      edit: 'Zone name',
      deleteBtn: 'Delete Zone',
      deleteShape: 'Delete Shape to create another one',
      overridePayment: 'Override payment method',
      acceptCash: 'Accept cash',
      acceptCard: 'Accept card',
      acceptPos: 'POS on delivery (unpaid)'
    },
    settingsInfoPages: {
      single: 'page',
      noPage: 'No pages added yet.',
      title: 'Page Title',
      content: 'Page Content',
      newPage: 'New Page',
      showInHeader: 'Show in header',
      showInFooter: 'Show in footer',
      imageSize: 'Image size',
      imageSizeContain: 'Contain',
      imageSizeCover: 'Cover',
      imageSizeFullPage: 'Full Page',
      addedSuccess: 'Page saved successfully.',
      deletedSuccess: 'Page deleted successfully',
      deleteMsg: 'Are you sure you want to delete this page?',
      TERMS_CONDITIONS: 'Terms and Conditions',
      PRIVACY_POLICY: 'Privacy Policy',
      CONTACT_DETAILS: 'Contact Details',
      FIDELITIES_PROMOTIONS: 'Fidelities Promotions',
      LOYALITY_POINTS: 'Loyalty points rules',
      DONATION_POINTS: 'Rules for donating points',
      CUSTOM: 'Custom',
      ABOUT_US: 'Despre Noi',
      COOKIE_POLICY: 'Politica Cookies'
    },
    settingsRewards: {
      single: 'point',
      plural: 'points',
      state: 'State',
      points: 'point(s)',
      moneySpent: 'Money Spent to points',
      pointsTo: 'Points to Money',
      // numberOfcurrencyNeedToSpend: 'Amount of money client has to spend to earn 1 point.',
      numberOfcurrencyNeedToSpend: 'Number of points earned for each {currency} spent.',
      default: 'If left blank, default values will be used',
      numberOfpointsToReward: 'Amount of points client needs when he wants to pay using points.',
      rewardSuccess: 'Loyalty program data saved successfully',
      referalActive: 'Referal module has been activate',
      referalInActive: 'Referal module has been de-activate',
      enableNotifications: 'Enable Notifications',
      notifyUsersLoyaltyPoints: 'Notify the users when they receive loyalty points.',
      customizeLoyaltyPointsNotification: 'Customize the notification message from ',
      timeInterval: 'Time interval ',
      fromTime: 'From',
      toTime: 'To',
      from: 'Time interval ',
      here: 'here',
      initialReferal: 'Percentage of first order total to gain',
      parentReferal: 'Percentage gained by parent',
      loyaltyOnlyFullPoints: 'Allow only full points',
      loyaltyOnlyFullPointsHelp: 'Round earned points down to whole numbers per order, after discounts, using the configured conversion rates. Partial points do not carry forward. Existing balances and redemption value stay unchanged.',
      loyaltyMinOrderValue: 'Minimum order value to earn loyalty points',
      loyaltyMinOrderValueHelp: 'Product value after discounts, excluding shipping and tips. Orders below this amount earn no points. Leave empty for no minimum.',
      loyaltyPointsAppLimit: 'Max loyalty points allowed as discount per order'
    },
    settingsPushNotif: {
      order_new: 'New order message',
      order_completed_pickup: 'Completed order message - Pick-up',
      order_completed_meet: 'Completed order message - Meet me half way',
      order_completed_delivery: 'Completed order message - Delivery',
      order_completed_eat: 'Completed order message - Eat on location',
      order_canceled: 'Canceled order message',
      notifUpdated: 'Push notifications data saved successfully',
      preview: 'Preview',
      time: 'time',
      dateTime: 'date and time',
      persons: 'persons number',
      timePrev: '11:30 (in 30 minutes)',
      personsPrev: '3',
      dateTimePrev: 'Tuesday, February 15, 2019, at 6pm',
      info: '* In case you do not need the delivery time to be shown please leave empty the last field.',
      selectedLocations: 'Selected locations:',
      pointsPrev: '(number of points)',
      worthPrev: '(points\' worth)'
    },
    settingsTips: {
      tipsLabel: 'Tips',
      tipsTaxes: 'Tips taxes',
      tipsVat: 'Tips VAT',
      state: 'Use tips',
      tipsSuccess: 'Tips saved successfully'
    },
    settingsPlans: {
      plan1Title: 'Monthly',
      plan1Rate: '160€ / month',
      plan1Description: 'Get started with a monthly fixed fee, no matter the amount of sales you make through the app.',
      plan2Title: 'Sales percentage',
      plan2Rate: '10%',
      plan2Description: 'Pay as you sell. Chose the Sales Percentage and pay a monthly fee in relation with the amount you sell through the app.',
      current: 'Current subscription',
      switch: 'Switch'
    },
    settingLocationGroups: {
      active: 'Active',
      isOpen: 'Open',
      displayInSlider: 'Display groups in slider',
      noData: 'No data. Create new groups with "+" button. ',
      parentGroup: 'Parent Group',
      write: '(Write...)'
    },
    paymentPage: {
      invoice: 'Invoice',
      total: 'Total',
      forDate: 'For date',
      payed: 'Payed',
      transaction: 'Transaction',
      payLink: 'Pay Link',
      viewInvoice: 'View invoice',
      download: 'Download',
      pay: 'Pay',
      invoiceList: 'Invoice list'
    },
    filter: {
      filter: 'Filter',
      action: 'Action',
      create: 'Filter Created',
      update: 'Filter Updated',
      areYouSureDelete: 'Are you sure you want to delete this filter',
      yes: 'Yes',
      deleted: 'Filter deleted',
      noFilters: 'No filters',
      name: 'Name',
      addFilter: 'Add filter',
      filters: 'Filters',
      value: 'Value',
      filterProducts: 'Filters Products',
      filterName: 'Filter Name',
      val: 'Val',
      filterUpdated: 'Filters Updated',
      minOneFilterValueRequired: 'Minim one filter value per filter required',
      filterType: 'Filter Type',
      type_exists: 'Filter Type Exists',
      filter_value_exists: 'Filter Value Exists',
      some_filter_applied: 'Successfully updated but some filter or value are applied on products and it can\'t be deleted'
    },
    newsletterCard: {
      title: 'List with news, info and support',
      titleNews: 'News',
      titleMonthlyInfo: 'Monthly Info',
      titleVideoSupport: 'Video and Support',
      helpVideoSupport: 'Do you need help?',
      searchPlaceholder: 'Search',
      noResultsMessage: 'Could not find any video with this name or title.',
      tableName: 'Name',
      tableDate: 'Date',
      tableDownload: 'Download',
      buttonDownload: 'Download',
      allArticles: 'All articles',
      articleFound: 'article found',
      searchArticle: 'Search article',
      readArticle: 'Read article'
    },
    groupOption: {
      areYouSure: 'Are you sure?',
      importTitle: 'Add this group to all products in the category',
      importAdd: 'Add'
    },
    rkeeperV2: {
      title: 'RKeeper V2',
      url: 'Endpoint URL',
      slug: 'Restaurant Slug',
      apiUser: 'API User (X-Api-User)',
      apiSecret: 'API Secret (X-Api-Secret)',
      secret: 'Webhook Secret',
      testLogin: 'Test login',
      save: 'Save',
      saved: 'Saved',
      error: 'An error occurred',
      active: 'Active',
      loginOk: 'Login successful',
      loginFail: 'Login failed',
      syncMenu: 'Sync menu',
      syncQueued: 'Menu sync started…',
      running: 'Menu sync in progress…'
    },
    rkeeper: {
      rkeeper: 'RKeeper',
      import: 'Import',
      products: 'Import All Products',
      categories: 'Import Categories',
      sync: 'RKeeper Synchronization',
      onlyProducts: 'Sync Only New Products',
      onlyOptions: 'Sync Only New Options',
      productPrices: 'Sync Product Prices',
      optionPrices: 'Sync Option Prices',
      importSuccess: 'The import was successful. Don\'t forget to sync prices.',
      importError: 'The import could not be completed',
      syncSuccess: 'The synchronization was successful',
      syncError: 'The synchronization could not be completed',
      importInProgress: 'The import has started. This process can take a few minutes',
      syncInProgress: 'The synchronization has started. This process can take a few minutes'
    },
    glovo: {
      noTrackingNumber: 'No tracking number was found. Courier was not canceled',
      areYouSure: 'Are you sure you want to call Glovo courier?',
      errorPickupTime: 'Choosen pick up time is not available',
      outOfWorkingAreaDeliveryAddress: 'Delivery address is not available',
      canNotCancel: 'The order has been picked up already, it cannot be canceled',
      CAN_NOT_CANCEL: 'The order has been picked up already, it cannot be canceled',
      addressesNotInSameCityCode: 'Choosen addresses are not in the same city',
      outOfWorkingHours: 'There are no couriers available at the moment',
      outOfWorkingAreaPickupAddress: 'Pick up address is not available',
      error: 'An error occurred',
      syncLabel: 'Sync Glovo Menu',
      noTopCat: 'Deactivate unused top categories and try again',
      noCat: 'The categories that are active have no active products'
    },
    tazz: {
      noTrackingNumber: 'No tracking number was found. Courier was not canceled',
      areYouSure: 'Are you sure you want to call Tazz courier?',
      areYouSureCancel: 'Are you sure you want to cancel Tazz courier?',
      errorPickupTime: 'Choosen pick up time is not available',
      outOfWorkingAreaDeliveryAddress: 'Delivery address is not available',
      canNotCancel: 'The order has been picked up already, it cannot be canceled',
      CAN_NOT_CANCEL: 'The order has been picked up already, it cannot be canceled',
      addressesNotInSameCityCode: 'Choosen addresses are not in the same city',
      outOfWorkingHours: 'There are no couriers available at the moment',
      outOfWorkingAreaPickupAddress: 'Pick up address is not available',
      error: 'An error occurred',
      syncLabel: 'Sync Tazz Menu',
      tazzStatus1: 'The courier was not called',
      tazzStatus2: 'The courier was called',
      tazzStatus3: 'The courier was not called',
      tazzStatus4: 'The courier was canceled',
      tazzStatus5: 'An error ocurred',
      orderPrepared: 'O. Prepared'
    },
    importProductsError: {
      noTopCat: 'Deactivate unused top categories and try again',
      noCat: 'The categories that are active have no active products'
    },
    bolt: {
      acceptOrders: 'Accept Orders',
      menu: 'Menu',
      sync: 'Update started, it make take a while',
      syncError: 'Updated could not be made'
    },
    wolt: {
      integrateLocation: 'Choose location to onboard',
      getWolt: 'Get onto Wolt',
      updateCredentials: 'Update Credentials',
      redirectToWolt: 'Redirect to Wolt'
    },
    posnet: {
      enableReport: 'Enable report',
      reportDate: 'Report Date',
      confirmActivateReport: 'Do you want to activate the report for date {date}?',
      confirmActivateReportAutomated: 'Are you sure you want to activate the report in automated mode for yesterday\'s date ({date})?'
    },
    epRestaurant: {
      importLabel: 'Import Ep Restaurant Menu',
      resendQuestion: 'Are you sure you want to resend this order?'
    },
    nexus: {
      ordersPeriod: 'Orders Interval',
      elgibleOrders: 'In order to be eligible for integration, orders must be collected and in status "DELIVERED".',
      ordersAlreadyIntegrated: 'Orders that are already successfully integrated are not considered.',
      pickupDatetime: 'Pickup Date',
      paymentType: 'Payment Type',
      orderStatus: 'Order Status',
      isSent: 'Status',
      retryCount: 'Retries',
      retryAt: 'Retry At',
      receiptNumber: 'Receipt Number',
      nexusOrderId: 'Nexus Document ID',
      sentStatus0: 'Pending',
      sentStatus1: 'Sent',
      sentStatus2: 'Failed',
      sentStatus3: 'Cancelled',
      sentStatus4: 'Retry Scheduled',
      sentStatus5: 'Pending Cancellation',
      vatRate: 'VAT Rate',
      markResend: 'Resend',
      markCancellation: 'Cancel',
      markResendConfirm: 'The filtered selection will be marked to be sent again to Nexus. Do you wish to proceed?',
      markCancellationConfirm: 'The filtered selection will be marked for cancellation in Nexus. Do you wish to proceed?',
      markSuccessMessage: 'The orders have been marked and will be sent in a few minutes. The logs can be found in the Actions column.',
      invoiceStatus: 'Nexus Status',
      invoiceLog: 'Nexus Log',
      invoiceSend: 'Send to Nexus',
      invoiceSendConfirm: 'Mark this invoice to be sent to Nexus?',
      invoiceStornoConfirm: 'Mark this invoice for storno in Nexus?',
      invoiceMarkSuccess: 'The invoice has been marked for Nexus and will be processed shortly.',
      invoiceNoOrder: 'This invoice has no linked order ID.',
      invoiceStatusUnknown: 'Nexus status is unavailable for this invoice.',
      invoiceStatus1: 'Queued for Nexus',
      invoiceStatus1Text: 'The invoice is waiting to be sent to Nexus.',
      invoiceStatus2: 'Sending to Nexus',
      invoiceStatus2Text: 'The invoice is currently being sent to Nexus.',
      invoiceStatus3: 'Sent successfully',
      invoiceStatus3Text: 'The invoice was sent to Nexus successfully.',
      invoiceStatus4: 'Send failed',
      invoiceStatus4Text: 'An error occurred while sending the invoice to Nexus.',
      invoiceStatus5: 'Queued for storno',
      invoiceStatus5Text: 'The invoice is marked for storno in Nexus.',
      invoiceStatus6: 'Storno completed',
      invoiceStatus6Text: 'The invoice was successfully cancelled in Nexus.',
      invoiceStatus7: 'Storno failed',
      invoiceStatus7Text: 'An error occurred while cancelling the invoice in Nexus.'
    },
    rsystem: {
      fetchOrganizations: 'Retrieve organizations',
      choose: 'Choose an option',
      tipsId: 'Tips type',
      completeSetup: 'Complete the R Systems organization, terminal group and payment mappings before saving.',
      proc: 'Proc (percentage)',
      fix: 'Fix (fixed amount)',
      adjustable: 'Adjustable',
      recommended: 'Recommended',
      payment_CASH: 'Cash',
      payment_CARD: 'Online card',
      payment_POS: 'POS',
      payment_CARD_POS: 'Card at POS',
      payment_ONLINE: 'Online',
      reviewMappings: 'Review suggested mappings. Choose explicitly where multiple methods match.',
      destination: 'Destination',
      refreshMenu: 'The organization changed. Reconcile the old menu and explicitly import the selected organization’s menu before taking orders.',
      requestFailed: 'Unable to retrieve R Systems settings. Retry.',
      saved: 'Integration settings saved.',
      importConfirm: 'Import the menu for the saved organization? Reconcile the old menu first; existing orders will retain their saved product IDs.',
      importQueued: 'Menu retrieved and queued for processing.',
      apiKey: 'API Key',
      organisationId: 'Organization',
      terminalGroupId: 'Terminal group',
      paymentTypes: 'Payment Methods',
      discountId: 'Discount',
      settings: 'Settings',
      deleteMenu: 'Delete old menu before import',
      seoText: 'Make sure your menu has SEO text TapTasty before importing',
      import: 'Import'
    },
    checkbox: 'Allows selecting multiple options on the product',
    radio: 'Allows selecting only one option on the product',
    ebriza: {
      title: 'Ebriza',
      woltDriveErrorsUrl: 'Wolt Drive errors notification endpoint'
    },
    ...enLocale
  },
  ro: {
    btPayments: btPayments.ro,
    zoneAvailability: {
      title: 'Disponibilitate zonă',
      active: 'Zonă activă',
      activeHelp: 'O zonă inactivă nu mai este disponibilă pentru livrare (adresele din ea sunt tratate ca fiind în afara zonei de livrare).',
      inactive: 'Inactivă',
      activeColumn: 'Activă',
      scheduleEnabled: 'Activează programul orar',
      scheduleEnabledHelp: 'Când e dezactivat, zona funcționează ca până acum (disponibilă oricând livrează locația). Când e activat, zona e disponibilă doar în intervalele de mai jos.',
      withSchedule: 'Program',
      column: 'Disponibilitate',
      hoursRequired: 'Setează ora de început și de sfârșit pentru fiecare interval al zilelor bifate.',
      hoursOrder: 'Ora de început trebuie să fie mai mică decât ora de sfârșit.',
      overlap: 'Intervalele dintr-o zi nu se pot suprapune.',
      noOpenDay: 'Bifează cel puțin o zi în program (sau fă zona inactivă).',
      zoneLabel: 'Zona'
    },
    marketplace: marketplace.ro,
    platformMenuImport: platformMenuImport.ro,
    deliveryPreferences: {
      deliveryTypeTitle: 'Preferințe livrare',
      zonesTitle: 'Zone',
      slotsTitle: 'Sloturi',
      preferencesTitle: 'Tip livrare',
      name: 'Denumire externă (afișat în aplicație)',
      numeAdmin: 'Denumire internă',
      numeAdminPlaceholder: 'ex: Livrare standard pt locația X',
      add: 'Adaugă',
      edit: 'Editează',
      clone: 'Clonează',
      back: 'Înapoi',
      noData: 'Nu există înregistrări încă',
      saved: 'Salvat',
      deleteConfirm: 'Sigur vrei să ștergi această înregistrare?',
      // validation
      drawShapeRequired: 'Desenează o zonă pe hartă înainte de salvare.',
      seatsRequired: 'Completează toate rândurile de locuri (număr și preț).',
      duplicateZone: 'Această zonă este deja adăugată.',
      zoneRequired: 'Adaugă cel puțin o zonă de livrare.',
      hoursRequired: 'Setează ora de început și de sfârșit pentru zilele/rândurile active.',
      hoursOrder: 'Ora de început trebuie să fie mai mică decât ora de sfârșit.',
      slotRequired: 'Alege un slot pentru rândurile active.',
      // slots
      slotAdd: 'Adaugă slot',
      slotSingle: 'slot',
      costPerParte: 'Cost per parte (taxă de urgență, opțional)',
      costPerParteHelp: 'Dacă e setat, clientul poate alege în ce parte a slotului să vină (prima / ultima) pentru această taxă în plus.',
      seats: 'Locuri',
      seatsCount: 'Număr locuri (0 = nelimitat)',
      seatCost: 'Preț',
      addSeatTier: 'Adaugă rând de locuri',
      seatsHelp: 'Locurile se ocupă de la cel mai ieftin; cu cât clientul comandă mai târziu, cu atât e mai scump.',
      // zones
      zoneAdd: 'Adaugă zonă',
      zoneSingle: 'zonă',
      companyZone: 'Zonă companie',
      locationZone: 'Zonă locație',
      legacyReadonly: 'Zonă veche pe locație — needitabilă. Cloneaz-o ca s-o folosești în sistemul nou.',
      cloneName: 'Nume zonă nouă',
      showOtherZones: 'Arată alte zone pe hartă',
      showOtherZonesPlaceholder: 'Alege zone de afișat ca referință',
      shippingCost: 'Cost livrare',
      minOrderValue: 'Valoare minimă comandă',
      extraDeliveryTime: 'Timp livrare suplimentar (min)',
      // preferences
      preferenceAdd: 'Adaugă tip livrare',
      preferenceSingle: 'preferință',
      type: 'Tip',
      typeClassic: 'Clasică',
      typeSlot: 'Slot',
      typeClassicHelp: 'Clientul poate să selecteze, în funcție de bifele de jos, o dată/oră exactă sau varianta fără dată și oră.',
      typeSlotHelp: 'Apar mai multe sloturi și clientul își alege cel potrivit.',
      enabled: 'Activă',
      hourMode: 'Ore și dată',
      hourModeHourDate: 'Oră și dată',
      hourModeDateOnly: 'Doar dată',
      hourModeDisabled: 'Dezactivează ora și data',
      hourModeHourDateHelp: 'Clientul alege ora și data (data doar dacă offset și period nu sunt 0 și 1).',
      hourModeDateOnlyHelp: 'Clientul alege doar data.',
      hourModeDisabledHelp: 'Clientul nu alege nimic — livrarea se face după programul de livrări al restaurantului. În acest mod nu este disponibil nici programul: clientul pune comanda și va fi informat când o va primi.',
      offsetPeriodHelp: 'Offset = numărul de zile lucrătoare (deschise) de acum până când clientul are voie să comande. Period = numărul de zile lucrătoare (deschise) de la terminarea offset-ului în care clientul poate comanda. Ex: offset 1, period 2 → azi nu poate comanda, doar mâine și poimâine; dacă azi programul e închis, numărătoarea începe din următoarea zi deschisă.',
      availableDays: 'Zile disponibile',
      noPreorders: 'Acceptăm comenzi doar în timpul programului',
      isAlwaysOpen: 'Program de lucru non stop',
      minimumOrderValue: 'Valoare minimă comandă',
      defaultWaitingTime: 'Interval minim înainte de închidere (durata preparării comenzii + livrare)',
      autoAssignFirstSlot: 'Nu permite clientului să aleagă slotul, atribuie primul slot disponibil',
      delayHours: 'Întârziere (ore)',
      delayHoursHelp: 'Clientul poate alege doar sloturi care încep peste cel puțin atâtea ore de acum.',
      schedule: 'Program săptămânal',
      addScheduleRow: 'Adaugă slot',
      slot: 'Slot',
      selectSlot: 'Alege slot',
      startTime: 'Început',
      endTime: 'Sfârșit',
      active: 'Activ',
      closedDates: 'Suprascriere calendaristică a programului de livrare',
      closedDatesHelp: 'Pentru o dată anume poți opri livrarea toată ziua sau poți înlocui programul săptămânal cu un program propriu (sloturi și intervale, la fel ca mai sus), ex: sărbători.',
      closedAllDay: 'Nu se livrează toată ziua',
      closedOverrideSchedule: 'Suprascrie program',
      closedNoDelivery: 'Fără livrări în această zi',
      closedEmpty: 'Nicio suprascriere adăugată.',
      closedScheduleEmpty: 'Niciun slot adăugat pentru această zi.',
      closedScheduleRequired: 'Adaugă cel puțin un slot pentru fiecare zi cu program suprascris (sau alege „Nu se livrează toată ziua”).',
      closedCopyWeekly: 'Copiază programul de {day}',
      closedCopyConfirm: 'Înlocuiești sloturile acestei zile cu programul săptămânal de {day}?',
      closedDateDuplicate: 'Aceeași dată apare de mai multe ori în suprascrierea calendaristică.',
      addClosedDate: 'Adaugă dată',
      zones: 'Zone de livrare',
      selectZone: 'Alege zonă',
      noZone: 'Fără zonă',
      methods: 'Metode de livrare',
      // days
      mon: 'Luni',
      tue: 'Marți',
      wed: 'Miercuri',
      thu: 'Joi',
      fri: 'Vineri',
      sat: 'Sâmbătă',
      sun: 'Duminică',
      // method integration
      useMultiplePreferences: 'Folosește mai multe tipuri de livrare',
      useMultiplePreferencesHelp: 'Când e activ, această metodă folosește tipurile de livrare de mai jos în locul setărilor clasice.',
      selectPreferences: 'Tip livrare'
    },
    general: {
      noAccessRaport: 'Este necesara permisiunea la rapoarte!',
      noAccessUsers: 'Doar administratorii au acces la utilizatori',
      contactAdmin: 'Contactati administratorul',
      tips_department_id: 'Department Id',
      addConversion: 'Adauga Conversie',
      selectUnit: 'Selecteaza Unitate',
      download: 'Descarca',
      see: 'Vezi',
      visualize: 'Vizualizează',
      search: 'Caută',
      home: 'Acasă',
      add: 'Adaugă',
      edit: 'Editează',
      delete: 'Șterge',
      remove: 'Elimină',
      save: 'Salvează',
      saveAndSend: 'Salvează & Trimite',
      fillRequiredFields: 'Completați câmpurile obligatorii',
      update: 'Actualizează',
      cancel: 'Anulează',
      copy: 'Copiază',
      cancel2: 'Renunță',
      close: 'Închide',
      continue: 'Continuă',
      activate: 'Activează',
      deactivate: 'Dezactivează',
      active: 'Activ',
      inactive: 'Inactiv',
      specialPrice: 'Preț Special',
      removePhoto: 'Prea multe imagini încărcate',
      yes: 'Da',
      no: 'Nu',
      success: 'Succes',
      required: 'Necesar',
      back: 'Înapoi',
      next: 'Următorul',
      finish: 'Finalizează',
      download_xls: 'exportă in xls',
      download_pdf: 'exportă in pdf',
      detail: 'Amănunt',
      duplicate: 'Duplică',
      select: 'Selectează',
      all: 'Toate',
      alls: 'Toți',
      reset: 'Resetează',
      export: 'Exportă',
      loadMore: 'Încarcă mai mult',
      viewDetails: 'Vezi Detalii',
      details: 'Detalii',
      showing: '{length} rezultate afișate',
      action: 'Acțiune',
      enable: 'activezi',
      disable: 'dezactivezi',
      product: 'produsul',
      logout: 'Deconectare',
      from: 'de la ',
      to: 'pana la ',
      cancelCourier: 'Anulează curier',
      agree: 'De accord',
      agreePopupMessage: 'Pentru a permite browserului să redea sunete, trebuie să faceți clic pe butonul „De acord”. Aceasta va reda un sunet de test pentru a activa redarea sunetului in browser.',
      orderLocaionNoDriverLocation: 'Atentie! Locatia comenzi nu corespunde cu locatia soferului',
      day: 'ziua',
      notCompleted: 'necompletat',
      saveChanges: 'Salvează schimbările',
      doYouWantToLogout: 'Vrei sa te deconectezi?',
      minutes: 'minute',
      hour: 'ora',
      hours: 'ore',
      deliveryMethod: 'Metode Livrare',
      customSort: 'Compania folosește sortarea custom',
      none: 'Niciunul',
      unset: 'Nesetat',
      included: 'Inclus',
      error: 'Eroare',
      logo: 'Logo',
      appImage: 'Imagine aplicație',
      copyToClipboard: 'Copiază',
      copyUrlToClipboard: 'Copiază URL',
      start: 'Începe',
      actions: 'Acțiuni',
      leavePageQuestion: 'Modificările nesalvate se vor pierde. Ești sigur că dorești să părăsești pagina?',
      sortOrder: 'Sortează',
      sortCreatedAscending: 'Comandă plasată: cele mai vechi primele',
      sortCreatedDescending: 'Comandă plasată: cele mai noi primele',
      sortPickupAscending: 'Livrare așteptată: cele mai devreme primele',
      sortPickupDescending: 'Livrare așteptată: cele mai târzii primele',
      wallet: 'Încarcă bani',
      walletRemove: 'Descarcă portofel',
      walletAdd: 'Adaugă sumă în portofel',
      walletAddFor: 'Adaugă suma pentru',
      walletRemoveFor: 'Șterge suma pentru',
      walletPlaceholder: 'Introdu suma:',
      walletSuccess: 'Suma a fost adăugată în portofel!',
      walletRemoved: 'Suma a fost ștearsă în portofel!',
      walletError: 'A apărut o eroare la adăugarea sumei.',
      invalidAmount: 'Te rog să introduci un număr valid',
      amountExceedsBalance: 'Suma depășește soldul actual al portofelului',
      changeOrderLocationSuccess: 'Locația a fost actualizată cu succes!',
      changeOrderLocationFailed: 'Nu s-a putut actualiza locația. Vă rugăm să încercați din nou.',
      generalAreYouSure: 'Sunteți sigur?',
      generalLoader: 'Se încarcă, vă rugăm așteptați...',
      no_data: 'Nu s-au găsit date', // nu "sau" gasit?? serios?
      set: 'Setează',
      regenerateQr: 'Regenerare cod QR',
      noProduct: 'Nu sunt produse',
      noProductPos: 'Selectați un element din meniu pentru a începe.',
      applyPoints: 'Folosește punctele',
      loyaltyPoints: 'Puncte de loialitate:',
      apply: 'Aplică',
      load: 'Încarcă',
      reload: 'Reîncarcă',
      retry: 'Reîncearcă',
      normal: 'Normal',
      big: 'Mare',
      registrationDate: 'Dată înregistrare',
      accept: 'Aprobă',
      deny: 'Refuză',
      accepted: 'Acceptat',
      denied: 'Refuzat',
      pending: 'În așteptare',
      completed: 'Finalizat',
      contactSuportFeature: 'Contactați suportul pentru această funcționalitate',
      administration: 'Gestiune',
      noAdministrationsAvailable: 'Nu s-au găsit gestiuni',
      setAdministration: 'Apasă pe "Adaugă" pentru a seta o gestiune',
      loading: 'Vă rugăm așteptați',
      justMoment: 'Doar un moment...',
      orderId: 'ID Comandă',
      year: 'An',
      month: 'Lună',
      segment: 'Segment Curent',
      selectAll: 'Selectează tot',
      deselectAll: 'Anulează selecția',
      confirm: 'Confirmă',
      ok: 'OK',
      validate: 'Validează',
      noResults: 'Nu există rezultate.',
      clearSelection: 'Șterge selecția',
      associateTables: 'Asociază mese',
      associateChooseUsers: '1) Alege utilizatori',
      associateChooseTables: '2) Alege mese',
      selected: 'Selectați',
      emDash: '\u2014',
      idHash: '#{id}',
      breadcrumbSeparator: ' \u00bb ',
      statusUnknown: 'Status necunoscut',
      modulesActivate: 'Module activate',
      ecosystem: 'ECOSISTEMUL TAPTASTY',
      ecosystem_more_than_you_use: 'Taptasty este mai mult decât folosești acum.',
      how_much_you_use: 'Cât folosești tu',
      only_this_much_you_use: 'Doar atât folosești?',
      you_use_full_system: 'Folosești tot sistemul',
      all_taptasty_modules: 'Toate modulele TapTasty',
      modules_reservations: 'Rezervări',
      modules_tables: 'Mese',
      modules_dispatch: 'Dispecerat',
      modules_kds: 'KDS',
      modules_pms: 'PMS',
      modules_catalog: 'Catalog',
      modules_screens: 'Ecrane',
      modules_pos: 'POS',
      modules_inventory: 'Gestiune',
      modules_clients: 'Clienți',
      modules_orders: 'Comenzi',
      modules_add_order: 'Adaugă comandă',
      modules_marketing: 'Marketing',
      modules_marketing_gift: 'Card cadou',
      modules_kiosk: 'Kiosk',
      modules_qr_ordering: 'Comandă QR',
      modules_website: 'Website',
      modules_app: 'App',
      modules_active: 'Module active',
      modules_inactive_hint: 'Ți-ai dori să folosești?',
      modules_website_title: 'Modul Website',
      modules_website_message: 'Modulul Website nu este activat pentru această companie.',
      modules_website_hint: 'Activează-l din setările companiei.',
      modules_marketing_title: 'Modul Marketing este dezactivat',
      modules_marketing_message: 'Acest modul nu este inclus în planul tău actual sau nu este activat pentru companie.',
      modules_marketing_hint: 'Contactează administratorul sau upgradează planul pentru a activa funcționalitățile de marketing.',
      modules_gift_card_title: 'Modul Gift Card este dezactivat',
      modules_gift_card_message: 'Acest modul nu este activat pentru compania ta sau nu este inclus în planul actual.',
      modules_gift_card_hint: 'Contactează administratorul sau activează modulul Gift Card pentru a continua.'
    },
    pos: {
      default_interval_raport: 'Selecteaza intervalul rapoartelor',
      default_intervals_raport0: '00:00 la 23:59',
      default_intervals_raport1: 'de la ultimul Z',
      default_intervals_raport2: '05:00 la 05:00'
    },
    giftCard: {
      errorTotalNumberMax: 'Numărul total nu poate fi mai mare de 10000',
      errorExpirationTimeMax: 'Timpul de expirare nu poate fi mai mare de 700',
      addgift: '+ Adaugă Bază Card Cadou',
      value: 'Valoare',
      exp: 'Expirare (luni)',
      type: 'Tip',
      generatedCards: 'Carduri Generate',
      active: 'Activ',
      online: 'ONLINE',
      offline: 'OFFLINE',
      yes: 'Da',
      no: 'Nu',
      modalTitle: 'Adaugă Bază Card Cadou',
      typeLabel: 'Tip',
      selectType: 'Selectează tipul',
      valueLabel: 'Valoare',
      expLabel: 'Timp Expirare (luni)',
      totalCards: 'Total Carduri (Offline)',
      cancel: 'Anulează',
      save: 'Salvează',
      errorTitle: 'Eroare!',
      errorRequired: 'Tipul și Valoarea sunt obligatorii.',
      errorOffline: 'Total carduri obligatoriu pentru OFFLINE.',
      successTitle: 'Succes!',
      successMessage: 'Baza Card Cadou a fost creată.',
      errorCreate: 'Eroare la crearea bazei.',
      ok: 'OK',
      baseTitle: 'Bază Card Cadou',
      inactive: 'Inactiv',
      fromDate: 'De la',
      toDate: 'Până la',
      cardsListTitle: 'Listă Carduri Cadou',
      allStatus: 'Toate Statusurile',
      used: 'Folosit',
      unused: 'Nefolosit',
      allPayments: 'Toate Plățile',
      payed: 'Plătit',
      unpayed: 'Neplătit',
      export: 'Export',
      qr: 'QR',
      status: 'Status',
      payment: 'Plată',
      assignedTo: 'Atribuit Către',
      created: 'Creat',
      copyLink: 'Copiază Link',
      notAssigned: 'Neatribuit',
      showingRecords: 'Se afișează {from} până la {to} din {total} înregistrări',
      confirmDeleteTitle: 'Ești sigur?',
      confirmDeleteText: 'Toate cardurile nefolosite vor fi șterse de asemenea!',
      yesButton: 'Da',
      noButton: 'Nu',
      deleteSuccess: 'Baza de carduri cadou a fost ștearsă cu succes',
      deleteError: 'Eroare la ștergerea bazei de carduri cadou',
      linkCopied: 'Link copiat în clipboard!',
      updateSuccess: 'Actualizat cu succes',
      updateError: 'Eroare la actualizare',
      notAvailable: 'N/A',
      user: 'Utilizator'
    },
    txtForColors: {
      sideBarBg: {
        title: 'Fundal bara laterala',
        msg: 'Schimba culoarea fundalului la bara laterala'
      },
      mainPageBg: {
        title: 'Fundal continut meniu',
        msg: 'Schimba culoarea fundalului la continutul meniului'
      },
      addBtnColor: {
        title: 'Fundal culoarea butoane principale',
        msg: 'Schimba culoarea fundalului la butoanele principale'
      },
      addBtnColorInv: {
        title: 'Fundal texte butoane principale',
        msg: 'Schimba fundal textelor la butoanele principale'
      },
      iconsColor1: {
        title: 'Culoare fundal iconite/butoane',
        msg: 'Schimba culoarea fundalului la toate iconitele si butoaneele'
      },
      iconsColor2: {
        title: 'Fundal texte',
        msg: 'Schimba culoarea fundalului la unele textele'
      },
      secundarColor: {
        title: 'Pagina de start',
        msg: 'Schimba culoarea fundalului cand kiosskul este in asteptare'
      },
      principalColor: {
        title: 'Culoarea Principala',
        msg: 'Culoare principala a fundalului si a instrumentelor'
      }
    },
    stock: {
      saving: 'Saving...',
      saveStocks: 'Save Stocks',
      title: 'Stock Configuration',
      subtitle: 'Set stock for each product per location',
      searchByName: 'Search by name',
      productNamePlaceholder: 'Product name...',
      searchById: 'Search by ID',
      productIdPlaceholder: 'Product ID...',
      allCategories: 'All categories',
      resetFilters: 'Reset filters',
      loadingProducts: 'Loading products...',
      product: 'Product',
      idLabel: 'ID: {id}',
      currency: 'RON',
      notAvailable: 'Not available',
      active: 'Active',
      stock: 'Stock',
      stockPlaceholder: '0',
      reservation: 'Reservation (pcs)',
      reservationPlaceholder: '0',
      reservationError: 'Reservation cannot exceed stock',
      allowNegative: 'Allow Negative',
      activateForSources: 'Activate for sources:',
      pos: 'POS',
      app: 'App',
      website: 'Website',
      qr: 'QR',
      kiosk: 'Kiosk',
      page: 'Page {page} of {totalPages}',
      productsCount: '({totalRecords} products)',
      previous: 'Previous',
      next: 'Next',
      noProductsAvailable: 'No products available',
      stocksSavedSuccess: 'Stocks saved successfully!'
    },
    pricesFor: {
      1: 'Preț Website',
      2: 'Preț QR',
      3: 'Preț Kiosk',
      4: 'Preț POS',
      5: 'Preț GLOVO',
      6: 'Preț BOLT',
      7: 'Preț Wolt'
    },
    dispath: {
      reset_map: 'Reinițializează harta',
      dispatch: 'Dispecerat',
      drivers: 'Șoferi',
      driverID: 'Sofer ID',
      driverName: 'Nume sofer',
      value: 'Valoare',
      from: 'De la',
      totalActive: 'Total activi',
      totalInactive: 'Total inactivi',
      orders: 'Comenzi',
      reports: 'Rapoarte',
      walletReport: 'Portofel',
      programReport: 'Pontaj',
      activityReport: 'Timp activ',
      mapReport: 'Map',
      selectDriver: 'Selectează livratori',
      addGroupOrder: 'Batch de comenzi',
      unassigned: 'Nealocate',
      batched: 'Lot',
      grouped: 'Grupate',
      posibleGrouped: 'Grupuri posibile',
      sugestion: 'Sugestie',
      createOrderGroupSuccess: 'Grupul de comenzi a fost creat cu succes.',
      createOrderGroupError: 'Nu s-a putut crea grupul de comenzi',
      addOrderGroupPosibileSuccess: 'Comanda a fost adăugată la grup.',
      addOrderGroupPosibileError: 'Nu s-a putut adăuga comanda în grup.',
      assign: 'Asignat',
      legend: 'Legenda',
      driverWithOrder: 'Sofer cu comanda',
      driverWithoutOrder: 'Șofer fără comanda',
      movementDirection: 'Direcția de mișcare',
      stopWithDelivery: 'Oprit cu livrare',
      stopWithoutDelivery: 'Oprit fără livrare',
      general: 'General',
      users: 'Utilizatori',
      dispatchers: 'Dispeceri',
      walletSettings: 'Portofel plata cash / Plata la comanda',
      disableUndeliveredOrder: 'Dezactiveaza Comanda nelivrata',
      downloadApp: 'Descarca aplicatia de livrator',
      settings: 'Setări',
      addNewOrder: 'Adauga Comanda',
      zone: 'Zone'
    },
    kds: {
      importTitle: 'Setează secția selectată pe toate produsele din categoria selectată',
      section: 'Secție',
      status: 'Status',
      location: 'Locație',
      name: 'Nume',
      deliveryMethods: 'Metode de livrare',
      noData: 'Apăsați +Adaugă pentru un status nou',
      areYouSureDelete: 'Sigur dorești să ștergi aceast KDS?',
      kds: 'KDS',
      kitchenDisplayScreen: 'Ecran de bucătărie',
      kdsSections: 'Secții KDS',
      settings: 'Setări',
      general: 'General',
      useStartTimerForAllItems: 'Permite pornirea cronometrului pe toată comanda',
      startTimer: 'Pornește cronometrul',
      orderAveragePrepTime: 'Timp mediu de preparare',
      users: 'Utilizatori',
      sections: 'Secții',
      ods: 'ODS',
      report: 'Raport',
      orderDisplayScreen: 'Ecran de comandă',
      kdsCode: 'Cod Kds',
      loginCode: 'Login Code (cod unic din 4 cifre)',
      loginCodeNotUnique: 'Codul nu este unic',
      useOrderLanes: 'Afișare comenzi pe 2 coloane (Sala / Livrare)',
      lane_1_color: 'Culoare de fundal pentru comenzi pe sala',
      lane_2_color: 'Culoare de fundal pentru comenzi livrare',
      allowOptionTimer: 'Permite pornirea cronometrului pe opțiuni',
      allowOptionTimerInfo: 'Necesită setarea secților pe opțiuni',
      allowCourseTimer: 'Permite pornirea cronometrului pe feluri',
      timeProcessingStatus: 'Cronometreaza timpul petrecut in processing',
      displayStartedOrdersFirst: 'Afișează comenzile pornite primele',
      groupProductsByCategory: 'Grupează produsele după categorie',
      hidePreparedItems: 'Ascunde produsele preparate',
      displayWaiterName: 'Afișează numele ospătarului',
      displayDeliveryTime: 'Afișează ora de livrare',
      useAutoCloseOrders: 'Închide comanda automat când ultimul articol este preparat',
      useAutoCloseOrdersInfo: 'Când această setare este dezactivată, KDS central trebuie să închidă comanda',
      autoPrint: 'Printează automat',
      displayOrdersGrid: 'Afișează comenzile in grid',
      displayOrdersMode: 'Mod afișare comenzi',
      displayOrdersModeVertical: 'Vertical',
      displayOrdersModeCompactColumns: 'Coloane compacte',
      displayOrdersModeHorizontal: 'Orizontal',
      ordersSortColumn: 'Sortare comenzi după',
      ordersSortColumnPickup: 'Ora ridicare comandă',
      ordersSortColumnCreated: 'Ora plasare comandă',
      productSorting: 'Sortare produse',
      productSortingChronologic: 'Cronologic',
      productSortingPrepTime: 'Timp preparare',
      notificationSound: 'Sunet notificare',
      sound1: 'Sunet 1',
      sound2: 'Sunet 2',
      sound3: 'Sunet 3',
      playSound: 'Redă'
    },
    printer: {
      title: 'Imprimantă',
      subtitle: 'Configurează setările imprimantei',
      deleteConfirm: 'Sigur vrei să ștergi această imprimantă?',
      sectionGeneral: 'Informații generale',
      sectionType: 'Setări tip',
      sectionConnectivity: 'Conectivitate',
      sectionVersion: 'Versiune și tip conexiune',
      sectionOptions: 'Opțiuni și integrări',
      location: 'Locație',
      section: 'Secție',
      printerReceipt: 'Imprimantă notă de plată',
      printOptions: 'Imprimă opțiunile produselor',
      printProductClientComments: 'Imprimă comentariile clienților pe produse',
      printHotelFields: 'Imprimă câmpuri hotel',
      mergeItems: 'Grupează produsele',
      groupItemsByCategoryOnReceipt: 'Grupează produsele pe categorii pe bon',
      correspondingPos: 'POS-uri asociate',
      fontSize: 'Mărime font',
      paymentMethodsPrintTwice: 'Printează de două ori bonul pentru următoarele metode de plată',
      none: 'Niciuna',
      printAddress: 'Printează adresa',
      hideSingleOptionQty: 'Ascunde cantitatea 1 la opțiuni',
      displayPricesAndTotals: 'Afișează prețurile și totalurile',
      orderLabelPrintMode: 'Imprimare etichete comandă',
      orderLabelGrouped: 'Imprimare ca până acum (primele 7 rânduri, apoi câte 13 pe etichetă)',
      orderLabelPerProduct: 'Câte o etichetă pentru fiecare produs',
      orderLabelPerProductHint: 'Pentru a imprima un produs, activează opțiunea „Imprimă pe etichetele comenzii” din Catalog produse > Etichetă.',
      isLan: 'Este LAN',
      printerIpHost: 'IP/Host imprimantă',
      printerPortName: 'Port imprimantă'
    },
    invoice: {
      number: 'Număr',
      vatPercent: 'Cotă TVA',
      storno: 'Storno',
      proforma: 'Proforma',
      addProforma: 'Adaugă Proformă',
      invoiced: 'Factureaza',
      addSeries: 'Adaugă serie',
      type: 'Tip',
      invoices: 'Facturi',
      invoiceSupplier: 'Facturi furnizor',
      reports: 'Rapoarte',
      settings: 'Setări',
      addInvoice: 'Adaugă factura',
      invoice: 'Factura',
      client: 'Client',
      clientName: 'Nume Client',
      clientCUI: 'CUI',
      clientEmail: 'Email',
      clientPhone: 'Telefon',
      clientAddress: 'Adresă',
      clientCountry: 'Țară',
      clientCounty: 'Județ',
      selectCounty: 'Selectează județul',
      clientCity: 'Oraș',
      clientSector: 'Sector',
      selectSector: 'Selectează sectorul',
      clientStreet: 'Stradă',
      clientStreetNumber: 'Nr.',
      clientPostalCode: 'Cod poștal',
      issueDate: 'Data Emiterii',
      dueDate: 'Termen de Plată',
      seriesNumber: 'Serie și Număr',
      series: 'Serie',
      seriesDocument: 'Serii Documente',
      currency: 'Monedă',
      language: 'Limbă',
      valueNoVAT: 'Val. fără TVA',
      vatValue: 'Valoare TVA',
      lineExtensionAmount: 'Valoare linie',
      totalValue: 'Total',
      status: 'Status',
      spvStatus: 'Status SPV',
      spvStatusNotSent: 'Netrimis',
      spvStatusSent: 'Trimis',
      spvStatusError: 'Eroare',
      spvStatusPending: 'În procesare',
      spvUploadIndex: 'ID încărcare',
      invoiceDetails: 'Detalii Factura',
      supplierDetails: 'Detalii furnizor',
      clientDetails: 'Detalii client',
      proformaDetails: 'Detalii Proforma',
      otherDetails: 'Alte Detalii',
      productName: 'Denumire produs/serviciu',
      unitMeasure: 'UM',
      quantity: 'Cantitate',
      priceRON: 'Preț (RON)',
      vatRate: 'Cota TVA',
      includeVAT: 'Prețul include TVA?',
      yes: 'Da',
      no: 'Nu',
      download: 'Descarca PDF',
      filter: 'Filtru',
      startNumber: 'Număr de start',
      endNumber: 'Număr de sfârșit',
      seriesName: 'Nume serie',
      selectSeries: 'Selectează seria',
      vatPayer: 'Plătitor TVA',
      legalStatus: 'Statut Legal',
      statusLegal: {
        fizica: 'Persoană Fizică',
        juridicaRo: 'Persoană Juridică Română',
        juridicaEu: 'Persoană Juridică Europa'
      }
    },
    gestiune: {
      autoActive: 'Asigneaza automat',
      city: 'Oras',
      countries: 'Tara',
      taxRate: 'Cota TVA',
      customer: 'Client',
      fetchInvoice: 'Preia facturi E-Factura',
      changeProduct: 'Schimbă produs gestiune',
      searchProduct: 'Caută produs...',
      productManagement: 'Legături produs gestiune',
      prodLoading: 'Se încarcă produsul...',
      noGestion: 'Nu există legătură',
      change: 'Change',
      removeLink: 'Sterge Legatura (nu se vor face vanzari daca produsul asta apare)',
      sendToSPV: 'Trimite in SPV',
      salesMarkup: 'Vanzari Adaos',
      checkSpvStatus: 'Verificare status in SPV',
      downloadEfacturaXml: 'Descarcă XML SPV',
      viewSpvPdf: 'Vezi PDF SPV',
      fetchSpvMessages: 'Preia mesaje SPV',
      downloadSpvMessage: 'Descarcă',
      viewSpvMessage: 'Vezi mesaj SPV',
      fetchInvoiceDaysLabel: 'Pe câte zile?',
      fetchInvoiceDaysInvalid: 'Selectați un număr valid de zile.',
      purchase: 'Achiziție',
      codContabil: 'Cod contabil',
      analitic: 'Analitic',
      identificationCode: 'Cod de identificare',
      addInvoiceSupplier: 'Adauga factura furnizor',
      productMix: 'Product Mix',
      casare: 'Pierdere',
      category: 'Categorie',
      categoriesSettings: 'Categorii / Conturi',
      addCasare: 'Adaugă Pierdere',
      downloadExcel: 'Descarca XLS',
      activeProducts: 'Activeaza produs',
      number: 'Numar',
      validity: 'Valabilitate',
      stocLaZi: 'Stoc la zi',
      reportStock: 'Fisa magazie',
      reportInventory: 'Intrari–iesiri stocuri',
      copyProduct: 'Copiază produs',
      addProductInCasare: 'Adaugă produs(e) în casare',
      addProductInInvoice: 'Adaugă produs(e) în factura',
      addProductInProforma: 'Adaugă produs(e) în proforma',
      addProductInAviz: 'Adaugă produs(e) în aviz',
      addProductInNir: 'Adaugă produs(e) în notă intrare recepție',
      addProductInBonConsum: 'Adaugă produs(e) în bon de consum',
      addProductInBonTransfer: 'Adaugă produs(e) în nota de transfer',
      addProductInBonProductie: 'Adaugă produs(e) în bon de producție',
      addProductInOrder: 'Adaugă produs(e) în comandă',
      addBonProduction: 'Adaugă bon de producție',
      addInitialStock: 'Adaugă stoc inițial',
      initialStock: 'Stoc Inițial',
      operations: 'Operatiuni generale',
      orderErrors: 'Erori trimitere comenzi',
      integrations: 'Integrări',
      integrationsIntegration: 'Integrare',
      integrationsLocation: 'Locație',
      integrationsConfig: 'Config (doar citire)',
      integrationsData: 'Câmpuri integrare',
      integrationsJsonHint: 'Hint: poți lipi JSON aici (array/obiect).',
      integrationsUpdateById: 'Update după id (POST /integrations/upsert)',
      integrationsPutById: 'Update după id (PUT /integrations/{id})',
      integrationsNoteTitle: 'Cum funcționează',
      integrationsNoteBody: 'Selectează integrarea, opțional locația, apoi Caută. Rezultatele apar ca tabel; deschide un rând pentru editare. Salvare creează sau actualizează rândul.',
      integrationsAllLocations: 'Toate locațiile',
      integrationsOptional: 'opțional',
      integrationsOpenRow: 'Deschide',
      integrationsBackToList: 'Înapoi la listă',
      integrationsSelectRowHint: 'Alege un rând pentru a edita integrarea sau adaugă una nouă.',
      integrationsSelectIntegrationHint: 'Alegeți o integrare (sau Toate) și opțional o locație, apoi căutați.',
      integrationsEmptyTableHint: 'Nu există date. Folosește butonul Adaugă de sus pentru a crea o integrare nouă.',
      integrationsDeleteConfirm: 'Sigur doriți să ștergeți această integrare?',
      integrationsDeleteSuccess: 'Integrarea a fost ștearsă cu succes.',
      integrationsDeleteError: 'Integrarea nu a putut fi ștearsă. Încearcă din nou.',
      integrationsLocationOccupied: 'integrare existentă',
      integrationsCreateSuccess: 'Integrarea a fost creată cu succes.',
      integrationsUpdateSuccess: 'Integrarea a fost actualizată cu succes.',
      integrationsSaveError: 'Integrarea nu a putut fi salvată. Încearcă din nou.',
      integrationsMenuActivateConfirm: 'Se va salva integrarea, se va valida și trimite meniul, apoi se va activa locația. Continuați?',
      integrationsMenuActivateStepValidateMenu: 'Validare meniu',
      integrationsMenuActivateStepDeactivateLocation: 'Dezactivare locație',
      integrationsMenuActivateStepPushMenu: 'Trimitere meniu',
      integrationsMenuActivateStepCheckExportStatus: 'Așteptare finalizare export meniu',
      integrationsMenuActivateStepActivateLocation: 'Activare locație',
      integrationsActivateConfirm: 'Sigur că datele de autentificare, adresa locației și coordonatele sunt corecte?',
      integrationsActivateProgressStay: 'Vă rugăm să rămâneți pe acest ecran până la finalizarea activării.',
      integrationsActivateStepSave: 'Salvare integrare nouă',
      integrationsActivateStepTest: 'Testare credențiale',
      integrationsActivateStepWebhook: 'Înregistrare webhook',
      integrationsActivateTitle: 'Activare',
      integrationsValidateConfirm: 'Sigur că datele de autentificare, adresa locației și coordonatele sunt corecte?',
      integrationsValidateProgressStay: 'Vă rugăm să rămâneți pe acest ecran până la finalizarea validării.',
      integrationsValidateStepSave: 'Actualizare integrare',
      integrationsValidateStepTest: 'Testare credențiale',
      integrationsValidateStepWebhook: 'Înregistrare webhook',
      integrationsValidateTitle: 'Validare',
      integrationsWebhookStatusLabel: 'Webhook',
      integrationsWebhookRegistered: 'Înregistrat',
      integrationsWebhookNotRegistered: 'Neînregistrat',
      integrationsWebhookRegisterHint: 'Apăsați Validează pentru a înregistra webhook-ul.',
      integrationsWebhookRegisterError: 'Webhook-ul nu a putut fi înregistrat. Încercați din nou.',
      integrationsCredentialsTestError: 'Testarea credențialelor a eșuat.',
      integrationsCredentialsTestRetryHint: 'După remedierea problemelor, puteți testa din nou folosind butonul Validează.',
      integrationsCredentialErrorCodes: {
        glovo_laas_missing_api_url: 'URL-ul API Glovo nu este setat.',
        glovo_laas_missing_client_id: 'ID Client lipsește.',
        glovo_laas_missing_client_secret: 'Client secret lipsește.',
        glovo_laas_missing_location_id: 'Nicio locație nu este asociată.',
        wolt_drive_missing_api_url: 'URL-ul API Wolt Drive nu este setat.',
        wolt_drive_missing_client_id: 'ID Client lipsește.',
        wolt_drive_missing_client_secret: 'Client secret lipsește.',
        wolt_drive_missing_access_token: 'Token-ul de acces lipsește.',
        wolt_drive_missing_merchant_id: 'ID Merchant lipsește.',
        wolt_drive_missing_venue_id: 'ID Venue lipsește.',
        wolt_drive_missing_location_id: 'Nicio locație nu este asociată.',
        delivery_hero_missing_api_url: 'URL-ul API Delivery Hero nu este setat.',
        delivery_hero_missing_client_id: 'ID Client lipsește.',
        delivery_hero_missing_key_id: 'Key ID lipsește.',
        delivery_hero_missing_scope: 'Scope lipsește.',
        delivery_hero_missing_private_key: 'Cheia privată lipsește. Salvați integrarea pentru a genera cheile.',
        delivery_hero_missing_location_id: 'Nicio locație nu este asociată.',
        laas_location_not_found: 'ID-ul locației selectate este invalid.',
        laas_location_missing_address: 'Locației îi lipsesc orașul, strada sau numărul.',
        laas_location_missing_coordinates: 'Locației îi lipsesc latitudinea sau longitudinea.',
        laas_location_missing_phone: 'Locației îi lipsește numărul de telefon.',
        laas_no_user_email: 'Nu există un utilizator al companiei cu adresă de email.',
        laas_invalid_credentials: 'Credențiale invalide (401 / invalid token de la partener).',
        laas_call_courier_failed: 'Programarea curierului de test a eșuat.',
        laas_cancel_courier_failed: 'Anularea curierului de test a eșuat.',
        laas_no_partner_response: 'Nu s-a primit răspuns de la API-ul partenerului.',
        wolt_drive_reference_not_found: 'Referința Wolt lipsește după creare.'
      },
      integrationsGlovoLaasSetupTitle: 'Finalizați acești pași înainte de a crea integrarea:',
      integrationsGlovoLaasSetupStep1: 'Obțineți ID Client și ID Secret de la',
      integrationsGlovoLaasSetupStep2: 'Creați un brand la',
      integrationsDeliveryHeroSetupTitle: 'Finalizați acești pași pentru onboarding Delivery Hero ODR:',
      integrationsDeliveryHeroSetupStep1: 'Selectați locația și URL-ul API, apoi Salvați — generăm pe server o pereche de chei RSA PKCS#8.',
      integrationsDeliveryHeroSetupStep2: 'Descărcați cheia publică .pub și trimiteți-o către Delivery Hero pentru a primi Key ID.',
      integrationsDeliveryHeroSetupStep3: 'Introduceți Client ID, Key ID și Scope primite de la Delivery Hero.',
      integrationsDeliveryHeroSetupStep4: 'Apăsați Validează pentru a testa credențialele, apoi înregistrați URL-urile de callback la Delivery Hero ops.',
      integrationsDeliveryHeroKeysTitle: 'Chei RSA',
      integrationsDeliveryHeroKeysPending: 'Salvați integrarea pentru a genera perechea de chei publică/privată.',
      integrationsDeliveryHeroCopyPublicKey: 'Copiază cheia publică',
      integrationsDeliveryHeroDownloadPublicKey: 'Descarcă .pub',
      integrationsDeliveryHeroRegenerateKeys: 'Regenerează cheile',
      integrationsDeliveryHeroRegenerateKeysConfirm: 'Regenerarea cheilor invalidează cheia publică anterioară. Trebuie să trimiteți noul fișier .pub către Delivery Hero. Continuați?',
      integrationsDeliveryHeroRegenerateKeysSuccess: 'Noua pereche de chei RSA a fost generată.',
      integrationsDeliveryHeroCredentialsTitle: 'Credențiale de la Delivery Hero',
      integrationsDeliveryHeroCredentialsHint: 'Completați aceste câmpuri după ce Delivery Hero returnează Key ID pentru cheia publică trimisă.',
      integrationsDeliveryHeroScopePlaceholder: 'ex: pandago.api.ro.*',
      integrationsDeliveryHeroPublicKeyHint: 'Trimiteți această cheie publică (.pub) către Delivery Hero pentru a primi Key ID. Cheia privată rămâne pe server (PKCS#8, 2048 biți).',
      integrationsDeliveryHeroCallbacksTitle: 'URL-uri callback (de înregistrat la Delivery Hero)',
      integrationsDeliveryHeroStatusCallback: 'URL callback status',
      integrationsDeliveryHeroRefundCallback: 'URL callback refund',
      integrationsDeliveryHeroCallbacksHint: 'Aceste URL-uri sunt fixe pentru compania dvs. Furnizați-le către Delivery Hero ops la onboarding.',
      integrationsActionsTitle: 'Acțiuni',
      integrationsSyncMenu: 'Sincronizează meniul',
      integrationsMenuUploadCampaignsHint: 'Încărcarea meniului va șterge campaniile de pe platformă.',
      integrationsGlovoMenuSyncDailyLimitHint: 'Platforma Glovo nu permite mai mult de 5 sincronizări de meniu pe zi.',
      integrationsActionError: 'Acțiunea a eșuat. Încearcă din nou.',
      integrationsPlatformErrors: {
        unauthorized: 'Platforma a respins cererea deoarece credențialele sunt invalide sau expirate.',
        unauthorized_bolt: 'Bolt a respins cererea (401). Verificați {secretKey}, {integratorId} și {providerId} în setările integrării.',
        unauthorized_glovo: 'Glovo a respins cererea (401). Verificați {apiKey} și {storeId} în setările integrării.',
        unauthorized_wolt: 'Wolt a respins cererea (401). Verificați {apiKey}, {clientId} și {venueId}, apoi încercați din nou.',
        forbidden: 'Platforma a refuzat această acțiune. Contul poate să nu aibă permisiunea pentru această locație.',
        forbidden_bolt: 'Bolt a refuzat acțiunea. Verificați că {providerId} corespunde magazinului configurat în Bolt.',
        forbidden_glovo: 'Glovo a refuzat acțiunea. Verificați {storeId} și că magazinul este legat de contul dvs.',
        forbidden_wolt: 'Wolt a refuzat acțiunea. Verificați {venueId} și că locația este legată de contul dvs.',
        not_found: 'Platforma nu a găsit magazinul sau locația. Verificați identificatorii din integrare.',
        not_found_bolt: 'Bolt nu a găsit acest provider. Verificați {providerId} și {apiUrl}.',
        not_found_glovo: 'Glovo nu a găsit acest magazin. Verificați {storeId} și {apiUrl}.',
        not_found_wolt: 'Wolt nu a găsit această locație. Verificați {venueId} și {apiUrl}.',
        rate_limited: 'Platforma limitează temporar numărul de cereri. Așteptați câteva minute și încercați din nou.',
        network: 'Nu s-a putut contacta platforma. Verificați conexiunea la internet și încercați din nou.',
        unavailable: 'Platforma este temporar indisponibilă. Încercați din nou mai târziu.',
        toggleLocation_failed: 'Nu s-a putut actualiza pe platformă dacă locația acceptă comenzi.',
        pushMenu_failed: 'Nu s-a putut publica meniul pe platformă.',
        syncSchedule_failed: 'Nu s-a putut sincroniza programul de lucru cu platforma.',
        generic_failed: 'Acțiunea pe platformă a eșuat. Încercați din nou.'
      },
      integrationsMenuTopCategoriesPlaceholder: 'Toate categoriile de top',
      integrationsMenuTopCategoriesHint: 'Lasă gol pentru a exporta meniul complet.',
      integrationsMenuTopCategoriesExportNote: 'Filtrarea se aplică la următorul export de meniu.',
      integrationsGlovoValidateMenu: 'Validează meniul',
      integrationsGlovoPushMenu: 'Trimite meniul',
      integrationsValidateAndPushMenu: 'Validează și trimite meniul',
      integrationsMenuPreviewOpen: 'Deschide meniul',
      integrationsMenuPreviewLoading: 'Se încarcă meniul…',
      integrationsMenuPreviewOrder: 'Comandă',
      integrationsMenuPreviewAdd: 'Adaugă',
      integrationsMenuPreviewAddFor: 'Adaugă {qty} pentru {price}',
      integrationsMenuPreviewRequiredShort: 'Necesar',
      integrationsMenuPreviewChooseOne: 'Alege 1 articol',
      integrationsMenuPreviewTitle: 'Previzualizare meniu {platform}',
      integrationsMenuPreviewSubtitle: 'Răsfoiți categoriile, produsele și opțiunile așa cum vor apărea pe platformă.',
      integrationsMenuPreviewImport: 'Importă',
      integrationsMenuPreviewImporting: 'Se importă…',
      integrationsMenuPreviewSearchPlaceholder: 'Caută produse, opțiuni, id-uri…',
      integrationsMenuPreviewSearchEmpty: 'Niciun produs nu corespunde căutării.',
      integrationsMenuPreviewSearchClear: 'Șterge',
      integrationsMenuPreviewImportConfirmTitle: 'Importați meniul?',
      integrationsMenuPreviewImportConfirmText: 'Meniu va fi validat și trimis pe platformă.',
      integrationsMenuPreviewBack: 'Înapoi la meniu',
      integrationsMenuPreviewOutOfStock: 'Stoc epuizat',
      integrationsMenuPreviewOptionRequired: 'Obligatoriu',
      integrationsMenuPreviewOptionOptional: 'Opțional',
      integrationsMenuPreviewOptionRange: 'Alegeți {min}–{max}',
      integrationsGlovoCheckStatus: 'Verifică status export',
      integrationsGlovoExportsToday: 'Exporturi azi',
      integrationsGlovoLastExport: 'Ultimul export',
      integrationsGlovoExportStatus: 'Status',
      integrationsGlovoNoExport: 'Niciun export încă',
      integrationsGlovoExportPending: 'În așteptare — verifică statusul',
      integrationsGlovoExportInProgress: 'În curs',
      integrationsGlovoExportSuccess: 'Reușit',
      integrationsGlovoExportFailed: 'Eșuat',
      integrationsGlovoValidationResult: 'Rezultat validare',
      integrationsGlovoStatusResult: 'Status export',
      integrationsGlovoValidateSuccess: 'Validarea meniului s-a finalizat.',
      integrationsGlovoValidateSuccessTitle: 'Validare meniu',
      integrationsGlovoValidationFailedTitle: 'Validarea meniului a eșuat',
      integrationsGlovoShowMore: 'Arată mai mult',
      integrationsGlovoShowLess: 'Arată mai puțin',
      integrationsGlovoValidationErrors: 'Erori',
      integrationsGlovoValidationWarnings: 'Avertismente',
      integrationsMenuValidationExpandHint: 'Deschideți detaliile de mai jos pentru a vedea categoriile, produsele și opțiunile afectate.',
      integrationsMenuValidationEditEntity: 'Editează',
      integrationsMenuValidationEditEntityHint: 'Se deschide într-un tab nou',
      integrationsMenuValidationTryAgain: 'Încearcă din nou',
      integrationsMenuValidationProceedAnyway: 'Continuă oricum',
      integrationsMenuValidationProceedAnywayHint: 'Validarea a raportat probleme. Dacă sunt rezultate fals pozitive, puteți continua exportul meniului.',
      integrationsMenuValidationProceedingAnyway: 'Se continuă exportul în ciuda problemelor de validare.',
      integrationsMenuValidationEditPageHint: 'După salvare, închideți acest tab și încercați din nou.',
      integrationsMenuValidationErrorCodes: {
        CATEGORY_EMPTY: 'Categorii fără produse exportabile',
        PRODUCT_INVALID_PRICE: 'Produse cu preț zero sau negativ',
        OPTION_MISSING_VALUES: 'Opțiuni cu valori lipsă',
        OPTION_INVALID_MIN: 'Opțiuni cu selecție minimă invalidă',
        MENU_EMPTY: 'Meniul este gol',
        MENU_NO_MATCHING_CATEGORIES: 'Nicio categorie nu corespunde filtrului de meniu selectat'
      },
      integrationsMenuValidationItemCategory: 'Categorie',
      integrationsMenuValidationItemProduct: 'Produs',
      integrationsMenuValidationItemOption: 'Opțiune',
      integrationsMenuValidationCategoriesEmpty: 'Categorii fără produse exportabile',
      integrationsMenuValidationProductsInvalidPrice: 'Produse cu preț invalid',
      integrationsMenuValidationOptionsMissingValues: 'Opțiuni cu valori lipsă',
      integrationsMenuValidationOptionsInvalidMin: 'Opțiuni cu minim invalid',
      integrationsGlovoCheckStatusDisabledHint: 'Trimite mai întâi meniul sau deschide o integrare care are deja un export.',
      integrationsGlovoStatusUpdated: 'Statusul exportului a fost actualizat.',
      integrationsGlovoPushAccepted: 'Trimiterea meniului a fost acceptată de Glovo.',
      integrationsGlovoMenuEmpty: 'Nu există produse de exportat.',
      integrationsGlovoActivateTitle: 'Activare',
      integrationsGlovoActivateConfirm: 'Se va salva integrarea, se va valida și trimite meniul către Glovo, apoi se va activa locația. Continuați?',
      integrationsGlovoActivateProgressStay: 'Vă rugăm să rămâneți pe acest ecran până la finalizarea activării.',
      integrationsGlovoActivateStepSave: 'Salvare integrare nouă',
      integrationsGlovoActivateStepValidateMenu: 'Validare meniu',
      integrationsGlovoActivateStepDeactivateLocation: 'Dezactivare locație Glovo',
      integrationsGlovoActivateStepPushMenu: 'Trimitere meniu către Glovo',
      integrationsGlovoActivateStepCheckExportStatus: 'Așteptare finalizare export meniu',
      integrationsGlovoActivateStepActivateLocation: 'Activare locație Glovo',
      integrationsGlovoActivateExportTimeout: 'Exportul meniului este încă în curs după câteva minute.',
      integrationsGlovoActivateExportFailedHint: 'Verificați erorile de export de mai sus, remediați meniul, apoi folosiți Trimite meniul și Verifică status export din Acțiuni.',
      integrationsGlovoActivateValidationFailedHint: 'Remediați problemele de meniu de mai sus, apoi încercați din nou Activare.',
      integrationsGlovoActivateMenuEmptyHint: 'Adăugați produse în meniul acestei locații, apoi încercați din nou Activare.',
      integrationsGlovoActivatePushFailedHint: 'Remediați problema de mai sus, apoi încercați din nou Activare.',
      integrationsGlovoActivateNoTransactionId: 'Glovo nu a returnat un ID de tranzacție pentru export. Încercați Trimite meniul din Acțiuni.',
      integrationsSyncSchedule: 'Sincronizează orarul',
      integrationsColActive: 'Activ',
      integrationsColActions: 'Acțiuni',
      integrationsColIsMenuLocation: 'Locație meniu',
      integrationsColIsUsingPricelist: 'Locație meniu și comenzi',
      integrationsFields: {
        id: 'ID',
        location_id: 'Locație',
        orders_location_id: 'Locație comenzi',
        active: 'Activ',
        api_url: 'URL API',
        api_key: 'Cheie API',
        client_id: 'ID Client',
        client_secret: 'Secret client',
        venue_id: 'ID Venue',
        is_integrated: 'Integrat',
        is_using_pricelist: 'Locație meniu și comenzi',
        is_auto_accept: 'Acceptă automat comenzile',
        platform_status_polling_enabled: 'Monitorizează disponibilitatea pe platformă',
        schedule: 'Program',
        is_menu_location: 'Locație meniu',
        created_at: 'Creat la',
        updated_at: 'Modificat la',
        access_token: 'Token acces',
        merchant_id: 'ID Merchant',
        auto_send_at_status: 'Trimite automat la status',
        auto_send_time: 'Timp trimitere automată',
        order_total_handshake: 'Cod obligatoriu pentru comenzi peste',
        feedback_emails: 'Email-uri feedback',
        integrator_id: 'ID Integrator',
        provider_id: 'ID Provider',
        secret_key: 'Cheie secretă',
        emails: 'Email-uri',
        user: 'Utilizator',
        password: 'Parolă',
        menu_language: 'Limba meniului',
        has_own_delivery: 'Livrare proprie',
        prep_time_buffer_in_minutes: 'Buffer timp pregătire (minute)',
        pos_implementation_name: 'Nume implementare POS',
        brand_name: 'Nume brand',
        brand_code: 'Cod brand',
        store_id: 'ID magazin',
        laas_client_id: 'ID Client',
        laas_client_secret: 'ID Secret',
        menu_top_categories: 'Categorii de top pentru meniu',
        key_id: 'Key ID',
        scope: 'Scope',
        webhook_secret: 'Secret webhook',
        public_key: 'Cheie publică'
      },
      integrationsFeedbackEmailsHint: 'Introduceți adresele de email separate prin virgulă, punct și virgulă sau pe linii noi',
      woltDriveAutoSendStatus_manual: 'Manual',
      woltDriveAutoSendStatus_processing: 'În procesare',
      woltDriveAutoSendStatus_prepared: 'Pregătită',
      integrationsTypes: {
        glovo: 'Glovo',
        glovo_laas: 'Glovo LaaS',
        bolt: 'Bolt',
        wolt: 'Wolt',
        wolt_drive: 'Wolt Drive',
        delivery_hero: 'Delivery Hero',
        nexus: 'Nexus',
        charisma: 'Charisma',
        clock_pms: 'Clock PMS',
        ebriza: 'Ebriza',
        rkeeper: 'rKeeper',
        rsystem: 'R-System',
        ep_restaurant: 'eP Restaurant',
        freya_on_premise: 'Freya (on-premise)',
        freya_cloud: 'Freya Cloud',
        grandchef: 'GrandChef'
      },
      dataStart: 'Data inceput',
      notaTransfer: 'Nota transfer',
      updateStockScriptic: 'Actualizeaza stoc scriptic',
      printInventorySheet: 'Fisa inventar',
      saveDraft: 'Salveaza ca Draft',
      saveAndValidate: 'Salveaza si Valideaza modificarile',
      cost: 'Cost',
      gestiune_descarcare: 'Gestiune descarcare',
      noteEntries: 'Nota intrare receptie',
      receptionOrder: 'Recepție Comandă',
      validateOrder: 'Validează Comandă',
      processingOrder: 'Procesare Comandă',
      stockNameTable: 'Denumire articol',
      stockUm: 'UM',
      stockPrice: 'Preț unitar',
      stockStocMinim: 'Stoc minim',
      stockQuantity: 'Stoc actual',
      stockValue: 'Valoare stoc ',
      stockStatus: 'Status',
      stockStatus1: '✅ OK',
      stockStatus2: '⚠️ Sub stoc minim',
      stockStatus3: '❗ Critic',
      stocksHistory: 'Istoric Stocuri',
      nirs: 'Nir',
      stockDate: 'Data',
      stockDocumentId: 'Nr. doc',
      stockDocumentType: 'Tip Document',
      revalidated: 'Salveaza si Revalideaza',
      stockIntrare: 'Intrare',
      stockIesire: 'Iesire',
      stockStocFinal: 'Stock Final',
      stockPret: 'Pret',
      stockValoareStoc: 'Valoare stoc ',
      stockObservatii: 'Observatii',
      noSeries: 'Nu există serii disponibile.',
      noGestiuni: 'Nu există gestiuni disponibile.',
      default: 'Default gestiune vanzare',
      quantityScriptic: 'Cantitate Scriptică',
      quantityFaptic: 'Cantitate Faptic',
      procesata: 'Procesată',
      nrProduse: 'Nr. Produse',
      fiscalizat: 'Fiscalizat',
      tipVanzare: 'Tip Vânzare',
      email: 'Email',
      process: 'Procesează',
      invoice: 'Factura',
      sendOrder: 'Trimite comanda',
      reception: 'Recepție',
      validate: 'Validează',
      generateNir: 'Generează Nir',
      searchClientsWithCUI: 'Cauta client dupa CUI',
      searchClients: 'Cauta client',
      termenValabilitate: 'Termen de valabilitate',
      scazamant: 'Scăzământ',
      addBonConsum: 'Adaugă bon de consum',
      addNoteTransfer: 'Adaugă notă de transfer',
      addClient: 'Adaugă client',
      clientName: 'Nume Client',
      ore: 'Ore',
      zile: 'Zile',
      procent: 'Procent',
      stocScriptic: 'Stoc Scriptic',
      stocFaptic: 'Stoc Faptic',
      difference: 'Difference',
      status: 'Status',
      inventoryNumber: 'Inventar #',
      differences: 'Diferențe',
      note: 'Notă',
      inventar: 'Inventar',
      users: 'Utilizatori',
      myOrders: 'Comenzile mele',
      forOrders: 'Comenzi primite',
      reports: 'Rapoarte',
      bankAccounts: 'Conturi bancare',
      pretPerUnitate: 'Preț per unitate',
      costPerUnit: 'Cost pe unitate',
      pricePerUnit: 'Preț per unitate',
      totalCost: 'Cost total',
      editPrice: 'Editează preț',
      stocK: 'Stoc',
      addOrder: 'Adaugă comandă',
      pretVanzare: 'Preț vânzare (TVA INCLUS)',
      stocMinim: 'Stoc minim',
      docFurnizori: 'Note intrare receptie',
      aviz: 'Aviz',
      addAviz: 'Adauga aviz',
      bonFiscal: 'Bon Fiscal',
      sales: 'Vanzari / Bonuri',
      outputs: 'Iesiri',
      commandProject: 'Comanda/Proiect',
      production: 'Productie',
      products: 'Produse',
      clients: 'Clienti',
      preview: 'Previzualizare',
      manager: 'Gestionar',
      receiver: 'Primitor',
      generateAvizNIR: 'Generează Aviz & NIR',
      cantitateNecesara: 'Cantitate necesară',
      cantitateConsumata: 'Cantitate consumată',
      avizGestiuneaPredatoare: 'Aviz (în gestiunea predatoare)',
      dataAviz: 'Data Aviz',
      nirGestiuneaPrimitoare: 'NIR (în gestiunea primitoare)',
      dataNIR: 'Data NIR',
      internalNote: 'Notă Internă',
      isBonProductie: 'Bon de Productie',
      fromGestiune: 'Din Gestiunea',
      toGestiune: 'La Gestiunea',
      fromLocation: 'Din Locația',
      toLocation: 'La Locația',
      transfer: 'Bon Transfer',
      cui: 'CUI',
      dashboard: 'Dashboard',
      numeGestiune: 'Nume gestiune',
      numeGestionar: 'Nume gestionar',
      gestiuni: 'Gestiuni',
      categorii: 'Categorii',
      contContabil: 'Cont contabil',
      currentNumber: 'Număr curent',
      codGestiune: 'Cod gestiune',
      consumption: 'Consum',
      addManagment: 'Adaugă gestiune',
      tipGestiune: 'Tip gestiune',
      cantitativValoric: 'Cantitativ Valorica (Recomandat)',
      cantitativValoricDesc: 'Produsele apar pe NIR la Cost de Achizitie. Folosita de magazine si depozite. Pentru orice tip de Produs: Marfa, Materii Prime, Materiale Consumabile..etc.',
      globalValoric: 'Global Valorica',
      globalValoricDesc: 'Produsele apar pe NIR la Pret de Vanzare. Folosita de magazinele mici. Doar pentru produse de tip Marfa si Ambalaje. Nu vei putea emite bonuri de consum de pe aceasta gestiune, de exemplu.',
      terti: 'Terti',
      tertiDesc: 'Atunci cand produsele tale sunt trimise la Terti pentru depozitare sau prelucrare.',
      workPoint: 'Punct lucru',
      adresaPunctLucru: 'Adresa Punct Lucru',
      administrator: 'Gestionar',
      stocks: 'Stocuri / Consumuri',
      history: 'Istoric',
      priceAchizitie: 'Pret achizitie',
      entries: 'Intrari',
      suppliers: 'Furnizori',
      lot: 'Lot',
      dataProductie: 'Data producției',
      dataExpirare: 'Data expirării',
      supplierOrders: 'Comenzi Furnizori',
      nomenclatorProducts: 'Nomenclator Produse',
      addProduct: 'Adaugă produs',
      product: 'Produs',
      codeProduct: 'Cod Produs',
      code: 'Cod',
      name: 'Nume',
      price: 'Pret',
      lineTotal: 'Valoare totală',
      gestiune: 'Gestiune',
      reteta: 'Nomenclatoare',
      emptyData: 'Nu există date',
      noData: 'Nu există date, folosește filtrele pentru selecție și apasă butonul "CAUTĂ"',
      recipte: 'Reteta',
      addReteta: 'Adauga produs in reteta',
      nr: 'Nr.',
      categoria: 'Categoria',
      tva: 'TVA %',
      pretFaraTva: 'Pret(fara TVA)',
      um: 'UM',
      seePDF: 'Vezi PDF',
      exportDocument: 'Exportă document SPV',
      currency: 'Moneda',
      settings: 'Setări',
      productName: 'Nume produs',
      productDescription: 'Descriere produs',
      type: 'Tip',
      codeFiscalFurnizor: 'Cod Fiscal furnizor',
      dataDocument: 'Data document',
      dataInStoc: 'Data in stoc',
      dataScadenta: 'Data scadentei',
      tipDocument: 'Tip document',
      nrDocument: 'Numar document',
      valoare: 'Valoare',
      valoareTaxable: 'Bază impozabilă',
      valoareTva: 'TVA',
      valoareTotal: 'Total',
      valoarePayable: 'De plată',
      precizie: 'Precizie',
      prețAchiziție: 'Preț Achiziție',
      nirsProduct: 'NIR-uri produs:',
      exports: 'Exporturi',
      inboundInvoices: 'Facturi de intrare contabilitate',
      accountingSales: 'Vânzări contabilitate',
      download_xml: 'Exportă arhiva SAGA XML',
      exportAccounting: {
        infoText: 'Pentru a genera exportul contabil, selectează o locație și un interval de dată și oră. Alege apoi formatul dorit (XML sau XLS) și așteaptă finalizarea procesului de generare. În funcție de volum, exportul poate dura câteva secunde.'
      },
      exportAccountingSales: {
        infoText: 'Pentru a genera exportul contabil al vânzărilor, selectează o locație și un interval de dată și oră. Alege apoi formatul dorit (XML sau XLS) și așteaptă finalizarea procesului de generare. În funcție de volum, exportul poate dura câteva secunde.'
      },
      miscareStoc: {
        vanzare: 'MISCARE STOC: VANZARE',
        intrare: 'MISCARE STOC: INTRARE',
        resetare: 'MISCARE STOC: RESETARE',
        inventar: 'MISCARE STOC: INVENTAR',
        intrareTransfer: 'MISCARE STOC: INTRARE TRANSFER',
        iesireTransfer: 'MISCARE STOC: IESIRE TRANSFER',
        bonConsum: 'MISCARE STOC: BON CONSUM',
        intrareProductie: 'MISCARE STOC: INTRARE PRODUCTIE',
        iesireProduse: 'MISCARE STOC: IESIRE PRODUSE',
        bonAnulat: 'MISCARE STOC: BON ANULAT',
        protocol: 'MISCARE STOC: PROTOCOL',
        donatie: 'MISCARE STOC: DONATIE'
      },
      stoc: {
        checkbox: '',
        nume: 'Nume',
        tag: 'Tag',
        tva: 'TVA',
        um: 'UM',
        cantitateRamasa: 'Cantitate Rămasă',
        costMediuAchizitie: 'Cost Mediu Achiziție',
        valoareTotala: 'Valoare Totală',
        action: {
          editareMultipla: 'Editare Multipla',
          bonConsum: 'Bon Consum',
          transferStoc: 'Transfer Stoc',
          resetareStoc: 'Resetare Stoc',
          exporta: 'Exportă Tot'
        }
      },
      bonTransfer: 'Bon Transer',
      locatie: 'Locație',
      nume: 'Nume',
      cantitate: 'Cantitate',
      cantitateHint: 'Cantitatea se adaugă cu punct (.), nu cu virgulă (,)',
      umTaptastyInfo: 'Unitatea de măsură la produsele gestionate din Taptasty se poate schimba din CATALOG -> Produse!',
      modifCantRamasa: 'Modif. Cant. Rămasă',
      pretUnitar: 'Preț Unitar',
      costMediuAchizitie: 'Cost Mediu Achiziție',
      costTotal: 'Cost Total',
      data: 'Data',
      detalii: 'Detalii',
      schimbaCotaTVA: 'Schimbă Cotă TVA',
      schimbaTag: 'Schimbă Tag',
      stergeTot: 'Șterge Tot',
      motiv: 'Motiv',
      cantitateDeConsum: 'Cantitate de Consum',
      pretUnitarFaraTVA: 'Preț Unitar fără TVA',
      pretTotal: 'Preț Total',
      furnizor: 'Furnizor',
      nrFactura: 'Nr. Factura',
      scadenta: 'Scadență',
      dataEmitere: 'Data Emitere',
      dataIntrare: 'Data Intrare',
      adaugaIntrare: 'Adaugă Intrare',
      nirInfoNote: '⚠️ <strong>Atenție!</strong> Nota de Intrare Recepție (NIR) este destinată exclusiv înregistrării recepției și intrării produselor în gestiune. Pentru gestionarea facturilor de furnizori, accesați <strong>Intrări → Facturi furnizori</strong>.',
      location: 'Locatie',
      supplier: 'Furnizor',
      invoiceDate: 'Data Emitere Factura',
      invoiceNumber: 'Nr Factura',
      dueDate: 'Scadenta',
      paid: 'Platit',
      invoiceDetails: 'Detalii Factura',
      invoiceProducts: 'Produse Factura',
      stockName: 'Denumire Stoc',
      companyName: 'Nume Companie',
      quantity1: 'Cant.',
      quantity2: 'Cant. Unitate',
      unit: 'Unitate',
      quantity3: 'Cant.',
      unitPrice: 'Pret Unitar',
      discount: 'Discount',
      valueNoVAT: 'Valoare Fara TVA',
      vat: 'TVA',
      valueVAT: 'Valoare TVA',
      valueWithVAT: 'Valoare Incl. TVA',
      searchByCUI: 'Cauta furnizor dupa CUI',
      addSupplier: 'Adaugă furnizor',
      abbreviation: 'Prescurtare',
      CUI: 'CUI',
      registrationNumber: 'Nr. Înregistrare',
      address: 'Adresă',
      bank: 'Bancă',
      IBAN: 'IBAN',
      dueDays: 'Scadența în zile',
      enterCUI: 'Introduceți CUI',
      search: 'Caută',
      invoiceEmissionDate: 'Data Emiterii Facturii',
      total: 'Total',
      balanceDue: 'Rest de Plată',
      addDiscount: 'Adaugă Discount',
      quantity: 'Cant',
      tag: 'Tag',
      sku: 'SKU',
      allExplanations: 'Toate explicațiile',
      explanations: 'Explicații utilizare produs',
      useAsGoods: 'Folosesc produsul ca și Marfă',
      useAsRawMaterial: 'Folosesc produsul ca și Materie Prima',
      useAsPackaging: 'Folosesc produsul ca și Ambalaj',
      useAsConsumable: 'Folosesc produsul ca și Consumabil',
      description: 'DESCRIERE',
      inventory: 'Inventar',
      createdBy: 'CREAT DE',
      modifiedBy: 'MODIFICAT DE',
      resetBy: 'RESETAT DE',
      date: 'Data',
      scriptDate: 'DATA SCRIPTICĂ',
      addInventory: 'Adaugă inventar',
      downloadInventory: 'Descarcă',
      fizica: 'Fizică',
      descriptionInventory: 'Descriere inventar',
      addFilter: 'Aduga Filtru',
      consumable: 'Consumabil',
      merchandise: 'Marfă',
      rawMaterialFull: 'Materie Primă',
      for: 'Pentru',
      filterName: 'Nume Filtru',
      selectColor: 'Selectați Culoarea',
      filterByNameSku: 'Filtrează după Nume sau SKU',
      filterByType: 'Filtrează după Tip',
      filterByTag: 'Filtrează după Tag',
      filterByQuantity: 'Filtrează după Cantitate',
      filterBySupplier: 'Filtrează după Furnizor',
      filterByVAT: 'Filtrează după TVA',
      selection: 'Selectare',
      view: 'Vizualizează',
      stockFilter: 'Filtru Stocuri',
      addCompany: 'Adaugă companie',
      distributorName: 'Distributor Name',
      balance: 'Balance',
      BalanceReport: 'Balanta centralizata',
      searchSuppliers: 'Caută după',
      ordersSuppliers: 'Comenzi furnizori',
      filterByProvider: 'Filtrează după furnizor',
      inStock: 'În stoc',
      necessary: 'Necesar',
      casaRegister: 'Registru de casa',
      action: 'Acțiune',
      document: 'Document',
      details: 'Detalii',
      payments: 'Plăți',
      collections: 'Încasări',
      addCasaRegister: 'Adaugă in registru de casa',
      value: 'Valoare'
    },
    menuLink: {
      alias: 'Alias',
      title: 'Titlu',
      updated: 'Actualizată',
      areYouSure: 'Sigur dorești să {label} pagina ?',
      deleted: 'Ștearsă',
      couldNotUpdate: 'Nu s-a actualizat',
      cancel: 'anulezi',
      delete: 'ștergi',
      added: 'Meniu link adăugat',
      promotions: 'Promoții',
      history: 'Istoric',
      orders: 'Comenzi',
      reservations: 'Rezervari',
      tables: 'Mese',
      orderspos: 'Adauga Comanda',
      dispatch: 'Dispecerat',
      favorite_orders: 'Comenzi favorite',
      tutorial: 'Tutorial',
      personal_info: 'Informații personale',
      single: 'Meniu link',
      cancelCourier: 'Anulează curier',
      logout: 'Deconectare',
      from: 'de la',
      to: 'până la',
      linkFor: 'Link pentru',
      externUrl: 'URL Extern',
      custom: 'Personalizat',
      day: 'ziua',
      couldNotSave: 'Nu s-a salvat'
    },
    pages: {
      allModules: 'Vezi toate modulele',
      automationMarketing: 'Marketing automat',
      stock: 'Stock',
      supportTicket: 'Suport Tichete',
      supportWidgetTokenUnavailable: 'Tokenul widgetului de suport nu este disponibil pentru această locație',
      login: 'Logare',
      register: 'Înregistrare',
      recoverPassword: 'Recuperează Parola',
      resetPassword: 'Resetează Parola',
      programTitle: 'Program',
      dashboard: 'Panou comandă',
      orderingManagement: 'Gestionare Comenzi',
      customerDetails: 'Detalii Client',
      customers: 'Clienți',
      approvals: 'Cereri de Inregistrare',
      giftCard: 'Gift Card',
      customersGroups: 'Grupuri de clienți',
      orders: 'Comenzi',
      reservations: 'Rezervari',
      tables: 'Mese',
      orderspos: 'Adauga Comanda',
      dispatch: 'Dispecerat',
      screens: 'Ecrane',
      transfer: 'Trasnfer',
      pos: 'Pos',
      tableMaps: 'Harti Mese',
      products: 'Produse',
      isPriceList: 'Liste Pret',
      catalog: 'Catalog',
      categories: 'Categorii',
      productOptions: 'Optiuni Produs',
      groupOptions: 'Grupuri Optiuni',
      marketing: 'Marketing',
      campaigns: 'Campanii',
      pushCampaigns: 'Campanii push notification',
      coupons: 'Cupoane',
      subscriptions: 'Abonamente',
      referralCampaigns: 'Campanii referral',
      loyaltyStoreCampaigns: 'Oferte Loialitate',
      ambassadorRequests: 'Cereri ambasadori',
      raffleCampaigns: 'Campanii tombolă',
      donationCampaigns: 'Campanii Donații',
      spinningWheelCampaigns: 'Roata Norocului',
      discountCampaigns: 'Campanii Reduceri',
      challengeCampaigns: 'Provocări',
      offersSlider: 'Banner oferte',
      reports: 'Rapoarte',
      feedback: 'Feedback',
      settings: 'Setări',
      logout: 'Delogare',
      fidelities: 'Fidelitate',
      topCategory: 'Categorii de top',
      infoPagesCustom: 'Pagini Personalizate',
      menuLinks: 'Linkuri meniu',
      infoPages: 'Pagini Informative',
      productFilters: 'Filtre Produs',
      promos: 'Card De Loialitate',
      menus: 'Meniuri QR',
      menuSubscriptions: 'Abonamente meniuri',
      orderScreen: 'Ecran Comenzi',
      clientOrderView: 'Display PickUp',
      payment: 'Facturi',
      newsletter: 'Noutăți',
      support: 'Suport',
      scanner: 'Scanează',
      gestiune: 'Gestiune',
      stocuri: 'Stocuri',
      intrari: 'Intrari',
      kds: 'KDS',
      ods: 'ODS',
      orderDisplayScreen: 'Ecrane',
      online: 'Online',
      invoice: 'Facturi',
      kiosk: 'Kiosk',
      qr: 'Qr'
    },
    infoPages: {
      single: 'pagină',
      title: 'Titlu',
      shortDescription: 'Scurtă descriere',
      updated: 'Actualizată',
      areYouSure: 'Sigur dorești să {label} pagina?',
      deleted: 'Ștearsă',
      couldNotUpdate: 'Nu s-a actualizat',
      cancel: 'anulezi',
      delete: 'ștergi',
      added: 'Pagină informativă personalizată adaugată',
      changeLinkTab: 'În caz că se adaugă un link, casuțele de text se vor schimba cu tasata TAB pentru următoarea și cu SHIFT + TAB pentru cea precedentă',
      infoPages: 'Pagini informative'
    },
    ordersStatus: {
      bill: 'Nota',
      AWAITING_TRANSPORT: 'În așteptarea transportului',
      CANCELED: 'Anulată',
      DELIVERED: 'Livrată',
      DRAFT: 'Ciornă',
      OPEN_DRAFT: 'Comanda deschisa',
      NEW: 'Nou',
      ON_HOLD: 'Asteptare',
      POSTPONED: 'Amânare',
      NOT_DELIVERED: 'Nelivrată',
      PICKED_UP_BY_DELIVERY: 'Preluată pentru livrare',
      PROCESSING: 'Procesată',
      PREPARED: 'Preparată',
      TRANSPORT: 'În transport',
      RESERVED: 'Rezervată',
      COMPLETED: 'Finalizată',
      FINISH: 'Finalizată',
      DRAFT_AWAITING_PAYMENT: 'Plată nefinalizată',
      reservedReady: 'Rezervată / Pregătită',
      completedReady: 'Finalizată / Pregătită',
      deliveredReady: 'Livrată / Pregătită',
      canceledForever: 'comenzii in anulată?  Aceasta actiune  este ireversibila!',
      checkIn: 'Checked-in'
    },
    ordersTypes: {
      GROUP: 'Grup',
      SINGLE: 'Individual'
    },
    paymentTypes: {
      CASH: 'Cash',
      CARD: 'Card Online',
      POS: 'POS la livrare (Neplătit)',
      CARD_POS: 'Terminal POS fizic (Platit)',
      CASH_MACHINE: 'Cash machine (Platit)',
      POS_KIOSK: 'POS Kiosk (Neplătit)',
      VIVA_INTENT: 'VIVA App',
      VIRAMENT: 'Virament',
      SPLIT: 'Fiecare Separat',
      ROOM: 'Transfer pe Camera',
      FOLIO: 'Transfer pe Folio',
      EVENT: 'Transfer pe Eveniment',
      MANCARE_PERSONAL: 'Mancare personal',
      PROTOCOL: 'Protocol',
      ONLINE: 'Online',
      Online: 'Online',
      GLOVO: 'GLOVO',
      GLOVO_CARD: 'GLOVO CARD',
      GLOVO_CASH: 'GLOVO CASH',
      BOLT: 'BOLT',
      BOLT_CASH: 'BOLT CASH',
      BOLT_CARD: 'BOLT CARD',
      WOLT: 'WOLT',
      WOLT_CASH: 'WOLT CASH',
      WOLT_CARD: 'WOLT CARD',
      VOUCHER: 'Voucher',
      GIFT_CARD: 'Card cadou',
      null: 'Neachitat'
    },
    paymentStatus: {
      notPaid: 'Suma Reţinută',
      notPaidDetails: 'Suma va fi retrasă de pe card în momentul în care comanda va fi marcată ca fiind "Livrată".',
      paid: 'Achitat',
      notOk: 'Refuzat'
    },
    campaignsModes: {
      AUTO: 'Automat',
      MANUAL: 'Manual'
    },
    campaignsNotificationTypes: {
      EMAIL: 'E-mail',
      PUSH: 'Notificări'
    },
    days: {
      monday: 'Luni',
      tuesday: 'Marți',
      wednesday: 'Miercuri',
      thursday: 'Joi',
      friday: 'Vineri',
      saturday: 'Sâmbătă',
      sunday: 'Duminică',
      0: 'Duminică',
      1: 'Luni',
      2: 'Marți',
      3: 'Miercuri',
      4: 'Joi',
      5: 'Vineri',
      6: 'Sâmbătă'
    },
    months: {
      1: 'Ianuarie',
      2: 'Februarie',
      3: 'Martie',
      4: 'Aprilie',
      5: 'Mai',
      6: 'Iunie',
      7: 'Iulie',
      8: 'August',
      9: 'Septembrie',
      10: 'Octombrie',
      11: 'Noiembrie',
      12: 'Decembrie'
    },
    daysShort: {
      Mon: 'Lu',
      Tue: 'Ma',
      Wed: 'Mi',
      Thu: 'Jo',
      Fri: 'Vi',
      Sat: 'Sa',
      Sun: 'Du'
    },
    gender: {
      selectGender: 'Selectează Genul',
      male: 'masculin',
      female: 'feminin',
      Male: 'Masculin',
      Female: 'Feminin',
      Other: 'Altul'
    },
    reportsAgesGroups: {
      selectAge: 'Selectează Vârsta',
      '20': 'Sub 20',
      'Under 20': 'Sub 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      '50+': '50+',
      Unspecified: 'Nespecificat'
    },
    deliveryTypes: {
      SELF_ORDERING: 'Masa/Kiosk',
      DELIVERY: 'Livrare',
      EAT_LOCATION: 'Comandă La Masă',
      MEET_HALF: 'Ne întâlnim la jumătate',
      PICK_UP: 'Ridicare comandă'
    },
    couponsTypes: {
      FIXED: 'Fix',
      PERCENTAGE: 'Procent',
      FREE_PRODUCT: 'Produs gratuit'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Fix (inclus)',
      PERCENTAGE_INCLUDED: 'Procent (inclus)',
      FIXED_EXCLUDED: 'Fix',
      PERCENTAGE_EXCLUDED: 'Procent'
    },
    productOptions: {
      checkbox: 'Permite selectarea mai multor opțiuni pe produs',
      radio: 'Permite selectarea unei singure opțiuni pe produs',
      upload: 'Optiunea cu upload de imagine',
      hidePrices: 'Ascunde prețurile',
      hasDefaultValue: 'Preselectează prima opțiune'
    },
    validations: {
      success: 'Success',
      priceUpdated: 'Prețul a fost actualizat cu succes',
      areYouSureYouWantTo: 'Sigur că dorești modificarea ',
      areYouSure: 'Sigur dorești să actualizezi statusul ',
      wentWrong: 'A apărut o eroare, te rugăm să încerci mai târziu...',
      pictureSize2MB: 'Fișiere jpg/png cu o dimensiune mai mică de 2MB ',
      pictureSizeExceed2MB: 'Dimensiunea pozelor nu poate depăși 2MB!',
      pictureSize: 'Fișiere jpg/png cu o dimensiune mai mică de 5MB',
      pictureLogo: 'Fișiere jpg/png/svg cu o dimensiune mai mică de 5MB ',
      pictureSizeExceed: 'Dimensiunea pozelor nu poate depăși 5MB!',
      pdfSize: 'Fișiere cu o dimensiune mai mică de 25MB ',
      pdfSizeExceed: 'Dimensiunea fișierului nu poate depăși 25MB!',
      archiveSizeExceed: 'Dimensiunea fișierului nu poate depăși 500MB!',
      wrongFormat: 'Formatul fisierului este gresit',
      removePhoto: 'Te rugăm să ștergi documentele existente pentru a putea adăuga altele noi',
      dataCouldNotBeSaved: 'Datele nu au putut fi salvate, te rugăm să încerci mai târziu.',
      passReq: 'ID-ul câmpului de parolă este necesar.',
      passMin: 'Parola trebuie să conțină cel puțin 6 caractere.',
      passConf: 'Parola și confirmarea parolei nu corespund.',
      validPoinsNo: 'Te rugăm să adaugi o sumă valabilă de bani și un comentariu.',
      imageResolution: '. Rezoluție recomandată 300px înălțime și 820px lățime.',
      imageResolutionWeb: '. Rrezoluție recomandată 300px înălțime și 1920px lățime.',
      doYouWantTo: 'Dorești să',
      hourIsSmallerThanCreated: 'Ora dorită este mai mică decât ora de plasare a comenzii',
      cancelReason: 'Motivul anularii este obligatoriu.',
      requiredField: 'Acest câmp este obligatoriu',
      invalidEnteredData: 'Datele introduse nu sunt valide.',
      vatPrinterIdRange: 'Doar 0–10.',
      vatPrinterIdNumeric: 'Doar cifre.',
      chooseDay: 'Alegeți cel puțin  o zi în care produsul va fi disponibil!',
      chooseLocation: 'Alegeți cel puțin o locație în care produsul va fi disponibil!',
      chooseLocationAndDeliveryMethod: 'Alegeți cel puțin o locație și o metodă de livrare pentru care produsul va fi disponibil!',
      timeInterval: 'Interval orar invalid!',
      noOverrideIntervals: 'Livrarea personalizată este activată dar nu există niciun interval adăugat. Adăugați cel puțin un interval.',
      overrideIntervalMissingHours: 'Toate intervalele trebuie să aibă orele "De la" și "Până la" completate.',
      overrideIntervalMissingDay: 'Toate intervalele trebuie să aibă cel puțin o zi selectată.',
      subtractPoints: 'Sigur doriti stergerea a'
    },
    upload: {
      uploadLabel: 'Încarcă Meniu',
      uploadMenuTemplateLabel: 'Încarcă Formular Meniu',
      browse: 'Caută',
      download: 'Descarca Codul QR',
      dynamicMenu: 'Meniu dinamic',
      staticMenu: 'Meniu PDF',
      downloadImportProductsTemplate: 'Descarcă formular meniu',
      upload: 'Încarcă',
      downloadButton: 'Descarcă',
      uploadImagesArchive: 'Încarcă arhivă cu imagini',
      file: 'Fișier'
    },
    productImport: {
      import: 'Import',
      importHistory: 'Istoric importuri',
      batch: 'Batch',
      date: 'Dată',
      file: 'Fișier',
      products: 'Produse',
      status: 'Status',
      review: 'Revizuiește',
      confirm: 'Confirmă',
      cancel: 'Anulează batch',
      remove: 'Elimină',
      removeConfirm: 'Eliminați acest rând din import? Nu va fi aplicat.',
      editRow: 'Editează rând import',
      product: 'Produs',
      action: 'Acțiune',
      actionType: 'Tip',
      actionCreate: 'Creare',
      actionUpdate: 'Actualizare',
      actionPriceListUpdate: 'Actualizare listă prețuri',
      price: 'Preț',
      category: 'Categorie',
      errors: 'Erori',
      pending: 'În așteptare',
      confirmed: 'Reușite',
      removed: 'Eliminate',
      uploadSuccess: 'Import încărcat. Revizuiți și confirmați modificările.',
      confirmSuccess: 'Import aplicat cu succes',
      statusPending: 'În așteptare',
      statusConfirmed: 'Confirmat',
      statusSuccessful: 'Reușit',
      statusPartiallyConfirmed: 'Parțial confirmat',
      statusPartiallySuccessful: 'Parțial reușit',
      statusCanceled: 'Anulat',
      statusError: 'Eroare',
      statusRemoved: 'Eliminat',
      exportProducts: 'Exportă produse',
      exportImages: 'Descarcă imagini',
      selectPriceProfile: 'Listă de prețuri',
      priceProfileRequired: 'Selectați o listă de prețuri înainte de confirmare',
      confirmTitle: 'Confirmă importul',
      confirmPriceHint: 'Alegeți lista de prețuri unde vor fi aplicate prețurile pe canale.',
      step1Title: 'Descarcă / exportă',
      step1Intro: 'Alegeți o opțiune: formular gol sau export cu produsele existente pe locație.',
      optionEmptyTitle: 'Formular gol',
      optionEmptyDesc: 'Descărcați un CSV gol și completați-l offline.',
      downloadEmptyForm: 'Descarcă formular gol',
      optionExportTitle: 'Exportă produsele existente',
      optionExportDesc: 'Exportați produsele curente ale locației în CSV-ul de meniu (necesită o listă de prețuri).',
      defaultPriceListHint: 'Dacă locația nu are listă de prețuri, creăm una cu numele „{location} default”.',
      noProductsForExport: 'Locația nu are produse, deci exportul este dezactivat.',
      step2Title: 'Completează formularul',
      step2Body: 'Deschide CSV-ul în Excel sau Google Sheets. Completează PRODUCT ID, PREȚ și prețurile pe canale offline, apoi salvează ca CSV.',
      step3Title: 'Imagini (.zip)',
      step3Hint: 'Încărcați un .zip cu imaginile produselor.',
      step4Title: 'Meniu (.csv)',
      step4Hint: 'Încărcați CSV-ul completat. Veți revizui și confirma importul în previzualizare înainte ca modificările să fie aplicate.',
      sectionIdentity: 'Identitate produs',
      sectionCategories: 'Categorii',
      sectionBase: 'Detalii de bază',
      sectionDescription: 'Descriere și etichete',
      sectionPrices: 'Prețuri pe canale',
      searchProduct: 'Potrivește produs existent',
      searchProductPlaceholder: 'Caută după nume…',
      productMatchNew: 'PRODUCT ID gol — la confirmare se creează un produs nou.',
      productMatchFound: 'Potrivit: {name}',
      productMatchUnknown: 'Produs necunoscut — căutați și selectați un produs existent, sau goliți ID-ul pentru creare.',
      topCategory: 'Categorie de top',
      secCategory: 'Categorii secundare',
      active: 'Activ',
      activeHint: '1 / 0 / da / nu',
      posId: 'POS ID',
      vat: 'TVA',
      section: 'Secțiune',
      weight: 'Greutate',
      imageFilename: 'Nume fișier imagine',
      imageFilenameHint: 'Numele din arhiva zip încărcată',
      desc: 'Descriere',
      nutritional: 'Valori nutriționale',
      allergenic: 'Alergeni',
      ingredients: 'Ingrediente',
      legacyTitle: 'Import vechi',
      legacyHint: 'Aplică CSV-ul imediat, fără previzualizare. Folosește formularul clasic (doar creare produse — fără PRODUCT ID / prețuri pe canale). Încărcați imaginile ca .zip aici înainte de importul CSV.',
      legacyDownloadLabel: 'Descarcă formular meniu',
      legacyDownload: 'Descarcă',
      legacyUpload: 'Încarcă',
      legacyUploadSuccess: 'Importul vechi a fost finalizat'
    },
    dashboard: {
      selectLocation: 'Selectează locația',
      selectZone: 'Zona',
      selectMethod: 'Metodă',
      selectDriver: 'Sofer',
      selectUsers: 'Administratori',
      selectClient: 'Client',
      selectedOrderFormFlags: 'Pentru comenzile din',
      selectedPaymentMethods: 'Pentru comenzile cu',
      serchCoupon: 'Caută(Cupon)',
      tile1Title: 'Comenzi Noi',
      tile2Title: 'Total Comenzi',
      tile3Title: 'Venituri',
      tile4Title: 'Comandă Medie',
      today: 'Azi',
      orderChart: 'Comenzi',
      completed: 'Număr de comenzi',
      canceled: 'Anulate',
      salesChart: 'Vânzări',
      salesIn: 'Vânzări în',
      top5Chart: 'Top 5 produse',
      orderingChart: 'Tipuri de comenzi',
      nrOfOrders: 'Număr de comenzi',
      nrOfEmails: 'Număr de emailuri'
    },
    customers: {
      addCustomerToGroup: 'Adaugă client în grup...',
      noApprovalRequired: 'Fără aprobare',
      searchPlaceholder: 'Caută după nume, telefon sau email...',
      myGroups: 'Grupurile mele',
      pendingApproval: 'în așteptare',
      noGroups: 'Nu face parte din niciun grup',
      approvalStatus: 'Status',
      approved: 'Aprobat',
      approve: 'Aprobă',
      clientApproved: 'Client aprobat cu succes!',
      membersRequireApproval: 'Membrii necesită aprobare',
      totalSales: 'Total vanzari',
      settings: 'Setari utilizator',
      allow_virament: 'Permiteti virament',
      singleTotal: 'Total client: ',
      noCustomer: 'Nici un Client Selectat',
      single: 'client',
      plural: 'clienți',
      deliveryOrders: 'Comenzi cu Livrare',
      pickupOrders: 'Comenzi cu Ridicare',
      meetHalfwayOrders: 'Comnezi "Ne intalnim la jumatate"',
      customerReservations: 'Rezervari',
      title: 'DETALII CLIENT',
      pointsTitle: 'Puncte Loialitate Client',
      currentPoints: 'Puncte Actuale',
      pointsAddTitle: 'Adaugă Puncte',
      pay: 'Tip Plata',
      id: 'ID',
      name: 'Nume',
      email: 'Email',
      phone: 'Telefon',
      use_calling_phone: 'Preia numar telefon',
      gender: 'Gen',
      birth: 'Data nașterii',
      location: 'Locație',
      address: 'Adresă',
      number: 'Număr',
      dateCreated: 'Data creare',
      delivery: 'Livrare',
      type: 'Tip',
      status: 'Status',
      total: 'Total',
      allTimeSale: 'Vânzări totale',
      fidelities: 'Label',
      none: 'Nici unul',
      pointsLabel: 'Bani cheltuiți',
      pointsLabelInPoints: 'Puncte primite',
      pointsAdjustmentHelp: 'Introdu o valoare pozitivă pentru a adăuga puncte sau o valoare negativă (de ex. -100) pentru a scădea puncte din soldul clientului.',
      points: 'puncte',
      point: 'punct',
      clientCanUse: 'Clientul va putea folosi',
      commentsLabel: 'Comentariu',
      pointsSuccess: 'Puncte loialitate adăugate cu succes.',
      pointsError: 'Nu am putut adăuga punctele de loialitate clientului.',
      addCommentPerClient: 'Adaugă comentariu per client',
      newCommentAdded: 'Comentariul a fost actualizat',
      clientNotification: 'Dorești sa folosești comenatariul pentru a notifica clientul?',
      filters: {
        withOrders: 'Cu Comenzi',
        withoutOrders: 'Fara Comenzi'
      },
      addGroup: 'Adaugă grup',
      deleteGroup: 'Grupul a fost șters.',
      saveGroup: 'Grupul a fost adăugat cu succes.',
      updateGroup: 'Grupul a fost actualizat cu succes.'
    },
    orders: {
      cancel_order_reason: 'Motiv Anulare',
      counterPerCustomer: 'Număr Comenzi',
      noOrders: 'Nici o comandă Selectată',
      single: 'Comanda',
      the_order: 'Comandă',
      category: 'Categorie',
      plural: 'comenzi',
      status: 'Status',
      location: 'Locație',
      updateStatus: 'Actualizează Status',
      editOrder: 'Editează',
      ordDetails: 'Detalii Comenzi',
      date: 'Data',
      madeAt: 'Comandă plasată la',
      pickupTime: 'Livrare / Ridicare la',
      preorder: 'PRECOMANDĂ',
      preorderFilter: 'Precomenzi',
      allOrders: 'Toate comenzile',
      pendingPreorders: 'Precomenzi în așteptare',
      withoutPendingPreorders: 'Fără precomenzi în așteptare',
      reservationTime: 'Oră Rezervare',
      expresoftStatus: 'Expresoft Status',
      expresoftQueue: 'In Trimitere',
      expresoftError: 'Eroare trimitere',
      expresoftSuccess: 'Trimis',
      reservationSeats: 'Rezervare Locuri',
      rating: 'Evaluare',
      meetupLocation: 'Punct de intalnire',
      ordLocation: 'Locație',
      delivery: 'Livrare',
      type: 'Tip',
      payment: 'Plată',
      name: 'Nume',
      qty: 'Cantitate',
      unit: 'Preț buc',
      unit_price: 'Preț pe bucată',
      final_price: 'Preț final',
      total: 'Total',
      totals_subtotals: 'Subtotal',
      totals_extras: 'Ecotaxă',
      totals_extras_27: 'Taxa Ambalaj',
      totals_extras_30: 'Ecotaxă',
      totals_extras_38: 'Sacosa Spartan',
      totals_extras_40: 'Ecotaxă',
      totals_extras_50: 'Ambalaj',
      totals_discount: 'Discount',
      totals_discount_loyalty_points: 'Discount puncte loialitate',
      totals_grandtotal: 'Total',
      totals_shipping: 'Livrare',
      totals_tip: 'Bacșiș',
      totals_donation: 'Donație',
      custComments: 'Comentariu Client',
      adminComments: 'Comentariu Admin',
      pos_response_title: 'Raspuns POS',
      fiscal_response_title: 'Raspuns Fiscal',
      custDetails: 'Detalii Clienți',
      shipping: 'Adresă Livrare',
      billing: 'Adresă Facturare',
      orderStatusSuccess: 'Statusul comenzii a fost actualizat cu succes',
      orderPrinterError: ', dar a aparut o eroare la conexiunea cu imprimanta.',
      orderCommnetSuccess: 'Comentariul pe comandă a fost actualizat cu succes',
      orderHourSuccess: 'Timpul de livrare / ridicare comandă actualizat cu succes',
      orderHourError: 'Te rugăm să oferi o oră validă.',
      none: 'Nici un comentariu',
      at: 'la',
      filtersApplied: 'Filtre aplicate - apasă butonul de filtru pentru a vedea mai mult',
      filtersList: 'Filtre aplicate',
      customFilters: 'Filtre specifice aplicate',
      resetFilters: 'apasă aici pentru a reseta și a vedea datele actualizate',
      noFiltersApplied: 'Nu sunt filtre aplicate',
      filtersAndSort: 'Filtre și Sortare',
      filters: 'Filtrează',
      pickupDatetime: 'Data și Ora Ridicare Comandă',
      placedDatetime: 'Data și Ora Plasare Comandă',
      orderId: 'ID Comandă',
      orderNumber: 'Număr Comandă',
      orderTotal: 'Total Comandă',
      enterOrderId: 'Introdu ID comandă',
      enterOrderNumber: 'Introdu număr comandă',
      selectDateRange: 'Selectează interval dată',
      min: 'Min',
      max: 'Max',
      operator: 'Operator',
      source: 'Sursă',
      note: 'Notificare',
      orderNoArticulate: 'Comanda',
      print: 'Printează (A4)',
      print2: 'Printează (A4 Restrâns)',
      printerPrint: 'Print (80mm)',
      printFiscal: 'Încasează',
      receipt: 'Bon fiscal',
      printedReceipt: 'Comanda a fost încasată',
      notPrintedReceipt: 'Comanda nu a fost încasată',
      rePrintFiscal: 'Reprintare bon',
      printerSuccess: 'Comanda a fost printată cu success.',
      printerErrror: 'A aparut o eroare la conexiunea cu imprimanta.',
      callCourier: 'Cheamă curier',
      callHioCourier: 'Hio',
      callTazzLaasCourier: 'Tazz Direct',
      callCourierCancel: 'Sigur dorești să anulezi chemarea curierului?',
      orderSentSuccess: 'Chemarea curierului a avut loc cu succes',
      orderCancelSuccess: 'Chemarea curierului a fost anulată',
      packageDetails: 'Selecteaza detalii colet',
      packageSize: 'Marime colet: ',
      courierTime: 'Timp de ridicare colet: ',
      sameStatus: 'Comanda este deja ',
      now: 'Acum',
      addTime: 'Adăugă timp',
      amountRefunded: 'Sumă returnată',
      amountIntegralRefunded: 'Suma a fost returnată integral clientului',
      refundSuccess: 'Returnarea banilor a fost realizată cu succes',
      refundManual: 'Returnarea banilor se va face din paylike manual',
      refundAutomat: 'Dorești returnarea automată a sumei ?',
      refundOrder: 'Rambursează',
      refundAlreadyDone: 'Deja rambursat',
      refundConfirmTitle: 'Rambursezi comanda?',
      refundConfirmText: 'Suma plătită va fi returnată clientului prin EuPlatesc. Această acțiune nu poate fi anulată.',
      refundAskCancel: 'Rambursarea a fost efectuată. Vrei să anulezi și comanda?',
      refundError: 'A apărut o eroare la procesarea rambursării.',
      orderCloseToDelivery: 'Comandă cu oră de livrare apropiată',
      erorrPaylike: 'Eroare din Paylike, un log s-a facut pe server cu eroarea returnată',
      sendToGrandchef: 'Dorești trimiterea comenzii către Grandchef?',
      grandchefError: 'Eroare din Grandchef',
      grandchefWait: 'Poți încerca doar o dată la 30 minute',
      cancelReason: 'Introduceti motivul...',
      contactPakageez: 'Eroare! Luați legătura cu Pakageez!',
      contactRapidDonkey: 'Eroare! Luați legătura cu Rapid Donkey!',
      contactChopChop: 'Eroare! Luați legătura cu Chop Chop!',
      contactDrCarmen: 'Eroare! Luați legătura cu Dr Carmen!',
      seeImage: 'Vezi Imaginea',
      freyaStatus: 'Status Freya',
      rkeeperStatus: 'Status RKeeper',
      freyaStatus1: 'In Trimitere',
      freyaStatus2: 'S-a trimis cu succes',
      freyaStatus3: 'Trimiterea a eșuat.',
      freyaStatus4: 'Anulat.',
      freyaSendAgain: 'Introduceți comanda manual sau încercați din nou.',
      legalPerson: 'Persoană juridică',
      individual: 'Persoană fizică',
      billingInfo: 'Date facturare',
      callDriver: 'Cheama curierul?',
      virament: 'Virament',
      cash: 'Cash',
      card: 'Card',
      online: 'Online',
      BOLT: 'BOLT',
      GLOVO: 'GLOVO',
      WOLT: 'WOLT',
      cancel: 'Anulează',
      card_no_pos: 'POS MOBIL',
      cui: 'CUI(optional)',
      glovoStatus: 'Status Glovo',
      glovoLaasEvents: 'Jurnale Glovo LaaS',
      glovoLaasEventsEvent: 'Acțiune',
      glovoLaasEventsTime: 'Oră',
      glovoLaasTrackCourier: 'Urmărește curierul',
      glovoLaasLogResponse: 'Răspuns',
      glovoLaasLogAction_Create_delivery: 'Creează livrare',
      glovoLaasLogAction_Create_delivery_failed: 'Creare livrare eșuată',
      glovoLaasLogAction_Cancel_delivery: 'Anulează livrare',
      glovoLaasLogAction_Cron_callCourier: 'Chemare curier automată (cron)',
      glovoLaasLogAction_Webhook_event_received: 'Eveniment webhook primit',
      tazzStatus: 'Status Tazz',
      tazzDirectStatus: 'Status Tazz Direct',
      courierStatus1: 'Curierul nu a fost chemat',
      courierStatus2: 'Curierul a fost chemat',
      courierStatus3: 'Curierul nu a fost chemat',
      courierStatus4: 'Curierul a fost anulat',
      courierStatus5: 'Livrare administrată de Glovo',
      courierStatus6: 'A apărut o eroare',
      courier: 'Curier',
      courierDeliveryError: 'Eroare',
      courierDeliverySuccess: 'Succes',
      packageNumber: 'Numar colete: ',
      zone: 'Zonă',
      roomNumber: 'Număr Cameră',
      pagerNumber: 'Număr pager',
      woltDriveStatus: 'Status Wolt Drive',
      deliveryHeroStatus: 'Status Delivery Hero',
      deliveryHeroAreYouSure: 'Chemați curierul Delivery Hero?',
      deliveryHeroEvents: 'Jurnale Delivery Hero',
      deliveryHeroEventsEvent: 'Acțiune',
      deliveryHeroEventsTime: 'Oră',
      deliveryHeroLogResponse: 'Răspuns',
      deliveryHeroLogAction_Create_order: 'Creare comandă',
      deliveryHeroLogAction_Create_order_failed: 'Creare comandă eșuată',
      deliveryHeroLogAction_Cancel_order: 'Anulare comandă',
      deliveryHeroLogAction_Cancel_order_failed: 'Anulare comandă eșuată',
      deliveryHeroLogAction_OAuth_token: 'Token OAuth',
      deliveryHeroLogAction_Status_webhook: 'Webhook status',
      deliveryHeroLogAction_Refund_webhook: 'Webhook refund',
      deliveryHeroLogAction_Autopilot_skip: 'Autopilot skip',
      noShipmentPromises: 'Nu sunt promisiuni de livrare disponibile pentru timpul selectat.',
      selectShipmentPromise: 'Selectează Promisiunea de Livrare',
      pleaseSelectPromise: 'Te rugăm să selectezi o promisiune de livrare.',
      confirmDeliveryDetails: 'Confirmă detaliile livrării',
      woltDriveEvents: 'Jurnale Wolt Drive',
      woltDriveEventsEvent: 'Acțiune',
      woltDriveEventsTime: 'Oră',
      woltDriveTrackCourier: 'Urmărește Curier',
      woltDriveLogResponse: 'Răspuns',
      woltDriveLogResponse_success: 'Succes',
      woltDriveLogAction_Get_shipment_promise: 'Obține promisiunea de livrare',
      woltDriveLogAction_Get_shipment_promise_failed: 'Estimare de livrare',
      woltDriveLogAction_Create_delivery: 'Creează livrare',
      woltDriveLogAction_Create_delivery_failed: 'Creare livrare eșuată',
      woltDriveLogAction_Cron_callCourier: 'Chemare curier automată (cron)',
      woltDriveLogAction_No_binding_shipment_promise: 'No binding shipment promise',
      woltDriveLogAction_Autopilot_No_valid_promises: 'Autopilot - No valid promises',
      woltDriveLogAction_Skip_create_delivery_autopilot_gate: 'Skip create delivery (autopilot gate)',
      woltDriveLogAction_Skip_callCourierAndRetry: 'Skip callCourierAndRetry',
      woltDriveLogAction_Cancel_courier: 'Cancel courier',
      woltDriveLogAction_Cancel_delivery_by_order: 'Cancel delivery by order',
      woltDriveLogAction_Cancel_delivery: 'Cancel delivery',
      woltDriveLogAction_Webhook_event_received: 'Webhook event received',
      woltDriveEventType_order_received: 'Comandă primită',
      woltDriveEventType_order_rejected: 'Comandă respinsă',
      woltDriveEventType_order_pickup_eta_updated: 'ETA ridicare actualizat',
      woltDriveEventType_order_pickup_started: 'Ridicare începută',
      woltDriveEventType_order_picked_up: 'Comandă ridicată',
      woltDriveEventType_order_pickup_arrival: 'Curierul ajunge la ridicare',
      woltDriveEventType_order_dropoff_started: 'Livrare începută',
      woltDriveEventType_order_dropoff_arrival: 'Curierul ajunge la livrare',
      woltDriveEventType_order_dropoff_completed: 'Livrare finalizată',
      woltDriveEventType_order_delivered: 'Comandă livrată',
      woltDriveEventType_order_customer_no_show: 'Client indisponibil',
      woltDriveEventType_order_location_updated: 'Locația curierului actualizată',
      woltDriveEventType_order_dropoff_eta_updated: 'ETA livrare actualizat',
      woltDriveEventType_order_handshake_delivery: 'Livrare cu PIN',
      woltDriveEventType_order_status_updated: 'Status comandă actualizat',
      woltDriveCancelErrorCode_INVALID_ORDER_STATE_TRANSITION: 'Nu se poate anula această livrare: comanda nu este într-o stare anulabilă. Vă rugăm să contactați suportul.',
      woltDriveShipmentPromisesErrorCode_DROPOFF_OUTSIDE_OF_DELIVERY_AREA: 'Locația de livrare este în afara zonei de livrare.',
      woltDriveCreateDeliveryErrorCode_CASH_ON_DELIVERY_DISABLED: 'Plata la livrare nu este disponibilă pentru Wolt Drive. Vă rugăm să contactați echipa Wolt Drive.'
    },
    ordersSource: {
      1: 'Kiosk',
      2: 'Qr',
      3: 'Pos',
      4: 'App',
      5: 'Website',
      6: 'Glovo',
      7: 'Wolt',
      8: 'Bolt'
    },
    boogit: {
      boogitStatus: 'Status Boogit',
      boogitStatus1: 'Nu s-a trimis',
      boogitStatus2: 'S-a trimis cu succes',
      boogitStatus3: 'Trimiterea a eșuat.',
      boogitStatus4: 'Anulat.'
    },
    charisma: {
      location: 'Locație',
      posIds: 'ID-uri POS',
      partnerCode: 'Cod partener',
      tipsItemId: 'ID articol bacșiș',
      createDate: 'Creat',
      updateDate: 'Modificat',
      orderOptionId: 'ID Opțiune Comandă',
      companyOptionId: 'ID Opțiune Companie',
      optionName: 'Nume Opțiune',
      optionValueName: 'Nume Valoare Opțiune',
      categoryAdministration: 'Gestiune',
      charismaInventory: 'Gestiune Charisma',
      logRvc: 'RVC',
      dataFrom: 'Răspuns',
      dataTo: 'Trimis',
      enterPosId: 'Introduceți Item Code',
      options: 'Opțiuni #',
      itemCode: 'Item Code',
      itemId: 'Item ID',
      enterItemCode: 'Introduceți Item Code dacă lipsește',
      sendAll: 'Trimite selecția',
      sendAllMessage: 'Comenzile au fost marcate și vor fi importate în Charisma în câteva minute, în funcție de numărul de comenzi',
      bill: 'Proformă',
      invoice: 'Factura Fiscală',
      documentType: 'Tip Document',
      charisma0: '-',
      charisma1: 'Netrimis',
      charisma2: 'Se trimite',
      charisma20: 'Se trimite',
      charisma3: 'Trimis',
      charisma4: 'Eroare',
      sendOnlyProform: 'Trimite doar Proforma',
      sendOnlyInvoice: 'Trimite doar Factura',
      orderItems: 'Articole comandă',
      sendHistory: 'Istoric trimitere',
      document: 'Document',
      resultCharisma: 'Rezultat Charisma',
      verdict: 'Verdict',
      logStatus: 'Status',
      logVerdictSuccess: 'Trimis cu succes',
      logVerdictError: 'Eroare la trimitere în Charisma',
      logVerdictCharismaError: 'Eroare Charisma',
      logVerdictAwaitingResponse: 'Trimis, așteaptă răspuns',
      logVerdictNoPayload: 'Nu există date înregistrate',
      logVerdictUnknown: 'Status necunoscut',
      logVerdictMissingPosIds: 'Eroare validare, lipsă id-uri Charisma. Vă rugăm completați mai sus și trimiteți.',
      logVerdictMissingCategoryAdministration: 'Lipsă gestiune de pe categorie, completați mai sus și trimiteți.',
      logVerdictConnectionError: 'Eroare conexiune server Charisma',
      logVerdictOrderNotDelivered: 'Comanda nu a fost livrată încă.',
      resendConfirm: 'Comanda a fost deja trimisă, ești sigur că vrei să trimiți din nou comanda?'
    },
    fiscalZ: {
      id: 'ID',
      zNumber: 'Număr',
      zTimestamp: 'Dată și oră',
      totalSalesA: 'Total Vânzări A',
      totalSalesB: 'Total Vânzări B',
      totalSalesC: 'Total Vânzări C',
      totalSalesD: 'Total Vânzări D',
      totalSalesE: 'Total Vânzări E',
      totalOtherTaxes: 'Total Alte Taxe',
      totalVatExempt: 'Total Scutit TVA',
      totalSales: 'Total Vânzări',
      totalVatA: 'Total TVA A',
      totalVatB: 'Total TVA B',
      totalVatC: 'Total TVA C',
      totalVatD: 'Total TVA D',
      totalVatE: 'Total TVA E',
      totalVat: 'Total TVA'
    },
    companyOptions: {
      id: 'Id',
      name: 'Nume',
      image: 'Imagine',
      prod_image: 'Imagine Produs (doar pt aplicatii custom)',
      info: 'Info',
      print_with_product_label: 'Imprimați cu eticheta produsului (pentru imprimantele de etichete)',
      product_id: 'Optiunea este Produsul',
      type: 'Tip',
      deleteQues: 'Această acțiune va șterge opțiunea și de pe produsele pe care este pusă. Ești sigură că dorești să continui?',
      deleteVal: 'Această acțiune va șterge valoarea și de pe produsele pe care este pusă. Daca nu doresti asta, nu salva!',
      active: 'Activ',
      quantitySettings: 'Setări Cantitate',
      allowQuantity: 'Permite cantitate',
      minQuantity: 'Cantitate minimă',
      maxQuantity: 'Cantitate maximă',
      quantityMinMaxError: 'Cantitatea minimă nu poate fi mai mare decât cantitatea maximă'
    },
    catalogProd: {
      prod_desc: 'Descriere',
      prod_general: 'General',
      prod_price: 'Pret',
      prod_loc: 'Locatie',
      prod_opt: 'Optiuni',
      prod_mark: 'Marketing',
      prod_lab: 'Label',
      prod_set: 'Setari',
      same_name_are_you_shore: 'Acest nume se mai regaseste si la alt produs, Esti sigur ca vrei sa salvezi?',
      max_purchases_per_customer: 'Achiziții maxime per client',
      preparation_time_in_minutes: 'Timp de preparare (minute)',
      category_preparation_time_hint: 'Timp de preparare categorie: {minutes} min',
      label_type: 'Tip',
      orderLabelSettings: 'Etichete de comandă',
      printOnOrderLabel: 'Imprimă pe etichetele comenzii',
      printOnOrderLabelHint: 'Produsul se imprimă dacă îl bifezi aici și alegi „Câte o etichetă pentru fiecare produs” pe imprimanta Order Label.',
      label_name: 'Nume produs pe eticheta',
      label_ingredients: 'Ingrediente pe eticheta',
      label_allergens: 'Alergeni pe eticheta',
      label_exp_txt: 'Text expirare (ex: A se consuma de preferabil dupa 2 ore de la deschidere)',
      sold_with_menu_suggestion: 'Cu sugestii de meniu',
      sold_with_menu_suggestion_pos: 'Activează pe POS această funcționalitate!',
      noProducts: 'Nici un produs selectat',
      single: 'produs',
      plural: 'produse',
      generalDetails: 'Detalii Generale',
      aditionalInfo: 'Informatii aditionale',
      id: 'ID',
      name: 'Nume',
      desc: 'Descriere',
      image: 'Imagine',
      image_size: 'Dimensiune Image',
      video_thumbnail: 'Video Thumbnail',
      imageMore: 'Alte imagini',
      video: 'Video',
      category: 'Categorie',
      topCategory: 'Categorie de top',
      partialPay: 'Plata partiala',
      isDeposit: 'Este Avans',
      isAgeRestrict: 'Restricție de vârstă',
      limitQuantityKioskQr: 'Cantitate 1 pentru Kiosk/Qr',
      secondaryCategory: 'Categorie secundara',
      coursesType: 'Tip fel',
      coursesTypeMaxAllowed: 'Valoarea maximă permisă de locație: {max}',
      coursesTypeLocationNotPermitted: 'Locația nu permite feluri',
      price: 'Preț',
      usePriceToShow: 'Folosește afișare de preț',
      priceToShow: 'Preț pentru afișare',
      oldPrice: 'Preț vechi',
      newPrice: 'Preț nou',
      deliveryMethod: 'Metodă de livrare',
      useDiscountPrice: 'Folosește preț redus',
      taxes: 'Taxe aplicate',
      status: 'Status',
      posid: 'POS ID',
      allowUserComments: 'Permite utilizatorilor să lase un mesaj',
      availableInStore: 'Disponibil doar in restaurant',
      validFromTo: 'Valabil de la - până la',
      prodType: 'Tip Produs',
      singleType: 'indivuald',
      groupType: 'grup',
      rewardPoints: 'Puncte loialitate',
      moneySpent: 'Bani în Puncte',
      numberOfYouNeedToSpend: 'Suma de {currency} pe care clientul trebuie să o cheltuiască pentru a primi 1 punct.',
      points: 'puncte',
      soldWith: 'Vândut cu',
      pickAnOption: 'Alege o opțiune',
      minNoSelected: 'Nr. min selectat',
      maxNoSelected: 'Nr. max selectat',
      optVal: 'Valoare',
      leaveEmpty: 'Lasă gol sau pune 0 dacă opțiunea nu costă suplimentar',
      prodDeleted: 'Produs șters cu succes',
      prodAdded: 'Produs adăugat cu succes',
      prodUpdated: 'Produs actualizat cu succes',
      prodPhotoError: 'Nu am putut salva poza de produs, te rugăm să încerci mai târziu.',
      rewardPossibelValue: 'Posibile valori',
      errorOptions: 'Vă rugăm să verificați ca toate câmpurile produsului să fie completate corespunzător.',
      productOptionError: 'Vă rugăm să verificați ca toate opțiunile produsului să fie completate corespunzător.',
      minNoNegative: 'Nr. minim nu poate fi mai mic de 0',
      maxNoNegative: 'Nr. maxim nu poate fi mai mic de 0',
      minNoTooHigh: 'Nr. minim nu poate depăși nr. maxim',
      maxNoTooHigh: 'Nr. maxim nu poate depăși nr. valorilor',
      optionInUse: 'Această opțiune este folosită de unele produse. Ștergeți-o mai întâi de pe produse.',
      locationSettings: 'Setări de locație',
      availableIn: 'Disponibil în',
      availableInLocation: 'Disponibil în locație',
      availableFor: 'Disponibil pentru',
      availableForSource: 'Disponibil pentru sursă',
      groupOption: 'Grup de opțiuni',
      deliveryMethodsandHours: 'Metode si ore de livrare',
      overrideSettings: 'Suprascrie Setarile',
      addLocationValidation: 'Unele optiuni nu sunt compatibile cu locatiile selctate, dacă continuați, optiunile vor fi eliminate, daca nu, locatia dorită nu va fi adaugată.',
      productAvailableIn: 'Produsul este disponibil în',
      particularLocationSettings: 'Setări particular per locație',
      activateParticularSettings: 'Activează setări particular',
      withoutThisOptionDefault: '*fără activarea acestei opțiuni vor fi folosite setările implicite',
      highlightsProduct: 'Evidențiază produs',
      search: 'Căutare',
      availability: 'Disponibilitate',
      setLimitedAvailability: 'Aplica disponibilitate limitata',
      leaveEmptyAvailability: 'Lasă gol pentru cantitale nelimitată.',
      timeOptions: 'Opțiuni de dată și timp',
      picktimeOptions: 'Selectează opțiunea:',
      timeOptionsValues: {
        none: 'Niciuna',
        dateTimePicker: 'Selector de dată și oră',
        dateRangePicker: 'Selector de interval de dată'
      },
      maxQuantityIn: 'Cantitate maximă în',
      unitOfTime: 'unitatea de timp',
      youChoose: 'Ai ales',
      isUsedFor: '*Este folosită doar pe locațiile bifate în setări',
      isHiddenFromListing: 'Ascunde din lista de produse',
      isHiddenFromSearch: 'Ascunde din cautarea de produse',
      isHiddenFromQrMenu: 'Ascunde din meniul Qr',
      isHiddenFromPOS: 'Ascunde din POS',
      isHiddenFromKiosk: 'Ascunde din Kiosk si Meniu Qr',
      Monday: 'Lu',
      Tuesday: 'Ma',
      Wednesday: 'Mi',
      Thursday: 'Jo',
      Friday: 'Vin',
      Saturday: 'Sam',
      Sunday: 'Dum',
      accesRestricted: 'Ne pare rău dar nu ai acces la acest produs',
      disableProductUsedByBanner: 'Dezactivarea acestui produs va dezactiva și oferta aferentă. Ești sigur?',
      deleteProductUsedByBanner: 'Ștergerea acestui produs va dezactiva și oferta aferentă. Ești sigur?',
      availabilityTitle: 'Disponibilitate produs',
      fromTime: 'De la',
      toTime: 'până la',
      timePlaceholder: 'Selectează ora',
      productNotAvailable: 'Produs indisponibil',
      productNotAvailableError: 'Vă rog completați aceste două câmpuri.',
      swalTitleChangeStatus: 'Vă rog setați statusul produsului ca "activ" înainte.',
      externalProductId: 'ID Extern',
      minQuantity: 'Cantitate Minimă',
      hideFromPlatforms: 'Ascunde de pe platforme',
      changeLocations: 'Schimbă locațiile',
      includeAllLocationsProducts: 'Include și produsele disponibile în toate locațiile',
      bulkLocationsMode: 'Acțiune',
      bulkModeAdd: 'Adaugă',
      bulkModeRemove: 'Elimină',
      bulkModeReplace: 'Înlocuiește',
      massUpdate: 'Actualizare în masă',
      massUpdateSubtitle: 'Urmează să actualizezi {count} produse',
      bulkActionActive: 'Activ / Inactiv',
      bulkActionPrice: 'Preț',
      bulkActionVat: 'TVA',
      bulkActionSection: 'Secție',
      bulkActionOptionGroups: 'Grupuri de opțiuni',
      bulkActionDelete: 'Șterge',
      bulkOverrideDeliveryHint: 'La activare, adaugă doar metodele de livrare necesare (+). Programele de override existente pe produsele selectate sunt înlocuite. Intervalele inactive nu se salvează. Dezactivarea șterge programele existente.',
      bulkOverrideLocationsHint: 'Lasă gol pentru toate locațiile companiei. Se aplică doar locațiile pe care le are deja fiecare produs.',
      bulkOverrideAddIntervalHint: 'Apasă + pentru a adăuga un interval pentru această metodă.',
      bulkPriceDirection: 'Direcție',
      bulkPriceIncrease: 'Crește',
      bulkPriceDecrease: 'Scade',
      bulkPriceMode: 'Tip',
      bulkPriceFlat: 'Sumă fixă',
      bulkPricePercent: 'Procent (%)',
      bulkPriceAmount: 'Valoare',
      bulkPriceBaseOnlyHint: 'Se modifică doar prețul de bază. Noul preț nu va coborî sub 0.',
      bulkOptionGroupsMode: 'Mod asociere',
      bulkOptionGroupsModeHint: 'Adaugă păstrează grupurile existente. Înlocuiește le schimbă cu cele selectate.',
      bulkDeleteWarning: 'Această acțiune va șterge {count} produse. Nu poate fi anulată ușor.',
      bulkDeleteEnableLabel: 'Da, șterge produsele selectate (celelalte acțiuni în masă vor fi ignorate)',
      confirmBulkMultiple: 'Aplică aceste modificări pe {count} {products}:',
      bulkProductSingular: 'produs',
      bulkProductPlural: 'produse',
      confirmBulkAreYouSure: 'Ești sigur?',
      bulkSummaryAddLocations: 'să adaugi locații ({value}) la {count} {products}',
      bulkSummaryRemoveLocations: 'să elimini locații ({value}) de la {count} {products}',
      bulkSummarySetActive: 'să setezi {count} {products} ca activ',
      bulkSummarySetInactive: 'să setezi {count} {products} ca inactiv',
      bulkSummaryIncreasePriceFlat: 'să crești prețul de bază la {count} {products} cu {amount} {currency}',
      bulkSummaryIncreasePricePercent: 'să crești prețul de bază la {count} {products} cu {amount}%',
      bulkSummaryDecreasePriceFlat: 'să scazi prețul de bază la {count} {products} cu {amount} {currency}',
      bulkSummaryDecreasePricePercent: 'să scazi prețul de bază la {count} {products} cu {amount}%',
      bulkSummaryAddOptionGroups: 'să adaugi grupuri de opțiuni ({value}) la {count} {products}',
      bulkSummaryReplaceOptionGroups: 'să înlocuiești grupurile de opțiuni pe {count} {products} cu ({value})',
      bulkSummarySetVat: 'să setezi TVA {value} pe {count} {products}',
      bulkSummarySetSection: 'să setezi secția {value} pe {count} {products}',
      bulkSummaryEnableOverride: 'să activezi suprascrierea setărilor pe {count} {products}',
      bulkSummaryEnableOverrideWithSchedule: 'să înlocuiești programele de override pe {count} {products}',
      bulkSummaryDisableOverride: 'să dezactivezi suprascrierea setărilor pe {count} {products}',
      bulkSummaryDelete: 'să ștergi {count} {products}',
      bulkSummaryGeneric: 'să actualizezi {count} {products}',
      confirmBulkAddLocations: 'Ești sigur că vrei să adaugi locații la {count} produse?',
      confirmBulkRemoveLocations: 'Ești sigur că vrei să elimini locații de la {count} produse?',
      confirmBulkSetActive: 'Ești sigur că vrei să setezi {count} produse ca active?',
      confirmBulkSetInactive: 'Ești sigur că vrei să setezi {count} produse ca inactive?',
      confirmBulkIncreasePriceFlat: 'Ești sigur că vrei să crești prețul de bază la {count} produse cu {amount}?',
      confirmBulkIncreasePricePercent: 'Ești sigur că vrei să crești prețul de bază la {count} produse cu {amount}%?',
      confirmBulkDecreasePriceFlat: 'Ești sigur că vrei să scazi prețul de bază la {count} produse cu {amount}?',
      confirmBulkDecreasePricePercent: 'Ești sigur că vrei să scazi prețul de bază la {count} produse cu {amount}%?',
      confirmBulkAddOptionGroups: 'Ești sigur că vrei să adaugi grupuri de opțiuni la {count} produse?',
      confirmBulkReplaceOptionGroups: 'Ești sigur că vrei să înlocuiești grupurile de opțiuni pe {count} produse?',
      confirmBulkSetVat: 'Ești sigur că vrei să setezi TVA pe {count} produse?',
      confirmBulkSetSection: 'Ești sigur că vrei să setezi secția pe {count} produse?',
      confirmBulkDelete: 'Ești sigur că vrei să ștergi {count} produse?',
      confirmBulkGeneric: 'Ești sigur că vrei să actualizezi {count} produse?',
      bulkLocationsUpdated: 'Locațiile au fost actualizate pentru {updated} produse',
      bulkMassUpdated: 'Au fost actualizate {updated} produse',
      couldNotFetchProductOptions: 'Nu am putut prelua opțiunile de produs. Te rugăm să contactezi suportul'
    },
    vat: {
      selectVat: 'Cota Tva',
      generalTaxes: 'Taxe Generale',
      deleteVatSuccess: 'TVA șters cu succes',
      deleteVatError: 'Eroare! TVA-ul nu a fost șters'
    },
    magister: {
      syncLabel: 'Sincronizare meniu Magister',
      syncPrices: 'Sincronizare prețuri',
      syncStocks: 'Sincronizare stocuri',
      magisterStatus: 'Status Magister',
      magisterStatus1: 'In Trimitere',
      magisterStatus2: 'S-a trimis cu succes',
      magisterStatus3: 'Trimiterea a eșuat',
      magisterStatus4: 'Comanda a fost anulată'
    },
    catalogProdRewardsHints: {
      hint1: 'Lasă gol pentru a putea aplica valoarea implicită din setări',
      hint2: 'Pune 0 pentru a nu aplica punctele de loialitate pentru acest produs',
      hint3: 'Adaugă o valoare pozivită pentru a trece peste valoarea implicită din setări'
    },
    catalogCateg: {
      no_discount_allowed: 'Nu accepta discount la aceasta categorie pe pos!',
      disabledOrderSources: 'Dezactivează categoria pentru sursele',
      disabledOrderSourcesHelp: 'Categoria nu va fi disponibilă pe sursele selectate.',
      isAgeRestrict: 'Restricție de vârstă',
      notification_email: 'Notificare E-mail',
      single: 'categorie',
      plural: 'categorii',
      color: 'Culoare',
      name: 'Nume',
      image: 'Imagine',
      displayType: 'Tip afișare',
      shortDescription: 'Scurtă Descriere',
      validFromTo: 'Valabil de la - până la',
      areYouSure: 'Ești sigur că vrei să {label} această categorie?',
      categAdded: 'Categorie adăugată cu succes',
      categUpdated: 'Categorie actualizată cu succes',
      categDeleted: 'Categorie ștearsă cu succes',
      prodDeleted: 'Produse ștearse cu succes',
      couldNotSave: 'Poza de categorie nu a fost salvată, te rugăm să încerci mai târziu.',
      List: 'Listă',
      Grid: 'Grilă',
      assignTopCategory: 'Asignează categorie de top',
      pleaseSelect: 'Va rugam selectati / Nu are categorie părinte',
      categoriesWithoutParent: 'Categorii fara parinte',
      topCategory: 'Categorie de top',
      forceMethod: 'Forteaza metodele de livrare',
      selectMethod: 'Selecteaza metodele',
      enableMethod: '(Pentru activare scoate categoria de top)',
      vat: 'TVA %',
      vatTitle: 'TVA',
      included: 'inclus',
      preparation_time_in_minutes: 'Timp de preparare (minute)',
      areYouSureDeleteProducts: 'Sigur dorești să ștergi toate produsele din această categorie?',
      deleteProducts: 'Șterge toate produsele din această categorie',
      overrideSettingsHelp: 'Când este activat, categoria apare în meniu doar pentru locația, metoda de livrare, ziua și intervalul orar selectate.',
      userLabelings: 'Etichetări utilizator',
      userLabelingsHelp: 'Această categorie va fi vizibilă doar pentru utilizatorii cu una din aceste etichete',
      schedule: 'Orar',
      useSchedule: 'Folosește orar',
      scheduleActive: 'Orar activ',
      scheduleHelp: 'Un singur orar pentru această categorie de top, valabil în toate locațiile. În afara acestor intervale, comanda din această categorie nu este disponibilă în aplicație.',
      secondaryMember: 'secundar'
    },
    catalogProdOpt: {
      addNewOptionValue: 'Adauga Optiune Noua',
      active: 'Status Valoare Optiune',
      image: 'Imagine Optiune',
      generalInformation: 'Informatii Generale',
      settings: 'Setari',
      optionType: 'Tip Optine',
      info: 'Informatii optiune (nutritionale)',
      infoPlaceholder: 'Aceste informatii vor aparea sub optiune pe kiosk/qr',
      single: 'Opțiune',
      plural: 'opțiuni',
      new: 'Opțiune Nouă',
      name: 'Nume',
      option_name: 'Nume Optiune',
      label: 'Etichetă (vizibilă doar in panoul de administrare)',
      type: 'Tip',
      show_type: 'Cum apare în aplicație',
      show_type_kiosk: 'Cum apare pe Kiosk / Comanda la masă',
      vat: 'Cota TVA optiune',
      vatSGR: 'Cota TVA SGR',
      section: 'Sectia Optiunii',
      value: 'Valoare',
      values: 'Valori',
      posid: 'POS ID 1 (integrari)',
      posid2: 'POS ID 2 (integrari)',
      variants_id: 'Pos ID Variants (integrari)',
      optionSaved: 'Opțiune produs salvată cu succes.',
      areyouSure: 'Ești sigur că dorești să ștergi această opțiune?',
      optLocationError: 'Optiunea {opt_name} trebuie sa includa locația {loc_name}',
      menuQr: 'Meniu QR',
      displayInMenu: 'Afișați în meniu QR',
      alsoSaveProduct: 'După modificarea și salvarea opțiunilor este necesar să salvați și produsele pe care sunt aplicate acestea. Vizitați pagina de',
      sgrName: 'Taxa SGR',
      sgrPos: 'POS ID SGR',
      sgrPrice: 'Pret SGR',
      isModifier: 'Plus/No/Side in POS',
      isProduct: 'Opțiune este produs',
      isProductDesc: 'ex: cola, frișcă, bacon, ciuperci, mare, mic, etc...',
      isModifier2: 'Opțiune este modificator',
      isModifierDesc: 'ex: cald, rece, bine făcut, etc... (NU ARE IMPLICAȚII ÎN GESTIUNE)',
      productIdRequired: 'Product ID este obligatoriu pentru toate valorile când opțiunea este setată ca produs!'
    },
    marketingSubscriptions: {
      single: 'abonament',
      refundPayment: 'Returnează suma',
      reason: 'Motiv (obligatoriu)',
      reasonRequired: 'Scrie motivul',
      cancelSubscription: 'Anulează abonamentul',
      cancelHint: 'Abonamentul se oprește acum și nu se mai reînnoiește. Nu se returnează bani (pentru asta folosește butonul de la fiecare plată).',
      cancelAreYouSure: 'Anulezi abonamentul acum?',
      cancelDone: 'Abonamentul a fost anulat',
      downgrade: 'Retrogradează',
      downgradeTo: 'Mută pe nivelul',
      downgradeHint: 'Clientul trece acum pe un nivel mai mic; următoarea reînnoire va fi la prețul acelui nivel. Nu se mișcă bani.',
      downgradeAreYouSure: 'Muți clientul pe {name} acum?',
      downgradeDone: 'Abonamentul a fost mutat pe nivelul mai mic',
      history: 'Istoric acțiuni',
      noHistory: 'Nicio acțiune a operatorului încă.',
      eventCancel: 'Anulat',
      eventDowngrade: 'Retrogradat',
      eventRefund: 'Sumă returnată',
      payRefunded: 'Rambursată',
      refundAndCancel: 'Rambursează și anulează abonamentul',
      refundHint: 'Suma de {amount} a acestei plăți se returnează clientului (reversal dacă tranzacția nu e încă încasată, refund dacă e încasată). Abonamentul NU se modifică: pentru asta folosește Anulează / Retrogradează de sus.',
      refundComment: 'Motiv (obligatoriu)',
      refundCommentRequired: 'Scrie motivul rambursării',
      refundConfirm: 'Confirmă rambursarea',
      refundAreYouSure: 'Returnezi {amount} clientului? Abonamentul nu se modifică.',
      refundDone: 'Plata a fost returnată',
      refundTypeRefund: 'Refund',
      refundTypeReversal: 'Reversal',
      dateFrom: 'De la',
      dateTo: 'Până la',
      renewalCancelledAt: 'A renunțat la reînnoire pe',
      customerActiveSubscriptions: 'Abonamente active',
      customerNoSubscriptions: 'Niciun abonament activ',
      until: 'până la',
      newCoupon: 'Cupon nou',
      newCouponTitle: 'Cupon nou pentru abonament',
      inheritedFromLevel: 'Din nivelul {level} - {name}',
      ownCouponsTitle: '+ Cupoanele acestui nivel',
      inheritedIncluded: 'inclus din nivelul {level} - {name}',
      details: 'Detalii',
      name: 'Nume',
      price: 'Preț',
      description: 'Descriere (cum funcționează)',
      image: 'Poză',
      imageHint: 'jpg / png, max 5MB',
      active: 'Activ',
      status: 'Status',
      coupons: 'Cupoane',
      couponsHint: 'Doar cupoanele bifate "Cupon pentru abonament". Clientul primește și cupoanele nivelurilor de dedesubt.',
      selectedCount: '{count} selectate',
      searchCoupons: 'Caută cupon după nume sau cod',
      noCoupons: 'Nu există încă cupoane de abonament. Creează unul cu butonul "Cupon nou".',
      noCouponsFound: 'Niciun cupon nu corespunde căutării.',
      multipleCodes: 'Coduri multiple',
      freeProduct: 'Produs gratuit',
      inactive: 'inactiv',
      noneAssigned: 'Fără cupoane',
      actions: 'Acțiuni',
      saved: 'Abonamentul a fost salvat',
      deleted: 'Abonamentul a fost șters',
      areYouSureDelete: 'Sigur vrei să ștergi abonamentul',
      deleteLastLevelWarning: 'Este singurul nivel, așa că se șterge și familia.',
      nameRequired: 'Numele este obligatoriu',
      priceRequired: 'Prețul este obligatoriu (0 sau mai mare)',
      noSubscriptions: 'Nu ai încă abonamente. Adaugă primul.',
      levelsCount: '{count} niveluri',
      oneLevel: '1 nivel',
      activeSubscribersCount: '{count} abonați activi',
      paymentAccount: 'Cont de plată',
      editFamily: 'Editează familia',
      allSubscribers: 'Toți abonații',
      subscribers: 'Abonați',
      addLevelOnTop: 'Adaugă nivel peste {name}',
      level: 'Nivel',
      benefits: 'Beneficii',
      inheritedCount: '+{count} din nivelurile de dedesubt',
      inheritedTitle: 'Moștenite din nivelurile de dedesubt',
      lockedDelete: 'Are abonați (activi sau care așteaptă plata), îl poți doar dezactiva.',
      notTopDelete: 'Doar ultimul nivel din familie poate fi șters.',
      inactiveHint: 'Inactiv = nu se mai poate cumpăra. Cei care îl au îl păstrează și se reînnoiesc.',
      family: 'Familie',
      familyName: 'Numele familiei',
      familyNew: 'Familie nouă',
      familyExisting: 'Adaugă într-o familie existentă',
      familyNameHint: 'Implicit, numele abonamentului',
      selectFamily: 'Alege familia',
      familyRequired: 'Alege familia',
      willBeLevel: 'Va fi nivelul {level}, peste {name} ({price})',
      levelOf: 'Nivelul {level} din familia {family}',
      priceHintBelow: 'Nivelul de dedesubt: {name} - {price}. Diferența la upgrade: {diff}',
      priceHintAbove: 'Nivelul de deasupra: {name} - {price}',
      priceTooLow: 'Prețul trebuie să fie mai mare decât al nivelului de dedesubt ({price})',
      priceTooHigh: 'Prețul trebuie să fie mai mic decât al nivelului de deasupra ({price})',
      inheritedCoupons: 'Beneficii moștenite',
      noInherited: 'Fără beneficii moștenite (nivel de bază).',
      paymentProcessor: 'Procesator de plăți',
      paymentRequired: 'Alege procesatorul de plăți',
      noPaymentAccounts: 'Compania nu are niciun procesator de plăți euPlatesc. Adaugă unul din Setări > Plăți.',
      paymentLockedHint: 'Procesatorul de plăți nu se poate schimba cât timp familia are abonați activi.',
      familySaved: 'Familia a fost salvată',
      familyNameRequired: 'Numele familiei este obligatoriu',
      subscribersTitle: 'Abonați',
      stateAll: 'Toți',
      stateActive: 'Activi',
      stateExpiring: 'Expiră în 5 zile',
      stateUnpaid: 'Neplătit',
      stateExpired: 'Expirați',
      stateCancelled: 'Anulați',
      statePending: 'Așteaptă prima plată',
      stateAbandoned: 'Abandonat (neplătit)',
      customer: 'Client',
      activeFrom: 'Activ de la',
      activeUntil: 'Activ până la',
      activeUntilRange: 'Activ până la (interval)',
      autoRenew: 'Reînnoire automată',
      autoRenewAll: 'Reînnoire: toate',
      yes: 'Da',
      no: 'Nu',
      totalPaid: 'Total plătit',
      lastPayment: 'Ultima plată',
      searchSubscribers: 'Caută după nume, email sau telefon',
      allLevels: 'Toate nivelurile',
      noSubscribers: 'Niciun abonat pentru filtrele alese.',
      backToList: 'Înapoi la listă',
      periods: 'Istoric pe luni',
      kindFirst: 'Prima plată',
      kindRenewal: 'Reînnoire',
      kindUpgrade: 'Upgrade',
      periodPaid: 'Plătit',
      periodUnpaid: 'Neplătit',
      periodCancelled: 'Anulat',
      paymentAttempts: 'Încercări de plată',
      methodLink: 'Link de plată',
      methodSavedCard: 'Card salvat',
      payCreated: 'Creată',
      payPending: 'În așteptare',
      paySuccess: 'Reușită',
      payFailed: 'Eșuată',
      payExpired: 'Expirată',
      payCancelled: 'Anulată',
      showLogs: 'Loguri procesator',
      request: 'Request',
      response: 'Răspuns',
      noPeriods: 'Nu există încă perioade.',
      noPayments: 'Nicio încercare de plată.',
      card: 'Card',
      currentLevel: 'Nivel curent',
      renewalPrice: 'Preț reînnoire',
      subscriberSince: 'Abonat din',
      autoChargeAttempts: 'Încercări de debitare automată',
      notifiedAt: 'Notificare de expirare trimisă'
    },
    marketingAutomation: {
      single: 'campanie automată',
      details: 'Detalii campanie automată',
      name: 'Nume',
      type: 'Tip campanie',
      period: 'Perioada de funcționare',
      active: 'Activă',
      status: 'Status',
      notifications: 'Notificări',
      coupons: 'Cupoane',
      state_running: 'În desfășurare',
      state_scheduled: 'Programată',
      state_ended: 'Încheiată',
      typeBirthday: 'Zi de naștere',
      typeGeofencing: 'Geofencing (în rază)',
      typeAbandonedCart: 'Produse uitate în coș',
      typeProductViews: 'Produs văzut de mai multe ori',
      comingSoon: 'în curând',
      typeLocked: 'Tipul nu se mai poate schimba după crearea campaniei.',
      birthdayRule: 'Cupoanele se aplică automat doar în ziua de naștere a clientului, o singură dată pe an. Un client care a beneficiat deja anul acesta nu mai este notificat.',
      announceTitleBox: 'Anunț înainte de ziua de naștere',
      announceDaysBefore: 'Trimite-l cu',
      daysBeforeBirthday: 'zile înainte de ziua de naștere',
      announceOffHint: 'Fără anunț: clientul primește doar notificarea din ziua respectivă.',
      announceDaysBeforeShort: 'Anunț cu {days} zile înainte',
      announceDaysInvalid: 'Între 1 și {max} zile.',
      dayTitleBox: 'Notificare în ziua de naștere',
      onTheDayShort: 'În ziua de naștere',
      sentAt: 'trimise la {time}',
      endsIn: 'se încheie în {days} zile',
      endsToday: 'se încheie azi',
      startsIn: 'începe în {days} zile',
      pushTitle: 'Titlu notificare',
      pushMessage: 'Text notificare',
      sendTime: 'Ora de trimitere',
      sendTimeHint: 'Notificările se trimit la această oră (fusul orar al companiei).',
      preview: 'Previzualizare',
      placeholdersHint: 'Poți folosi în text (click pentru a adăuga):',
      clickToInsert: 'Click pentru a-l adăuga în text',
      placeholderName: 'prenumele clientului',
      placeholderDays: 'câte zile mai sunt până la ziua de naștere',
      placeholderCode: 'codul cuponului (informativ)',
      codeNeedsCoupon: 'disponibil după ce selectezi un cupon (mai jos)',
      codeNotInNoCoupon: 'nu se folosește în notificarea fără cupon',
      codeWithoutCoupon: 'Campania nu are cupon: {cod} se trimite gol (textul pleacă fără cod).',
      exampleAnnounceNoCouponTitle: 'Ziua ta se apropie! Mai sunt {zile} zile 🎉',
      exampleAnnounceNoCouponMessage: 'Bună, {nume}! Ne bucurăm să fim alături de tine la acest moment frumos. Vino cu prietenii la noi sau comandă din aplicație și hai să sărbătorim împreună!',
      exampleDayNoCouponTitle: 'La mulți ani, {nume}! 🎂',
      exampleDayNoCouponMessage: 'Îți dorim o zi minunată, plină de bucurii și oameni dragi alături. Te așteptăm cu drag să sărbătorim împreună!',
      optional: 'opțional',
      cartRule: 'Doar coșurile din aplicație ale clienților logați, create după pornirea campaniei, mai noi de 5 zile și cu produse. Notificarea 1 pleacă la X minute după ultima modificare a coșului (cu cuponul, valabil 24h, o singură dată, pe orice comandă). Notificarea 2 doar dacă prima a fost trimisă și coșul nu s-a mai modificat. Maxim 2 notificări pe coș; un coș nou = notificări noi.',
      cartFirstBox: 'Notificarea 1',
      variantWithCoupon: 'cu cupon',
      variantNoCampaignCoupon: 'reminder (campania nu are cupon)',
      variantNoCoupon: 'fără cupon',
      noCouponNeedsCoupon: 'disponibilă după ce selectezi un cupon (mai jos); fără cupoane, toți primesc notificarea de mai sus',
      cartFirstDelay: 'Trimite-o la',
      minutesAfterChange: 'minute după ultima modificare a coșului',
      cartNoCouponBox: 'Notificarea 1 fără cupon',
      cartNoCouponHint: 'Pleacă în locul celei de mai sus clienților care nu primesc cupon de data asta (au primit deja unul în ultimele X zile – vezi „Recurența cuponului” – sau cuponul nu mai e valabil). Nu promite reducere aici.',
      cartSecondBox: 'Notificarea 2',
      cartSecondDelay: 'Trimite-o la',
      minutesAfterFirst: 'minute după notificarea 1',
      cartSecondHint: 'Doar dacă notificarea 1 a fost trimisă și clientul nu a mai modificat coșul. Pleacă și la clienții fără cupon, așa că scrie-o general (sau folosește {cod}, gol pentru ei).',
      cartSecondOffHint: 'Se trimite doar notificarea 1.',
      quietBox: 'Ore de liniște (fără notificări noaptea)',
      quietFrom: 'de la',
      quietTo: 'până la',
      quietHint: 'O notificare care ar cădea în acest interval pleacă imediat după ce se termină (fusul orar al companiei). Notificarea 2 se calculează de la ora la care a plecat efectiv prima.',
      quietOffHint: 'Notificările pleacă la orice oră.',
      cooldownBox: 'Recurența cuponului',
      cooldownLabel: 'Cuponul din nou abia după',
      cooldownNeedsCoupon: 'disponibil după ce selectezi un cupon (mai sus)',
      cooldownDays: 'zile (0 = la fiecare coș uitat)',
      cooldownHint: 'După ce un client a primit un cupon de coș, coșurile uitate din acest interval primesc doar reminder-ul (textul fără cupon).',
      cartFirstWhen: 'la {time} după ultima modificare',
      cartSecondWhen: 'la {time} după notificarea 1',
      unitDay: 'z',
      delayInvalid: 'Între {min} și {max} minute.',
      cooldownInvalid: 'Între 0 și {max} zile.',
      quietInvalid: 'Începutul și sfârșitul orelor de liniște trebuie să fie diferite.',
      exampleCartFirstTitle: '{nume}, ai uitat ceva în coș 🛒',
      exampleCartFirstMessage: 'Produsele tale te așteaptă! Finalizează comanda în următoarele 24 de ore și ai 10% reducere cu codul {cod} – se aplică automat.',
      exampleCartNoCouponTitle: '{nume}, coșul tău te așteaptă 🛒',
      exampleCartNoCouponMessage: 'Produsele alese sunt încă în coș. Finalizează comanda în câteva secunde, din aplicație.',
      exampleCartSecondTitle: 'Ultima șansă, {nume}!',
      exampleCartSecondMessage: 'Coșul tău e încă aici. Nu rata ce ți-ai ales – comandă acum din aplicație.',
      statusAllSent: 'Notificați',
      status_notified: 'Doar reminder',
      status_converted: 'Coș comandat',
      cartStatusGranted: 'Cupon activ',
      cartStatusUsed: 'A folosit cuponul',
      validUntil: 'până la {time}',
      cart: 'Coș',
      cartPush1Short: 'Notif. 1',
      cartPush2Short: 'Notif. 2',
      cartPlaced: 'comandat',
      beneficiaries: 'Beneficiari',
      beneficiariesTitle: 'Beneficiari',
      viewBeneficiaries: 'Vezi lista',
      statusAll: 'Toți',
      status_granted: 'Acordat',
      status_used: 'A beneficiat',
      status_expired: 'Expirat (nefolosit)',
      customer: 'Client',
      birthday: 'Ziua de naștere',
      yearLabel: 'anul {year}',
      order: 'Comandă',
      searchCustomer: 'Caută nume, telefon, email...',
      allYears: 'Toți anii',
      noBeneficiaries: 'Nimeni deocamdată.',
      announcePushShort: 'Anunț',
      dayPushShort: 'În zi',
      pushNotSent: 'netrimis',
      push_sent: 'trimis',
      push_nodevice: 'fără notificări',
      push_failed: 'eșuat',
      useExample: 'Folosește exemplul',
      useExampleConfirm: 'Înlocuiești titlul și textul actual cu exemplul?',
      previewExampleNote: 'Câmpuri goale: previzualizarea arată textul exemplu.',
      codeMissing: 'Textul folosește {cod}, dar niciun cupon selectat nu are cod.',
      exampleAnnounceTitle: 'Ziua ta se apropie! Mai sunt {zile} zile 🎉',
      exampleAnnounceMessage: 'Bună, {nume}! Ne bucurăm să fim alături de tine la acest moment frumos, așa că de ziua ta îți oferim 20% reducere la o comandă de minimum 100 lei, cu codul {cod}. Vino cu prietenii la noi sau comandă din aplicație și hai să sărbătorim împreună!',
      exampleDayTitle: 'La mulți ani, {nume}! 🎂',
      exampleDayMessage: 'Azi e ziua ta, iar cadoul nostru te așteaptă: 20% reducere la toate preparatele, la o comandă de minimum 100 lei. Codul tău {cod} se aplică automat. Bucură-te de el chiar acum!',
      couponsHint: 'Opțional: fără cupon, campania trimite doar notificările. Apar doar cupoanele bifate „Se folosește în marketing automat”; clientul primește toate cupoanele selectate.',
      selectedCount: '{count} selectate',
      newCoupon: 'Cupon nou',
      newCouponTitle: 'Cupon nou de marketing automat',
      noCoupons: 'Nu există încă niciun cupon de marketing automat. Creează unul cu „Cupon nou”.',
      searchCoupons: 'Caută cupon...',
      noCouponsFound: 'Niciun cupon găsit.',
      couponsRequired: 'Selectează cel puțin un cupon.',
      couponInactive: 'Cupon inactiv',
      inactive: 'inactiv',
      expired: 'expirat',
      saved: 'Campania a fost salvată.',
      deleted: 'Campania a fost ștearsă.',
      areYouSureDelete: 'Sigur vrei să ștergi campania {name}?'
    },
    marketingCoupons: {
      single: 'cupon',
      isAutomation: 'Se folosește în marketing automat',
      isAutomationHint: 'Cuponul nu se aplică tuturor și codul lui nu poate fi introdus: se aplică automat doar clienților cărora li-l acordă o campanie automată (ex. de ziua lor).',
      automationCampaigns: 'Campanii automate',
      automationLockedUsed: 'Acordat de campanii automate: scoate-l întâi din ele.',
      automationLockedCampaign: 'Anunțat de campanii push: nu poate fi folosit în marketing automat.',
      automationInfoCode: 'Cupon de marketing automat: codul este doar informativ (poate apărea în notificări cu {cod}). Nu poate fi introdus nicăieri: reducerea se aplică automat clienților care îndeplinesc condițiile campaniei.',
      automationCodeLabel: 'Cod informativ (opțional)',
      automationCodePlaceholder: 'ex. ZINASTERE20',
      automationBadge: 'Automat',
      subscriptionAutomationExclusive: 'Un cupon nu poate fi și de abonament, și de marketing automat.',
      isSubscription: 'Cupon pentru abonament',
      isSubscriptionHint: 'Se aplică doar clienților cu un abonament activ care îl include: fără cod, niciodată aplicat automat, fără limite de utilizare.',
      subscriptionBadge: 'Abonament',
      subscriptionLevels: 'Inclus în abonamentele',
      subscriptionLockedUsed: 'Cuponul e inclus în abonamente: scoate-l din ele ca să-l poți debifa.',
      subscriptionLockedCampaign: 'Cuponul e anunțat în campanii push, deci nu poate deveni cupon de abonament.',
      subscriptionNoCode: 'Cuponul de abonament nu are cod: se aplică doar clienților cu abonament activ.',
      name: 'Nume',
      code: 'Cod',
      multipleCodes: 'Coduri multiple',
      discount: 'Reducere',
      freeProduct: 'Produs gratuit',
      validFromTo: 'Valabil de la - până la',
      daysLeft: 'Zile rămase',
      status: 'Status',
      active: 'Activ',
      pushCampaigns: 'Campanii push',
      notAssigned: 'Neasignat',
      couponDetails: 'Detalii cupon',
      couponSaved: 'Cuponul a fost salvat.',
      couponDeleted: 'Cuponul a fost șters.',
      areYouSureDelete: 'Ești sigur că vrei să ștergi cuponul',
      deleteAssignedWarning: 'Cuponul este anunțat de campaniile push: {campaigns}. Acestea vor rămâne fără cupon.',
      selectCoupon: 'Cuponul anunțat de campanie',
      selectCouponHelp: 'Reducerea este aplicată de cupon (cu valabilitatea și condițiile lui). Campania doar îl anunță. Cupoanele se gestionează din tab-ul Cupoane.',
      noCoupon: 'Fără cupon',
      couponInactive: 'Cuponul selectat este inactiv.',
      couponOutsideCampaign: 'Perioada campaniei iese din valabilitatea cuponului.',
      deleteCampaignCouponQuestion: 'Campania anunță cuponul {coupon}. Cuponul nu se șterge odată cu campania. Ce faci cu el?',
      keepCouponActive: 'Păstrează cuponul neschimbat',
      deactivateCoupon: 'Dezactivează cuponul',
      export: 'Export',
      openQr: 'Deschide imaginea QR',
      qrLink: 'Link imagine QR',
      used: 'Folosit',
      sources: 'Surse comenzi',
      allSources: 'Toate',
      noCategories: 'Nu există categorii / produse',
      generatorTitle: 'Generare coduri',
      generatorCount: 'Număr de coduri (max 1000)',
      generatorLength: 'Lungimea părții aleatorii',
      generatorCharset: 'Caractere',
      generatorCharsetAlnum: 'Litere + cifre (fără 0/O, 1/I/L)',
      generatorCharsetLetters: 'Doar litere',
      generatorCharsetDigits: 'Doar cifre',
      generatorPrefix: 'Prefix (în față)',
      generatorSuffix: 'Sufix (în spate)',
      generatorGroup: 'Grupare cu "-"',
      generatorGroupNone: 'Fără grupare',
      generatorExample: 'Exemplu',
      generate: 'Generează',
      generatedCodes: 'Au fost generate {count} coduri. Salvează cuponul ca să le păstrezi.',
      deleteAllCodes: 'Șterge toate',
      deleteAllCodesConfirm: 'Ștergi toate cele {count} coduri? Codurile deja salvate se șterg la salvarea cuponului.',
      codeStatus_available: 'Disponibil',
      codeStatus_used: 'Folosit',
      codeStatus_new: 'Nou (nesalvat)'
    },
    marketingCampaigns: {
      intern: 'Intern',
      extern: 'Extern',
      url: 'URL',
      category: 'Categorie',
      product: 'Produs',
      single: 'campanie',
      plural: 'campanii',
      name: 'Nume',
      nameHelper: 'Acest nume va fi folosit ca subiect in notificarile trimise pe e-mail.',
      image: 'Imagine',
      startEnd: 'Start - Sfârșit Perioadă',
      daysLeft: 'Zile rămase',
      timesUsed: 'Nr. folosiri',
      status: 'Status',
      actions: 'Acțiuni',
      send: 'Trimite',
      stopSending: 'Oprește trimiterea',
      campaignStoppedSuccessfuly: 'Trimiterea campaniei a fost oprită',
      areYouSureCancelSending: 'Sigur vrei să oprești trimiterea',
      notBeingSending: 'nu se trimite',
      cannotDelete: 'Campania nu poate fi ștearsă in timp ce este trimisă',
      cannotModify: 'Campania nu poate fi modificată in timpul trimiterii',
      off: 'din',
      sentData: 'Date despre trimitere',
      sent: 'Total trimise',
      notif_sent: 'Notificări',
      email_sent: 'E-mailuri',
      areYouSureNotif: 'Ești sigur că dorești să trimiți aceste notificări?',
      notifSent: 'Notificările au fost puse în listă și urmează a fi trimise!',
      campaignDeleted: 'Campanie ștearsă cu succes.',
      areYouSureDelete: 'Ești sigur că vrei să ștergi ',
      campaignAdded: 'Campanie adăugată cu succes',
      campaignUpdated: 'Campanie actualizată cu succes',
      campaignPhotoError: 'Poza de campanie nu a fost salvată, te rugăm să încerci mai târziu.',
      campaignDetails: 'Detalii Campanie',
      description: 'Text notificari',
      maxDescription: '(max. 400 caractere)',
      characters: 'caractere',
      validFromTo: 'Valabil de la - până la',
      notif: 'Notificări',
      mode: 'Mod',
      setHours: 'Setează Orele',
      selectTime: 'Alege Ora',
      chooseTarget: 'Alege publicul țintă',
      gender: 'Gen',
      age: 'Vârstă',
      city: 'Oraș',
      locations: 'Locații',
      visibleInLocations: 'Categorie vizibilă în următoarele locații',
      visibleInLocationsInfo: 'Această funcționalitate este disponibilă doar în Aplicație',
      ordersAbove: 'Comenzi mai sus',
      ordersBelow: 'Comenzi mai jos',
      ordersAboveNr: 'Nr comenzi mai sus',
      ordersBelowNr: 'Nr comenzi mai jos',
      addCoupon: 'Adaugă cupon',
      applyTo: 'Aplică la',
      value: 'Valoare',
      code: 'Cod',
      addValue: 'Adauga Valoare',
      minValue: 'Suma Minima',
      counter_max_usage: 'De cate ori poate folosi o persoana acest cupon?',
      counter_max_usage_example: 'Tastați numarul maxim de utilizari/persoana. Tastati 0 pentru nelimitat.',
      counter_max_usage_total: 'De cate ori poate folosi acest cupon in total?',
      counter_max_usage_total_example: 'Tastați numarul maxim de utilizari. Tastati 0 pentru nelimitat.',
      generateCode: 'Generează Cod',
      Products: 'Produse',
      Shipping: 'Livrare',
      Tax: 'Taxe',
      chooseCategProduct: 'Alege categoriile sau produsele pe care se va aplica cuponul:',
      delivery_methods: 'Pe care metode de livrare sa se aplice cuponul?',
      order_source_ids: 'Surse comenzi',
      order_source_ids_all: 'Toate sursele',
      order_source_ids_help: 'Lasă gol pentru a aplica cuponul pe toate sursele de comenzi.',
      location_ids: 'Pe care locatii sa se aplice cuponul?',
      sendNotificationTo: 'Trimite notificare la',
      chooseDayForInterval: 'Alegeți ziua pentru interval',
      chooseHoursForInterval: 'Alegeți orele pentru interval',
      useInterval: 'Folosește interval',
      isCumulativeCheck: 'Acest cupon se aplica cumulat',
      isAutoApplyCheck: 'Acest cupon se aplica direct',
      doesApplyOnPromotionalItems: 'Acest cupon se aplica doar pe produsele din promoție',
      intervalMustBeSet: 'Intervalul trebuie setat',
      campaignWasSent: 'Campania a fost trimisă în ultimele 30 de min',
      isSecondUseCheck: 'Acest cupon se aplica direct dupa prima utilizare',
      couponHasMultipleCodes: 'Foloseste mai multe coduri de coupon',
      withOrdersLabel: 'Cu/fără comenzi',
      withOrders: 'cu comenzi',
      withoutOrders: 'fără comenzi',
      withLoyaltyPointsLabel: 'Puncte de loialitate',
      withLoyaltyPointsAll: 'Toți',
      withLoyaltyPoints: 'cu puncte',
      withoutLoyaltyPoints: 'fără puncte',
      loyaltyPointsColumn: 'Puncte de loialitate',
      groups: 'Grupuri clienți',
      exclude_groups: 'Exclude Grupuri clienți',
      chooseImage: 'Alege o imagine',
      template: 'Model',
      useEmailTemplate: 'Folosește textul atât pentru notificări cât și pentru email',
      productTreeError: 'Bifați cel puțin un produs',
      checkAll: 'Bifează tot',
      freeProduct: 'Produs gratuit de adăugat în coș',
      freeProductPlaceholder: 'Tastează numele produsului pentru a căuta...',
      freeProductRequired: 'Selectează un produs gratuit',
      freeProductSelectTypeHint: 'Selectează tipul «Produs gratuit» de mai sus pentru a alege produsul care se adaugă în coș.',
      freeProductHelp: 'Acesta este produsul adăugat automat în coșul clientului. Lista din dreapta definește produsele/categoriile pentru care se aplică cuponul.',
      freeProductSearchHint: 'Începe să tastezi numele produsului pentru a-l găsi și selecta.',
      minOrderValue: 'Subtotal minim comandă',
      minOrderValuePlaceholder: '0 = fără minim',
      minOrderValueHelp: 'Produsul gratuit se aplică doar când subtotalul comenzii (produse + extra) este cel puțin această valoare. Lasă gol sau 0 pentru fără minim.',
      registeredAfter: 'Înregistrat după',
      period: 'De la - până la',
      location: 'Locația',
      open: 'Deschide'
    },
    loyaltyStore: {
      campaignName: 'Nume campanie',
      description: 'Descriere',
      generalSettings: 'Setări generale',
      active: 'Activ',
      availability: 'Disponibilitate',
      locations: 'Locații',
      locationsInfo: 'Lasă gol pentru toate locațiile',
      rewards: 'Recompense',
      rewardsCount: 'Recompense',
      addReward: 'Adaugă recompensă',
      editReward: 'Editează recompensa',
      reward: 'Recompensă',
      rewardType: 'Tip',
      typeProduct: 'Produs',
      typeGiftCard: 'Gift card',
      product: 'Produs',
      category: 'Categorie',
      searchCategory: 'Caută categorie',
      searchProduct: 'Caută produs',
      giftCardValue: 'Valoare gift card',
      pointsCost: 'Cost puncte fidelitate',
      deleteConfirmation: 'Ești sigur că vrei să ștergi?',
      rewardsSaveFailed: 'Campania a fost salvată, dar unele recompense nu au putut fi salvate. Recompensele rămase sunt păstrate aici. Apasă Salvează pentru a reîncerca.',
      nameRequired: 'Numele campaniei este obligatoriu',
      pointsCostRequired: 'Costul în puncte este obligatoriu',
      productRequired: 'Produsul este obligatoriu',
      giftValueRequired: 'Valoarea gift card este obligatorie',
      giftCardsModuleRequired: 'Activează gift card-urile de marketing pe companie pentru recompense tip gift card.',
      timesSold: 'Vânzări',
      totalPointsSpent: 'Total puncte cheltuite',
      totalGiftValue: 'Valoare gift cards emise',
      purchases: 'Achiziții',
      user: 'Utilizator',
      orderId: 'ID comandă',
      giftCardId: 'ID gift card',
      datetime: 'Dată și oră',
      campaign: 'Campanie'
    },
    donationCampaigns: {
      single: 'campanie donație',
      plural: 'campanii donații',
      id: 'ID',
      search: 'Caută',
      name: 'Nume',
      beneficiary: 'Beneficiar',
      description: 'Descriere',
      image: 'Imagine',
      startEnd: 'Data început - sfârșit',
      daysLeft: 'Zile rămase',
      targetAmount: 'Sumă țintă',
      suggestedAmount: 'Sumă sugerată',
      collectedAmount: 'Sumă colectată',
      progress: 'Progres',
      donorsCount: 'Donatori',
      donationsCount: 'Donații',
      details: 'Detalii Campanie Donație',
      stats: 'Statistici',
      active: 'Activ',
      location: 'Locații',
      locationInfo: 'Lasă gol pentru a fi disponibilă în toate locațiile',
      allCampaigns: 'Toate campaniile',
      areYouSureDelete: 'Ești sigur că vrei să ștergi',
      campaignDeleted: 'Campania de donație a fost ștearsă cu succes.',
      campaignAdded: 'Campania de donație a fost adăugată cu succes.',
      campaignUpdated: 'Campania de donație a fost actualizată cu succes.',
      removeCurrentImage: 'Te rugăm să ștergi imaginea curentă înainte de a adăuga una nouă',
      fundingMode: 'Mod finanțare',
      fundingModeClientOptional: 'Clientul alege donația la checkout',
      fundingModeRestaurantFlat: 'Restaurantul plătește o sumă fixă per comandă',
      fundingModeRestaurantPercent: 'Restaurantul plătește un procent din subtotalul comenzii',
      restaurantFlatAmount: 'Sumă per comandă',
      restaurantPercent: 'Procent din subtotalul comenzii (0–100)',
      allLocations: 'Toate locațiile',
      onlyOneActivePerLocation: 'Poate exista o singură campanie de donație activă per locație.',
      fiscalizationInfoPrefix: 'Pentru a configura cum sunt fiscalizate donațiile, deschide ',
      fiscalizationInfoLink: 'Locații,',
      fiscalizationInfoSuffix: ' editează locația, mergi la Alte setări → Setări Pos și setează "{field}".',
      activeCampaignExistsTitle: 'Campanie salvată',
      activeCampaignExistsMessage: 'Campania a fost salvată cu succes, dar există o altă campanie activă ({name}). Dorești să activezi această campanie în loc?',
      activeCampaignExistsActivateMessage: 'Există o altă campanie activă ({name}). Dorești să activezi această campanie în loc?',
      activeCampaignExistsWarning: 'Atenție: aceasta înseamnă că cealaltă campanie nu va mai fi vizibilă pentru utilizatori!'
    },
    raffleCampaigns: {
      single: 'campanie tombolă',
      plural: 'campanii tombolă',
      id: 'ID',
      name: 'Nume',
      search: 'Caută',
      searchParticipants: 'Caută email sau nume',
      userId: 'ID utilizator',
      description: 'Descriere',
      winnersDescription: 'Lista câștigătorilor',
      winnersPlaceholder: 'Utilizează acest câmp pentru a informa utilizatorii despre cine a câștigat tombola',
      image: 'Imagine',
      startEnd: 'Început - Sfârșit',
      details: 'Detalii campanie tombolă',
      active: 'Activ',
      type: 'Tip',
      typeOrderCount: 'Tombolă',
      typeOrderTotal: 'Erou',
      typeOrderCountHint: 'Pe baza numărului de comenzi. Câștigătorul aleatoriu este ales cu un instrument terț.',
      typeOrderTotalHint: 'Câștigătorul este determinat pe baza sumei cheltuite în aplicație.',
      typeLocked: 'Tipul nu poate fi schimbat după creare.',
      typeRequired: 'Tipul este obligatoriu.',
      minOrderValue: 'Valoare minimă comandă',
      pdf: 'PDF',
      periodRequired: 'Datele de început și sfârșit sunt obligatorii.',
      areYouSureDelete: 'Ești sigur că vrei să ștergi',
      campaignDeleted: 'Campania tombolă a fost ștearsă cu succes.',
      campaignAdded: 'Campania tombolă a fost adăugată cu succes.',
      campaignUpdated: 'Campania tombolă a fost actualizată cu succes.',
      removeCurrentImage: 'Te rugăm să ștergi imaginea curentă înainte de a adăuga una nouă',
      removeCurrentPdf: 'Te rugăm să ștergi PDF-ul curent înainte de a adăuga unul nou',
      usersJoined: 'Utilizatori înscriși',
      ordersCount: 'Număr comenzi',
      ordersTotal: 'Total comenzi',
      participants: 'Participanți',
      exportEntries: 'Export înscrieri',
      joinedAt: 'Data înscrierii',
      score: 'Scor',
      orderNumber: 'Număr comandă',
      orderCreatedAt: 'Data comenzii',
      registeredAt: 'Data înregistrării'
    },
    challengeCampaigns: {
      single: 'provocare',
      plural: 'provocări',
      id: 'ID',
      search: 'Caută',
      searchByTitle: 'Caută după titlu',
      title: 'Titlu',
      titlePlaceholder: 'ex. Early Bird',
      description: 'Descriere',
      descriptionPlaceholder: 'ex. Comandă 5 cafele înainte de ora 9',
      image: 'Imagine',
      details: 'Detalii provocare',
      target: 'Țintă',
      minOrderValue: 'Valoare minimă comandă',
      periodOfTimeDays: 'Perioadă membru (zile)',
      periodOfTimeDaysHint: 'ex. 365 = client de 1 an de la prima comandă',
      distinctOrder: 'Comandă distinctă',
      distinctOrderHint: 'Când este activ, fiecare comandă eligibilă contează ca 1 pas, indiferent de cantitate.',
      timePeriod: 'Perioada provocării',
      orderTimeFrom: 'Ora comenzii de la',
      orderTimeTo: 'Ora comenzii până la',
      conditions: 'Condiții (ȘI)',
      conditionsAndInfo: 'Condițiile configurate se combină cu ȘI. Lasă o condiție goală pentru a o ignora.',
      deliveredOnlyInfo: 'Doar comenzile în status Livrat contează pentru progres.',
      goalGroup: 'Obiectiv',
      orderFiltersGroup: 'Filtre comandă',
      scheduleGroup: 'Program',
      catalogGroup: 'Produse & categorii',
      locations: 'Locații',
      deliveryMethods: 'Metode livrare',
      sources: 'Surse comandă',
      days: 'Zilele săptămânii',
      products: 'Produse',
      categories: 'Categorii',
      leaveEmptyAll: 'Lasă gol pentru toate',
      daySun: 'Duminică',
      dayMon: 'Luni',
      dayTue: 'Marți',
      dayWed: 'Miercuri',
      dayThu: 'Joi',
      dayFri: 'Vineri',
      daySat: 'Sâmbătă',
      summaryMembership: 'Utilizatorul trebuie să fie client de cel puțin {days} zile (țintă {target}).',
      summaryOrders: 'Finalizează {target} comenzi.',
      summaryProductQty: 'Ajunge la o cantitate totală de {target} din produsele/categoriile selectate.',
      summaryMinOrder: 'Doar comenzi cu valoare minimă de {amount} {currency}.',
      summaryLocations: 'Doar la: {list}.',
      summaryDelivery: 'Doar metode: {list}.',
      summarySources: 'Doar surse: {list}.',
      summaryDays: 'Doar în: {list}.',
      summaryOrderTime: 'Doar între {from} și {to}.',
      summaryPeriod: 'Provocarea este disponibilă de la {from} până la {to}.',
      summaryProducts: 'Produse: {list}.',
      summaryCategories: 'Categorii: {list}.',
      summaryWithinDays: 'Progresul trebuie finalizat în {days} zile.',
      areYouSureDelete: 'Ești sigur că vrei să ștergi',
      campaignDeleted: 'Provocarea a fost ștearsă.',
      campaignAdded: 'Provocarea a fost adăugată.',
      campaignUpdated: 'Provocarea a fost actualizată.',
      removeCurrentImage: 'Șterge imaginea curentă înainte de a adăuga una nouă',
      dateFrom: 'Data de la',
      dateTo: 'Data până la',
      reportDateHint: 'Statisticile de finalizare folosesc data completării. Progresul folosește data ultimului progres.',
      completedUsers: 'Finalizate',
      inProgressUsers: 'În progres',
      startedUsers: 'Începute',
      completionRate: 'Rată finalizare',
      allUsers: 'Toți',
      status_COMPLETED: 'Finalizat',
      status_IN_PROGRESS: 'În progres',
      status_NOT_STARTED: 'Neînceput',
      user: 'Utilizator',
      progress: 'Progres',
      startedAt: 'Primul progres',
      lastProgressAt: 'Ultimul progres',
      completedAt: 'Finalizat la',
      userProgress: 'Progres utilizator',
      dateTime: 'Data / ora',
      orderId: 'ID comandă',
      progressGenerated: 'Progres'
    },
    spinningWheel: {
      confirmDelete: 'Sigur dorești să ștergi această înregistrare?',
      percentageOverflow: 'Probabilitățile premiilor active nu pot depăși 100%. Modificarea nu a fost salvată.',
      campaignTitle: 'Titlu campanie',
      description: 'Descriere',
      availability: 'Disponibilitate',
      minOrderValue: 'Valoare minimă comandă',
      locations: 'Locații',
      locationsInfo: 'Lasă gol pentru a aplica la toate locațiile.',
      rewardsCount: 'Premii',
      percentages: 'Total % câștig',
      active: 'Activ',
      generalSettings: 'Setări generale',
      activeRequires100: 'Campania poate fi activată doar când premiile active însumează exact 100%.',
      mustTotal100: 'trebuie să însumeze 100%',
      rewards: 'Premii',
      addReward: 'Adaugă premiu',
      editReward: 'Editează premiu',
      reward: 'Premiu',
      rewardType: 'Tip premiu',
      winningPercentage: 'Probabilitatea în % de câștig',
      displayTitle: 'Titlu afișat',
      displayDescription: 'Descriere afișată',
      loyaltyPoints: 'Puncte de loialitate',
      couponType: 'Tip discount',
      couponAppliesTo: 'Cuponul se aplică la',
      couponProducts: 'Produse',
      couponDelivery: 'Livrare',
      couponTaxes: 'Taxe',
      couponPercentage: 'Procent',
      couponFixed: 'Sumă fixă',
      discount: 'Discount',
      product: 'Produs',
      searchProduct: 'Caută produs',
      sortOrder: 'Ordine de afișare',
      sortOrderHelp: 'Ordinea stabilește afișarea premiilor pe roată, nu ordinea câștigării. Premiul se alege aleatoriu, conform probabilității de câștig.',
      freeProductCouponHelp: 'Produsul gratuit este premiul câștigat la Roata norocului. Nu este necesară selectarea unor categorii sau produse suplimentare.',
      actions: 'Acțiuni',
      openCampaign: 'Deschide campania',
      duplicate: 'Duplică',
      datesRequired: 'Datele de disponibilitate (de la / până la) sunt obligatorii.',
      autoGenerateNotice: 'O campanie și un cupon vor fi create automat pentru acest premiu. Poți modifica campania generată și configura notificările ulterior.',
      typeNothing: 'Nimic',
      typeLoyaltyPoints: 'Puncte de loialitate',
      typeDiscountCoupon: 'Cupon discount',
      typeFreeProduct: 'Cupon produs gratuit',
      titleRequired: 'Titlul campaniei este obligatoriu.',
      percentageRequired: 'Procentul de câștig trebuie să fie mai mare decât 0.',
      loyaltyPointsRequired: 'Punctele de loialitate sunt obligatorii.',
      discountRequired: 'Discountul este obligatoriu.',
      productRequired: 'Produsul este obligatoriu.',
      spins: 'Învârtiri',
      usersWhoSpun: 'Utilizatori care au învârtit',
      rewardsWon: 'Premii câștigate',
      rewardsRedeemed: 'Premii valorificate',
      redemptionRate: 'Rată valorificare',
      wins: 'Câștiguri',
      usersWhoWon: 'Utilizatori care au câștigat',
      redeemed: 'Valorificat',
      remaining: 'Rămas',
      users: 'Utilizatori',
      user: 'Utilizator',
      used: 'Folosit',
      available: 'Disponibil',
      spinId: 'ID învârtire',
      dateWon: 'Data câștigului',
      status: 'Status',
      dateRedeemed: 'Data valorificării',
      qualifyingOrder: 'Comandă eligibilă'
    },

    discountCampaigns: {
      single: 'campanie reducere',
      plural: 'campanii reduceri',
      id: 'ID',
      search: 'Caută',
      name: 'Nume',
      description: 'Descriere',
      image: 'Imagine',
      details: 'Detalii campanie reducere',
      startEnd: 'Start - Sfârșit',
      active: 'Activ',
      discount: 'Reducere',
      discountType: 'Tip reducere',
      discountType_flat: 'Sumă fixă',
      discountType_percent: 'Procent',
      priceProfile: 'Profil de preț',
      source: 'Canal',
      sourceMethodCombos: 'Canale / metode',
      productStandardPrice: 'Produs (preț standard)',
      pageInfo: 'Pagina {page} din {total} ({count} produse)',
      topCategory: 'Categorie top',
      topCategories: 'Categorii top',
      categories: 'Categorii',
      numberOfUnits: 'Limită unități',
      numberOfUnitsPlaceholder: 'Lăsați gol pentru nelimitat',
      numberOfUnitsHint: 'Număr maxim de unități cu reducere. Cum se împarte limita este controlat de setările de mai jos.',
      unitsSoldScope: 'Limită unități pe canal',
      unitsSoldScope_perLine: 'Per linie (sursă + metodă)',
      unitsSoldScope_perSource: 'Per sursă (metodele partajează)',
      unitsSoldScopeHint: 'Per linie: Eat-in și Takeout au fiecare limita lor. Per sursă: toate metodele din același canal partajează o singură limită.',
      unitsSoldPool: 'Limită unități pe produs',
      unitsSoldPool_perProduct: 'Per produs',
      unitsSoldPool_absolute: 'Absolut (toate produsele partajează)',
      unitsSoldPoolHint: 'Per produs: fiecare produs are limita lui. Absolut: toate produsele din campanie partajează aceeași limită.',
      useIntervals: 'Limitează la intervale orare',
      useIntervalsHint: 'Când este dezactivat, campania este activă toată ziua în perioada selectată.',
      intervalDay: 'Zi',
      addInterval: 'Adaugă interval',
      intervalOverlap: 'Intervalele se suprapun sau unul îl include pe celălalt. Folosiți zile/ore diferite sau ștergeți intervalul redundant.',
      intervalInvalidRange: 'Introduceți ore valide și diferite pentru început și sfârșit. O oră de sfârșit mai mică înseamnă că intervalul se încheie în ziua următoare.',
      previewTitle: 'Produse afectate',
      previewCount: '{count} produse se potrivesc',
      searchProduct: 'Caută după nume produs',
      searchProductId: 'ID produs',
      product: 'Produs',
      pricingType: 'Preț',
      pricingProfile: 'Profil',
      pricingCatalog: 'Catalog',
      method: 'Metodă',
      originalPrice: 'Preț original',
      discountAmount: 'Reducere',
      discountedPrice: 'Preț redus',
      cap: 'Limită',
      unitsSold: 'Unități vândute',
      productsCount: 'Produse',
      regenerateWarning: 'Liniile de produse vor fi regenerate. Continuați?',
      areYouSureDelete: 'Sigur doriți să ștergeți',
      campaignDeleted: 'Campania de reducere a fost ștearsă cu succes.',
      campaignAdded: 'Campania de reducere a fost adăugată cu succes.',
      campaignUpdated: 'Campania de reducere a fost actualizată cu succes.',
      removeCurrentImage: 'Eliminați imaginea curentă înainte de a adăuga una nouă',
      products: 'Produse',
      productsIncluded: 'Produse incluse',
      createCampaign: 'Creează campanie',
      campaignButton: 'Campanie reducere',
      applyDiscount: 'Aplică reducere',
      clearSelection: 'Deselectează tot',
      selectionSummary: '{cells} celule selectate · {products} produse',
      selectForCampaign: 'Selectează pentru campanie',
      noPriceConfigured: 'Fără preț configurat',
      viewEditDiscount: 'Vezi / editează reducerea',
      discShort: 'Disc.',
      newCampaignModal: 'Campanie reducere nouă',
      newCampaignSubtitle: 'Lista de preț: {name} · {cells} celule selectate',
      priceProfileLocked: 'Blocat pe profilul de preț curent',
      period: 'Perioadă',
      listPrice: 'Preț listă',
      invalidDiscount: 'Reducere invalidă',
      discountExceedsPrice: 'Reducerea nu poate depăși prețul',
      confirmDeleteLine: 'Elimini reducerea și produsul din campanie?'
    },
    donationReport: {
      campaign: 'Campanie',
      client: 'Client',
      amount: 'Sumă',
      date: 'Dată',
      totalAmount: 'Sumă totală',
      totalDonations: 'Total Donații',
      totalDonors: 'Total Donatori',
      campaignOrders: 'Comenzi'
    },
    marketingOffers: {
      single: 'banner ofertă',
      plural: 'banner oferte',
      title: 'Titlu',
      status: 'Status',
      image: 'Imagine',
      imageWeb: 'Imagine Web',
      imageBanner: 'Imagine Banner',
      imageLanding: 'Imagine Landing',
      linkType: 'Tip Link',
      startEndDate: 'Valabil de la - până la',
      actions: 'Acțiuni',
      offerAdded: 'Banner ofertă adăugat cu succes.',
      offerUpdated: 'Banner ofertă actualizat cu succes.',
      offerDeleted: 'Banner ofertă șters cu succes.',
      weCouldNot: 'Poza pentru bannerul de oferă nu a fost salvată, te rugăm să încerci mai târziu.',
      validImg: 'Te rugăm să adaugi o imagine validă.',
      areYouSure: 'Ești sigur că dorești să {label} acest banner ofertă?',
      pageText: 'Text Pagină',
      pickCateg: 'Alege Categoria',
      pickProd: 'Alege Produsul',
      pickLoc: 'Alege Locația',
      groupClients: 'Alege grupul de clienti',
      none: 'Nici unul',
      banners: 'Bannere',
      offers: 'Oferte',
      display: 'Afisare',
      addGroup: 'Adaugă grup',
      offerSuccess: 'Ofertă de grup adăugată cu succes.',
      categoryBanner: 'Categoriile în care vă fi afișat',
      dispalyBannerInCategory: 'Afișează banner în categorie'
    },
    marketingOffersTypes: {
      category: 'categorie',
      product: 'produs',
      page: 'pagină'
    },
    marketingFidelities: {
      fidelities: 'Fidelitate',
      userLabeling: 'Segmentare clienti',
      name: 'Nume',
      ordersValue: 'Valoare Comenzi',
      ordersNumber: 'Număr Comenzi',
      MOR: 'Media Comenzi Perioada (MOR)',
      MORCalcComenzi: 'Numar comenzi anuale',
      MORInfo: `
        <div class="info" style="font-size: 12px;">
          <p><b>Ce introduci aici?</b></p>

          <p>
            Introduci <b>numărul mediu de comenzi</b> pe care vrei să le
            plaseze un client <b>pe lună</b>, calculat la nivel de an.
          </p>

          <p><b>Formula sistemului:</b></p>

          <p>
            <i>Medie MOR = Număr comenzi pe an ÷ 12 luni</i>
          </p>

          <p><b>Exemplu practic (Pentru rangul Silver):</b></p>

          <p>
            Dacă vrei ca un client să aibă <b>6 comenzi pe an</b>,
            introduci valoarea <b>0.5</b> (deoarece 6 ÷ 12 = 0.5).
          </p>
        </div>
      `,
      color: 'Culoare',
      notification: 'Notificare',
      userNotification: 'Notificare Utilizator',
      userNotificationPlaceholder: 'Felicitări! Ați ajuns la {level}!',
      userNotificationInfo: 'Notificare primită de către client la atingerea pragului',
      coupon: 'Cupon',
      product: 'Produs gratuit',
      recurrenceInfo: 'Produsul gratuit/ cuponul setat se aplică o dată la {recurrence}',
      description: 'Descriere',
      descriptionPlaceholder: 'adaugă desert gratuit la comandă',
      descriptionInfo: 'Descriere disponibilă doar in panoul de administrare',
      nameLabel: 'Nume Etichetă',
      addLabel: 'Adaugă Etichetă',
      noData: 'Nu sunt date',
      updateUserLabeling: 'Etichetă Utilizator Actualizată',
      createdUserLabeling: 'Etichetă Utilizator Creată',
      areYouSureDelete: 'Sigur dorești să ștergi această etichetă ?',
      labelDeleted: 'Etichetă ștersă',
      orderNumberRequired: 'Acest câmp sau numărul de comenzi este obligatoriu',
      orderValueRequired: 'Acest câmp sau valoare comenzilor este obligatoriu',
      yes: 'Da',
      applyCupon: 'Aplică Cupon',
      applyproduct: 'Aplică Produs',
      badgeColor: 'Culoare Etichetă',
      badgeName: 'Nume Etichetă',
      value: 'Valoare',
      number: 'Număr',
      appliedForLastMonth: 'Etichetele se vor aplica doar pentru comenzile din ultimele 30 de zile',
      checkTermsAndConditionFidelities: 'Verifică promoțiile de fidelitate de la paginile informative',
      labelingPrimaryOption: 'Selectați opțiunea principală pentru etichete',
      labelingSuccess: 'Setările pentru etichete au fost actualizată cu succes!',
      updatePrimaryOption: 'Actualizează opțiunea',
      showLabelOnUser: 'Afișează nivelul utilizatorilor în aplicația mobil',
      sentUserLabelNotification: 'Permiteți trimiterea notificărilor de actualizare a etichetei utilizatorului',
      infoAboutShowUserLabelUpdated: 'Informațiile despre afișarea etichetei de utilizator au fost actualizate',
      labelingInterval: 'Alegeți intervalul de aplicare',
      '0': 'Pe viață',
      '30': '30 de zile',
      '60': '60 de zile',
      '90': '90 de zile',
      '120': '120 de zile',
      '150': '150 de zile',
      '180': '180 de zile',
      recurrence: 'Recurență',
      noReccurence: 'fără',
      oneDay: '1 zi',
      threeDays: '3 zile',
      fiveDays: '5 zile',
      sevenDays: '7 zile',
      tenDays: '10 zile',
      fifteenDays: '15 zile',
      twentyDays: '20 zile',
      twentyFiveDays: '25 zile',
      updatePoints: 'Actualizare puncte',
      availableProducts: 'Un produs trebuie sa fie disponibil in toate locatiile pentru a fi eligibil'
    },
    marketingPromos: {
      to_receive: 'De primit',
      multiple: 'Se poate revendica de mai multe ori per comandă',
      redeemFromNextOrder: 'Se poate revendica doar de la următoarea comandă',
      addFreeProductAutomatically: 'Adaugă produsul gratuit automat la comandă',
      allowOnePointPerOrder: 'Permite un singur punct pe comandă',
      expiryInfo: 'Setați 0 pentru a acorda puncte doar pentru comanda curentă',
      to_order: 'De comandat',
      toOrderError: 'Vă rugăm selectați produse care pot fi comandate',
      toReceiveError: 'Vă rugăm selectați produse care pot fi primite',
      location: 'Locația',
      title: 'Titlu',
      treshold: 'Limita n',
      category: 'Categorie',
      product: 'Produs',
      products: 'Produse',
      expiry: 'Valabilitate puncte (zile)',
      none: 'Nici unul',
      marketingPromos: 'Promo',
      generateQrCode: 'Generează Qr Code',
      code: 'Code',
      promoDeleted: 'Promoție ștearsă',
      areYouSureDelete: 'Sigur dorești să ștergi această etichetă',
      promoAdded: 'Promoție adăugată cu succes.',
      promoUpdated: 'Promoție ofertă actualizat cu succes.',
      weCouldNot: 'Datele nu au fost salvate, te rugăm să încerci mai târziu.',
      startEndDate: 'Valabil de la - până la',
      image: 'Imagine',
      validImg: 'Te rugăm să adaugi o imagine validă.',
      print: 'Print',
      firstname: 'Nume',
      lastname: 'Prenume',
      points: 'Puncte',
      email: 'Email',
      description: 'Descriere',
      descriptionPlaceholder: 'Descrierea va fi afișată în aplicație',
      notificationText: 'Text notificare',
      notificationTextPlaceholder: 'Acest mesaj va fi trimis utilizatorului când acumulează suficiente puncte pentru un produs gratuit (Lăsați gol pentru a omite notificarea)',
      send: 'Trimite'
    },
    referralProgram: {
      v2: {
        ambassador_1: 'Ambasador 1',
        ambassador_2: 'Ambasador',
        referee: 'Afiliat',
        none: 'Fără recompensă',
        coupon: 'Cupon',
        rewardKind: 'Tip recompensă',
        selectCoupon: 'Selectează cuponul',
        campaignDefault: 'Setarea campaniei',
        legacyCombined: 'Sumă fixă + procent existente',
        unavailableCoupon: 'Cupon indisponibil (#{id})',
        loadingCoupons: 'Se încarcă cupoanele…',
        noCoupons: 'Nu există cupoane active disponibile.',
        couponsLoadFailed: 'Cupoanele nu au putut fi încărcate.',
        retry: 'Reîncearcă',
        couponRequired: 'Selectează un cupon.',
        couponUnavailable: 'Selectează un cupon disponibil.',
        percentInvalid: 'Introdu un procent între 0 și 100.',
        amountInvalid: 'Introdu o valoare mai mare sau egală cu zero.',
        maxOrdersInvalid: 'Introdu un număr întreg pozitiv sau lasă gol pentru comenzi nelimitate.',
        visibleInApp: 'Afișează în aplicație',
        hierarchyTitle: 'Recomandări ambasador',
        hierarchy: 'Ambasador → Afiliat',
        purchaseFlow: 'Comenzile afiliatului recompensează afiliatul și ambasadorul său direct. Comenzile ambasadorului nu generează recompense referral.',
        cashbackTitle: 'Recompense la fiecare comandă',
        cashbackHelp: 'Aceste recompense continuă după atingerea limitei primelor comenzi. Configurează separat fiecare beneficiar.',
        order_reward: 'Recompensă la primele comenzi',
        cashback: 'Recompensă la fiecare comandă',
        couponsAwarded: 'Cupoane acordate'
      },
      generalSettings: 'Setări generale',
      campaignName: 'Nume campanie',
      active: 'Activă',
      availableBetween: 'Disponibilitate (calendar)',
      optionalAvailability: 'Lasă gol pentru perioada nelimitată',
      tableAvailability: 'Disponibilitate',
      orderRewardsSection: 'Recompense la primele comenzi',
      orderRewardsActive: 'Recompense la comenzi activate',
      refereeRewardFlat: 'Recompensă afiliat',
      ambassadorOrderRewardFlat: 'Recompensă ambasador',
      maxOrdersForOrderRewards: 'Număr maxim comenzi contorizate',
      unlimitedPlaceholder: 'Lasă gol pentru nelimitat',
      cashbackSection: 'Cashback ambasador din comenzile afiliaților',
      cashbackFlatOrPercent: 'Alege dacă cashback-ul este procent din total sau sumă fixă pe comandă.',
      ambassadorCashbackActive: 'Cashback activ',
      cashbackAmountType: 'Tip cashback',
      cashbackTypePercent: 'Procent (%)',
      cashbackTypeFlat: 'Sumă fixă',
      cashbackPercentValue: 'Procent din total comandă (%)',
      cashbackFlatValue: 'Sumă fixă pe comandă livrată',
      cashbackHintPercent: 'Procent din totalul comenzii afiliatului plătit ambasadorului.',
      cashbackHintFlat: 'Sumă monetară fixă pe fiecare comandă livrată pentru ambasador.',
      nameRequired: 'Introduceți numele campaniei.',
      cashbackPercentRequired: 'Introduceți procentul de cashback când cashback-ul este activ.',
      cashbackFlatRequired: 'Introduceți suma fixă de cashback când cashback-ul este activ.',
      notificationEmailsTitle: 'Emailuri notificări referral',
      notificationEmailsHelp: 'Adrese care primesc cereri noi de ambasador (separate prin virgulă sau linie nouă).',
      notificationEmailsPlaceholder: 'echipa@companie.ro',
      orderRewards: 'Recompense comenzi',
      cashback: 'Cashback',
      requestStatus: 'Status',
      desiredCode: 'Cod dorit',
      createdAt: 'Solicitat la',
      approveRequest: 'Aprobă ambasador',
      selectCampaign: 'Campanie referral',
      selectCampaignRequired: 'Selectați o campanie referral.',
      rewardSummaryDisabled: 'Dezactivat',
      approvedCodeOptional: 'Cod referral aprobat (opțional)',
      denyReason: 'Motiv respingere (opțional)',
      ambassadorId: 'Ambasador',
      refereesCount: 'Afiliați',
      totalRewards: 'Total recompense',
      totalCashbackPercent: 'Total cashback',
      refereeId: 'Afiliat',
      refereeTotals: 'Total comenzi afiliat',
      ambassadorEarnings: 'Câștig ambasador',
      refereeReward: 'Recompensă afiliat',
      ambassadorOrderReward: 'Recompensă ambasador (comandă)',
      ambassadorCashback: 'Cashback ambasador',
      rewardType: 'Tip recompensă',
      rewardTypeLoyaltyPoints: 'Puncte fidelitate',
      rewardTypeWallet: 'Credit portofel',
      loyaltyPointsModuleRequired: 'Pentru a alege punctele de loialitate ca recompensă, trebuie să configurați mai întâi modulul de puncte de loialitate.',
      loyaltyPointsModuleLink: 'Mergi la setările punctelor de loialitate',
      orderRewardsSummaryIncomplete: 'Configurați recompensele fixe pentru afiliați și/sau ambasador.',
      cashbackSummaryIncomplete: 'Configurați valoarea cashback-ului pentru a vedea rezumatul.',
      cannotDeleteHasEnrolledUsers: 'Campania nu poate fi ștearsă deoarece există deja utilizatori înscriși. Dezactivați-o în schimb pentru a opri noile înscrieri.',
      deactivateCampaign: 'Dezactivează campania',
      filterByCampaign: 'După campanie',
      filterByAmbassador: 'După ambasador'
    },
    reports: {
      labelEvolution: 'Evoluție Etichete',
      items: 'Produse',
      wallet_id: 'ID',
      wallet_firstname: 'Prenume',
      wallet_lastname: 'Nume',
      wallet_email: 'Email',
      wallet_phone: 'Telefon',
      wallet_loyalty_points: 'Puncte fidelitate',
      wallet_donation_points: 'Puncte donație',
      wallet_value: 'Portofel',
      wallet_driver_wallet: 'Portofel șofer',
      salesPaymentMethod: 'Raport Vanzari',
      paymentTypes: 'Metode de plată',
      giftCardsSoldTotal: 'Total vânzări carduri cadou',
      giftCardsSoldAmount: 'Vânzări carduri cadou',
      orderedProducts: 'Produse comandate',
      number: 'Nr Comandă',
      trends: 'Performanță',
      clients: 'Clienți',
      products: 'Produse',
      marketing: 'Marketing',
      today: 'Azi',
      orderChart: 'Comenzi',
      clientsChart: 'Clienți',
      completed: 'Finalizate',
      canceled: 'Anulate',
      salesChart: 'Vânzări',
      salesIn: 'Vânzări în',
      customersChart: 'Clienți',
      appInstalls: 'Aplicații Instalate',
      custWithAcc: 'Conturi clienți',
      top10Chart: 'Top 10 produse',
      top5Chart: 'Top 5 produse',
      orderingChart: 'Tip comandă',
      periodExceeds6Months: 'Te rugăm să selectezi o perioadă mai mică de 6 luni',
      nrOfOrders: 'Număr comenzi',
      customersAge: 'Vârsta client',
      customersGender: 'Gen client',
      name: 'Nume',
      timerApp: 'Timp în aplicație',
      appInstalled: 'Aplicații Instalate',
      gender: 'Gen',
      location: 'Locație',
      partnerCode: 'Cod partener',
      email: 'Email',
      phone: 'Telefon',
      age: 'Vârstă',
      donation_points: 'Puncte donatie',
      label: 'Etichetă',
      filter: 'Filtrează',
      userDetails: 'Detalii Client',
      salesDetails: 'Detalii Vânzări',
      salesProductNr: 'Număr vânzări produs',
      totalAmount: 'Sumă Totală',
      totalProducts: 'Total Produse',
      ordersNumber: 'Număr Comenzi',
      minAmount: 'Sumă totală minimă',
      minOrders: 'Nr min comenzi',
      maxOrders: 'Nr max comenzi',
      itemsSold: 'Produse vândute',
      campaign: 'Campanii',
      couponsTimesUsed: 'Număr cupoane utilizate',
      revenue: 'Vânzări',
      total: 'Total',
      paymentType: 'Metodă plată',
      date: 'Dată',
      closingOrder: 'Închidere comandă',
      dateColumnCreate: 'Creare',
      dateColumnClose: 'Închidere',
      dateColumnFiscalize: 'Fiscalizare',
      salesReport: 'Raport Vânzări',
      salesReportBeta: 'Raport Vânzări BETA',
      accountingReport: 'Raport Contabil',
      orderorder: 'Comandă',
      export: 'Exportă',
      cash: 'Numerar',
      card: 'Online (Aplicatie)',
      cardPayment: 'Card',
      pos: 'POS Mobil',
      cardPos: 'POS Fizic',
      splitCardPos: 'Separat Card',
      splitCash: 'Separat Numerar',
      virament: 'Virament',
      protocol: 'Protocol',
      staffFood: 'Mancare Personal',
      room: 'Transfer Camera',
      event: 'Transfer Eveniment',
      folio: 'Transfer Folio',
      tips: 'Bacșiș',
      splitVoucher: 'Voucher',
      unpaid: 'Neachitat',
      orderPaidStatus: 'Achitat',
      boltCard: 'Card Bolt',
      boltCash: 'Numerar Bolt',
      glovoCard: 'Card Glovo',
      glovoCash: 'Numerar Glovo',
      woltCard: 'Card Wolt',
      woltCash: 'Numerar Wolt',
      woltOtherMethods: 'Wolt Alte metode',
      totalPayFromWallet: 'Total plată portofel',
      totalSum: 'Sumă Totală',
      totalSales: 'Total Vânzări',
      totalCash: 'Total Numerar',
      totalOnline: 'Total Online',
      totalCard: 'Total Card',
      totalCredit: 'Total Credit',
      totalNonFiscal: 'Total Alte Metode',
      unfiscalTotal: 'Total Nefiscalizat',
      unfiscalCash: 'Nefiscalizat Numerar',
      unfiscalOnline: 'Nefiscalizat Online',
      unfiscalCard: 'Nefiscalizat Card',
      unfiscalCredit: 'Nefiscalizat Credit',
      search: 'Căutare',
      searchFilter: 'Caută(nume, email, telefon)',
      searchClient: 'Caută client (nume, email, telefon)',
      noRawData: 'Nu există date disponibile',
      rawDataTvaA: 'TVA A',
      rawDataTvaB: 'TVA B',
      rawDataTvaC: 'TVA C',
      rawDataTvaD: 'TVA D',
      rawDataTvaE: 'TVA E',
      rawDataTvaS: 'SCUTIT TVA S',
      rawDataAlteTaxe: 'ALTE TAXE #',
      rawDataNrAnulariNefiscale: 'NR. ANULARI NEFISCALE',
      rawDataValAnulariNefiscale: 'VAL. ANULARI NEFISCALE',
      rawDataNumerarInSertar: 'NUMERAR IN SERTAR LEI',
      rawDataNumerar: 'NUMERAR',
      rawDataCard: 'CARD',
      rawDataCredit: 'CREDIT',
      rawDataTicheteMasa: 'TICHETE MASA',
      rawDataTicheteValorice: 'TICHETE VALORICE',
      rawDataVoucher: 'VOUCHER',
      rawDataPlataModerna: 'PLATA MODERNA',
      rawDataAvansInNumerar: 'AVANS IN NUMERAR',
      rawDataAlteMetode: 'ALTE METODE',
      rawDataValTotalVanzA: 'VAL. TOTAL VANZ - A',
      rawDataValTotalVanzB: 'VAL. TOTAL VANZ - B',
      rawDataValTotalVanzC: 'VAL. TOTAL VANZ - C',
      rawDataValTotalVanzD: 'VAL. TOTAL VANZ - D',
      rawDataValTotalVanzE: 'VAL. TOTAL VANZ - E',
      rawDataValTotalAlteTaxe: 'VAL. TOTAL ALTE TAXE #',
      rawDataValTotalScutitTvaS: 'VAL. TOTAL SCUTIT DE TVA - S',
      rawDataValTotalVanzari: 'VAL. TOTAL VANZARI',
      rawDataTotalTvaA: 'TOTAL TVA A 21%',
      rawDataTotalTvaB: 'TOTAL TVA B 11%',
      rawDataTotalTvaC: 'TOTAL TVA C 0%',
      rawDataTotalTvaD: 'TOTAL TVA D 0%',
      rawDataTotalTvaE: 'TOTAL TVA E 0%',
      rawDataTotalTva: 'TOTAL TVA',
      rawDataClientiCodFiscalTotalTva: 'CLIENTI COD FISCAL - TOTAL TVA',
      rawDataClientiCodFiscalTotalSumar: 'CLIENTI COD FISCAL - TOTAL SUMAR',
      rawDataNrBonuriClientiCodFiscal: 'NR. BONURI CLIENTI COD FISCAL',
      rawDataNumarBonuriFiscale: 'NUMAR BONURI FISCALE',
      rawDataNumarBonuriNefiscale: 'NUMAR BONURI NEFISCALE',
      rawDataNrDmje01: 'NR. DMJE 01',
      rawDataDmjeCapacitate: 'DMJE CAPACITATE',
      rawDataSpatiuLiberDmje: 'SPATIU LIBER DMJE',
      rawDataSpatiuOcupat: 'SPATIU OCUPAT',
      rawDataNrAmef: 'NR.AMEF',
      rawDataTd: 'TD',
      rawDataData: 'DATA',
      rawDataOra: 'ORA',
      rawDataSN: 'S/N',
      rawDataLogo: '{LOGO}',
      rawDataSha256: 'SHA-256 PENTRU Z',
      searchEmployee: 'Caută operator (nume, email, telefon)',
      discount: 'Reducere',
      totalDiscount: 'Discount Total',
      ordersWithDiscount: 'Comenzi cu Discount',
      ordersWithFidelity: 'Comenzi cu Fidelitate',
      totalFidelityDiscount: 'Total Fidelitate',
      newCustomers: 'Clienți noi',
      totalTax: 'Total Taxe',
      slotTax: 'Taxa Slot',
      slotPartTax: 'Taxa Slot Parte',
      tax: 'Taxe',
      shipping: 'Livrare',
      delivery_type: 'Metoda de livrare',
      zone: 'Zona de livrare',
      avarageOrderValue: 'Valoare medie per Comanda',
      clientsWOrders: 'Clienți cu comenzi',
      emailSend: 'Emailuri trimise în ultimele 6 luni',
      emailTotal: 'Total emailuri trimise: ',
      newCustomersChart: 'Clienți Noi',
      productsSalesReport: 'Raport vânzări produse',
      productsSalesReport2: 'Vânzări produse',
      productSaleTrendsReport: 'Trend vânzări produse',
      salesTrendsReport: 'Trend vânzări',
      topProductsReport: 'Top Produse',
      topCategoriesReport: 'Top Categorii',
      orderFromReport: 'Vânzari Verticale',
      productsAndOptionsReport: 'Raport Produse și Opțiuni',
      options: 'Opțiuni',
      netValue: 'Valoare Netă',
      stornoReport: 'Storno Utilizatori',
      operatorSalesReport: 'Vânzari Protocol Operator',
      waiterTipsReport: 'Bacșiș ospătari',
      waiterTipsUserName: 'Nume utilizator',
      waiterTipsValue: 'Valoare',
      waiterTipsZRange: 'Interval Z',
      waiterTipsMode: 'Mod',
      waiterTipsModeWaiter: 'Ospătari',
      waiterTipsModeDelivery: 'Livrare',
      waiterTipsSelectWaiters: 'Ospătari',
      waiterTipsSelectDrivers: 'Șoferi',
      masterReport: 'Raport General',
      masterReportBeta: 'Raport General (Beta)',
      fiscalZReport: 'Raport Fiscal Z',
      withoutOptions: 'fără opțiuni, fără sgr',
      customerLifetimeValueReport: 'Raport Venituri Client',
      referralProgramReport: 'Raport Afiliați',
      raffleCampaignsReport: 'Raport campanii tombolă',
      orderStatus: 'Raport status comenzi',
      pdfRaport: 'Raport comenzi pentru livrare',
      pricePerUnit: 'Preț pe bucată',
      quantity: 'Cantitate',
      average: 'Medie',
      productName: 'Nume Produs',
      couponCode: 'Cupon',
      checkOrder: 'Folosește comanda',
      loyaltyPoints: 'Puncte de Fidelidate',
      donationReport: 'Raport Donații',
      donationCampaignsReport: 'Raport Campanii Donații',
      loyaltyStoreReport: 'Loyalty Store',
      challengeCampaignsReport: 'Raport Provocări',
      spinningWheelReport: 'Raport Roata Norocului',
      ocr: 'Ocr',
      stockMovements: 'Mișcări stoc produse',
      reorderPopupResponses: 'Răspunsuri popup comandă',
      dateTime: 'Dată și oră',
      reorderResponse: 'Răspuns',
      reorderResponseYes: 'Da',
      reorderResponseNo: 'Nu',
      dateInterval: 'Interval dată',
      allLocations: 'Toate locațiile',
      stockMovementType: 'Tip mișcare',
      stockMovementUserRole: 'Rol utilizator',
      stockMovementOrderPlaced: 'Plasare comandă',
      stockMovementManualAdjustment: 'Ajustare manuală',
      wallet: 'Wallet',
      requestReport: 'Solicită Raport',
      requestSuccess: 'Solicitare Trimisă',
      requestInfo: 'Raportul va putea fi descarcat de mâine',
      requestConfirm: 'Am înțeles',
      reportRequestTab: 'Solicitări Rapoarte',
      charismaReport: 'Raport Charisma',
      charismaLocationReceipt: 'Raport Z Charisma',
      nexusReport: 'Raport Nexus',
      nexusItems: 'Jurnal Comandă',
      nexusOrderLogs: 'Nexus Jurnale Comenzi',
      sendReceipts: 'Trimite Bonuri',
      dashboardReport: 'Raport Panou Comanda',
      reportTypePlaceholder: 'Raport',
      pointsReport: 'Raport Puncte',
      fromUppercase: 'De la',
      toUppercase: 'Până la',
      availableUntil: 'Valabil până la',
      pdfRaportDeliveryOrders: 'Comenzi Livrare',
      statusReport: 'Timp Procesare Comenzi',
      taxation: 'Fiscalizare',
      withReceipt: 'Fiscalizate',
      withoutReceipt: 'Nefiscalizate',
      receiptNumber: 'Nr Bon',
      zet: 'Zet',
      noDataAvailable: 'Nu sunt date disponibile',
      topCategory: 'Categorie de top',
      orderId: 'ID Comandă',
      posId: 'ID Pos',
      productId: 'ID Produs',
      itemPosId: 'ID Pos Item',
      menuItemPosId: 'ID Pos Item Meniu',
      orderCreatedAt: 'Oră deschidere comandă',
      orderNumber: 'Număr comandă',
      tableNumber: 'Număr masă',
      orderItemCreatedAt: 'Oră deschidere produs',
      orderItemMarkingTime: 'Oră marcare produs',
      category: 'Categorie',
      product: 'Produs',
      operation: 'Operație',
      operator: 'Operator',
      section: 'Secție',
      fullPrice: 'Preț întreg',
      grossPrice: 'Preț întreg per produs',
      orderItemDiscount: 'Reducere produs',
      orderDiscount: 'Reducere comandă',
      orderLoyaltyDiscount: 'Reducere fidelitate comandă',
      orderItemValueCollected: 'Sumă încasată',
      vatAmount: 'Sumă TVA',
      orderItemNetPrice: 'Preț fără TVA',
      paymentMethod: 'Metodă de plată',
      fiscalization: 'Fiscalizare',
      roomNumber: 'Număr cameră',
      folioId: 'ID folio',
      interval: 'Interval',
      split: 'Separat',
      orderComments: 'Comentarii comandă',
      productComments: 'Comentarii produs',
      tableOpenOrders: 'Comenzi deschise la mase',
      orderSeriesNumber: 'Serie / nr. comandă',
      posDeviceName: 'POS',
      waiterName: 'Ospătar',
      orderTransfersCount: 'Transferuri',
      orderStornosCount: 'Storno',
      posOrderActionTypes: {
        openOrder: 'Deschidere comandă',
        markProduct: 'Marcare produs',
        preNote: 'Pre notă',
        closeOrder: 'Închidere comandă',
        storno: 'Storno',
        transferOut: 'Transfer OUT',
        transferIn: 'Transfer IN'
      },
      posOrderActionMarkProduct: 'Marcare "{name}"',
      posOrderActionMarkProductGeneric: 'Marcare produse',
      orderProductsCount: 'Număr produse comandă',
      transferTable: 'Masă transfer',
      initialItems: 'Produse initiale',
      transferredTag: 'Transferat',
      transferOut: 'Produse transferate',
      remainingItems: 'Produse rămase',
      itemsReceived: 'Produse primite',
      posOrderActionsReport: 'Raport acțiuni comenzi POS',
      zNumber: 'Număr Z',
      deviceName: 'Nume Dispozitiv',
      zTimestamp: 'Data și Ora Z',
      credit: 'Credit',
      mealTickets: 'Tichete Masă',
      valueTickets: 'Tichete Valorice',
      voucher: 'Voucher',
      modernPayment: 'Plată Modernă',
      advanceInCash: 'Avans în Numerar',
      otherMethods: 'Alte Metode',
      cashInDrawer: 'Numerar în Sertar',
      nrFiscalReceipts: 'Nr. Bonuri Fiscale',
      nrNonFiscalReceipts: 'Nr. Bonuri Nefiscale',
      fiscalReceiptsAmount: 'Valoare bonuri fiscale',
      nonFiscalReceiptsAmount: 'Valoare bonuri nefiscale',
      paymentMethodsStandard: 'Metode de plată standard',
      paymentMethodsOther: 'Alte metode de plată',
      paymentMethodsIntegration: 'Metode de plată integrări',
      totalSalesA: 'Total Vânzări A',
      totalSalesB: 'Total Vânzări B',
      totalSalesC: 'Total Vânzări C',
      totalSalesD: 'Total Vânzări D',
      totalSalesE: 'Total Vânzări E',
      totalVat: 'Total TVA',
      totalVatA: 'Total TVA A',
      totalVatB: 'Total TVA B',
      totalVatC: 'Total TVA C',
      totalVatD: 'Total TVA D',
      totalVatE: 'Total TVA E',
      totalOtherTaxes: 'Total Alte Taxe',
      totalVatExempt: 'Total Scutit TVA',
      nrFiscalCodeClientReceipts: 'Nr. Bonuri cu Cod Fiscal Client',
      fiscalCodeClientsTotalSum: 'Sumă Totală Clienți cu Cod Fiscal',
      fiscalCodeClientsTotalVat: 'TVA Total Clienți cu Cod Fiscal',
      productCount: 'Număr produse',
      lastSearch: 'Ultima căutare',
      duration: 'Durată comandă',
      tables: 'Mese',
      quantityUnit: 'Unitate măsură',
      singleUnit: 'buc',
      clientId: 'ID Client',
      clientName: 'Nume Client',
      registrationDate: 'Data Înregistrării',
      firstOrderDate: 'Data Primei Comenzi',
      lastOrderDate: 'Data Ultimei Comenzi',
      monthlyOrderCount: 'Număr Comenzi (total)',
      monthlyOrderValueTotal: 'Valoare Totală Comenzi',
      averageOrderValue: 'Valoare Medie Comandă',
      // monthlyOrderAverage: 'Valoare Medie Comandă (lunar)',
      monthlyOrderAverage: 'Frecvență lunară',
      isNewClient: 'Client Nou',
      isInactiveClient: 'Client Inactiv',
      daysSinceLastOrder: 'Zile de la Ultima Comandă',
      acquisitionChannel: 'Canal de Achiziție',
      estimatedCLV: 'CLV 12 Luni',
      churnRate: 'Rata Churn',
      option: 'Opțiune',
      item: 'Produs',
      type: 'Tip',
      searchProducts: 'Caută',
      orderCounter: 'Număr comenzi',
      preordersItems: 'Produse Precomandă',
      itemName: 'Nume Produs',
      saleWeek: 'Săptămâna',
      filteredData: 'Datele afișate sunt din perioada:',
      source: 'Sursă',
      withStorno: 'Storno',
      withoutStorno: 'Fără Storno',
      orderTotal: 'Total Comandă',
      old: 'Vechi',
      custom: 'Personalizat',
      salesProtocol: 'Total Vânzări Protocol',
      salesStaff: 'Total Vânzări Personal',
      countProtocol: 'Număr comenzi Protocol',
      countStaff: 'Număr comenzi Personal',
      salesProtocolStaff: 'Total Vânzări Protocol + Personal',
      countProtocolStaff: 'Număr comenzi Protocol + Personal',
      salesReportSearch: 'Caută după produs, categorie, operator',
      id: 'ID',
      sold: 'Vândut',
      eatIn: 'În locație',
      takeOut: 'La pachet',
      other: 'Altele',
      waste: 'Risipă',
      employee: 'Angajat',
      refund: 'Rambursat',
      usage: 'Utilizare',
      unitQty: 'Cantitate unitară',
      unitPrice: 'Preț unitar',
      sales: 'Vânzări',
      netSales: 'Vânzări Nete',
      grandTotal: 'Total General',
      mixReport: 'Raport Mix',
      noData: 'Nu există date',
      uncategorized: 'Necategorizat'
    },
    orderFrom: {
      unknown: 'Necunoscut',
      kiosk: 'Kiosk',
      qr: 'QR',
      pos: 'POS',
      app: 'Aplicație',
      website: 'Site',
      glovo: 'Glovo',
      wolt: 'Wolt',
      bolt: 'Bolt',
      POS: 'POS',
      application: 'Aplicație',
      online: 'Site',
      table: 'Masă',
      tazz: 'Tazz',
      phone: 'Telefonic',
      inlocation: 'Rezervare'
    },
    feedback: {
      sigle: 'feedback',
      type: 'Tip',
      sentBy: 'Trimis prin',
      text: 'Text',
      seen: 'Văzut',
      sentAt: 'Trimis la',
      search: 'Caută',
      comment: 'Comentariu',
      response: 'Răspuns',
      send: 'Răspunsul vă fii trimis către utilizator prin notificare și email la momentul salvării'
    },
    orderScreen: {
      typeKitchen: 'Bucătărie',
      typeClient: 'Client',
      selectLocation: 'Selectați o locație pentru a putea opta pentru metoda Client',
      excludeSections: 'Exclude secțiile',
      includeTableOrders: 'Include comenzi de la Masă și Kiosk',
      posIds: 'POS-uri',
      odsBackgroundColor: 'Culoare fundal',
      odsHeaderTextColor: 'Culoare text antet',
      odsBodyTextColor: 'Culoare text numere',
      odsStatus1Color: 'Culoare comenzi procesate',
      odsStatus2Color: 'Culoare comenzi in lucru',
      odsStatus3Color: 'Culoare comenzi preparate',
      odsColumn1TextLanguage1: 'Text coloana 1 (limba 1)',
      odsColumn1TextLanguage2: 'Text coloana 1 (limba 2)',
      odsColumn2TextLanguage1: 'Text coloana 2 (limba 1)',
      odsColumn2TextLanguage2: 'Text coloana 2 (limba 2)',
      odsOffline: 'ODS offline',
      ipServer: 'IP Server',
      odsCode: 'Cod ODS',
      connectivity: 'Conectivitate',
      offline: 'Offline',
      online: 'Online'
    },
    feedbackTypes: {
      feedback: 'Feedback',
      issue: 'Problemă',
      suggestion: 'Sugestie'
    },
    settings: {},
    blogPage: {
      categories: 'Categorii',
      categoriesHint: 'Opțional — articolele pot fi și fără categorie.',
      categoryName: 'Nume categorie',
      noCategories: 'Nicio categorie încă.',
      articles: 'Articole',
      addArticle: 'Adaugă articol',
      editArticle: 'Editează articol',
      allCategories: 'Toate categoriile',
      noCategory: 'Fără categorie',
      allStatuses: 'Toate statusurile',
      searchByTitle: 'Caută după titlu',
      noArticles: 'Niciun articol găsit.',
      cover: 'Copertă',
      coverHint: 'recomandat 1200x630px, max 5MB',
      imageAlt: 'Text alternativ poză (SEO)',
      title: 'Titlu',
      slug: 'Link articol (slug)',
      slugHint: 'Se generează din titlu dacă rămâne gol.',
      shortDescription: 'Descriere scurtă (sub titlu)',
      content: 'Conținut',
      category: 'Categorie',
      author: 'Autor',
      publishedAt: 'Data publicării',
      publishedAtHint: 'Dacă e gol, la publicare se folosește data curentă.',
      status: 'Status',
      published: 'Publicat',
      draft: 'Ciornă',
      scheduled: 'Programat',
      seo: 'SEO',
      metaTitle: 'Meta titlu',
      metaDescription: 'Meta descriere',
      metaKeywords: 'Cuvinte cheie (separate prin virgulă)',
      titleRequired: 'Titlul este obligatoriu.',
      deleteCategoryConfirm: 'Ștergi categoria „{name}”? {count} articol(e) vor rămâne fără categorie.',
      deleteArticleConfirm: 'Ștergi articolul „{name}”?'
    },
    settingsPages: {
      homepageSections: 'Secțiuni Homepage',
      interactiveTour: 'Tur Interactiv',
      blog: 'Blog',
      interactiveTourFirstLogin: 'Folosește turul interactiv la prima autentificare',
      interactiveTourAlways: 'Folosește turul interactiv mereu',
      interactiveTourDisplayMode: 'Mod de afișare imagine',
      interactiveTourDisplayContain: 'Încadrată (contain)',
      interactiveTourDisplayCover: 'Umplere (cover)',
      interactiveTourDisplayFullPage: 'Pagină întreagă',
      searchNameEmail: 'Caută după nume sau email',
      ordersFilter: 'Comenzi / Fără comenzi',
      userSettings: 'Setări utilizator',
      generalSettings: 'Setări generale',
      moduleManager: 'Manager module',
      locationSettings: 'Setări locație',
      myProfile: 'Profilul meu',
      users: 'Utilizatori',
      general: 'General',
      companyDetails: 'Detalii Companie',
      printers: 'Imprimante',
      fiscalPrinter: 'Imprimantă fiscală',
      tableManager: 'Manager Mese',
      kioskModule: 'Kiosk',
      qrModule: 'Qr',
      tableZones: 'Manager Zone',
      measurementsUnits: 'Unitati de masura',
      kdsSections: 'Secții',
      paymentGroups: 'Procesatori Plăți',
      companyLocations: 'Locații',
      dateTime: 'Dată și Timp',
      currency: 'Monedă',
      accounting: 'Contabilitate',
      tax: 'Taxe',
      payment: 'Plata',
      orderingMng: 'Management Comenzi',
      loyalty: 'Program Loialitate',
      push: 'Notificări',
      tips: 'Bacșiș',
      integrations: 'Integrări',
      app: 'Aplicație',
      locationGroups: 'Grupuri de Locații',
      locationGroupsName: 'Nume',
      locationGroupsDescription: 'Descriere',
      locationGroupsPhoto: 'Fotografie',
      locationGroupsAdded: 'S-au adăugat noi grupuri de locații',
      locationGroupsUpdated: 'Grupurile de locații au fost actualizate cu succes',
      locationGroupsPicError: 'Nu am putut salva fotografia grupurilor de locații. Încercați din nou mai târziu.',
      locationGroupsDelete: 'Ștergeți grupul de locații',
      locationGroupsAreYouSure: 'Sigur doriți să ștergeți acest grup de locații?',
      locationGroupsSelect: 'Selecteaza grupul de locatii din care face parte:',
      subscription: 'Subscripție',
      myPlan: 'Abonamentul meu',
      infoPages: 'Pagini informative',
      taxLabeling: 'Etichete Taxe',
      deliveryMethods: 'Metode livrare',
      filters: 'Filtre',
      filterProducts: 'Filtre Produse',
      companyWeb: 'Website Companie',
      services: 'Servicii',
      scanner: 'Scanner clienti',
      settings: 'Setări'
    },
    permission: {
      // GENERAL
      general_can_access_dashboard: 'Permite acces la Dashboard',
      general_can_access_clients: 'Permite acces la Clienți',
      general_can_access_orders: 'Permite acces la Comenzi',
      general_can_access_tables: 'Permite acces la Mese',
      general_can_access_reservations: 'Permite acces la Rezervări',
      general_can_access_add_order: 'Permite acces la Adăugare comandă',
      general_can_access_dispatch: 'Permite acces la Livrări',
      general_can_access_kds: 'Permite acces la KDS',
      general_can_access_screens: 'Permite acces la Ecrane',
      general_can_access_pos: 'Permite acces la POS',
      general_can_access_inventory: 'Permite acces la Gestiune',
      general_can_access_catalog: 'Permite acces la Catalog',
      general_can_access_marketing: 'Permite acces la Marketing',
      general_can_access_scan: 'Permite acces la Scanare',
      general_can_access_reports: 'Permite acces la Rapoarte',
      general_can_access_feedback: 'Permite acces la Feedback',
      general_can_access_setings: 'Permite acces la Setări',
      general_can_access_pay: 'Permite acces la Plăți',
      general_can_access_suport: 'Permite acces la Suport',
      general_can_access_price_lists: 'Permite vizualizarea listelor de prețuri',
      // GESTIUNE
      can_access_supplier_orders: 'Gestiune - Access la Comenzi Furnizor',
      can_create_supplier_order: 'Gestiune - Creaza Comenzi Furnizor',
      can_send_supplier_order: 'Gestiune - Trimite Comenzi Furnizor',
      can_receive_supplier_order: 'Gestiune - Receptie Comenzi Furnizor',
      can_validate_supplier_order: 'Gestiune - Valideaza Comenzi Furnizor',
      can_generate_nir: 'Gestiune - Generare Nir',
      can_process_supplier_order: 'Gestiune - Proceseaza Comenzi Furnizor',
      can_generate_aviz: 'Gestiune - Poate genera aviz',
      can_generate_invoice: 'Gestiune - Poate genera facturi',
      can_access_dashboard: 'Gestiune - Access la dashboard',
      can_access_gestiune: 'Gestiune - Access la gestiune',
      can_access_reports: 'Gestiune - Access la rapoarte',
      can_access_settings: 'Gestiune - Access la setari'
    },
    settingUsers: {
      permissions: 'Permisiuni:',
      permissionsGestiune: 'Permisiuni Gestiune',
      permissionsGeneral: 'Permisiuni Generale',
      single: 'utilizator',
      fn: 'Prenume',
      ln: 'Nume',
      email: 'Email',
      phone: 'Telefon',
      active: 'Program Activ',
      scheduleStatus: 'Programul este:',
      scheduleActive: 'activ',
      scheduleInactive: 'inactiv',
      username: 'Nume utilizator',
      program: 'Alege programul',
      lang: 'Limba interfață',
      langMsg: 'Acesta este limba în care vei vedea panoul de administrare.',
      avatar: 'Avatar',
      role: 'Rol',
      locations: 'Access la comenzi din locatiile',
      locations_helptext: 'Important: In cazul in care nu sunt selectate locatii, utilizatorul va avea acces la toate locatiile.',
      resetPass: 'Resetează Parolă',
      password: 'Parolă',
      pass: 'Parolă',
      confPass: 'Confirmă Parolă',
      userAdded: 'Utilizator nou adăugat cu succes',
      userUpdated: 'Utilizator actualizat cu succes',
      userPicError: 'Avatarul utilizatorului nu a fost salvat, te rugăm să încerci mai târziu.',
      USER: 'USER',
      DRIVER: 'DRIVER',
      OWNER: 'OWNER',
      LOCATION_ADMIN: 'LOCATION ADMIN',
      MARKETER: 'MARKETER',
      OPERATOR: 'OPERATOR',
      KDS_OPERATOR: 'KDS OPERATOR',
      USER_CUSTOM: 'Utilizator Custom',
      DISPATCHER: 'DISPATCHER'
    },
    settingTable: {
      'use_tips': 'Foloseste Bacsis',
      'yumm_integration_external_ip': 'Ip extern integrare Yumm',
      onlineQrTitle: 'QR comandă online',
      onlineQrDesc: 'Cod QR care deschide comanda online pentru această masă.',
      onlineQrEmpty: 'Încă nu a fost generat un QR online.',
      onlineQrGenerate: 'Generează QR',
      onlineQrRegenerate: 'Regenerează QR',
      onlineQrCopy: 'Copiază linkul',
      'all': 'Toate',
      'activ': 'Activ',
      'inactiv': 'Inactiv',
      'as_useer': 'Ca Utilizator',
      'series': 'Serie Comanda',
      'start_number': 'Numar de start Comanda',
      'allow_maps': 'Harti Mese',
      'use_table_maps': 'Foloseste harti mese',
      'disable_eat_in': 'Opreste Eat In',
      'disable_delivery': 'Opreste Delivery',
      'disable_pick_up': 'Opreste Pick Up',
      'disable_drive_in': 'Opreste Drive In',
      allDeliveryMethodsDisabled: 'Cel puțin o metodă de livrare trebuie să rămână activă (Eat In, Delivery, Pick Up sau Drive In).',
      'default_method': 'Metoda Default',
      'default_sort_checkout_buttons': 'Ordoneaza primele 4 butoane din checkout',
      'disable_tips': 'Opreste Tips',
      'disable_ballance': 'Opreste Balance',
      'auto_print_receipt': 'Printează nota de plată automat',
      'auto_print_receipt_on_metods': 'Printează nota de plată automat pt metodele',
      'auto_print_receipt_on_status': 'Printează nota de plată automat pentru statusurile',
      allowClosingOrdersWithoutReceipt: 'Permite închiderea comenzilor fără bon fiscal',
      'allow_close_order_without_receipt': 'Permite închiderea comenzilor fără bon fiscal',
      'allow_closing_orders_without_driver': 'Permite închiderea comenzilor fără șofer',
      'comment_for_virament': 'Comentariu pentru virament',
      'stop_print_section': 'Opreste printarea pe sectii',
      'close_order': 'Inchide Comenzile cu status delivered tot timpul',
      'set_logged_user_in_reports': 'Filtrează rapoartele după utilizatorul autentificat',
      'disable_seats': 'Dezactiveaza aparitia popupului cu numarul de locuri la masa',
      'disable_pager': 'Dezactiveaza aparitia popupului cu numarul de pager',
      'block_z_until_all_orders_fiscalized': 'Blocheaza Z pana toate comenzile sunt fiscalizate',
      'allowed_fiscal_payment_methods': 'Metode de plată fiscale permise',
      'allow_fiscal': 'Permite fiscalizarea',
      'allow_change_payment_type_on_fiscalization': 'Permite schimbarea tipului de plată la fiscalizare',
      'use_block_actions_after_print': 'Blochează acțiunile după printare',
      'auto_print_fiscal_on_status': 'Selecteaza statusurile pentru care vrei auto fiscalizare',
      'auto_print_fiscal_on_source': 'Selecteaza sursele pentru care vrei auto fiscalizare',
      'auto_print_fiscal_on_payment_methods': 'Selecteaza metodele de plata pentru care vrei auto fiscalizare',
      'auto_print_fiscal_on_payment_methods_help': 'Fiscalizarea automată necesită cel puțin o sursă și un status selectat. Comanda trebuie să corespundă ambelor selecții. Fără metode de plată selectate, sunt incluse toate metodele pentru acele surse și statusuri.',
      'disable_required_options': 'Opreste Validarea optiunilor',
      'is_manager': 'Este Manager',
      'table_for_one_user': 'Masa este atribuită primului utilizator',
      'pos_allow_order_change_status': 'Permite schimbarea de status pe comenzi',
      'pos_allow_reports': 'Permite filtrarea rapoartelor',
      'pos_allow_approvals': 'Permite aprobarea actiunilor',
      'pos_allow_advanced_settings': 'Permite setări avansate',
      'pos_allow_advanced_settings_info': 'exemplu: ștergerea comenzilor mai vechi de 2 zile',
      'pos_allow_access_reports': 'Permite accesul la rapoarte',
      'bank_terminal': 'Terminal Bancar',
      'has_bank_terminal': 'Are terminal bancar conectat (FiscalNet)',
      'has_integrated_bank_terminal': 'Are terminal bancar propriu conectat',
      'sound_new_order': 'Activează sonerie pentru comenzi noi',
      'sound_notification': 'Activează sunet pentru notificări',
      'sync_products_from_all_locations': 'Sincronizează produsele din locatiile setate',
      'sync_location_ids': 'Locații de sincronizat',
      'is_dispatch': 'Mod dispatch',
      'menu_orientation': 'Orientarea meniului',
      'vertical': 'Vertical',
      'horizontal': 'Orizontal',
      'allow_tables_access_only_if_assigned': 'Masa nu poate fi utilizată fără un utilizator atribuit',
      'use_fiscal_net_at_modern_payment': 'Folosește FiscalNet la Plata Modernă',
      'allow_bank_transfer': 'Permite plată prin Virament Bancar',
      'pos_allow_transfer': 'Permite Transfer',
      'pos_allow_waiter_transfer': 'Permite transfer ospătar',
      'pos_allow_table_transfer': 'Permite transfer masă',
      'pos_allow_staff_food': 'Permite plată pentru Mâncare Personal',
      'allow_some_top_categories': 'Permite doar câteva categorii de top pentru acest utilizator',
      'allow_some_top_categories_map': 'Permite doar câteva categorii de top pentru aceasta harta',
      'staff_food_daily_budget': 'Buget zilnic mâncare personal',
      'pos_allow_discount': 'Accepta Discount',
      'pos_allow_storno': 'Permite Storno',
      'pos_allow_refund': 'Permite Refund',
      'allow_access_all_tables': 'Permite accesul la toate mesele',
      'allow_change_driver': 'Permite schimbarea șoferului',
      'allow_print_note': 'Permite note de plată',
      'not_allowed_order_statuses': 'Statusuri de comandă nepermise',
      'pos_allow_mobile_pos': 'Accepta Pos Mobil',
      'pos_allow_plata_moderna': 'Accepta Plata Moderna',
      'pos_allow_protocol': 'Accepta Protocol',
      'pos_allow_glovo': 'Accepta Glovo',
      'pos_allow_bolt': 'Accepta Bolt',
      'pos_allow_wolt': 'Accepta Wolt',
      'pos_allow_tips': 'Accepta Bacșiș',
      'pos_disable_cancel_order': 'Dezactivează anularea comenzii',
      'pos_filter_status_orders': 'Alege statusurile care vrei sa fie selectate default pt comenzii',
      'email': 'Email',
      'lastname': 'Nume',
      'firstname': 'Prenume',
      'login_code': 'Login Code (unique 4 digits)',
      'login_code_already_used': 'Acest cod de autentificare este deja folosit.',
      'lock_screen_timeout_min': 'Durata pentru blocarea ecranului (minute)',
      'round': 'Rotund',
      'squere': 'Patrat',
      'table_shape': 'Forma',
      'deleteZoneTitle': 'Ești sigur?',
      'deleteZoneTxt': 'Prin această acțiune vor fi șterse toate mesele și kioskurile care aparțin acestei zone împreună cu setările de disponibilitate ale acestora!',
      'app_available': 'Disponibilă pentru rezervare',
      'min_pers': 'Numărul minim de persoane',
      'max_pers': 'Numărul maxim de persoane',
      'with_open_order': 'Comanda deschisa',
      'with_split_pay': 'Plateste separat',
      'tableSave': 'Salvat cu success',
      'short_spv': 'Valoare SPV',
      'short': 'Prescurtare',
      'name': 'Nume',
      'number': 'Nume masă',
      'kioskName': 'Nume Kiosk',
      'offlineLoginCode': 'Cod login:',
      'location': 'Locație',
      'type': 'Tip',
      'zone': 'Zonă',
      'maps': 'Harti Mese',
      'loginCode': 'Cod Logare',
      'printOrder': 'Printeaza bonul de comanda:',
      'posSet': 'Setări Pos',
      'fiscalSet': 'Setări Imprimantă Fiscală',
      'use_pager': 'Cu Pager',
      'use_methods': 'Activeaza metodele la kiosk (Pickup, eat in)',
      'kiosk_offline': 'Kiosk offline',
      'kioskVideo': 'Video kiosk (rulează pe ecranul de start)',
      'kioskVideoHint': 'MP4 sau WEBM, max 50MB. Salvează kioskul după upload.',
      'kioskVideoTooBig': 'Video-ul poate avea maxim 50MB',
      'kioskVideoUploaded': 'Video încărcat. Salvează kioskul ca să se aplice.',
      'kioskVideoRemove': 'Șterge',
      'kioskVideoHintAuto': 'MP4 sau WEBM, max 50MB. Video-ul se salvează automat pe kiosk după upload.',
      'kioskVideoSaved': 'Video încărcat și salvat pe kiosk.',
      'kioskVideoRemoved': 'Video șters.',
      'qr_offline': 'QR offline',
      'qrSettings': 'Setări QR',
      'qrGeneralSettings': 'Detalii generale',
      'qrConnectionSettings': 'Conexiune offline',
      'qrServiceSettings': 'Setări service',
      'qrCapacitySettings': 'Capacitate și disponibilitate',
      'qrNumberingSettings': 'Numerotare documente',
      'qrPaymentMethods': 'Metode de plată QR',
      'qrPaymentMobilePos': 'POS mobil',
      'qrPaymentCard': 'Card',
      'qrPaymentBankTerminal': 'Terminal bancar',
      'qrPaymentDirectConnection': 'Legat direct',
      'qrPaymentMode_online': 'QR online',
      'qrPaymentMode_offline': 'QR offline',
      'qrPaymentType_CASH': 'Numerar',
      'qrPaymentType_POS': 'POS mobil — fără declanșare terminal',
      'qrPaymentType_CARD_POS': 'POS mobil — declanșare terminal',
      'qrServiceCode': 'Cod mod service',
      'reloadAllKiosks': 'Reload all kiosks',
      'reload': 'Reload',
      'reloadPending': 'Reload în așteptare',
      'kiosksWillReloadNextOrder': 'Kioscurile isi vor face reload la urmatoarea comanda!',
      'use_cash_machine': 'Cu Cash Machine',
      'disable_cash_payment': 'Dezactivează plata cash',
      'kiosk_is_using_fiscal_receipt_for_sections': 'Chioșcul folosește imprimanta fiscala pentru secții',
      'without_OrderFormFlags': 'Fara comenzile din:',
      'use_fiscal_net': 'Cu FiscalNet',
      'use_fiscal_net_with_pos': 'Pos cu FiscalNet',
      'printerSet': 'Setări Imprimantă',
      'server_ip': 'IP server',
      'server_port': 'Port server',
      'terminal_port': 'Port terminal',
      'ip': 'Ip',
      'port': 'Port',
      'host': 'Host',
      'p1': 'Adr1',
      'p2': 'Adr2',
      'kioskUrl': 'Descarcare installer Kiosk',
      'disableAuth': 'Oprește POS',
      'disableAuthInfo': 'POS-ul nu va mai funcționa până la efecutarea unei noi instalări',
      'disableAuthScreen': 'Oprește Ecran',
      'disableAuthScreenInfo': 'Ecranul nu va mai funcționa până la efecutarea unei noi instalări',
      'printerIp': 'IP și Port Imprimantă',
      'printerIpExample': 'ex. 127.0.0.1:8080',
      'serverIp': 'Ip server',
      'serverIpExample': 'ex. 192.168.1.100',
      'waiters': 'Ospătari',
      'dispalyProductsImage': 'Afișează imaginile produselor',
      'assignWaiter': 'Alege ospătari',
      'allowPosUseCoupons': 'Verifică cupoanele active în timp real',
      'posSetClientOnOrder': 'Întreabă clientul dacă are cont',
      'pos_confirm_order_close_on_method_select': 'Confirmă închiderea și fiscalizarea comenzii la selectarea metodei de plată',
      'posDisplayAllProductOptions': 'Afișează toate opțiunile pe produs',
      'posDefaultCourseCount': 'Numărul de feluri',
      'posAllowGroupProducts': 'Permite gruparea produselor identice în comandă',
      'forceCreditForIntegrationCashOrders': 'Forțează „Credit” pentru comenzile din integrări plătite în „Numerar”',
      'posUseYummVoucher': 'Folosește voucher YUMM',
      'posUseStock': 'Folosește stoc pe POS',
      'posAskStornoBackInStock': 'Întreabă dacă produsele se pun înapoi pe stoc la storno',
      'pos_keep_first_waiter_id_order_split': 'Păstrează ID-ul primului ospătar la împărțirea comenzii',
      'posDisplayTipsOnOrder': 'Afișează bacșișurile pe comandă',
      'searchTable': 'Caută mese după nume',
      externalId: 'ID extern',
      externalIdPlaceholder: 'Referință externă (ex. POS sau integrare)',
      group_tables_users: 'Mese și utilizatori',
      group_order_types: 'Tipuri de comandă',
      group_closing_orders: 'Închiderea comenzilor',
      group_payments: 'Plăți și terminale',
      group_fiscal_printing: 'Fiscalizare și tipărire',
      group_display: 'Afișare și interfață',
      group_reports: 'Rapoarte',
      fiscalPrinter: 'Imprimantă fiscală',
      cantar: 'Cântar'
    },
    referalSettings: {
      'inactive_loyalty': 'Vă rugăm să activați punctele de fidelitate!',
      'points_handle': 'Cum sa fie adaugate punctele',
      'only_referal': 'Numai punctele pentru modul recomandări',
      'only_fidelity': 'Numai punctele de fidelitate',
      'both_points': 'Ambele puncte',
      'higher_point': 'Doar valoarea mai mare',
      'initial_parent_percentage': 'Procentaj din prima comandă pentru persoana care recomandă',
      'initial_order_percentage': 'procent din comanda',
      'initial_child_percentage': 'Procentaj din prima comandă pentru persoana recomandată',
      'order_count': 'Pentru câte comenzi se aplică beneficiile (în afară de prima comandă)',
      'order_count_info': 'Dacă nu este completat, numărul de comenzi este nelimitat.',
      'order_values': 'Procentaj după prima comandă',
      'parent_order_percentage': 'Procentaj din comandă pentru persoana care recomandă',
      'parent_order_percentage_info': 'Dupa prima comanda ce procentaj din comanda se aplica',
      'child_order_percentage': 'Procentaj din comandă pentru persoana recomandată',
      'parent_receive_points': 'Beneficii și pentru persoana care este recomandată'
    },
    addOrder: {
      toGo: 'La Pachet',
      commentTitle: 'Adaugă comentariu',
      choosePay: 'Alege metoda de plată',
      'areYouSureDelete': 'Ești sigur că vrei să ștergi?',
      'adressDeleted': 'Adresă ștearsă cu succes',
      'titleClient': 'Detalii client',
      'titleMethod': 'Metoda livrare',
      'titleLocation': 'Locație',
      'titleAdress': 'Adresă livrare',
      'titleStatus': 'Status',
      'done': 'Gata',
      'datepicker': 'Alege data de livrare',
      'hourpicker': 'Alege ora de livrare',
      'how_many': 'Pentru cate persoame se face rezervarea',
      'tags': 'Comanda din',
      'fromTable': 'Pentru: ',
      'titlePopupTip': 'Adauga Valoarea',
      'btnPopup': 'Adauga',
      'titlePopupPriceModify': 'Editare pret produs',
      'titlePopupCoupon': 'Adauga cupon',
      'errorPopupCoupon': 'Cupon gresit',
      'freeCouponProductAdded': 'Produs gratuit adăugat în coș: {products}',
      'errorProduct1': 'Produsele nu mai sunt disponibile și au fost șterse din coș',
      'errorProduct2': 'Unul sau mai multe produse nu mai sunt disponibile și au fost șterse din coș',
      'errorProduct3': 'Trebuie sa aveti produse in cos pentru a putea comanda!',
      'errorProduct4': 'Te rugam sa selectezi metoda si locatia',
      'errorProduct5': 'Te rog adauga un client',
      'errorProduct6': 'Metoda de plata neselectata',
      'errorProduct7': 'Te rog adauga o adresa',
      'errorProduct8': 'ERROR, Va rugăm să verificați imprimantă fiscală și dispozitivul bancar POS!',
      'add': 'Adaugă',
      'edit': 'Editează',
      'total': 'TOTAL',
      'infosup': 'Adaugă informații suplimentare',
      'state': 'Județ',
      'city': 'Oraș',
      'adress': 'Bloc, scară, etaj, apartament',
      'number': 'Număr',
      'street': 'Strada',
      'adressname': 'Nume Adresa',
      'sexf': 'Feminin',
      'sexm': 'Masculin',
      'sex': 'Sex',
      'birthdate': 'Data nașterii',
      'contactperson': 'Persoana de contact',
      'newclient': 'Adaugă un client',
      'newadress': 'Adaugă sau alege adresa ',
      'save1': 'Alege și salveaza modificarile',
      'deliveryAdress': 'Adaugă o adresa nouă',
      'deliveryAdressEdit': 'Editează adresa',
      'prodId': 'ID / Cod Client',
      'firstName': 'Prenume',
      'lastName': 'Nume',
      'contactPers': 'Persoana de contact',
      'clientSelected': 'Client selectat',
      'clearFields': 'Gloeste Campurile',
      'addAdress': '+ Adaugă adresă',
      'existingClient': 'Comandă trimisa din',
      'orderNow': 'Plasează Comanda',
      'editOrderNow': 'Finalizează editarea',
      'POS': 'Pos',
      'pos': 'Pos',
      'cash': 'Cash',
      'free': 'Gratis',
      'protocol': 'Protocol',
      'coment': 'Comentariu Comandă',
      'client_notif': 'Acest text se va trimite clientului',
      'addTip': 'Adaugă bacșiș',
      'removeTip': 'Sterge bacșiș',
      'addCoupon': 'Adaugă cupon de reducere',
      'removeCoupon': 'Sterge cupon de reducere',
      'modif': 'modifică',
      'freeProd': 'Produs Gratuit',
      'partialPay': 'Editare Pret',
      'info': 'Info',
      'orderDet': 'Detalii',
      'cartDet': 'Sumar comanda',
      'fast': 'Cat mai rapid',
      'selectHour': 'Selecteaza ora',
      'selectPayment': 'Selecteaza metoda de plata',
      'pleaseSelectMethodAndLoc': 'Va rugam sa selectati metoda si locatia!',
      'locSelect': 'Selectati o locatie',
      'searchProduct': 'caută produse',
      'phone': 'Telefon',
      'email': 'E-mail',
      'inlocation': 'In Locatie',
      'glovo': 'Glovo',
      'tazz': 'Tazz',
      'bolt': 'Bolt',
      'wolt': 'Wolt',
      'application': 'Aplicatie',
      'online': 'Online',
      'adressNotInRange': 'Esti prea departe, te rog schimba adresa!',
      'adressNotCorect': 'Adresa nu este corecta',
      'noClient': 'Comanda fara client',
      'other': 'Altele'
    },
    settingCompany: {
      authAppCode: 'Cod autentificare in Locatie',
      generateAuthAppCode: 'Genereaza code',
      purchase_limit_interval_hours: 'Disponibilitate interval limită de achiziție în ore',
      integrators_department: 'Taxe Integratori',
      integrators_tax_vat_printer_id: 'ID imprimantă TVA',
      other_taxes_vat_printer_id: 'ID imprimantă pentru corecții',
      donation_vat_printer_id: 'ID imprimantă pentru donații',
      vatPrinterIdColumn: 'ID imprimantă',
      integrators_tax_vat_amount: 'Valoarea TVA-ului',
      integrators_department_id: 'ID departament',
      title: 'Companie',
      location: 'Locație',
      name: 'Nume',
      selfOrderDomain: 'Self Ordering Domain',
      appLink: 'Link Aplicatie',
      appLinkAndroid: 'Android link aplicatie',
      appLinkIos: 'Ios link aplicatie',
      lang: 'Limba aplicație',
      bussLoc: 'Locație local',
      deliveryLabels: 'Status metode de livrare',
      deliveryType: 'Metoda de livrare',
      pick_up: 'Ridicare comandă',
      meet_half: 'Ne întâlnim la jumătate',
      delivery: 'Livrare',
      eat_location: 'Rezervare masă',
      self_ordering: 'Self Ordering',
      phone: 'Telefon',
      street: 'Stradă',
      number: 'Nr.',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      email: 'Email',
      city: 'Oraș',
      country: 'Țară',
      state: 'Județ',
      availableDaysHrs: 'ZILE ȘI ORE DISPONIBILE',
      from: 'de la',
      to: 'până la',
      preOrder: 'pre-comandă de la',
      allowPreOrder: 'Permite Pre-comandă',
      cardPaymentDetails: 'Setari plată cu cardul',
      paylikeKeys: 'Chei utilizate pentru Paylike',
      posDiscount: 'POS id pentru discount',
      userTaxes: 'TAXE UTILIZATE',
      noTaxMsg: 'Info: Ai făcut modificări la taxe, nu uita să le salvezi.',
      areYouSureDelete: 'Ești sigur că dorești să ștergi această locație? Această acțiune va șterge, de asemenea, setările de comandă pentru această opțiune.',
      pickLocationToCopy: 'Alege locația de la acre vrei să copiezi produsele',
      areYouSureTax: 'Sigur dorești să elimini această taxă din lista impozitelor? Nu uita să salvezi modificările făcute!',
      areYouSureVat: 'Sigur dorești să elimini această cotă din lista TVA? ',
      companyUpdated: 'Datele companiei au fost actualizate cu succes',
      locationUpdated: 'Datele locației au fost actualizate cu succes',
      updateError: 'Datele nu au fost salvate. Vă rugăm să verificați din nou datele introduse!',
      companyProdCopied: 'Produsele au fost copiate cu success.',
      companyProdAddLoc: 'Locatie adaugata pe produse cu succes.',
      copyBtn: 'Adauga locatii pe produse',
      companyProdDeleted: 'Produsele au fost sterse cu success.',
      areYouSureDeleteProd: 'Ești sigur că dorești să ștergi toate produsele din locație?',
      wrongAddress: 'Adresa locației "{location}" nu este corectă.',
      deleteLocationValidation: 'Această locație nu se poate șterge pentru ca este folosită pe produse sau opțiuni.',
      email_feedback: 'Adrese de e-mail pentru a primi feedback din aplicaţii',
      email_feedback_helptext: 'Puteți folosi mai multe adrese separata prin virgulă.',
      printSettings: 'Setari printare',
      automatPrintOrder: 'Printare web automată A4',
      autoSendOrderToPrinter: 'Printare comandă imprimantă 80 mm',
      autoPrintLocalServer: 'Printare automată nota de secție de pe serverul local (comenzi noi sau în procesare)',
      printerIp: 'IP/Host Imprimantă',
      printerPort: 'Port Imprimantă',
      hostname: 'Hostname (pc)',
      printerName: 'Nume Imprimanta (din windows)',
      printer_is_usb: 'Este pe USB',
      copyProductsFrom: 'Copiază produse din ',
      deleteProducts: 'Șterge toate produsele din această locație',
      menuActions: 'Acțiuni meniu',
      overEighteen: 'Restricționarea utilizatorilor sub 18 ani (necesară pentru vânzarea de alcool prin aplicație)',
      setRadiusArea: 'Setează rază de livrare',
      setDrawArea: 'Setează rază desenată de livrare',
      jump_to_menu: 'Sari direct la meniu',
      jump_to_categories_menu: 'Permite accesarea directă a meniului din aplicație, înaintea metodelor de livrare.',
      allow_fiscal_print: 'Permite printarea bonurilor fiscale.',
      payment_btns_v2: 'Butoane de payment V2',
      pos: 'POS',
      use_pos_notifications: 'Folosește notificări POS',
      use_clients_offline: 'Folosește clienți offline',
      use_gift_card_on_pos: 'Folosește card cadou în POS',
      app: 'App',
      use_interactive_tour_always: 'Folosește turul interactiv mereu',
      use_interactive_tour_first_login: 'Folosește turul interactiv la prima autentificare',
      force_location_from_deeplink: 'Forțează locația din deeplink-uri',
      just_card_txt_to_kiosk: 'Text doar card pe Kiosk',
      table_scroll_menu_horizontal: 'Scroll meniu orizontal',
      add_packing_method_to_comment: 'Adaugă metoda de servire (în locație / la pachet) în comentariul comenzii pe Kiosk',
      useProdTimeOpt: 'Foloseste optiuni de timp pentru produse (doar pentru metoda de rezervare)',
      allowPlaceUntilCloseHour: 'Permite plasare comenzi până la ora închiderii',
      sortProductsMethods: 'Metode de sortat produse',
      alphabetic_asc: 'După nume ascendent',
      alphabetic_desc: 'După nume descendent',
      price: 'După preț',
      custom: 'Custom',
      infoCustomSort: '(sortarea custom este facută pe fiecare categorie în secțiunea de editare)',
      filters: 'Filtre',
      allowSoundAtStatusNew: 'Permite sunet de atenționare la comenzi cu status NOU',
      addStatusOnHold: 'Permite statusul In Asteptare',
      addStatusPostponed: 'Permite statusul Amânare',
      removeTotalsExtrasFromDiscount: 'Nu aplica discount si din taxe',
      useGrandTotalForDeliveryZoneShippingCost: 'Aplică costul de livrare pe baza valorii finale a comenzii',
      allowSoundAtStatusProcessing: 'Permite sunet de atenționare la comenzi cu status PROCESATĂ',
      allowSoundAtStatusProcessingV1: 'Permite sunet in funcție de timpul implicit de așteptare',
      allowSoundAtStatusProcessingV2: 'Permite sunet in funcție de 1/4 din timpul implicit de așteptare',
      allowSoundAtStatusProcessingV3: 'Permite sunet in funcție de 1/2 din timpul implicit de așteptare',
      allowSoundAtStatusProcessingV0: 'Fără sunet',
      allowToOrderUnderMinValueWithCoupon: 'Permite plasarea de comenzi sub valoarea minimă, când este aplicat un cupon',
      flagFastOrderFromAdmin: 'Comanda in locatie rapida',
      allowSoundForMehods: 'Permite sunet pentru următoarele metode de livrare',
      generateQrMenu: 'Pentru a genera coduri QR actualizati',
      generateClientViewLink: 'Pentru a genera link-urile actualizati',
      generateQrMenuSettings: 'locațiile companiei',
      email_transport: 'Email transport',
      lateOrders: 'Comnezi întârziate',
      tipSuggestion: 'Sugesti Bacsis',
      reorderPopupTitle: 'Popup comandă (meniu QR)',
      reorderPopupMinutes: 'Minute de inactivitate până la afișarea popup-ului',
      reorderPopupHelp: '0 sau gol dezactivează popup-ul. Nu apare pe kiosk. Apare doar dacă există cel puțin un produs în coș.',
      kioskQrSettingsTab: 'Setări Kiosk/QR',
      kioskSettingsTitle: 'Setări Kiosk/Qr',
      kioskUsingTopCategoryLabel: 'Folosește categoriile principale',
      kioskUsingTopCategoryHelp: 'Când este activat, meniul este grupat pe categorii principale la detalii, kiosk și QR.',
      kioskFiscalReceiptForCashLabel: 'Kiosk-ul folosește bon fiscal pentru numerar',
      kioskNonFiscalReceiptForCardLabel: 'Kiosk-ul folosește bon nefiscal pentru card',
      kioskAddToCartNotificationPositionLabel: 'Poziția notificării la adăugarea produsului în coș',
      kioskAddToCartNotificationPositionPopup: 'Pop-up',
      kioskAddToCartNotificationPositionSidebar: 'Bară laterală',
      tipSuggestionType: 'Tip',
      tipSuggestionSuggestion: 'Sugestia',
      discountSuggestion: 'Sugestie Discount',
      discountSuggestionType: 'Tip',
      discountSuggestionSuggestion: 'Sugestia',
      discountSuggestionFix: 'Fix',
      discountSuggestionProc: 'Procent',
      twilio_call: 'Amintește-mi de comenzile întârziate prin apel telefonic',
      twilio_call_early_mark: 'Amintește-mi în primele 5 minute',
      transport_setings: 'Setari Transport',
      google_maps_api_key: 'Cheie google API',
      deliveryMethodsReflect: 'Actualizările metodelor de livrare trebuie să se reflecte în',
      locationGroups: 'grupurile de locații',
      automatedProcessedStatus: 'Setează automat statusul comenzii din "Nou" in "Procesată"',
      donationPointValue: 'Paritate puncte donatie',
      donationPointValueNr: '(loyalty * thisValue = donationPoints)',
      alertMultipleOrders: 'Alerta pentru comenzi per ora',
      alertMultipleOrdersNr: 'Numar de comenzi per ora',
      smsoToken: 'Token',
      smsoSender: 'User ID',
      smsoTokenExtern: 'Token Extern',
      smsoSenderExtern: 'User ID Extern',
      locationImage: 'Imaginea Locației',
      holidayTitle: 'Orar de vacanță',
      holidayAlert: 'Zilele din metodele de livrare se dezactivează/reactivează automat în funcție de intervalul orarului de vacanță.',
      holidayEnabled: 'Activat',
      holidayValidFromTo: 'Valabil de la - până la',
      apiKey: 'Cheie API',
      cif: 'CIF',
      addToCC: 'Adaugă-mă la CC',
      automatedInvoice: 'Emite factura automat',
      invoicePerOrder: 'Emitere Factura pe Comandă',
      series: 'Seria Facturii',
      sendInvoice: 'Trimite Factura',
      openInvoice: 'Deschide Factura',
      use_auto_dispatch: 'Mod automat',
      newOrdersProcessing: 'Procesează comenzi noi',
      autoGroupingByZone: 'Grupare automată după zonă',
      preparedStatus: 'Statusul "Preparată"',
      autoModeText: 'Sistemul este acum în modul automat. Comenzi vor fi primite, procesate și organizate automat în loturi pe baza zonelor geografice. Odată batch-uite, sistemul va aloca livrările la cel mai apropiat livrator disponibil, asigurând o distribuție eficientă și la timp a comenzilor.',
      manualModeText: 'Sistemul este acum în modul manual. Comenzi vor fi procesate individual de un operator uman. Acest lucru include primirea comenzilor, organizarea lor în loturi pe baza zonelor geografice și manual atribuirea livrărilor la cel mai apropiat livrator disponibil pentru a asigura o distribuție optimă.',
      assignOrderToDriver: 'Atribuie comanda unui livrator',
      drivers: 'Drivers',
      unavailableRestaurantTitle: 'Aplicație Indisponibilă',
      unavailableRestaurantText: 'Mesaj',
      unavailableRestaurantImage: 'Imagine',
      unavailableRestaurantTextPlaceHolder: 'Acest mesaj va fi afișat utilizatorilor atunci când nici o locație nu are cel puțin o metodă de livrare activată',
      digitalWaiter: 'Ospătar Digital',
      invoices: 'Facturi',
      printer: 'Imprimantă',
      menuIntegration: 'Integrare',
      orderStatus: 'Status comandă',
      smsoIntegration: 'Integrare SMSO',
      languages: 'Limbi disponibile',
      preferences: 'Preferințe',
      appQRCode: 'Cod QR Aplicație Mobilă',
      digitalWaiterMode: 'Mod Meniu QR',
      allowOpenOrderLabel: 'Mod comandă deschisă',
      allowOpenOrderHelp: 'Activează modul comandă deschisă de pe meniul QR, permițând clienților să adauge la aceeași comandă în mai multe reprize.',
      paymentGroup: 'Procesator de plată',
      createLocationCost: 'Crearea unei noi locații implică costuri suplimentare. Dorești să continui?',
      activateLocationCost: 'Activarea unei noi locații implică costuri suplimentare. Dorești să continui?',
      closeOrders: 'Închide toate comenzile cu {deliveryMethod}',
      closeOrdersAfter: 'după x ore',
      closeOrdersAt: 'la ora selectată',
      autoChangeStatus: 'Schimba statusul automat pentru comenzile cu {deliveryMethod}',
      otherSettings: 'Alte setări',
      accessAndVisibility: 'Acces si vizibilitate',
      measurements_units_id: 'Unitate de masura',
      quantitative_unit: 'Unitate Cantitativa',
      reportProductOptionTitle: 'Raport Produse si Optiuni',
      email__prod_opt_report: 'Adresa email unde se va trimite raportul',
      time__prod_opt_report: 'Ora la care se va trimite raportul',
      inv_company_name: 'Denumire firmă',
      inv_fiscal_code: 'Cod fiscal',
      inv_trade_register: 'Reg comerțului',
      inv_phone: 'Telefon',
      inv_email: 'E-mail',
      inv_country: 'Tara',
      inv_address: 'Strada',
      inv_street_number: 'Numar',
      inv_county: 'Județ',
      inv_city: 'Localitate',
      inv_additional_data: 'Date adiționale',
      inv_is_vat_payer: 'Platitor de TVA',
      inv_is_vat_payer_0: 'NU este platitor de TVA',
      inv_is_vat_payer_1: 'ESTE platitor de TVA',
      inv_bank_account: 'Cont bancar',
      inv_bank: 'Banca',
      inv_bank_branch: 'Sucursala',
      initalOrderStatusKiosk: 'Status initial pentru comenzile de la Kiosk',
      initalOrderStatusApp: 'Status initial pentru comenzile din Aplicatie si Web'
    },
    menuSubscriptions: {
      single: 'abonament meniu',
      newTitle: 'Abonament meniu nou',
      noSubscriptions: 'Nu există abonamente de meniuri. Adaugă primul abonament.',
      perDayShort: 'zi',
      durationDays: '{days} zile',
      menusCount: '{count} meniuri',
      defaultMenuShort: 'implicit',
      zonesCount: '{count} zone',
      notReady: 'Nu poate fi vândut încă, lipsesc',
      notReadyHint: 'Completează ce lipsește ca să îl poți activa',
      readyActive: 'Abonamentul este complet și activ (se poate cumpăra).',
      readyInactive: 'Abonamentul este complet. Activează-l ca să poată fi cumpărat.',
      saveFirst: 'Salvează întâi abonamentul',
      active: 'Activ',
      activeAfterMenus: 'Se poate activa după ce adaugi cel puțin un meniu.',
      saved: 'Abonamentul a fost salvat.',
      deleted: 'Abonamentul a fost șters.',
      areYouSureDelete: 'Sigur ștergi abonamentul {name}?',
      tabGeneral: 'General',
      tabDelivery: 'Livrare',
      tabMenus: 'Meniuri',
      tabCalendar: 'Calendar',
      name: 'Nume',
      namePlaceholder: 'ex: Vegan - Prânz',
      nameRequired: 'Numele este obligatoriu.',
      location: 'Locația care pregătește comenzile',
      locationPlaceholder: 'Alege locația',
      locationHint: 'Comenzile zilnice se creează pe această locație; produsele se aleg din meniul ei.',
      locationRequired: 'Alege locația.',
      pricePerDay: 'Preț pe zi',
      pricePerDayHint: 'O porție pentru o zi. Fiecare meniu trebuie să dea exact acest total.',
      priceRequired: 'Prețul pe zi este obligatoriu.',
      duration: 'Durata (zile calendaristice)',
      durationHint: 'Clientul alege data de start (cu maxim {days} zile înainte) și primește livrări în zilele de livrare din această perioadă.',
      durationWeekendHint: 'Dacă punem 30 de zile, dar nu livrăm în weekend, real vor fi aprox. 21 de zile de livrare (depinde cum pică zilele în care nu livrăm).',
      durationEstimate: 'Cu zilele de livrare alese acum: {range} zile de livrare din {days} zile calendaristice.',
      maxSubscribers: 'Maxim abonați activi',
      unlimited: 'Nelimitat',
      maxSubscribersHint: 'Gol = nelimitat.',
      minQuantity: 'Cantitate minimă',
      maxQuantity: 'Cantitate maximă',
      quantityHint: 'Câte porții poate cumpăra clientul (ex: 2 = mâncare dublă în fiecare zi).',
      description: 'Descriere',
      image: 'Imagine',
      imageHint: 'jpg/png, max 5MB',
      deliveryDays: 'Zile de livrare',
      deliveryDaysHint: 'În aceste zile se creează câte o comandă pentru fiecare abonat.',
      deliveryHours: 'Intervale de livrare',
      deliveryHoursHint: 'Clientul alege unul dintre intervale la cumpărare.',
      hoursInvalid: 'Fiecare interval de livrare trebuie să aibă început și sfârșit (începutul înaintea sfârșitului).',
      from: 'De la',
      to: 'Până la',
      addInterval: 'Adaugă interval',
      orderLead: 'Creează comanda cu',
      minutes: 'minute înainte',
      orderLeadExample: 'Ex: pentru livrarea de la {from}, comanda intră în sistem (POS/bucătărie) la {time}.',
      orderLeadExampleDayBefore: 'Ex: pentru livrarea de la {from}, comanda intră în sistem (POS/bucătărie) la {time} cu o zi înainte.',
      zones: 'Zone de livrare',
      zonesPickLocation: 'Alege întâi locația (tab-ul General).',
      noZones: 'Nu există zone de livrare pentru companie sau pentru această locație.',
      zone: 'Zonă',
      zoneDefaultFee: 'Taxa zonei',
      zoneFee: 'Taxa pe livrare',
      companyZone: 'zonă companie',
      locationZone: 'zonă locație',
      zoneInactive: 'inactivă',
      zonesHint: 'Taxa se plătește pentru fiecare livrare. Gol = taxa zonei; 0 = livrare gratuită.',
      fixErrors: 'Completează câmpurile marcate',
      rescaleQuestion: 'Prețul pe zi s-a schimbat. Ajustez proporțional prețurile produselor din cele {count} meniuri ca să dea {price}?',
      rescaleYes: 'Da, ajustează',
      rescaleNo: 'Nu, le ajustez eu',
      dayShort: {
        monday: 'Lu',
        tuesday: 'Ma',
        wednesday: 'Mi',
        thursday: 'Jo',
        friday: 'Vi',
        saturday: 'Sâ',
        sunday: 'Du'
      },
      months: {
        0: 'Ianuarie',
        1: 'Februarie',
        2: 'Martie',
        3: 'Aprilie',
        4: 'Mai',
        5: 'Iunie',
        6: 'Iulie',
        7: 'August',
        8: 'Septembrie',
        9: 'Octombrie',
        10: 'Noiembrie',
        11: 'Decembrie'
      },
      issues: {
        no_location: 'locația',
        no_price: 'prețul pe zi',
        no_delivery_days: 'zilele de livrare',
        no_delivery_hours: 'intervalele de livrare',
        no_zones: 'zonele de livrare',
        no_menu: 'cel puțin un meniu',
        menu_price_mismatch: 'meniuri cu totalul diferit de prețul pe zi ({menus})'
      },
      menusTitle: 'Meniuri',
      menusHint: 'Meniul implicit se livrează în toate zilele fără alt meniu în calendar. Fiecare meniu trebuie să dea {price}.',
      newMenu: 'Meniu nou',
      editMenu: 'Editează meniul',
      noMenus: 'Nu există meniuri. Primul meniu adăugat devine meniul implicit.',
      defaultMenu: 'Implicit',
      makeDefault: 'Fă-l meniul implicit',
      duplicate: 'Duplică',
      totalMismatch: 'total {total} - nu corespunde prețului pe zi',
      upcomingDays: '{count} zile în calendar',
      willAssignDates: 'După salvare, meniul va fi pus pe zilele: {dates}',
      menuName: 'Nume meniu',
      menuNamePlaceholder: 'ex: Luni - săptămâna 1',
      menuNameRequired: 'Numele meniului este obligatoriu.',
      addProducts: 'Adaugă produse',
      searchProducts: 'Caută produs după nume sau ID',
      allCategories: 'Toate categoriile',
      noProductsFound: 'Nu s-au găsit produse.',
      catalogPrice: 'preț catalog',
      catalogPriceHint: 'Preț catalog (orientativ)',
      vat: 'TVA',
      course: 'Fel',
      product: 'Produs',
      quantity: 'Cantitate',
      unitPrice: 'Preț în meniu',
      lineTotal: 'Total',
      noItems: 'Adaugă cel puțin un produs în meniu.',
      productMissing: 'Produsul nu mai există. Înlocuiește-l.',
      putDifferenceHere: 'Pune diferența pe acest produs',
      cannotPutDifference: 'Diferența nu se poate împărți exact la cantitatea acestui produs. Alege un produs cu cantitatea 1.',
      cannotRescale: 'Nu se poate ajunge exact la total cu aceste cantități. Adaugă un produs cu cantitatea 1 sau ajustează manual.',
      menuTotal: 'Total meniu',
      difference: 'Diferență',
      adjustProportionally: 'Ajustează proporțional la {price}',
      priceRuleHint: 'Prețurile din meniu sunt cele care apar pe comandă și pe bonul fiscal. Prețul din catalog este doar orientativ.',
      totalMustMatch: 'Totalul meniului ({total}) trebuie să fie egal cu prețul pe zi ({price}).',
      deleteMenuQuestion: 'Sigur ștergi meniul {name}?',
      deleteMenuDays: 'Cele {count} zile din calendar vor primi meniul implicit.',
      deleteMenuDefault: 'Următorul meniu devine meniul implicit.',
      menuSaved: 'Meniul a fost salvat.',
      menuSavedAssigned: 'Meniul a fost salvat și pus pe zilele selectate.',
      courses: {
        1: 'Felul 1',
        2: 'Felul 2',
        3: 'Felul 3',
        4: 'Desert',
        5: 'Mic dejun',
        6: 'Prânz',
        7: 'Cină',
        8: 'Gustare'
      },
      calendarHint: 'Selectează zilele de livrare și alege meniul lor. Zilele fără meniu ales primesc meniul implicit.',
      calendarCustom: 'Meniu ales',
      calendarDefault: 'Meniul implicit',
      calendarNoDelivery: 'Fără livrare',
      calendarNoDeliveryShort: 'fără livrare',
      calendarNoMenus: 'Adaugă întâi un meniu (tab-ul Meniuri).',
      calendarNoMenu: 'fără meniu',
      calendarSaved: 'Calendarul a fost salvat.',
      selectMonth: 'Selectează toată luna',
      clearSelection: 'Deselectează',
      selectedDays: '{count} zile selectate',
      chooseMenu: 'Alege meniul',
      applyMenu: 'Pune meniul',
      resetToDefault: 'Revino la meniul implicit',
      newMenuForDays: 'Meniu nou pentru aceste zile'
    },
    menuSubscribers: {
      title: 'Abonați',
      offer: 'Abonament',
      allOffers: 'Toate abonamentele',
      customer: 'Client',
      searchPlaceholder: 'Nume, email, telefon sau ID',
      statusLabel: 'Status',
      status: {
        all: 'Toți',
        paid: 'Au plătit',
        active: 'Activi',
        pending: 'Doar au încercat',
        abandoned: 'Abandonați',
        stopped: 'Opriți',
        finished: 'Finalizați'
      },
      empty: 'Nu există abonați.',
      period: 'Perioada',
      portions: '{count} porții',
      portionsLabel: 'Porții',
      deliveries: 'Livrări',
      deliveriesHint: 'livrate / comenzi create / total',
      scheduledCount: '{count} programate',
      cancelledCount: '{count} anulate',
      errorsCount: '{count} cu eroare',
      orderedCount: '{count} comenzi create',
      deliveredOf: '{delivered} livrate din {total}',
      money: 'Bani',
      total: 'Total',
      paid: 'Plătit',
      refunded: 'Returnat',
      refundable: 'Se mai poate returna',
      valueDelivered: 'Valoare livrată',
      valueNotDelivered: 'Valoare nelivrată',
      details: 'Detalii',
      stop: 'Oprește abonamentul',
      stopHint: 'Nu se mai creează comenzi: cele {count} livrări rămase se anulează. Banii nu se returnează automat (folosește Returnează bani).',
      stopConfirm: 'Oprește',
      stopQuestion: 'Sigur oprești abonamentul lui {name}?',
      stopped: 'Abonamentul a fost oprit.',
      refund: 'Returnează bani',
      refundHint: 'Se pot returna maxim {max}. Valoarea livrărilor nefăcute este {notDelivered} (orientativ - suma o alegi tu).',
      amount: 'Suma',
      useSuggested: 'folosește {amount}',
      refundProcessorHint: 'Dacă plata nu e încă decontată la euPlatesc (de obicei în aceeași zi), se poate anula doar integral; o sumă parțială se poate returna după decontare.',
      refundConfirm: 'Returnează',
      refundQuestion: 'Sigur returnezi {amount} clientului?',
      refundDone: 'Suma a fost returnată.',
      reason: 'Motiv',
      reasonPlaceholder: 'Motivul (rămâne în istoric)',
      interval: 'Interval livrare',
      day: 'zi',
      deliveryFee: 'taxă livrare',
      source: 'Cumpărat din',
      address: 'Adresa',
      zone: 'Zona',
      phone: 'Telefon',
      comments: 'Observații',
      stoppedInfo: 'Oprit pe {date} de {user}',
      noDeliveries: 'Nu există livrări (abonamentul nu a fost plătit).',
      date: 'Data',
      menu: 'Meniu',
      deliveryStatus: 'Livrare',
      deliveryStatuses: {
        scheduled: 'Programată',
        order_created: 'Comandă creată',
        cancelled: 'Anulată',
        error: 'Eroare'
      },
      orderAt: 'comanda la {date}',
      order: 'Comanda',
      value: 'Valoare',
      note: 'Notă',
      payments: 'Plăți',
      noPayments: 'Nicio plată.',
      paymentStatuses: {
        created: 'Creată',
        pending: 'Link generat',
        success: 'Plătită',
        failed: 'Eșuată',
        expired: 'Link expirat',
        cancelled: 'Anulată',
        refunded: 'Returnată integral'
      },
      refundStatuses: {
        pending: 'în curs',
        success: 'returnat',
        failed: 'eșuat'
      },
      history: 'Istoric acțiuni',
      noHistory: 'Nicio acțiune.',
      events: {
        stop: 'Oprit',
        refund: 'Returnat'
      }
    },
    crossSell: {
      posSettingsTab: 'Setări POS',
      title: 'Produse cross-sell / upsell',
      help: 'Produsele selectate îi vor fi sugerate operatorului de POS la finalizarea comenzii (checkout).',
      selectedTitle: 'Produse selectate',
      noneSelected: 'Niciun produs selectat încă.',
      searchPlaceholder: 'Caută produse...',
      allCategories: 'Toate categoriile',
      loading: 'Se încarcă...',
      noResults: 'Niciun produs găsit.',
      maxReached: 'Poți selecta cel mult {max} produse.',
      pageInfo: 'Pagina {page} din {pages} ({total} produse)'
    },
    scanner: {
      clientNotFound: 'Clientul nu a fost găsit',
      notEnoughFunds: 'Numărul introdus este prea mare',
      expired: 'Codul a expirat',
      confirm: 'Confirmă',
      wrongInput: 'Numărul introdus nu este valid',
      scanCode: 'Scanează codul QR al clientului'
    },
    settingDateTime: {
      timezone: 'Fus orar',
      timeFormat: 'Formatul de timp',
      dateFormat: 'Formatul de dată',
      saveMsg: 'Setările pentru dată și oră salvate cu succes'
    },
    settingCurrency: {
      currency: 'Moneda localului',
      saveMsg: 'Moneda localului salvată cu succes'
    },
    settingTaxes: {
      single: 'Taxă',
      name: 'Nume',
      type: 'Tip',
      amount: 'Cost',
      notice: 'La "Etichete Taxe" definește doar un nume de etichetă pentru impozitul ce trebuie aplicat. Pentru a defini detaliile fiscale, cum ar fi valoarea sau tipul, trebuie să accesați ',
      notice2: 'detalii companie',
      singleTaxLabel: 'Etichetă Taxă',
      notice3: 'La secțiunea "Taxe Generale" definești taxele care sunt aplicate, valoarea sau tipul acestora, dacă dorești să creezi o etichetă nouă accesează',
      notice4: 'etichete taxe',
      notice5: 'La secțiunea "TVA%" definești cotele TVA incluse in preț, dacă dorești să creezi o etichetă nouă accesează'
    },
    settingsPayment: {
      publicKey: 'Cheie publică',
      privateKey: 'Cheie privată'
    },
    settingsWeb: {
      header_color: 'Culoare background header',
      header_text_color: 'Culoare text header',
      success: 'Detaliile au fost actualizate cu succes',
      fbLink: 'Link Facebook',
      igLink: 'Link Instagram',
      trpLink: 'Link Tripadvisor',
      twitterLink: 'Link Twitter',
      tiktokLink: 'Link Tiktok',
      linkedinLink: 'Link LinkedIn',
      websitePrezentareLink: 'Link Website Prezentare',
      whatsapp: 'Chat WhatsApp',
      gpLink: 'Google Play',
      asLink: 'Apple Store',
      fbPixel: 'Facebook Pixel',
      fbapid: 'Facebook App ID',
      interCol: 'Culoare interfata',
      g4a: 'Integrare GA4',
      site: 'Link website',
      category_proportion: 'Imagine categorie',
      product_proportion: 'Imagine produs',
      background_color: 'Culoare fundal',
      font_product_title: 'Font titlu produs/categorie',
      font_product_description: 'Font descriere produs',
      display_mode: 'Mod afisare',
      display_image_category: 'Afisare imagine categorie',
      social_media: 'Linkuri social media',
      link_app: 'Linkuri aplicatii',
      tracking: 'Analytics',
      design: 'Design aplicatie',
      structure: 'Structura aplicatie'

    },
    settingsOrdering: {
      shipping_department_id: 'ID-ul departamentului de expediere',
      reservation_pay_per_person: 'Plateste pe persoana',
      extraCostRange: 'Extra Cost Range',
      panaLa: 'Pana la: ',
      distanceInKm: 'Distanta in km',
      showTheRestOfTheZones: 'Arata si celelalte zone pe harta',
      copyRangesFromLocation: 'Copiază raze din locație',
      selectLocationToLoadRanges: 'Selectează o locație pentru a încărca razele.',
      location: 'Locație',
      selectLocation: 'Selectează locație',
      ranges: 'Raze',
      min_interval_reservations: 'Durata in minute dintre intervalele posibile pentru rezervare',
      min_standard_reservations: 'Durata unei rezervări (ore)',
      min_between_reservations: 'Durata dintre rezervări (minute)',
      available_days: 'Orar',
      reservation_available_in_app: 'Permite rezervări la masă',
      reservationWidgetTitle: 'Widget rezervări pentru site',
      reservationWidgetHint: 'Copiază scriptul pe site. Company ID, Method ID și token-ul locației se completează automat.',
      reservationWidgetPosition: 'Poziție',
      reservationWidgetLanguage: 'Limbă',
      reservationWidgetHoursToStay: 'Ore de ședere',
      reservationWidgetDefaultPersons: 'Număr implicit de persoane',
      reservationWidgetTableZone: 'Zonă mese',
      reservationWidgetCountryPrefix: 'Prefix țară',
      reservationWidgetRestaurantName: 'Nume restaurant',
      reservationWidgetScript: 'Script de integrare',
      reservationWidgetCopy: 'Copiază scriptul',
      reservationWidgetCopied: 'Copiat',
      reservationWidgetPreview: 'Previzualizare',
      reservationWidgetPosBottomRight: 'Jos dreapta',
      reservationWidgetPosBottomLeft: 'Jos stânga',
      reservationWidgetPosTopRight: 'Sus dreapta',
      reservationWidgetPosTopLeft: 'Sus stânga',
      max_number_seats: 'Capacitate maximă de locuri în locație',
      offnoPreorders: 'Trebuie sa ai offset 0 si period 1 pt a functiona',
      noPreorders: 'Nu aceptam precomenzi',
      isAlwaysOpen: 'Deschis permanent',
      isAlwaysOpenPreorderHours: 'Ore precomandă după miezul nopții',
      reservationTaxesTitle: 'Adaugă program mese',
      reservationTaxesTitleEmpty: 'Niciun program adaugat',
      reservationTaxAdvanceConsumption: 'Acest preț reprezintă avans în consumație',
      infoBoxTitle: 'Adauga informatii extra',
      infoBoxRadioCheck: 'Modifica optiunea',
      infoBoxRadio: 'O singura optiune',
      infoBoxCheck: 'Mai multe optiuni',
      enabled: 'Activat',
      allow_fidelities: 'Permite fidelizarea',
      allow_fidelitiesHelp: 'Necesită fidelizarea activă',
      allow_sms_notifications: 'Permite sms de anuntare client la statusul preparată (*necesita integrare smso activa)',
      paymentOptions: 'Opțiuni de plată',
      paymentOptionsErr: 'Câmpul de opțiuni de plată este obligatoriu.',
      closeOrderAfterHours: 'Valorile posibile sunt între 0 și 23.',
      waitingTime: 'Timpul de așteptare implicit',
      count_orders_starts_from_hour: 'Ora de la care începe numerotarea comenzilor',
      maxDistanceInMeter: 'Distanta in metri pentru raza de accesare masa:',
      minimumOrderValue: 'Comanda minima',
      extraDeliveryTime: 'Timp EXTRA',
      minutes: 'min',
      hours: 'ore',
      shippingCost: 'Cost livrare',
      deliveryRange: 'Rază de livrare',
      deliveryRangeUnit: 'm',
      posId: 'POS ID pentru cost livrare',
      shippingTax: 'Taxe livrare',
      locations: 'Locație',
      selectLocations: 'Selectează sau lasă gol pentru toate',
      street: 'Stradă',
      city: 'Oraș',
      country: 'Țară',
      state: 'Județ',
      availableDays: 'Zile și ore disponibile',
      availableDaysErr: 'Câmpul pentru zilele și orele disponibile este obligatoriu.',
      notice: 'Verifică câmpurile necompletate din cadrul modalităților de livrare active',
      saveSuccess: 'Datele despre detaliile comenzilor au fost salvate cu succes',
      deliveryRules: 'Reguli de livrare',
      addRange: 'Adauga regula',
      shippingCities: 'Localitati',
      shippingNeighborhoods: 'Cartiere',
      citiesValidationError: 'Valorile localitatilor trebuie sa fie unice pentru o regula de livrare.',
      errorAutoChangeStatusAfterMin: 'Valorile posibile sunt între 0 și 360.',
      hourAndDate: 'Ora si Data',
      justDate: 'Doar data',
      deactivateDeliveryHours: 'Dezactivează ora si data',
      offset: 'Offset',
      period: 'Period',
      chooseZone: 'Alege zonă',
      addZone: 'Adaugă zonă',
      newZone: 'Zonă Nouă'
    },
    settingsZone: {
      edit: 'Nume Zona',
      deleteBtn: 'Sterge Zona',
      deleteShape: 'Sterge forma pt a crea una noua',
      overridePayment: 'Suprascrie metoda de plată',
      acceptCash: 'Accept cash',
      acceptCard: 'Accept card',
      acceptPos: 'POS la livrare (neplătit)'
    },
    settingsInfoPages: {
      single: 'pagină',
      noPage: 'Nu s-au adăugat pagini încă.',
      title: 'Titlu Pagină',
      content: 'Conținut Pagină',
      newPage: 'Pagină nouă',
      showInHeader: 'Afișare în header',
      showInFooter: 'Afișare în footer',
      imageSize: 'Mărime imagine',
      imageSizeContain: 'Încadrare',
      imageSizeCover: 'Acoperire',
      imageSizeFullPage: 'Pagină completă',
      addedSuccess: 'Pagină salvată cu succes.',
      deletedSuccess: 'Pagină ștearsă cu succes',
      deleteMsg: 'Ești sigur că dorești să ștergi această pagină?',
      TERMS_CONDITIONS: 'Termeni și Condiții',
      PRIVACY_POLICY: 'Politica de Confidențialitate',
      CONTACT_DETAILS: 'Date Contact',
      FIDELITIES_PROMOTIONS: 'Promoții fidelitate',
      LOYALITY_POINTS: 'Reguli puncte de loialitate',
      DONATION_POINTS: 'Reguli puncte de donat',
      CUSTOM: 'Personalizată',
      ABOUT_US: 'Despre Noi',
      COOKIE_POLICY: 'Politica Cookies'
    },
    settingsRewards: {
      single: 'punct',
      plural: 'puncte',
      state: 'Status',
      points: 'punct(e)',
      moneySpent: 'Suprascriere rată de conversie',
      pointsTo: 'Puncte în Bani',
      // numberOfcurrencyNeedToSpend: 'Suma de bani pe care clientul trebuie să o cheltuiască pentru a câștiga 1 punct.',
      numberOfcurrencyNeedToSpend: 'Număr de puncte primit la fiecare {currency} cheltuit.',
      default: 'Câmpurile goale nu modifică rata de conversie inițială',
      numberOfpointsToReward: 'Suma de puncte de care clientul are nevoie atunci când vrea să plătească folosind puncte.',
      rewardSuccess: 'Datele programului de loialitate salvate cu succes',
      referalActive: 'Modulul de recomandări a fost activat',
      referalInActive: 'Modulul de recomandări a fost dezactivat',
      enableNotifications: 'Activează Notificările',
      notifyUsersLoyaltyPoints: 'Notifică clienții când primesc puncte de fideliate.',
      customizeLoyaltyPointsNotification: 'Personalizează notificarea de ',
      timeInterval: 'Interval orar ',
      fromTime: 'De la ora',
      toTime: 'La ora',
      here: 'aici',
      initialReferal: 'Procent din prima comanda pentru a castiga puncte',
      parentReferal: 'Puncte primite de parinte',
      loyaltyOnlyFullPoints: 'Permite doar puncte întregi',
      loyaltyOnlyFullPointsHelp: 'Rotunjește în jos punctele câștigate pe comandă, după reduceri, folosind ratele de conversie configurate. Fracțiunile de punct nu se reportează. Soldul existent și valoarea punctelor la utilizare rămân neschimbate.',
      loyaltyMinOrderValue: 'Valoarea minimă a comenzii pentru acordarea punctelor de loialitate',
      loyaltyMinOrderValueHelp: 'Valoarea produselor după reduceri, fără livrare și bacșiș. Comenzile sub această valoare nu primesc puncte. Lăsați gol pentru a nu aplica un prag minim.',
      loyaltyPointsAppLimit: 'Numărul maxim de puncte de loialitate permise ca discount pe comandă'
    },
    settingsPushNotif: {
      order_new: 'Mesaj nou comandă',
      order_completed_pickup: 'Mesaj comandă finalizată - Ridicare comandă',
      order_completed_meet: 'Mesaj comandă finalizată - Ne întâlnim la jumătate',
      order_completed_delivery: 'Mesaj comandă finalizată - Livrare',
      order_completed_eat: 'Mesaj comandă finalizată - Rezervare masă',
      order_canceled: 'Mesaj comandă anulată',
      notifUpdated: 'Datele notificărilor prin mesaj salvate cu succes',
      preview: 'Previzualizare',
      time: 'oră',
      dateTime: 'data și ora',
      persons: 'numărul clientului',
      timePrev: '11:30 (în 30 de minute)',
      personsPrev: '3',
      dateTimePrev: 'Marți, 15 februarie 2026, la 18',
      pointsPrev: 'numărul punctelor',
      worthPrev: 'echivalentul punctelor',
      info: '* În cazul în care nu doriți afișarea orei de livrare, lăsați liber ultimul câmp.',
      selectedLocations: 'Locații selectate:'
    },
    settingsTips: {
      tipsLabel: 'Bacșiș',
      tipsTaxes: 'Taxe bacșiș',
      tipsVat: 'TVA bacșiș',
      state: 'Folosește bacșiș',
      tipsSuccess: 'Bacșiș salvat cu succes'
    },
    settingsPlans: {
      plan1Title: 'Lunar',
      plan1Rate: '160Euro / lună',
      plan1Description: 'Începe cu o taxă fixă lunară, indiferent de suma facturată prin aplicație.',
      plan2Title: 'Procentaj vânzari',
      plan2Rate: '10%',
      plan2Description: 'Plătești în funcție de cât vinzi. Alege procentul din vânzări și vei plăti o taxă lunară raportată doar la vânzările tale prin aplicație.',
      current: 'Subscripția actuală',
      switch: 'Schimbă'
    },
    settingLocationGroups: {
      active: 'Activ',
      isOpen: 'Deschis',
      displayInSlider: 'Pune grupurile în "slider"',
      noData: 'Creați noi grupuri folosind butonul "+"',
      parentGroup: 'Grupul Părinte',
      write: '(Scrie...)'
    },
    paymentPage: {
      invoice: 'Factura',
      total: 'Total',
      forDate: 'Pentru data',
      payed: 'Plătită',
      transaction: 'Tranzacția',
      payLink: 'Link Plată',
      viewInvoice: 'Vezi factura',
      download: 'Descarcă',
      pay: 'Plătește',
      invoiceList: 'Listă Facturi'
    },
    filter: {
      filter: 'Filtru',
      action: 'Acțiuni',
      create: 'Filtru Creat',
      update: 'Filtru Actualizat',
      areYouSureDelete: 'Sigur vrei să ștergi acest filtru',
      yes: 'Da',
      deleted: 'Filtru șters',
      noFilters: 'Nu există filtre',
      name: 'Nume',
      addFilter: 'Adaugă filtru',
      remove: 'șterge',
      filters: 'Filtre',
      value: 'Valoare',
      filterProducts: 'Filtre Produse',
      filterName: 'Denumire Filtru',
      val: 'val',
      filterUpdated: 'Filtre Actualizate',
      minOneFilterValueRequired: 'Minim o valoare pe filtru este obligatorie',
      filterType: 'Tipul filtrului',
      type_exists: 'Tipul filtrului exista',
      filter_value_exists: 'Valoarea filtrului exista',
      some_filter_applied: 'Actualizare cu succes, dar unele filtre/valori sunt aplicate pe produse și nu au putut fi șterse'
    },
    newsletterCard: {
      title: 'Listă cu noutăți, informații și suport',
      titleNews: 'Noutăți',
      titleMonthlyInfo: 'Informații lunare',
      titleVideoSupport: 'Video și Suport',
      helpVideoSupport: 'Ai nevoie de ajutor?',
      searchPlaceholder: 'Caută',
      noResultsMessage: 'Nu s-a găsit nici un video cu acest nume sau titlu.',
      tableName: 'Nume',
      tableDate: 'Dată',
      tableDownload: 'Descarcă',
      buttonDownload: 'Descarcă',
      allArticles: 'Toate articolele',
      articleFound: 'articole găsite',
      searchArticle: 'Caută un articol',
      readArticle: 'Citește articolul'
    },
    groupOption: {
      areYouSure: 'Ești sigur?',
      importTitle: 'Adaugă acest grup la toate produsele din categoria',
      importAdd: 'Adaugă'
    },
    rkeeperV2: {
      title: 'RKeeper V2',
      url: 'URL Endpoint',
      slug: 'Restaurant Slug',
      apiUser: 'API User (X-Api-User)',
      apiSecret: 'API Secret (X-Api-Secret)',
      secret: 'Webhook Secret',
      testLogin: 'Testează login',
      save: 'Salvează',
      saved: 'Salvat',
      error: 'A apărut o eroare',
      active: 'Activ',
      loginOk: 'Login reușit',
      loginFail: 'Login eșuat',
      syncMenu: 'Sincronizează meniu',
      syncQueued: 'Sincronizarea meniului a pornit…',
      running: 'Sincronizare în curs…'
    },
    rkeeper: {
      rkeeper: 'RKeeper',
      import: 'Import',
      products: 'Importă Toate Produsele',
      categories: 'Import Categorii',
      sync: 'Sincronizare RKeeper',
      onlyProducts: 'Sincronizează Doar Produse Noi',
      onlyOptions: 'Sincronizează Doar Opțiuni Noi',
      productPrices: 'Sincronizează Prețuri Produse',
      optionPrices: 'Sincronizează Prețuri Opțiuni',
      importSuccess: 'Importul a fost făcut cu succes. Nu uitați să sincronizați prețurile',
      importError: 'Importul nu a putut fi efectuat',
      syncSuccess: 'Sincronizarea a fost făcută cu succes',
      syncError: 'Sincronizarea nu a putut fi efectuată',
      importInProgress: 'Importul a început. Acest proces poate dura câteva minute',
      syncInProgress: 'Sincronizarea a început. Acest proces poate dura câteva minute'
    },
    glovo: {
      noTrackingNumber: 'Numărul comenzii nu a fost găsit, curierul nu a fost anulat.',
      areYouSure: 'Sigur vrei să chemi curier Glovo?',
      errorPickupTime: 'Ora aleasă este înafară orarului de serviciu',
      outOfWorkingAreaDeliveryAddress: 'Adresa de livrare este înafară arieri de serviciu',
      canNotCancel: 'Comanda a fost deja preluată, livrarea nu poate fi anulată',
      CAN_NOT_CANCEL: 'Comanda a fost deja preluată, livrarea nu poate fi anulată',
      addressesNotInSameCityCode: 'Adresele nu sunt în același oraș',
      outOfWorkingHours: 'Nici un curier nu este disponibil',
      outOfWorkingAreaPickupAddress: 'Adresa de ridicare este înafara ariei de livrare',
      error: 'A apărut o eroare',
      syncLabel: 'Sincronizare meniu Glovo',
      noTopCat: 'Dezactivați categoriile de top nefolosite și încercați din nou',
      noCat: 'Categoriile active nu conțin produse active'
    },
    tazz: {
      noTrackingNumber: 'Numărul comenzii nu a fost găsit, curierul nu a fost anulat.',
      areYouSure: 'Sigur vrei să chemi curier Tazz?',
      areYouSureCancel: 'Sigur vrei să anulezi curierul Tazz?',
      errorPickupTime: 'Ora aleasă este înafară orarului de serviciu',
      outOfWorkingAreaDeliveryAddress: 'Adresa de livrare este înafară arieri de serviciu',
      canNotCancel: 'Comanda a fost deja preluată, livrarea nu poate fi anulată',
      CAN_NOT_CANCEL: 'Comanda a fost deja preluată, livrarea nu poate fi anulată',
      addressesNotInSameCityCode: 'Adresele nu sunt în același oraș',
      outOfWorkingHours: 'Nici un curier nu este disponibil',
      outOfWorkingAreaPickupAddress: 'Adresa de ridicare este înafara ariei de livrare',
      error: 'A apărut o eroare',
      syncLabel: 'Sincronizare meniu Tazz',
      tazzStatus1: 'Curierul nu a fost chemat',
      tazzStatus2: 'Curierul a fost chemat',
      tazzStatus3: 'Curierul nu a fost chemat',
      tazzStatus4: 'Curierul a fost anulat',
      tazzStatus5: 'A aparut o eroare',
      orderPrepared: 'C. Preparată'
    },
    importProductsError: {
      noTopCat: 'Dezactivați categoriile de top nefolosite și încercați din nou',
      noCat: 'Categoriile active nu conțin produse active'
    },
    bolt: {
      acceptOrders: 'Acceptă comenzi din marketplace',
      menu: 'Meniu',
      sync: 'Sincronizarea a inceput, poate dura cateva minute',
      syncError: 'Sincronizarea nu poate fi realizata'
    },
    wolt: {
      integrateLocation: 'Alege locația pentru integrare',
      getWolt: 'Înrolare Wolt',
      updateCredentials: 'Actualizează Credențiale',
      redirectToWolt: 'Redirecționare Wolt'
    },
    posnet: {
      enableReport: 'Activează raportul',
      reportDate: 'Data raportului',
      confirmActivateReport: 'Doriți să activați raportul pentru data {date}?',
      confirmActivateReportAutomated: 'Sunteți sigur că doriți să activați raportul în mod automat pentru data de ieri ({date})?'
    },
    epRestaurant: {
      importLabel: 'Ep Restaurant - Acțiuni Meniu',
      importButton: 'Importă',
      syncButton: 'Sincronizează',
      resendQuestion: 'Sunteți sigur că doriți să retrimiteți această comandă?'
    },
    nexus: {
      ordersPeriod: 'Perioada Comenzi',
      elgibleOrders: 'Pentru a fi considerate eligibile pentru integrare comenzile trebuie sa fie fiscalizate, in statusul "LIVRAT".',
      ordersAlreadyIntegrated: 'Nu se iau in considerare comenzile deja integrate cu succes.',
      pickupDatetime: 'Dată Ridicare',
      paymentType: 'Tip Plată',
      orderStatus: 'Status Comandă',
      isSent: 'Status',
      retryCount: 'Reîncercări',
      retryAt: 'Reîncercare la',
      receiptNumber: 'Nr. Bon',
      nexusOrderId: 'ID Document Nexus',
      sentStatus0: 'În așteptare',
      sentStatus1: 'Trimis',
      sentStatus2: 'Eșuat',
      sentStatus3: 'Anulat',
      sentStatus4: 'Reîncercare programată',
      sentStatus5: 'Anulare în curs',
      vatRate: 'Cotă TVA',
      markResend: 'Retrimitere',
      markCancellation: 'Anulare',
      markResendConfirm: 'Selecția filtrată va fi marcată pentru retrimitere către Nexus. Doriți să continuați?',
      markCancellationConfirm: 'Selecția filtrată va fi marcată pentru anulare în Nexus. Doriți să continuați?',
      markSuccessMessage: 'Comenzile au fost marcate și vor fi trimise în câteva minute. Jurnalele pot fi găsite în coloana Acțiuni.',
      invoiceStatus: 'Status Nexus',
      invoiceLog: 'Log Nexus',
      invoiceSend: 'Trimite în Nexus',
      invoiceSendConfirm: 'Marcați această factură pentru trimitere în Nexus?',
      invoiceStornoConfirm: 'Marcați această factură pentru stornare în Nexus?',
      invoiceMarkSuccess: 'Factura a fost marcată pentru Nexus și va fi procesată în scurt timp.',
      invoiceNoOrder: 'Această factură nu are un ID de comandă asociat.',
      invoiceStatusUnknown: 'Statusul Nexus nu este disponibil pentru această factură.',
      invoiceStatus1: 'În așteptare',
      invoiceStatus1Text: 'Factura urmează să fie trimisă în Nexus.',
      invoiceStatus2: 'În trimitere',
      invoiceStatus2Text: 'Factura este în curs de trimitere către Nexus.',
      invoiceStatus3: 'Trimisă cu succes',
      invoiceStatus3Text: 'Factura a fost trimisă cu succes în Nexus.',
      invoiceStatus4: 'Eroare la trimitere',
      invoiceStatus4Text: 'A apărut o eroare la trimiterea facturii în Nexus.',
      invoiceStatus5: 'Marcată pentru stornare',
      invoiceStatus5Text: 'Factura a fost marcată pentru stornare în Nexus.',
      invoiceStatus6: 'Stornată cu succes',
      invoiceStatus6Text: 'Factura a fost stornată cu succes în Nexus.',
      invoiceStatus7: 'Eroare la stornare',
      invoiceStatus7Text: 'A apărut o eroare la stornarea facturii în Nexus.'
    },
    rsystem: {
      fetchOrganizations: 'Preia organizațiile',
      choose: 'Alege o opțiune',
      tipsId: 'Tip bacșiș',
      completeSetup: 'Completează organizația, grupul terminal și mapările de plată R Systems înainte de salvare.',
      proc: 'Proc (procentual)',
      fix: 'Fix (sumă fixă)',
      adjustable: 'Ajustabil',
      recommended: 'Recomandat',
      payment_CASH: 'Numerar',
      payment_CARD: 'Card online',
      payment_POS: 'POS',
      payment_CARD_POS: 'Card la POS',
      payment_ONLINE: 'Online',
      reviewMappings: 'Verifică mapările sugerate. Alege explicit când există mai multe metode posibile.',
      destination: 'Destinație',
      refreshMenu: 'Organizația s-a schimbat. Reconciliază meniul vechi și importă explicit meniul organizației selectate înainte de a prelua comenzi.',
      requestFailed: 'Setările R Systems nu au putut fi preluate. Reîncearcă.',
      saved: 'Setările integrării au fost salvate.',
      importConfirm: 'Importați meniul organizației salvate? Reconciliați mai întâi meniul vechi; comenzile existente păstrează ID-urile produselor salvate.',
      importQueued: 'Meniul a fost preluat și pus în coada de procesare.',
      apiKey: 'Cheie API',
      organisationId: 'Organizație',
      terminalGroupId: 'Grup terminal',
      paymentTypes: 'Metode de Plată',
      discountId: 'Discount',
      settings: 'Setări',
      deleteMenu: 'Ștergeți meniul vechi înainte de import',
      seoText: 'Asigurați-vă că meniul conține text SEO TapTasty înainte de a-l importa',
      import: 'Import'
    },
    checkbox: 'Permite selectarea mai multor opțiuni pe produs',
    radio: 'Permite selectarea unei singure opțiuni pe produs',
    ebriza: {
      title: 'Ebriza',
      woltDriveErrorsUrl: 'Endpoint notificare erori Wolt Drive'
    },
    ...roLocale
  },
  el: {
    btPayments: btPayments.en,
    marketplace: marketplace.el,
    general: {
      search: 'Αναζήτηση',
      home: 'Αρχική',
      add: 'Προσθέτω',
      edit: 'Επεξεργασία',
      delete: 'Διαγραφή',
      remove: 'Αφαίρεσε',
      save: 'Αποθηκευση',
      update: 'Ενημέρωση',
      cancel: 'Ακηρωση',
      continue: ' Συνέχισε',
      activate: 'Ενεργοποίησε',
      deactivate: 'Απενεργοποίησε',
      active: 'Ενεργός',
      inactive: 'Ανενεργό',
      specialPrice: 'Ειδική τιμή',
      yes: 'Ναι',
      no: 'Οχι',
      success: 'Επιτυχία',
      required: 'Απαιτείται',
      back: 'πίσω',
      next: 'Επόμενο',
      finish: 'Τέλος',
      duplicate: 'Αντίγραφο',
      select: 'Επιλέγω',
      all: 'Ολα',
      reset: 'Επαναφορά',
      export: 'Εξαγωγή',
      loadMore: 'Φόρτωσε περισσότερα',
      viewDetails: 'Δείτε λεπτομέρειες',
      showing: 'Εμφάνιση {length} αποτέλεσμα (s)',
      logout: 'Αποσύνδεση',
      from: 'από',
      to: 'προς το',
      agree: 'Συμφωνώ',
      agreePopupMessage: 'Για να επιτρέψετε στο πρόγραμμα περιήγησης να αναπαράγει ήχο, πρέπει να κάνετε κλικ στο "Συμφωνώ". Αυτό θα αναπαράγει έναν δοκιμαστικό ήχο προκειμένου να ενεργοποιηθεί η αναπαραγωγή ήχου. ',
      day: 'ημέρα',
      notCompleted: 'μη ολοκληρωμένο',
      saveChanges: 'αποθήκευσε τις αλλαγές',
      doYouWantToLogout: 'Θέλετε να αποσυνδεθείτε?',
      deliveryMethod: 'ΜΕΘΟΔΟΙ ΠΑΡΑΔΟΣΗΣ',
      none: 'Κανένας',
      unset: 'Μη ορισμένο',
      couldNotSave: 'Δεν ήταν δυνατή η αποθήκευση του συνδέσμου μενού',
      couldNotUpdate: 'Δεν ήταν δυνατή η ενημέρωση του συνδέσμου μενού'
    },
    pages: {
      login: 'Σύνδεση',
      register: 'Εγγραφη',
      recoverPassword: 'Ανάκτηση κωδικού πρόσβασης',
      resetPassword: 'Επαναφορά κωδικού πρόσβασης',
      dashboard: 'Ταμπλό',
      orderingManagement: 'Διαχείριση Παραγγελιών',
      customerDetails: 'Πληροφορίες Πελάτη',
      customers: 'Πελάτες',
      customersGroups: 'Ομάδες',
      orders: 'Παραγγελίες',
      reservations: 'Reservations',
      products: 'Προϊόντα',
      catalog: 'Κατάλογος',
      categories: 'Κατηγορίες',
      productOptions: 'Επιλογές προϊόντος',
      marketing: 'Μάρκετινγκ',
      campaigns: 'Καμπάνιες',
      raffleCampaigns: 'Καμπάνιες κλήρωσης',
      donationCampaigns: 'Καμπάνιες Δωρεών',
      spinningWheelCampaigns: 'Spinning Wheel',
      offersSlider: 'Προσφορά Slider',
      reports: 'Αναφορές',
      feedback: 'Ανατροφοδότηση',
      settings: 'Ρυθμίσεις',
      logout: 'Αποσύνδεση',
      fidelities: 'Πόντοι',
      infoPages: 'Σελίδες πληροφοριών',
      productFilters: 'Φίλτρα προϊόντων',
      promos: 'προσφορές',
      menus: 'Μενού',
      clientOrderView: 'Οθόνη PickUp'
    },
    ordersStatus: {
      bill: 'Bill',
      AWAITING_TRANSPORT: 'Περιμένοντας τη μεταφορά',
      CANCELED: 'Ακυρώθηκε',
      DELIVERED: 'Παραδόθηκε',
      DRAFT: 'Προσχέδιο',
      NEW: 'Νέος',
      ON_HOLD: 'Σε κράτηση',
      POSTPONED: 'Αναβλήθηκε',
      NOT_DELIVERED: 'Δεν έχει παραδωθεί',
      PICKED_UP_BY_DELIVERY: 'Έγινε παραλαβή για παράδοση',
      PROCESSING: 'Επεξεργασία',
      PREPARED: 'Ετοιμος',
      TRANSPORT: 'Σε μεταφορά',
      RESERVED: 'Κατοχυρωμένα',
      COMPLETED: 'Οριστικοποίηση',
      FINISH: 'Τέλος',
      reservedReady: 'Δεσμευμένο / έτοιμο',
      completedReady: 'Ολοκληρώθηκε / Έτοιμο',
      deliveredReady: 'Παραδόθηκε / προετοιμάστηκε'
    },
    ordersTypes: {
      GROUP: 'Ομάδα',
      SINGLE: 'Ατομικό'
    },
    paymentTypes: {
      CASH: 'Μετρητά',
      CARD: 'Κάρτα'
    },
    paymentStatus: {
      notPaid: 'Δεν πληρώθηκε',
      notPaidDetails: ' Το ποσό θα χρεωθεί μόλις η παραγγελία επισημανθεί ως παραδόθηκε',
      paid: 'Πληρώθηκε',
      notOk: 'Απορρίφθηκε'
    },
    campaignsModes: {
      AUTO: 'Αυτόματο',
      MANUAL: 'Εγχειρίδιο'
    },
    campaignsNotificationTypes: {
      EMAIL: 'Ηλεκτρονική διέυθυνση',
      PUSH: 'Ειδοποίηση'
    },
    days: {
      monday: 'Δευτερα',
      tuesday: 'Τριτη',
      wednesday: 'Τεταρτη',
      thursday: 'Πεμπτη',
      friday: 'Παρασκευη',
      saturday: 'Σαββατο',
      sunday: 'Κυριακη'
    },
    daysShort: {
      Mon: 'Δευτερα',
      Tue: 'Τριτη',
      Wed: 'Τεταρτη',
      Thu: 'Πεμπτη',
      Fri: 'Παρασκευη',
      Sat: 'Σαββατο',
      Sun: 'Κυριακη'
    },
    gender: {
      selectGender: 'Επιλογή φύλου',
      male: 'Αρσενικό',
      female: 'Θηλυκό',
      Male: 'Αρσενικό',
      Female: 'Θηλυκό',
      Other: ' Άλλο'
    },
    reportsAgesGroups: {
      selectAge: 'Επιλέξτε Ηλικία',
      'Under 20': 'Κάτω από 20',
      '20': 'Κάτω από 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      Unspecified: ' Απροσδιόριστος'
    },
    deliveryTypes: {
      DELIVERY: 'Διανομή',
      EAT_LOCATION: 'Φάτε στην τοποθεσία',
      MEET_HALF: 'Συναντηση στη μεση της διαδρομης',
      PICK_UP: 'Παραλαβη'
    },
    couponsTypes: {
      FIXED: 'Σταθερό',
      PERCENTAGE: 'Ποσοστό',
      FREE_PRODUCT: 'Δωρεάν προϊόν'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Σταθερό (περιλαμβάνεται)',
      PERCENTAGE_INCLUDED: 'Ποσοστό (συμπεριλαμβάνεται)',
      FIXED_EXCLUDED: 'Σταθερό (εξαιρούμενο)',
      PERCENTAGE_EXCLUDED: 'Ποσοστό (εξαιρούμενο)'
    },
    productOptions: {
      checkbox: 'Επιτρέπει την επιλογή πολλαπλών επιλογών στο προϊόν',
      radio: ' Επιτρέπει την επιλογή μόνο μίας επιλογής στο προϊόν'
    },
    validations: {
      areYouSureYouWantTo: ' Είστε σίγουροι ότι θέλετε να',
      areYouSure: 'Είστε βέβαιοι ότι θέλετε να ενημερώσετε την κατάσταση σε',
      wentWrong: ' Κάτι πήγε στραβά, δοκιμάστε ξανά αργότερα …',
      pictureSize: 'jpg/png αρχεία με μέγεθος μικρότερο από 5MB',
      pictureSizeExceed: 'Το μέγεθος εικόνας δεν μπορεί να υπερβαίνει τα 5MB!',
      pdfSize: 'pdf αρχεία με μέγεθος μικρότερο από 25MB',
      pdfSizeExceed: 'Το μέγεθος pdf δεν μπορεί να ξεπεράσει τα 25MB!',
      archiveSizeExceed: 'Το μέγεθος του αρχείου δεν μπορεί να ξεπεράσει τα 500MB!',
      wrongFormat: 'Λάθος μορφή',
      removePhoto: 'Παρακαλώ αφαιρέστε το τρέχον αρχείο για να μπορέσετε να προσθέσετε ένανέο.',
      dataCouldNotBeSaved: 'Δεν ήταν δυνατή η αποθήκευση δεδομένων, δοκιμάστε ξανά αργότερα.',
      passReq: 'Απαιτείται το αναγνωριστικό πεδίου κωδικού πρόσβασης',
      passMin: 'Ο κωδικός πρόσβασης πρέπει να είναι τουλάχιστον 6 χαρακτήρες.',
      passConf: 'Η επιβεβαίωση του κωδικού πρόσβασης και του κωδικού πρόσβασης δεν ταιριάζει',
      validPoinsNo: 'Προσθέστε ένα έγκυρο χρηματικό ποσό και ένα σχόλιο.',
      hourIsSmallerThanCreated: 'Ο επιλεγμένος χρόνος είναι μικρότερος από τον χρόνο υποβολής της παραγγελίας',
      vatPrinterIdRange: '0–10 only.',
      vatPrinterIdNumeric: 'Numbers only.'
    },
    upload: {
      uploadLabel: 'Μεταφόρτωση μενού',
      browse: 'Ξεφυλλίζω',
      download: 'Λήψη κωδικού QR'
    },
    dashboard: {
      selectLocation: 'Τοποθεσία:',
      tile1Title: 'Νέες παραγγελίες',
      tile2Title: 'Συνολικές παραγγελίες',
      tile3Title: 'Εσοδα',
      tile4Title: 'Πρόσφατα εγγεγραμμένοι χρήστες',
      today: 'Σήμερα',
      orderChart: 'Παραγγελιες',
      completed: 'Αριθμός παραγγελιών',
      canceled: 'Ακυρώθηκε',
      salesChart: 'Πωλήσεις',
      salesIn: 'Πωλήσεις σε',
      top5Chart: 'Κορυφαία 5 προϊόντα',
      orderingChart: 'Τύποι παραγγελιών',
      nrOfOrders: 'Αριθμός παραγγελιών',
      nrOfEmails: 'Αριθμός email'
    },
    customers: {
      noCustomer: 'Δεν έχει επιλεχθεί πελάτης',
      single: 'πελάτης',
      plural: 'πελάτες',
      title: 'ΠΛΗΡΟΦΟΡΙΕΣ ΠΕΛΑΤΗ',
      pointsTitle: 'Πόντοι Επιβράβευσης Πελατών',
      currentPoints: 'Τρέχοντες πόντοι',
      pointsAddTitle: 'Πρόσθεσε πόντους',
      pay: 'Pay Type',
      id: 'Ταυτότητα',
      name: 'Ονομα',
      email: 'ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ',
      phone: 'Τηλέφωνο',
      use_calling_phone: 'Preia numar telefon',
      gender: 'Γένος',
      birth: 'Ημέρα Γέννησης',
      location: 'Τοποθεσία',
      address: 'Διεύθυνση',
      number: 'Αριθμός',
      dateCreated: 'Ημερομηνία Δημιουργίας',
      delivery: 'Διανομή',
      type: 'Τύπος',
      status: 'Κατάσταση',
      total: 'Σύνολο',
      allTimeSale: 'Πώληση όλων των εποχών ',
      none: 'Κανένα',
      pointsLabel: 'Χρήματα που δαπανήθηκαν',
      pointsLabelInPoints: 'Points earned',
      pointsAdjustmentHelp: 'Εισαγάγετε μια θετική τιμή για να προσθέσετε πόντους ή μια αρνητική τιμή (π.χ. -100) για να αφαιρέσετε πόντους από το υπόλοιπο του πελάτη.',
      points: 'points',
      point: 'point',
      clientCanUse: 'Customer can use',
      commentsLabel: 'Σχόλιο',
      pointsSuccess: ' Οι πόντοι επιβράβευσης προστέθηκαν με επιτυχια.',
      pointsError: 'Δεν μπορούσαμε να προσθέσουμε τους πόντους στον πελάτη.',
      addCommentPerClient: 'Προσθήκη σχολίου ανά πελάτη',
      newCommentAdded: 'Το σχόλιο έχει ενημερωθεί',
      filters: {
        withOrders: 'Cu Comenzi',
        withoutOrders: 'Χωρίς Παραγγελίες'
      },
      addGroup: 'Προσθήκη ομάδας',
      deleteGroup: 'Η ομάδα διαγράφηκε με επιτυχία.',
      saveGroup: 'Η ομάδα προστέθηκε με επιτυχία',
      updateGroup: 'Η ομάδα ενημερώθηκε με επιτυχία'
    },
    orders: {
      counterPerCustomer: 'Αριθμός παραγγελιών',
      noOrders: 'Δεν έχει επιλεγεί καμία παραγγελία',
      single: 'παραγγελία',
      the_order: 'H παραγγελία',
      plural: 'Οι παραγγελιες',
      status: 'Κατάσταση',
      location: 'Τοποθεσία',
      updateStatus: 'Ενημέρωση κατάστασης',
      editOrder: 'Edit Order',
      ordDetails: 'Λεπτομέρειες Παραγγελίας',
      date: 'Ημερομηνία',
      madeAt: 'Παραγγελία που έγινε στο',
      pickupTime: 'Διανομή / Παραλαβή από το κατάστημα στο',
      preorder: 'ΠΡΟΠΑΡΑΓΓΕΛΙΑ',
      preorderFilter: 'Προπαραγγελίες',
      allOrders: 'Όλες οι παραγγελίες',
      pendingPreorders: 'Εκκρεμείς προπαραγγελίες',
      withoutPendingPreorders: 'Χωρίς εκκρεμείς προπαραγγελίες',
      reservationTime: ' Ώρα Κράτησης',
      reservationSeats: 'Θέσεις κράτησης',
      rating: 'Εκτίμηση',
      meetupLocation: 'Τοποθεσία συναντήσεως',
      ordLocation: 'Παραγγελία Τοποθεσία',
      delivery: 'Διανομή',
      type: 'Τύπος',
      payment: 'Πληρωμή',
      name: 'Ονομα',
      qty: 'Qty',
      unit: 'Τιμή μονάδας',
      unit_price: 'Τιμή μονάδας',
      final_price: 'Τελική τιμή',
      total: 'Σύνολο',
      totals_subtotals: 'Συνολο',
      totals_discount: 'Εκπτωση',
      totals_discount_loyalty_points: 'Εκπτωση απο τους ποντους',
      totals_grandtotal: 'Σύνολο',
      totals_shipping: 'Αποστολή',
      totals_extras: ' Σακούλα',
      totals_tip: 'Συμβουλές',
      totals_donation: 'Δωρεά',
      custComments: 'Σχόλιο πελάτη',
      adminComments: 'Σχόλιο διαχειριστή',
      custDetails: 'Πληροφορίες Πελάτη',
      shipping: 'Διεύθυνση αποστολής',
      billing: 'Διεύθυνση χρέωσης',
      orderStatusSuccess: 'Η κατάσταση παραγγελίας ενημερώθηκε με επιτυχία',
      orderCommnetSuccess: 'Σχόλιο Παραγγελία ενημερώθηκε με επιτυχία',
      orderHourSuccess: 'Η επιλογη του χρονο  διανομή / παραλαβή από το κατάστημα  ενημερώθηκε με επιτυχία',
      orderHourError: 'Καταχωρίστε μια έγκυρη ώρα.',
      none: 'Κανένα σχόλιο',
      at: ' στο',
      filtersApplied: 'Εφαρμοσμένα φίλτρα - κάντε κλικ στο κουμπί φίλτρου για να δείτε περισσότερα',
      customFilters: 'Εφαρμόστηκαν προσαρμοσμένα φίλτρα',
      resetFilters: 'Κάντε κλικ εδώ για επαναφορά και προβολή ζωντανών δεδομένων',
      note: ' Σημείωση',
      orderNoArticulate: 'Σειρά',
      print: ' Τυπώνω (A4)',
      printerPrint: ' Τυπώνω (80mm)',
      printerSuccess: 'Η παραγγελία εκτυπώθηκε με επιτυχία.',
      printerErrror: 'Παρουσιάστηκε σφάλμα στη σύνδεση με τον εκτυπωτή.',
      addTime: 'Προσθέστε χρόνο',
      amountRefunded: 'Επιστροφή χρημάτων',
      amountIntegralRefunded: 'Το ποσό επιστράφηκε αναπόσπαστο στον πελάτη',
      refundSuccess: 'Το ποσό επιστράφηκε με επιτυχία',
      refundManual: 'Τα χρήματα θα επιστραφούν από τη μη αυτόματη πληρωμή',
      refundAutomat: 'Θέλετε αυτόματη επιστροφή χρημάτων ?',
      refundOrder: 'Επιστροφή χρημάτων',
      refundAlreadyDone: 'Έχει ήδη επιστραφεί',
      refundConfirmTitle: 'Επιστροφή χρημάτων παραγγελίας;',
      refundConfirmText: 'Το ποσό θα επιστραφεί στον πελάτη μέσω EuPlatesc. Η ενέργεια δεν μπορεί να αναιρεθεί.',
      refundAskCancel: 'Η επιστροφή ολοκληρώθηκε. Θέλετε να ακυρώσετε και την παραγγελία;',
      refundError: 'Παρουσιάστηκε σφάλμα κατά την επεξεργασία της επιστροφής.',
      orderCloseToDelivery: 'Παραγγελία με ώρα παράδοσης πιο κοντά',
      erorrPaylike: 'Σφάλμα Paylike, δημιουργήθηκε ένα αρχείο καταγραφής στο διακομιστή με το σφάλμα να επιστραφεί'
    },
    companyOptions: {
      id: 'Id',
      name: 'Name',
      image: 'Image',
      prod_image: 'Product Image (just custom app)',
      info: 'Info',
      type: 'Type',
      deleteQues: 'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',
      deleteVal: 'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',
      active: 'Active',
      quantitySettings: 'Quantity Settings',
      allowQuantity: 'Allow quantity',
      minQuantity: 'Minimum quantity',
      maxQuantity: 'Maximum quantity',
      quantityMinMaxError: 'Minimum quantity cannot be greater than maximum quantity'
    },
    catalogProd: {
      noProducts: 'Δεν έχει επιλεγεί κανένα προϊόν',
      single: 'προϊόν',
      plural: 'προϊόντα',
      generalDetails: 'Γενικές λεπτομέρειες',
      name: 'Ονομα',
      desc: 'Περιγραφή',
      image: 'Εικόνα',
      category: 'Κατηγορία',
      price: 'Τιμή',
      oldPrice: 'Παλιά τιμή',
      newPrice: 'Νέα τιμή',
      useDiscountPrice: 'Χρησιμοποιήστε μειωμένη τιμή',
      taxes: 'Εφαρμοσμένοι φόροι',
      status: 'Κατάσταση',
      posid: 'Αναγνωριστικό POS',
      allowUserComments: 'Επιτρέψτε σχόλια χρηστών',
      availableInStore: 'Διατίθεται μόνο στο κατάστημα',
      validFromTo: 'Ισχύει από - έως',
      prodType: 'Τύπος Προϊόντος',
      singleType: 'ατομικο',
      groupType: 'ομάδα',
      rewardPoints: 'Πόντοι επιβράβευσης',
      moneySpent: 'Χρήματα σε πόντους',
      numberOfYouNeedToSpend: 'Ο αριθμός {currency} που ο πελάτης πρέπει να δαπανήσει για να πάρει ένα σημείο.',
      points: 'ποντους',
      soldWith: 'Πωλείται με',
      pickAnOption: 'Επιλέξτε μια επιλογή',
      minNoSelected: 'Ελάχιστος αριθμός. επιλεγμένο',
      maxNoSelected: 'Μέγ αριθμός. επιλεγμένο',
      optVal: 'Αξία',
      leaveEmpty: 'Αφήστε κενό ή βάλτε το 0 αν η επιλογή δεν κοστίζει επιπλέον',
      prodDeleted: 'Το προϊόν διαγράφηκε με επιτυχία',
      prodAdded: 'Το προϊόν προστέθηκε με επιτυχία',
      prodUpdated: 'Το προϊόν ενημερώθηκε με επιτυχία',
      prodPhotoError: 'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας του προϊόντος, δοκιμάστε ξανά αργότερα.',
      rewardPossibelValue: 'Πιθανές τιμές',
      errorOptions: 'Ελέγξτε όλες τις επιλογές προϊόντον, μερικές ενδέχεται να μην συμπληρώνονται.',
      locationSettings: 'Ρυθμίσεις τοποθεσιών',
      availableIn: 'Διαθέσιμο σε',
      deliveryMethodsandHours: 'Μέθοδοι παράδοσης και ώρες',
      overrideSettings: 'Παράκαμψη ρυθμίσεων',
      addLocationValidation: 'Ορισμένες επιλογές προϊόντος δεν είναι συμβατές με τις επιλεγμένες τοποθεσίες, εάν συνεχίσετε, οι επιλογές θα καταργηθούν, εάν όχι, η τοποθεσία δεν θα προστεθεί.',
      productAvailableIn: 'Το προϊόν είναι διαθέσιμο σε',
      particularLocationSettings: 'Ειδικές ρυθμίσεις για κάθε τοποθεσία',
      activateParticularSettings: 'Ενεργοποίηση προσαρμοσμένων ρυθμίσεων',
      withoutThisOptionDefault: '*χωρίς να ενεργοποιήσετε αυτήν την επιλογή, θα χρησιμοποιηθούν οι προεπιλεγμένες ρυθμίσεις',
      highlightsProduct: 'Το προϊόν επισημαίνει',
      search: 'Αναζήτηση',
      isHiddenFromListing: 'Απόκρυψη από τη λίστα προϊόντων',
      isHiddenFromSearch: 'Απόκρυψη από την αναζήτηση προϊόντων',
      isHiddenFromQrMenu: 'Hide from Qr menu',
      isHiddenFromPOS: 'Ascunde din POS',
      isHiddenFromKiosk: 'Ascunde din Kiosk si Meniu Qr',
      Monday: 'Δευ',
      Tuesday: 'Τρι',
      Wednesday: 'Τετ',
      Thursday: 'Πεμ',
      Friday: 'Παρ',
      Saturday: 'Σαβ',
      Sunday: 'Κυρ',
      accesRestricted: 'Δυστυχώς, δεν έχετε πρόσβαση σε αυτό το προϊόν',
      changeLocations: 'Change locations',
      includeAllLocationsProducts: 'Include also the products available in all locations',
      bulkLocationsMode: 'Action',
      bulkModeAdd: 'Add',
      bulkModeRemove: 'Remove',
      bulkModeReplace: 'Replace',
      massUpdate: 'Mass update',
      massUpdateSubtitle: 'You are about to update {count} products',
      bulkActionActive: 'Active / Inactive',
      bulkActionPrice: 'Price',
      bulkActionVat: 'VAT',
      bulkActionSection: 'Section',
      bulkActionOptionGroups: 'Option groups',
      bulkActionDelete: 'Delete',
      bulkOverrideDeliveryHint: 'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',
      bulkOverrideLocationsHint: 'Leave empty to use all company locations. Only locations that already belong to each product are applied.',
      bulkOverrideAddIntervalHint: 'Click + to add a schedule interval for this method.',
      bulkPriceDirection: 'Direction',
      bulkPriceIncrease: 'Increase',
      bulkPriceDecrease: 'Decrease',
      bulkPriceMode: 'Type',
      bulkPriceFlat: 'Flat amount',
      bulkPricePercent: 'Percentage (%)',
      bulkPriceAmount: 'Amount',
      bulkPriceBaseOnlyHint: 'Only the base price is changed. The new price will never go below 0.',
      bulkOptionGroupsMode: 'Association mode',
      bulkOptionGroupsModeHint: 'Add keeps existing groups. Replace overwrites them with the selected ones.',
      bulkDeleteWarning: 'This will permanently delete {count} products. This action cannot be undone easily.',
      bulkDeleteEnableLabel: 'Yes, delete the selected products (other mass actions will be ignored)',
      confirmBulkMultiple: 'Apply these changes to {count} {products}:',
      bulkProductSingular: 'product',
      bulkProductPlural: 'products',
      confirmBulkAreYouSure: 'Are you sure?',
      bulkSummaryAddLocations: 'add locations ({value}) to {count} {products}',
      bulkSummaryRemoveLocations: 'remove locations ({value}) from {count} {products}',
      bulkSummarySetActive: 'set {count} {products} as active',
      bulkSummarySetInactive: 'set {count} {products} as inactive',
      bulkSummaryIncreasePriceFlat: 'increase the base price of {count} {products} by {amount} {currency}',
      bulkSummaryIncreasePricePercent: 'increase the base price of {count} {products} by {amount}%',
      bulkSummaryDecreasePriceFlat: 'decrease the base price of {count} {products} by {amount} {currency}',
      bulkSummaryDecreasePricePercent: 'decrease the base price of {count} {products} by {amount}%',
      bulkSummaryAddOptionGroups: 'add option groups ({value}) to {count} {products}',
      bulkSummaryReplaceOptionGroups: 'replace option groups on {count} {products} with ({value})',
      bulkSummarySetVat: 'set VAT {value} on {count} {products}',
      bulkSummarySetSection: 'set section {value} on {count} {products}',
      bulkSummaryEnableOverride: 'enable override settings on {count} {products}',
      bulkSummaryEnableOverrideWithSchedule: 'replace override schedules on {count} {products}',
      bulkSummaryDisableOverride: 'disable override settings on {count} {products}',
      bulkSummaryDelete: 'delete {count} {products}',
      bulkSummaryGeneric: 'update {count} {products}',
      confirmBulkAddLocations: 'Are you sure you want to add locations to {count} products?',
      confirmBulkRemoveLocations: 'Are you sure you want to remove locations from {count} products?',
      confirmBulkSetActive: 'Are you sure you want to set {count} products as active?',
      confirmBulkSetInactive: 'Are you sure you want to set {count} products as inactive?',
      confirmBulkIncreasePriceFlat: 'Are you sure you want to increase the base price of {count} products by {amount}?',
      confirmBulkIncreasePricePercent: 'Are you sure you want to increase the base price of {count} products by {amount}%?',
      confirmBulkDecreasePriceFlat: 'Are you sure you want to decrease the base price of {count} products by {amount}?',
      confirmBulkDecreasePricePercent: 'Are you sure you want to decrease the base price of {count} products by {amount}%?',
      confirmBulkAddOptionGroups: 'Are you sure you want to add option groups to {count} products?',
      confirmBulkReplaceOptionGroups: 'Are you sure you want to replace option groups on {count} products?',
      confirmBulkSetVat: 'Are you sure you want to set VAT on {count} products?',
      confirmBulkSetSection: 'Are you sure you want to set the section on {count} products?',
      confirmBulkDelete: 'Are you sure you want to delete {count} products?',
      confirmBulkGeneric: 'Are you sure you want to update {count} products?',
      bulkLocationsUpdated: 'Updated locations for {updated} products',
      bulkMassUpdated: 'Updated {updated} products',
      couldNotFetchProductOptions: 'Could not fetch product options. Please contact support.'
    },
    catalogProdRewardsHints: {
      hint1: 'Αφήστε κενό για να εφαρμόσετε την προεπιλεγμένη τιμή από τις ρυθμίσεις',
      hint2: 'Βάλτε 0 για να μην εφαρμόσετε πρόγραμμα ανταμοιβής σε αυτό το προϊόν',
      hint3: 'Προσθέστε μια θετική τιμή για να παρακάμψετε την προεπιλεγμένη τιμή από τις ρυθμίσεις'
    },
    catalogCateg: {
      single: 'κατηγορία',
      plural: 'κατηγορίες',
      color: 'Culoare',
      name: 'Ονομα',
      image: 'Εικονα',
      displayType: 'Τύπος οθόνης',
      shortDescription: 'Σύντομη περιγραφή',
      validFromTo: 'Ισχύει από - έως',
      areYouSure: 'Είστε βέβαιοι ότι θέλετε να {label} αυτήν την κατηγορία;',
      categAdded: 'Η κατηγορία προστέθηκε με επιτυχία',
      categUpdated: 'Η κατηγορία ενημερώθηκε με επιτυχία',
      categDeleted: 'Η κατηγορία διαγράφηκε επιτυχώς',
      couldNotSave: 'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας κατηγορίας, δοκιμάστε ξανά αργότερα.',
      List: 'Λίστα',
      Grid: 'Πλέγμα',
      pleaseSelect: 'Επιλέξτε / Δεν ισχύει',
      categoriesWithoutParent: 'Κατηγορίες χωρίς γονέα',
      topCategory: 'Κορυφαία κατηγορία',
      forceMethod: 'Μέθοδοι παράδοσης δυνάμεων',
      selectMethod: 'Επιλέξτε μεθόδους',
      enableMethod: '(Για να ενεργοποιήσετε την κατάργηση της κορυφαίας κατηγορίας)',
      overrideSettingsHelp: 'Όταν είναι ενεργοποιημένο, η κατηγορία εμφανίζεται στο μενού μόνο για την επιλεγμένη τοποθεσία, μέθοδο παράδοσης, ημέρα και χρονικό παράθυρο.',
      userLabelings: 'Ετικέτες χρηστών',
      userLabelingsHelp: 'Αυτή η κατηγορία θα είναι ορατή μόνο για χρήστες με μία από αυτές τις ετικέτες',
      schedule: 'Πρόγραμμα',
      useSchedule: 'Χρήση προγράμματος',
      scheduleHelp: 'Ένα πρόγραμμα για αυτή την κορυφαία κατηγορία σε όλες τις τοποθεσίες. Εκτός αυτών των ωρών, η παραγγελία από αυτή την κατηγορία δεν είναι διαθέσιμη στην εφαρμογή.'
    },
    catalogProdOpt: {
      single: 'Επιλογή',
      plural: 'επιλογές',
      new: 'Νέα επιλογή',
      name: 'Ονομα',
      type: 'Τύπος',
      value: 'Αξία',
      values: 'Αξίες',
      optionSaved: 'Οι επιλογές προϊόντος αποθηκεύτηκαν με επιτυχία.',
      areyouSure: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την επιλογή;',
      optLocationError: '{opt_name} η επιλογή πρέπει να περιλαμβάνει {loc_name} διαθέσιμες τοποθεσίες',
      menuQr: 'Μενού QR',
      displayInMenu: 'Εμφάνιση στο μενού QR'
    },
    marketingCampaigns: {
      single: 'καμπάνια',
      plural: 'καμπάνιες',
      name: 'Ονομα',
      nameHelper: 'Αυτό το όνομα θα χρησιμοποιηθεί ως θέμα για τις ειδοποιήσεις μέσω ηλεκτρονικού ταχυδρομείου που αποστέλλονται για αυτήν την καμπάνια.',
      image: 'Εικόνα',
      startEnd: 'Ημερομηνία Έναρξης - Τέλους',
      daysLeft: 'Μέρες που απομένουν',
      timesUsed: 'Φορές που χρησιμοποιήθηκαν',
      status: 'Κατάσταση',
      actions: 'Ενέργειες',
      send: 'Στείλετε',
      in_queue: 'To be sent',
      sent: 'Total sent',
      notif_sent: 'Notification',
      email_sent: 'E-mail',
      areYouSureNotif: 'Είστε βέβαιοι ότι θέλετε να στείλετε τις ειδοποιήσεις;',
      notifSent: 'Έγινε αποστολή ειδοποιήσεων',
      campaignDeleted: 'Η καμπάνια διαγράφεται με επιτυχία.',
      areYouSureDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε',
      campaignAdded: 'Η καμπάνια προστέθηκε με επιτυχία',
      campaignUpdated: 'Η καμπάνια ενημερώθηκε με επιτυχία',
      campaignPhotoError: 'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας της καμπάνιας, δοκιμάστε ξανά αργότερα.',
      campaignDetails: 'Στοιχεία καμπάνιας',
      description: 'Περιγραφή',
      maxDescription: '(μέγιστο 400 χαρακτήρες)',
      characters: 'χαρακτήρες',
      validFromTo: 'Ισχύει από - έως',
      notif: 'Ειδοποιήσεις',
      model: 'Μοντέλο',
      setHours: 'Ορίστε Ώρες',
      selectTime: 'Επιλέξτε χρόνο',
      chooseTarget: 'Επιλέξτε το κοινό-στόχο',
      gender: 'Γένος',
      age: 'Ηλικία',
      city: 'Πόλη',
      location: 'Τοποθεσία',
      visibleInLocations: 'Ορατό στις ακόλουθες τοποθεσίες',
      visibleInLocationsInfo: 'Αυτή η λειτουργία είναι διαθέσιμη μόνο στην Εφαρμογή',
      ordersAbove: 'παραγγελίες άνω',
      addCoupon: 'Προσθήκη κουπονιού',
      applyTo: 'Προσθήκη κουπονιού',
      value: 'Αξία',
      code: 'Κώδικας',
      counter_max_usage: 'Πόσες φορές ένα άτομο μπορεί να χρησιμοποιήσει αυτό το κουπόνι ; ',
      counter_max_usage_total: 'Πόσες φορές μπορεί να χρησιμοποιηθεί αυτό το κουπόνι συνολικά;',
      counter_max_usage_example: 'Πληκτρολογήστε έναν αριθμό για τον μέγιστο αριθμό χρήσεων ανά άτομο. Πληκτρολογήστε 0 για απεριόριστο.',
      counter_max_usage_total_example: 'Πληκτρολογήστε έναν αριθμό για τον μέγιστο αριθμό χρήσης. Πληκτρολογήστε 0 για απεριόριστο.',
      generateCode: 'Δημιουργία κώδικα',
      Products: ' Προϊόντα',
      Shipping: ' Αποστολή',
      chooseCategProduct: 'Επιλέξτε κατηγορίες ή προϊόντα στα οποία θα εφαρμοστεί το κουπόνι: ',
      delivery_methods: 'Σε ποιες μεθόδους παράδοσης πρέπει να εφαρμοστεί το κουπόνι;',
      order_source_ids: 'Order sources',
      order_source_ids_all: 'All sources',
      order_source_ids_help: 'Leave empty to apply on all order sources.',
      location_ids: 'Σε ποια τοποθεσία πρέπει να εφαρμοστεί το κουπόνι;',
      sendNotificationTo: 'Αποστολή ειδοποίηση σε',
      chooseDayForInterval: 'Επιλέξτε μια ημέρα για διάστημα',
      chooseHoursForInterval: 'Επιλέξτε ώρες για διάστημα',
      useInterval: 'χρησιμοποιήστε το διάστημα',
      intervalMustBeSet: 'Το διάστημα πρέπει να οριστεί',
      campaignWasSent: 'Η καμπάνια εστάλη τα τελευταία 30 λεπτά',
      isSecondUseCheck: 'Αυτό το κουπόνι ισχύει αμέσως μετά την πρώτη χρήση',
      groups: 'Ομάδες πελατών',
      freeProduct: 'Δωρεάν προϊόν για προσθήκη στο καλάθι',
      freeProductPlaceholder: 'Επιλέξτε προϊόν',
      freeProductRequired: 'Επιλέξτε ένα δωρεάν προϊόν'
    },
    marketingOffers: {
      single: 'προσφορά πανό',
      plural: 'Προσφορες πανό',
      title: 'Τίτλος',
      status: 'Κατάσταση',
      image: 'Εικόνα',
      imageWeb: 'Εικόνα Ιστού',
      imageBanner: 'Imagine Banner',
      imageLanding: 'Imagine Landing',
      linkType: 'Τύπος συνδέσμου',
      startEndDate: 'Ημερομηνία έναρξης - λήξης',
      actions: 'Ενέργειες',
      offerAdded: 'Προστέθηκε με επιτυχία το banner προσφοράς.',
      offerUpdated: 'Το banner προσφοράς ενημερώθηκε με επιτυχία.',
      offerDeleted: 'Το banner της προσφοράς διαγράφηκε επιτυχώς.',
      weCouldNot: 'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας του slider, δοκιμάστε ξανά αργότερα.',
      validImg: 'Προσθέστε μια έγκυρη εικόνα.',
      areYouSure: 'Είστε βέβαιοι ότι θέλετε να {label} αυτό το banner προσφοράς;',
      pageText: 'Κείμενο σελίδας',
      pickCateg: 'Διαλέξτε κατηγορία',
      pickProd: 'Επιλογή προϊόντος',
      pickLoc: 'Επιλέξτε τοποθεσία',
      none: 'Κανένα',
      banners: 'Πανό',
      offers: 'Προσφορές',
      display: 'Απεικόνιση',
      addGroup: 'Προσθήκη ομάδας',
      offerSuccess: 'Η ομαδική προσφορά προστέθηκε με επιτυχία'
    },
    marketingOffersTypes: {
      category: 'κατηγορία',
      product: 'προϊόν',
      page: 'σελίδα'
    },
    marketingFidelities: {
      fidelities: 'Πιστότητα',
      loyalityPoint: 'Πόντους',
      userLabeling: 'Προσθήκη ετικετών χρήστη',
      name: ' Όνομα',
      ordersValue: 'Αξία παραγγελίας',
      ordersNumber: 'Αριθμός παραγγελιών',
      color: 'Χρώμα',
      notification: 'Ειδοποίηση',
      coupon: 'Κουπόνι',
      product: 'Προϊόν',
      nameLabel: 'Όνομα ετικέτας',
      addLabel: 'Προσθήκη ετικέτας',
      noData: 'Χωρίς δεδομένα',
      updateUserLabeling: 'Ενημερωμένη ετικέτα χρήστη',
      createdUserLabeling: 'Δημιουργήθηκε ετικέτα χρήστη',
      areYouSureDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την ετικέτα;',
      labelDeleted: 'Η ετικέτα διαγράφηκε',
      orderNumberRequired: 'Αυτό το πεδίο ή ο αριθμός εντολών απαιτείται',
      orderValueRequired: 'Αυτό το πεδίο ή, η αξία των παραγγελιών απαιτείται',
      yes: 'Ναι',
      applyCupon: 'Εφάρμοσε το κουπόνι',
      applyproduct: 'Εφαρμογή προϊόντος',
      badgeColor: 'Χρώμα ετικέτας',
      badgeName: 'Όνομα ετικέτας',
      value: ' Αξία',
      number: 'Αριθμός',
      appliedForLastMonth: 'Οι ετικέτες θα ισχύουν μόνο για παραγγελίες εντός των τελευταίων 30 ημερών',
      checkTermsAndConditionFidelities: 'Ελέγξτε τις προσφορές στις σελίδες πληροφοριών',
      labelingPrimaryOption: 'Επιλέξτε την κύρια επιλογή για τις ετικέτες',
      labelingSuccess: 'Η κύρια επιλογή ετικέτας ενημερώθηκε με επιτυχία!',
      updatePrimaryOption: 'Ενημερώστε την επιλογή',
      showLabelOnUser: 'πώς να προσθέσετε ετικέτες στους χρήστες',
      infoAboutShowUserLabelUpdated: 'Ενημερωμένες πληροφορίες σχετικά με την ετικέτα χρήστη της εκπομπής',
      labelingInterval: 'Επιλέξτε ένα διάστημα εφαρμογής',
      '0': 'Διάρκεια Ζωής',
      '30': '30 ημέρες',
      '60': '60 ημέρες',
      '90': '90 ημέρες',
      '120': '120 ημέρες',
      recurrence: 'επανάληψη',
      noReccurence: 'None',
      oneDay: '1 ημέρες',
      threeDays: '3 ημέρες',
      fiveDays: '5 ημέρες',
      sevenDays: '7 ημέρες',
      tenDays: '10 ημέρες',
      fifteenDays: '15 ημέρες',
      twentyDays: '20 ημέρες',
      twentyFiveDays: '25 ημέρες'
    },
    marketingPromos: {
      title: 'Τίτλος',
      treshold: 'Treshold n',
      category: 'Κατηγορία',
      product: 'Προϊόν',
      products: 'Προϊόντα',
      none: 'Κανένας',
      marketingPromos: 'Προώθηση',
      generateQrCode: 'Δημιουργία κωδικού Qr',
      code: 'Κώδικας',
      promoDeleted: 'Η προώθηση διαγράφηκε',
      areYouSureDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την προσφορά ?',
      promoAdded: 'Προστέθηκε η προσφορά',
      promoUpdated: 'Η προώθηση ενημερώθηκε με επιτυχία.',
      weCouldNot: 'Δεν ήταν δυνατή η αποθήκευση των δεδομένων, δοκιμάστε ξανά αργότερα.',
      startEndDate: 'Ημερομηνία Έναρξης - Λήξης',
      image: 'Εικόνα',
      validImg: 'Προσθέστε μια έγκυρη εικόνα.',
      print: 'Τυπώνω',
      firstname: 'Ονομα',
      lastname: 'Επίθετο',
      points: 'Πόντοι',
      email: 'Ηλεκτρονική διέυθυνση',
      description: 'Περιγραφή'
    },
    reports: {
      orderedProducts: 'Παραγγελθέντα Προϊόντα',
      giftCardsSoldTotal: 'Total gift cards sold',
      giftCardsSoldAmount: 'Gift cards sold',
      number: 'Order nr',
      average: 'Μέση τιμή',
      trends: 'Τάσεις',
      clients: 'Πελάτες',
      products: 'Προϊόντα',
      marketing: 'Μάρκετινγκ',
      today: 'Σήμερα',
      orderChart: 'Παραγγελίες',
      clientsChart: 'Πελάτες',
      completed: 'Ολοκληρώθηκε',
      canceled: 'Ακυρώθηκε',
      salesChart: 'Πωλήσεις',
      salesIn: 'Πωλήσεις σε',
      customersChart: 'Πελάτες',
      appInstalls: 'εγκαταστάσεις εφαρμογών',
      custWithAcc: 'Πελάτες με λογαριασμό',
      top10Chart: 'Top 10 προϊόντα',
      top5Chart: 'Top 5 προϊόντα',
      orderingChart: 'Τύποι παραγγελιών',
      nrOfOrders: 'Αριθμός παραγγελιών',
      customersAge: 'Περίοδος πελατών',
      customersGender: 'Πελάτες Φύλο',
      name: 'Ονομα',
      appInstalled: 'Εγκατασταμενες εφαρμογές',
      gender: 'Γένος',
      location: 'Τοποθεσία',
      partnerCode: 'Κωδικός συνεργάτη',
      email: 'ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ',
      phone: 'Τηλέφωνο',
      age: ' Ηλικία',
      filter: 'Φίλτρο',
      label: 'Ετικέτα',
      userDetails: 'Πληροφορίες Πελάτη',
      salesDetails: 'Λεπτομέρειες πωλήσεων',
      salesProductNr: 'Αριθμός πωλήσεων προϊόντων',
      totalAmount: 'Συνολικό ποσό',
      totalProducts: 'Σύνολο προϊόντων',
      ordersNumber: 'Παραγγελίες',
      minAmount: 'Ελάχιστο συνολικό ποσό',
      minOrders: 'Ελάχιστες παραγγελίες',
      maxOrders: 'Μέγιστες παραγγελίες',
      itemsSold: 'Είδη που πωλήθηκαν',
      campaign: 'Καμπάνια',
      couponsTimesUsed: 'Χρήση των χρόνων κουπονιών',
      revenue: 'Εσοδα',
      total: 'Σύνολο',
      paymentType: 'Τρόπος πληρωμής',
      date: 'Ημερομηνία',
      salesReport: 'Αναφορά πωλήσεων',
      salesReportBeta: 'Αναφορά πωλήσεων BETA',
      order: 'Σειρά',
      export: 'Εξαγωγή',
      cash: 'Μετρητά',
      card: 'Κάρτα',
      pos: 'POS',
      tips: 'Φιλοδώρημα',
      totalSum: 'Συνολικό ποσό',
      search: 'Αναζήτηση',
      searchFilter: 'Αναζήτηση (όνομα, ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ, τηλέφωνο)',
      discount: 'Εκπτωση',
      totalDiscount: 'Συνολική έκπτωση',
      ordersWithDiscount: 'Παραγγελίες με Έκπτωση',
      ordersWithFidelity: 'Παραγγελίες με Fidelity',
      totalFidelityDiscount: 'Συνολική Έκπτωση Fidelity',
      clientsWOrders: 'Πελάτες με παραγγελίες',
      emailSend: 'Τα μηνύματα που στάλθηκαν τους τελευταίους 6 μήνες',
      emailTotal: 'Σύνολο email που στάλθηκαν: ',
      newCustomersChart: 'νέοι πελάτες',
      productsSalesReport: 'Πωλήσεις προϊόντων',
      pricePerUnit: 'Τιμή ανά μονάδα',
      quantity: 'Ποσότητα',
      productname: 'Ονομασία προϊόντος',
      couponCode: 'Κουπόνι',
      checkOrder: 'Χρήση παραγγελίας',
      donationReport: 'Αναφορά Δωρεών'
    },
    feedback: {
      sigle: 'Αξιολόγηση',
      type: 'Τύπος',
      sentBy: 'Στάλθηκε από',
      text: 'Κείμενο',
      seen: 'Δει',
      sentAt: 'Αποστολή σε',
      search: 'Αναζήτηση',
      comment: 'Σχόλιο'
    },
    feedbackTypes: {
      feedback: 'Αξιολόγηση',
      issue: 'Θέμα',
      suggestion: 'Πρόταση'
    },
    settings: {},
    blogPage: {
      categories: 'Κατηγορίες',
      categoriesHint: 'Προαιρετικό — τα άρθρα μπορούν να μην έχουν κατηγορία.',
      categoryName: 'Όνομα κατηγορίας',
      noCategories: 'Δεν υπάρχουν κατηγορίες ακόμα.',
      articles: 'Άρθρα',
      addArticle: 'Προσθήκη άρθρου',
      editArticle: 'Επεξεργασία άρθρου',
      allCategories: 'Όλες οι κατηγορίες',
      noCategory: 'Χωρίς κατηγορία',
      allStatuses: 'Όλες οι καταστάσεις',
      searchByTitle: 'Αναζήτηση με τίτλο',
      noArticles: 'Δεν βρέθηκαν άρθρα.',
      cover: 'Εξώφυλλο',
      coverHint: 'προτείνεται 1200x630px, έως 5MB',
      imageAlt: 'Εναλλακτικό κείμενο εικόνας (SEO)',
      title: 'Τίτλος',
      slug: 'Σύνδεσμος άρθρου (slug)',
      slugHint: 'Δημιουργείται από τον τίτλο αν μείνει κενό.',
      shortDescription: 'Σύντομη περιγραφή (κάτω από τον τίτλο)',
      content: 'Περιεχόμενο',
      category: 'Κατηγορία',
      author: 'Συντάκτης',
      publishedAt: 'Ημερομηνία δημοσίευσης',
      publishedAtHint: 'Αν είναι κενό, χρησιμοποιείται η τρέχουσα ημερομηνία κατά τη δημοσίευση.',
      status: 'Κατάσταση',
      published: 'Δημοσιευμένο',
      draft: 'Πρόχειρο',
      scheduled: 'Προγραμματισμένο',
      seo: 'SEO',
      metaTitle: 'Meta τίτλος',
      metaDescription: 'Meta περιγραφή',
      metaKeywords: 'Λέξεις-κλειδιά (χωρισμένες με κόμμα)',
      titleRequired: 'Ο τίτλος είναι υποχρεωτικός.',
      deleteCategoryConfirm: 'Διαγραφή της κατηγορίας "{name}"; {count} άρθρο(α) θα μείνουν χωρίς κατηγορία.',
      deleteArticleConfirm: 'Διαγραφή του άρθρου "{name}";'
    },
    settingsPages: {
      homepageSections: 'Ενότητες αρχικής σελίδας',
      interactiveTour: 'Διαδραστική περιήγηση',
      blog: 'Blog',
      interactiveTourFirstLogin: 'Χρήση διαδραστικής περιήγησης στην πρώτη σύνδεση',
      interactiveTourAlways: 'Χρήση διαδραστικής περιήγησης πάντα',
      interactiveTourDisplayMode: 'Λειτουργία εμφάνισης εικόνας',
      interactiveTourDisplayContain: 'Contain',
      interactiveTourDisplayCover: 'Cover',
      interactiveTourDisplayFullPage: 'Πλήρης σελίδα',
      userSettings: 'Ρυθμίσεις χρήστη',
      myProfile: 'Το προφίλ μου',
      users: 'Χρήστες',
      general: 'Γενικά',
      companyDetails: 'ΣΤΟΙΧΕΙΑ ΕΤΑΙΡΕΙΑΣ',
      dateTime: 'Ημερομηνία και ώρα',
      currency: 'Νόμισμα',
      accounting: 'Λογιστική',
      tax: 'Φόρος',
      payment: 'Πληρωμή',
      orderingMng: 'Διαχείριση παραγγελιών',
      loyalty: 'Πρόγραμμα Επιβράβευσης',
      push: 'Ειδοποιήσεις',
      tips: 'Συμβουλές',
      locationGroups: 'Ομάδες τοποθεσίας',
      locationGroupsName: 'Ονομα',
      locationGroupsDescription: 'Περιγραφή',
      locationGroupsPhoto: 'φωτογραφία',
      locationGroupsAdded: 'Προστέθηκαν νέες ομάδες τοποθεσιών',
      locationGroupsUpdated: 'Οι ομάδες τοποθεσιών ενημερώθηκαν με επιτυχία',
      locationGroupsPicError: 'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας της ομάδας τοποθεσιών. Προσπαθήστε ξανά αργότερα.',
      locationGroupsDelete: 'Διαγράψτε την ομάδα τοποθεσιών',
      locationGroupsAreYouSure: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την ομάδα τοποθεσιών;',
      locationGroupsSelect: 'Επιλέξτε την ομάδα τοποθεσιών στην οποία ανήκετε:',
      subscription: 'Συνδρομή',
      myPlan: 'Το σχέδιό μου',
      infoPages: 'Πληροφορίες Σελίδες',
      taxLabeling: 'Φορολογική επισήμανση',
      deliveryMethods: 'Τοποθεσίες και μέθοδοι παράδοσης',
      filters: 'Φίλτρα',
      filterProducts: 'Προϊόντα φίλτρων'
    },
    settingUsers: {
      single: 'χρήστης',
      fn: 'Ονομα',
      ln: 'Επίθετο',
      email: 'ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ',
      username: 'Όνομα χρήστη',
      lang: 'Γλώσσα διεπαφής',
      langMsg: 'Αυτή είναι η γλώσσα που θα δείτε στην περιοχή διαχείρισης.',
      avatar: 'Avatar',
      role: 'Ρόλος',
      locations: 'Πρόσβαση σε παραγγελίες από τοποθεσίες',
      locations_helptext: 'Σημαντικό: Εάν δεν έχει επιλεγεί τοποθεσία, αυτός ο χρήστης θα έχει πρόσβαση σε όλες τις τοποθεσίες .',
      resetPass: 'Επαναφορά κωδικού πρόσβασης',
      password: 'Κωδικός πρόσβασης',
      pass: 'Κωδικός πρόσβασης',
      confPass: 'Επιβεβαίωση Κωδικού',
      userAdded: 'Νέος χρήστης προστέθηκε με επιτυχία',
      userUpdated: 'Ο χρήστης ενημερώθηκε με επιτυχία',
      userPicError: 'Δεν ήταν δυνατή η αποθήκευση του avatar χρήστη, δοκιμάστε ξανά αργότερα.',
      USER: 'USER',
      DRIVER: 'DRIVER',
      LOCATION_ADMIN: 'LOCATION ADMIN',
      MARKETER: 'MARKETER'
    },
    settingCompany: {
      title: 'Εταιρία',
      location: 'Τοποθεσία',
      name: 'Ονομα',
      selfOrderDomain: 'Self Ordering Domain',
      appLink: 'Link Aplicatie',
      appLinkAndroid: 'Android link aplicatie',
      appLinkIos: 'Ios link aplicatie',
      lang: 'Γλώσσα εφαρμογής',
      bussLoc: 'Τοποθεσία επιχείρησης',
      deliveryLabels: 'Ετικέτες τύπων παραδόσεων',
      deliveryType: 'Τρόπος παράδοσης',
      pick_up: 'Παραλαβή από το κατάστημα',
      meet_half: 'Συνάντηση  στα μισά',
      delivery: 'Διανομή',
      eat_location: 'Φάτε στην τοποθεσία',
      self_ordering: 'Self Ordering',
      phone: 'Τηλέφωνο',
      street: 'Οδός',
      number: '’Οχι .',
      latitude: 'Γεωγραφικό πλάτος',
      longitude: 'Γεωγραφικό μήκος',
      email: 'Ηλεκτρονική διέυθυνση',
      city: 'Πόλη',
      country: 'Χώρα',
      state: 'Περιοχή',
      availableDaysHrs: 'ΔΙΑΘΕΣΙΜΕΣ ΗΜΕΡΕΣ ΚΑΙ ΩΡΕΣ',
      from: 'από',
      to: 'προς το',
      preOrder: 'προ-παραγγελία από',
      allowPreOrder: 'Αφήστε Προπαραγγελία',
      cardPaymentDetails: 'Ρυθμίσεις πληρωμής κάρτας',
      paylikeKeys: 'Paylike χρησιμοποιημένα κλειδιά',
      posDiscount: 'Αναγνωριστικό POS για έκπτωση',
      userTaxes: 'ΦΟΡΟΙ ΧΡΗΣΗΣ',
      noTaxMsg: 'Πληροφορίες: Έχετε κάνει αλλαγές στους φόρους, μην ξεχάσετε να τις αποθηκεύσετε.',
      areYouSureDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την τοποθεσία; Αυτή η ενέργεια θα διαγράψει επίσης τις ρυθμίσεις παραγγελίας για αυτήν την τοποθεσία.',
      pickLocationToCopy: 'Επιλέξτε μια τοποθεσία από την οποία θέλετε να αντιγράψετε τα προϊόντα',
      areYouSureTax: 'Είστε βέβαιοι ότι θέλετε να καταργήσετε αυτόν τον φόρο από τον κατάλογο των φόρων; Μην ξεχάσετε να αποθηκεύσετε τις αλλαγές!',
      companyUpdated: 'Τα δεδομένα της εταιρείας ενημερώθηκαν με επιτυχία.',
      companyProdCopied: 'Τα προϊόντα αντιγράφηκαν με επιτυχία.',
      wrongAddress: ' Η διεύθυνση της &quot;{location}&quot; τοποθεσίας δεν είναι σωστή.',
      deleteLocationValidation: 'Αυτή η τοποθεσία χρησιμοποιείται. Δεν μπορείτε να την διαγράψετε. Πρέπει να την αφαιρέσετε πρώτα από τα προϊόντα όπου χρησιμοποιείται.',
      email_feedback: 'E-mail για λήψη σχολίων από τις εφαρμογές για κινητά',
      email_feedback_helptext: 'Μπορείτε να χρησιμοποιήσετε πολλές διευθύνσεις ηλεκτρονικού ταχυδρομείου διαχωρισμένες με κόμματα.',
      printSettings: 'Ρυθμίσεις εκτύπωσης',
      automatPrintOrder: ' A4 Παραγγελία εκτύπωσης Ιστού αυτόματα',
      autoSendOrderToPrinter: '80 mm παραγγελία εκτύπωσης',
      autoPrintLocalServer: 'Αυτόματη εκτύπωση σημείωσης τμήματος από τον τοπικό διακομιστή (νέες παραγγελίες ή σε επεξεργασία)',
      printerIp: 'Εκτυπωτής IP/Host',
      printerPort: ' Εκτυπωτής Port',
      copyProductsFrom: 'Αντιγραφή προϊόντων από ',
      overEighteen: 'Περιορισμός χρηστών κάτω των 18 ετών (απαιτείται η πώληση αλκοόλ μέσω της εφαρμογής)',
      setRadiusArea: 'Ορίστε την περιοχή της ακτίνας',
      setDrawArea: 'Ορισμός περιοχής κλήρωσης',
      allowPlaceUntilCloseHour: 'Επιτρέψτε τις παραγγελίες μέχρι την ώρα κλεισίματος',
      sortProductsMethods: 'Μέθοδος ταξινόμησης προϊόντων',
      alphabetic_asc: 'Μετά την ανύψωση του ονόματος',
      alphabetic_desc: 'Μετά το όνομα απόγονος',
      price: 'Μετά την τιμή',
      custom: 'Εθιμο',
      infoCustomSort: '(η προσαρμοσμένη ταξινόμηση γίνεται σε κάθε ενότητα επεξεργασίας κατηγορίας)',
      filters: 'φίλτρα',
      allowSoundAtStatusNew: 'Να επιτρέπεται ο ήχος στην κατάσταση παραγγελιών ΝΕΟ',
      allowSoundAtStatusProcessing: 'Επιτρέψτε τον ήχο στην κατάσταση παραγγελιών ΕΠΕΞΕΡΓΑΣΙΑ',
      allowSoundAtStatusProcessingV1: 'Επιτρέπει τον ήχο σύμφωνα με τον προεπιλεγμένο χρόνο αναμονής',
      allowSoundAtStatusProcessingV2: 'Επιτρέπει τον ήχο σύμφωνα με το 1/4 του προεπιλεγμένου χρόνου αναμονής',
      allowSoundAtStatusProcessingV3: 'Επιτρέπει τον ήχο βάσει του 1/2 του προεπιλεγμένου χρόνου αναμονής',
      allowSoundAtStatusProcessingV0: 'Χωρίς ήχο',
      allowToOrderUnderMinValueWithCoupon: 'Επιτρέψτε να κάνετε παραγγελία κάτω από την ελάχιστη τιμή κατά την εφαρμογή κουπονιού',
      allowSoundForMehods: 'Επιτρέπει τον ήχο για τις ακόλουθες μεθόδους παράδοσης'
    },
    settingDateTime: {
      timezone: 'Ζώνη ώρας',
      timeFormat: 'Μορφή ώρας',
      dateFormat: 'Μορφή ημερομηνίας',
      saveMsg: 'Οι ρυθμίσεις ημερομηνίας και ώρας αποθηκεύτηκαν με επιτυχία'
    },
    settingCurrency: {
      currency: 'Νόμισμα καταστήματος',
      saveMsg: 'Τα δεδομένα νομίσματος αποθηκεύτηκαν με επιτυχία'
    },
    settingTaxes: {
      single: 'Φόρος',
      name: 'Ονομα',
      type: 'Τύπος',
      amount: 'Ποσό',
      notice: 'Πληροφορίες: Στο πεδίο &quot;Φορολογία&quot; ορίζετε μόνο ένα όνομα ετικέτας για τον φόρο που πρέπει να εφαρμοστεί. Για να ορίσετε τις φορολογικές λεπτομέρειες όπως η αξία ή ο τύπος που πρέπει να μεταβείτε',
      notice2: 'ΣΤΟΙΧΕΙΑ ΕΤΑΙΡΕΙΑΣ',
      singleTaxLabel: 'Φορολογική ετικέτα',
      notice3: 'Πληροφορίες: Στην ενότητα "Μεταχειρισμένοι φόροι" ορίζετε τους φόρους που εφαρμόζονται, λεπτομέρειες όπως αξία ή τύπος, εάν θέλετε να δημιουργήσετε ετικέτα φόρου μεταβείτε στη διεύθυνση',
      notice4: 'επισήμανση φόρου'
    },
    settingsPayment: {
      publicKey: 'Δημόσιο κλειδί',
      privateKey: 'Ιδιωτικό κλειδί'
    },
    settingsOrdering: {
      shipping_department_id: 'Shipping Department Id',
      distanceInKm: 'Distanta in km',
      min_interval_reservations: 'The number of minutes for interval reservation',
      min_standard_reservations: 'Numarul de ore alocat rezervarii',
      min_between_reservations: 'Numarul de minute intre rezervari',
      available_days: 'Timetable',
      reservation_available_in_app: 'Accepta rezervari la mese in app',
      offnoPreorders: 'You must have offset 0 and period 1 to work',
      noPreorders: 'Nu aceptam precomenzi',
      isAlwaysOpen: 'Always open',
      isAlwaysOpenPreorderHours: 'Preorder hours',
      reservationTaxesTitle: 'Adauga program mese',
      reservationTaxesTitleEmpty: 'Niciun program adaugat',
      reservationTaxAdvanceConsumption: 'Acest preț reprezintă avans în consumație',
      infoBoxTitle: 'Adauga informatii extra',
      infoBoxRadioCheck: 'Modifica optiunea',
      infoBoxRadio: 'O singura optiune',
      infoBoxCheck: 'Mai multe optiuni',
      enabled: 'Ενεργοποιήθηκε',
      paymentOptions: 'Επιλογές πληρωμής',
      paymentOptionsErr: 'Απαιτείται το πεδίο επιλογής πληρωμής.',
      waitingTime: 'Προεπιλεγμένος χρόνος αναμονής',
      minimumOrderValue: 'Ελάχιστη τιμή παραγγελίας',
      minutes: 'λεπτά',
      shippingCost: 'Κόστος αποστολής',
      deliveryRange: 'Εύρος παράδοσης',
      deliveryRangeUnit: 'm',
      posId: 'Κόστος αποστολής POS ID',
      shippingTax: 'Φόρος αποστολής',
      locations: 'Τοποθεσίες',
      street: 'Οδός',
      city: 'Πόλη',
      country: 'Χώρα',
      state: 'Περιοχή',
      availableDays: 'Διαθέσιμες ημέρες και ώρες',
      availableDaysErr: 'Απαιτείται το διαθέσιμο πεδίο επιλογής ημερών και ωρών.',
      notice: 'Ελέγξτε το σφάλμα στις καρτέλες μεθόδων παραγγελίας και, στη συνέχεια, προσπαθήστε να αποθηκεύσετε ξανά τη φόρμα',
      saveSuccess: 'Η παραγγελία δεδομένων στοιχείων αποθηκεύτηκε με επιτυχία',
      deliveryRules: 'Κανόνες παράδοσης',
      addRange: 'Προσθήκη κανόνα',
      shippingCities: 'Πόλη / Χωριά',
      shippingNeighborhoods: ' Γειτονιές',
      citiesValidationError: 'Βεβαιωθείτε ότι οι τιμές της πόλης είναι μοναδικές για κάθε εύρος παράδοσης',
      addZone: 'Προσθήκη ζώνης',
      newZone: 'Νέα ζώνη'
    },
    settingsZone: {
      edit: 'Edit',
      deleteBtn: 'Delete Zone',
      deleteShape: 'Delete Shape to create another one',
      overridePayment: 'Παράκαμψη τρόπου πληρωμής',
      acceptCash: 'Αποδοχή μετρητών',
      acceptCard: 'Αποδοχή κάρτας',
      acceptPos: 'POS κατά την παράδοση (απλήρωτο)'
    },
    settingsInfoPages: {
      single: 'σελίδα',
      noPage: 'Δεν υπάρχουν σελίδες ακόμα.',
      title: 'Τίτλος σελίδας',
      content: 'Περιεχόμενο σελίδας',
      newPage: 'Νέα σελίδα',
      showInHeader: 'Εμφάνιση στην κεφαλίδα',
      showInFooter: 'Εμφάνιση στο υποσέλιδο',
      addedSuccess: 'Η σελίδα αποθηκεύτηκε με επιτυχία.',
      deletedSuccess: 'Η σελίδα διαγράφηκε επιτυχώς',
      deleteMsg: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν τη σελίδα;',
      TERMS_CONDITIONS: 'Οροι και Προϋποθέσεις',
      PRIVACY_POLICY: 'Πολιτική Απορρήτου',
      CONTACT_DETAILS: 'Στοιχεία επικοινωνίας',
      FIDELITIES_PROMOTIONS: 'Προσφορές πιστότητας'
    },
    settingsRewards: {
      single: 'πόντο',
      plural: 'πόντους',
      state: 'κατάσταση',
      points: 'πόντοι',
      moneySpent: 'Χρήματα που ξοδεύτηκαν σε πόντους',
      pointsTo: 'Πόντοι σε χρήματα',
      numberOfcurrencyNeedToSpend: 'Το ποσό των χρημάτων που ο πελάτης πρέπει να ξοδέψει για να κερδίσει 1 πόντο.',
      numberOfpointsToReward: 'Το ποσό των πόντων που χρειάζεται ο πελάτης όταν θέλει να πληρώσει με πόντους.',
      timeInterval: 'Χρονοθήκη',
      fromTime: 'Από',
      toTime: 'Στην τάξη',
      rewardSuccess: 'Τα δεδομένα του προγράμματος επιβράβευσης αποθηκεύτηκαν με επιτυχία'
    },
    settingsPushNotif: {
      order_new: 'Νέο μήνυμα παραγγελίας',
      order_completed_pickup: 'Ολοκληρωμένο μήνυμα παραγγελίας - Παραλαβή',
      order_completed_meet: 'Συμπληρωμένο μήνυμα παραγγελίας - Έλα να συναντηθούμε',
      order_completed_delivery: 'Ολοκληρωμένο μήνυμα παραγγελίας - Διαμονή',
      order_completed_eat: 'Ολοκληρωμένο μήνυμα παραγγελίας - Φάτε στην τοποθεσία',
      order_canceled: 'Ακυρωμένο μήνυμα παραγγελίας',
      notifUpdated: 'Τα δεδομένα ειδοποιήσεις αποθηκεύτηκαν με επιτυχία',
      preview: 'Προεπισκόπηση',
      time: 'χρόνος',
      dateTime: 'ημερομηνία και ώρα',
      persons: 'αριθμός ατόμων',
      timePrev: '45 λεπτά',
      personsPrev: '3',
      dateTimePrev: 'Τρίτη, 15 Φεβρουαρίου 2019, στις 6μμ',
      info: 'Σε περίπτωση που δεν χρειάζεται να εμφανιστεί ο χρόνος παράδοσης, αφήστε κενό το τελευταίο πεδίο.',
      selectedLocations: 'Επιλεγμένες τοποθεσίες:'
    },
    settingsTips: {
      tipsTaxes: 'Συμβουλές φόρους',
      state: 'Χρήση συμβουλών',
      tipsSuccess: 'Χρήση συμβουλών'
    },
    settingsPlans: {
      plan1Title: 'Μηνιαίο',
      plan1Rate: '160 € / μήνα',
      plan1Description: 'Ξεκινήστε με ένα μηνιαίο σταθερό κόστος , ανεξάρτητα από το ποσό των πωλήσεων που πραγματοποιείται μέσω της εφαρμογής.',
      plan2Title: 'Ποσοστό πωλήσεων',
      plan2Rate: '10%',
      plan2Description: 'Πληρώστε καθώς πωλείται. Επιλέξτε το Ποσοστό Πωλήσεων και καταβάλλετε ένα μηνιαίο τέλος σε σχέση με το ποσό που πωλήσατε μέσω της εφαρμογής.',
      current: 'Τρέχουσα συνδρομή',
      switch: 'Αλλαγή',
      value: 'αξία'
    },
    filter: {
      filter: 'Φίλτρο',
      action: 'Ενέργειες',
      create: 'δημιουργία',
      update: 'εκσυγχρονίζω',
      areYouSureDelete: 'Θέλετε σίγουρα να διαγράψετε αυτό το φίλτρο',
      yes: 'Ναί',
      deleted: 'Το φίλτρο διαγράφηκε',
      noFilters: 'Δεν υπάρχουν φίλτρα',
      name: 'Ονομα',
      addFilter: 'Προσθήκη φίλτρου',
      remove: 'αφαιρώ',
      filters: 'φίλτρου',
      filterProducts: 'Προϊόντα φίλτρων',
      filterName: 'Όνομα φίλτρου',
      val: 'βαλ',
      filterUpdated: 'Τα φίλτρα ενημερώθηκαν',
      minOneFilterValueRequired: 'Το ελάχιστο o valoare είναι υποχρεωτικό',
      filterType: 'Τύπος φίλτρου',
      type_exists: 'Ο τύπος φίλτρου υπάρχει',
      filter_value_exists: 'Η τιμή του φίλτρου υπάρχει',
      some_filter_applied: 'Η ενημέρωση ήταν επιτυχής, αλλά ορισμένα φίλτρα εφαρμόζονται στα προϊόντα'
    },
    ordersSource: {
      1: 'Kiosk',
      2: 'Qr',
      3: 'Pos',
      4: 'App',
      5: 'Website',
      6: 'Glovo',
      7: 'Wolt',
      8: 'Bolt'
    },
    checkbox: 'Επιτρέπει την επιλογή πολλαπλών επιλογών στο προϊόν',
    radio: 'Επιτρέπει την επιλογή μίας μόνο επιλογής στο προϊόν',
    ...elLocale
  },
  nl: {
    btPayments: btPayments.en,
    marketplace: marketplace.nl,
    general: {
      search: 'Zoeken',
      home: 'Home',
      add: 'Toevoegen',
      edit: 'Bewerken',
      delete: 'Verwijderen',
      remove: 'Weghalen',
      save: 'Opslaan',
      update: 'Bijwerken',
      cancel: 'Annuleren',
      continue: 'Doorgaan',
      activate: 'activeren',
      deactivate: 'uitschakelen',
      active: 'actief',
      inactive: 'inactief',
      specialPrice: 'Speciale prijs',
      yes: 'Ja',
      no: 'Nee',
      success: 'Succes',
      required: 'vereist',
      back: 'terug',
      next: 'Volgende',
      finish: 'Einde',
      duplicate: 'Duplicaat',
      select: 'Selecteer',
      all: 'Alles',
      reset: 'Reset',
      export: 'Exporteer',
      loadMore: 'Laad Meer',
      viewDetails: 'Details bekijken',
      showing: 'Toon {lengte} resultaat(en)',
      enable: 'activeren',
      disable: 'deactiveren',
      product: 'product',
      logout: 'Afmelden',
      from: 'van',
      to: 'aan',
      cancelCourier: 'Bezorging annuleren',
      agree: 'Bevestigen',
      agreePopupMessage: 'Om de browser audio te laten afspelen, moet u op "Akkoord" klikken. Hiermee wordt een testgeluid afgespeeld om het geluid te activeren',
      day: 'dag',
      notCompleted: 'niet voltooid',
      saveChanges: 'Wijzigingen opslaan',
      doYouWantToLogout: 'Wilt u zich afmelden?',
      minutes: 'minuten',
      hour: 'uur',
      hours: 'uren',
      customSort: 'Bedrijf gebruikt aangepaste sortering',
      deliveryMethod: 'Leveringsmethoden',
      none: 'Geen',
      unset: 'Niet ingesteld'
    },
    menuLink: {
      alias: 'Alias',
      title: 'Titel',
      updated: 'Bijgewerkt',
      areYouSure: 'Weet u zeker dat u de menukoppeling {label} hebt?',
      deleted: 'Verwijderd',
      couldNotUpdate: 'Niet bijgewerkt',
      cancel: 'annuleren',
      delete: 'verwijderen',
      added: 'Menu link toegevoegd',
      promotions: 'Promoties',
      history: 'Geschiedenis',
      orders: 'Bestellingen',
      reservations: 'Reservations',
      favorite_orders: 'Voorkeur bestellingen',
      tutorial: 'Handleiding',
      personal_info: 'Persoonsgegevens',
      single: 'Menu link',
      cancelCourier: 'Bezorging annuleren',
      logout: 'Afmelden',
      from: 'van',
      to: 'aan',
      linkFor: 'Link voor',
      externUrl: 'Externe URL',
      custom: 'Aangepast',
      day: 'dag',
      couldNotSave: 'Kon de menulink niet opslaan'
    },
    pages: {
      login: 'Inloggen',
      register: 'Register',
      recoverPassword: 'Herstel wachtwoord',
      resetPassword: 'Reset wachtwoord',
      dashboard: 'Dashboard',
      orderingManagement: 'Ordermanagement',
      customerDetails: 'Klantgegevens',
      customers: 'Klanten',
      customersGroups: 'Groepen',
      orders: 'Bestellingen',
      reservations: 'Reservations',
      products: 'Producten',
      catalog: 'Catalogus',
      categories: 'Categorieën',
      productOptions: 'Productopties',
      marketing: 'Marketing',
      campaigns: 'Campagnes',
      donationCampaigns: 'Donatie Campagnes',
      raffleCampaigns: 'Loterij campagnes',
      spinningWheelCampaigns: 'Spinning Wheel',
      offersSlider: 'Aanbiedingen Slider',
      reports: 'Rapporten',
      feedback: 'Feedback',
      settings: 'Instellingen',
      logout: 'Afmelden',
      fidelities: 'Fidelity programma',
      topCategory: 'Top categorie',
      infoPagesCustom: 'Aangepaste pagina’s',
      menuLinks: 'Menulinks',
      infoPages: 'Info pagina’s',
      productFilters: 'Productfilters',
      promos: 'Promoties',
      menus: 'Menus',
      clientOrderView: 'Ophalen weergeven'
    },
    infoPages: {
      single: 'pagina',
      title: 'Titel',
      shortDescription: 'Korte Omschrijving',
      updated: 'Bijgewerkt',
      areYouSure: 'Weet u zeker dat u deze pagina wilt verwijderen?',
      deleted: 'Verwijderd',
      couldNotUpdate: 'Kon niet bijwerken',
      added: 'Aangepaste infopagina toegevoegd',
      changeLinkTab: 'Als er een koppeling wordt toegevoegd, wijzigt u het tekstvak met TAB voor volgende en SHIFT + TAB voor vorige',
      infoPages: 'Info pagina’s'
    },
    ordersStatus: {
      bill: 'Bill',
      AWAITING_TRANSPORT: 'Wacht op bezorging',
      CANCELED: 'Geannuleerd',
      DELIVERED: 'Geleverd',
      DRAFT: 'Ontwerp',
      NEW: 'Nieuw',
      ON_HOLD: 'In de wacht',
      POSTPONED: 'Uitgesteld',
      NOT_DELIVERED: 'Niet bezorgd',
      PICKED_UP_BY_DELIVERY: 'Opgehaald voor bezorging',
      PROCESSING: 'Verwerking',
      PREPARED: 'Voorbereid',
      TRANSPORT: 'Onderweg',
      RESERVED: 'Gereserveerd',
      COMPLETED: 'Voltooid',
      FINISH: 'Voltooid',
      reservedReady: 'Gereserveerd / Gereed',
      completedReady: 'Voltooid / Gereed',
      deliveredReady: 'Afgeleverd / Klaar'
    },
    ordersTypes: {
      GROUP: 'Groep',
      SINGLE: 'Enkel'
    },
    paymentTypes: {
      CASH: 'Cash',
      CARD: 'Online (Kaart)'
    },
    paymentStatus: {
      notPaid: 'Geautoriseerd (bedrag geblokkeerd)',
      notPaidDetails: 'Het bedrag wordt in rekening gebracht zodra de bestelling is gemarkeerd als Afgeleverd',
      paid: 'Betaald',
      notOk: 'Geweigerd'
    },
    campaignsModes: {
      AUTO: 'Auto',
      MANUAL: 'Handleiding'
    },
    campaignsNotificationTypes: {
      EMAIL: 'Email',
      PUSH: 'Push-melding'
    },
    days: {
      monday: 'Maandag',
      tuesday: 'Dinsdag',
      wednesday: 'Woensdag',
      thursday: 'Donderdag',
      friday: 'Vrijdag',
      saturday: 'Zaterdag',
      sunday: 'Zondag'
    },
    gender: {
      selectGender: 'Selecteer geslacht',
      male: 'mannelijk',
      female: 'vrouwelijk',
      Male: 'Man',
      Female: 'Vrouw',
      Other: 'Ander'
    },
    reportsAgesGroups: {
      selectAge: 'Selecteer leeftijd',
      '20': 'Jonger dan 20',
      'Under 20': 'Under 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      '50+': '50+',
      Unspecified: 'Niet gespecificeerd'
    },
    deliveryTypes: {
      DELIVERY: 'Levering',
      EAT_LOCATION: 'Reserveer een tafel',
      MEET_HALF: 'Ontmoet me halverwege',
      PICK_UP: 'Ophalen'
    },
    couponsTypes: {
      FIXED: 'Vast',
      PERCENTAGE: 'Percentage',
      FREE_PRODUCT: 'Gratis product'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Vast (inbegrepen)',
      PERCENTAGE_INCLUDED: 'Percentage (inbegrepen)',
      FIXED_EXCLUDED: 'Vast (exclusief)',
      PERCENTAGE_EXCLUDED: 'Percentage (exclusief)'
    },
    productOptions: {
      checkbox: 'Hiermee kunt u meerdere product opties selecteren',
      radio: 'Maakt het mogelijk om slechts één product optie te selecteren'
    },
    validations: {
      areYouSureYouWantTo: 'Weet je zeker dat je wilt',
      areYouSure: 'Weet je zeker dat je de status wilt bijwerken naar ',
      wentWrong: 'Er is iets misgegaan, probeer het later nog eens...',
      pictureSize: 'jpg/png bestanden met een grootte kleiner dan 5MB',
      pictureSizeExceed: 'De beeldgrootte mag niet groter zijn dan 5 MB!',
      pdfSize: 'pdf bestanden met een grootte kleiner dan 25MB',
      pdfSizeExceed: 'De pdf-grootte mag niet groter zijn dan 25MB!',
      archiveSizeExceed: 'De bestandsgrootte mag niet groter zijn dan 500MB!',
      wrongFormat: 'Verkeerd formaat',
      removePhoto: 'Verwijder het huidige bestand om een nieuw bestand toe te kunnen voegen',
      dataCouldNotBeSaved: 'Gegevens kunnen niet worden opgeslagen, probeer het later opnieuw. ',
      passReq: 'Wachtwoordveld id vereist.',
      passMin: 'Wachtwoord moet minimaal 6 tekens bevatten.',
      passConf: 'Wachtwoord en wachtwoordbevestiging komen niet overeen.',
      validPoinsNo: 'Voeg een geldig geldbedrag en een opmerking toe.',
      imageResolution: 'aanbevolen resolutie: 300px hoogte en 820px breedte.',
      imageResolutionWeb: 'aanbevolen resolutie: 300px hoogte en 1920px breedte.',
      doYouWantTo: 'Wilt u',
      hourIsSmallerThanCreated: 'Het uur dat u instelt is eerder dan het afgesproken uur',
      vatPrinterIdRange: '0–10 only.',
      vatPrinterIdNumeric: 'Numbers only.'
    },
    upload: {
      uploadLabel: 'Menu Uploaden',
      browse: 'Bladeren',
      download: 'QR-Code Downloaden'
    },
    dashboard: {
      selectLocation: 'Locatie:',
      tile1Title: 'Nieuw Bestellingen',
      tile2Title: 'Totaal aantal bestellingen',
      tile3Title: 'Opbrengst',
      tile4Title: 'Nieuw geregistreerde gebruikers',
      today: 'Vandaag',
      orderChart: 'Bestellingen',
      completed: 'Aantal bestellingen',
      canceled: 'Geannuleerd',
      salesChart: 'Verkoop',
      salesIn: 'Verkoop in',
      top5Chart: 'Top 5 producten',
      orderingChart: 'Besteltypes',
      nrOfOrders: 'Aantal bestellingen',
      nrOfEmails: 'Aantal emails'
    },
    customers: {
      noCustomer: 'Geen klant geselecteerd',
      single: 'Klant',
      plural: 'Klanten',
      title: 'KLANT DETAILS',
      pointsTitle: 'Klant loyaliteits punten',
      currentPoints: 'Huidige punten',
      pointsAddTitle: 'Punten toevoegen',
      pay: 'Pay Type',
      id: 'ID',
      name: 'Naam',
      email: 'Email',
      phone: 'Telefoon',
      use_calling_phone: 'Preia numar telefon',
      gender: 'Geslacht,',
      birth: 'Verjaardag',
      location: 'Locatie',
      address: 'Adres',
      number: 'Nummer',
      dateCreated: 'Datum aangemaakt',
      delivery: 'Levering',
      type: 'Type',
      status: 'Status',
      total: 'Totaal',
      allTimeSale: 'All time sale',
      none: 'Geen',
      pointsLabel: 'Uitgegeven geld',
      pointsLabelInPoints: 'Points earned',
      pointsAdjustmentHelp: 'Voer een positieve waarde in om punten toe te voegen of een negatieve waarde (bijv. -100) om punten van het klantensaldo af te trekken.',
      points: 'points',
      point: 'point',
      clientCanUse: 'Customer can use',
      commentsLabel: 'Commentaar',
      pointsSuccess: 'Loyaliteitspunten succesvol toegevoegd',
      pointsError: 'We konden de punten niet toevoegen aan de klant',
      addCommentPerClient: 'Opmerking toevoegen per client',
      newCommentAdded: 'De opmerking is toegevoegd',
      filters: {
        withOrders: 'Met bestellingen',
        withoutOrders: 'Zonder bestellingen'
      },
      addGroup: 'Groep toevoegen',
      deleteGroup: 'Groep succesvol verwijderd.',
      saveGroup: 'Groep is succesvol toegevoegd',
      updateGroup: 'Groep is succesvol bijgewerkt'
    },
    orders: {
      counterPerCustomer: 'Aantal bestelling',
      noOrders: 'Geen bestelling geselecteerd',
      single: 'bestelling',
      the_order: 'Order',
      plural: 'Orders',
      status: 'Status',
      location: 'Locatie',
      updateStatus: 'Update status',
      editOrder: 'Edit Order',
      ordDetails: 'Bestelgegevens',
      date: 'Datum',
      madeAt: 'Bestelling gedaan bij',
      pickupTime: 'Bezorgen /ophalen bij',
      preorder: 'PRE-ORDER',
      preorderFilter: 'Voorbestellingen',
      allOrders: 'Alle bestellingen',
      pendingPreorders: 'Openstaande voorbestellingen',
      withoutPendingPreorders: 'Zonder openstaande voorbestellingen',
      reservationTime: 'Reserveringstijd',
      reservationSeats: 'Zitplaatsen reserveren',
      rating: 'Waardering',
      meetupLocation: 'Ontmoetingsplaats',
      ordLocation: 'Bestel locatie',
      delivery: 'Levering',
      type: 'Type',
      payment: 'Betaling',
      name: 'Naam',
      qty: 'Qty',
      unit: 'Eenheidsprijs',
      unit_price: 'Eenheidsprijs',
      final_price: 'Eindprijs',
      total: 'Total',
      totals_subtotals: 'Subtotaal',
      totals_discount: 'Korting',
      totals_discount_loyalty_points: 'Korting van loyaliteitpunten',
      totals_grandtotal: 'Total',
      totals_shipping: 'Bezorging',
      totals_extras: 'Boodschappentas',
      totals_extras_30: 'Boodschappentas',
      totals_extras_38: 'Boodschappentas',
      totals_extras_40: 'Boodschappentas',
      totals_extras_50: 'Ambalaj',
      totals_tip: 'Tips',
      totals_donation: 'Donatie',
      custComments: 'Klantcommentaar',
      adminComments: 'Admin Commentaar',
      custDetails: 'Klantgegevens',
      shipping: 'Verzendadres',
      billing: 'Factuuradres',
      orderStatusSuccess: 'De status van de bestelling is bijgewerkt',
      orderPrinterError: 'maar er is een fout opgetreden in de verbinding met de printer.',
      orderCommnetSuccess: 'Het ordercommentaar is met success bijgewerkt. ',
      orderHourSuccess: 'Bestellevering / ophaaltijd is succesvol bijgewerkt. ',
      orderHourError: 'Selecteer een geldig tijd. ',
      none: 'Geen commentaar',
      at: 'bij',
      filtersApplied: 'Filters toegepast - klik op de filterknop om meer te zien.',
      customFilters: 'Aangepaste filters toegepast',
      resetFilters: 'Klik hier voor reset en de gegevens te zien',
      note: 'Aantekening',
      orderNoArticulate: 'Order',
      print: 'Afdrukken (A4) ',
      printerPrint: 'Afdrukken (80mm)',
      printerSuccess: 'Bestelling is succesvol afgedrukt.',
      printerErrror: 'Er is een fout opgetreden tijdens het verbinden met de printer',
      callCourier: 'Bel bezorger',
      callHioCourier: 'Hio',
      callCourierCancel: 'Weet u zeker het gesprek met de bezorger te annuleren?',
      orderSentSuccess: 'Bezorgersoproep is succesvol verzonden',
      orderCancelSuccess: 'Bezorgersoproep is geannuleerd',
      packageDetails: 'Pakketdetails selecteren',
      packageSize: 'Verpakkingsgrootte',
      courierTime: 'Ophaaltijd bezorger',
      now: 'Nu',
      addTime: 'Tijd toevoegen',
      amountRefunded: 'Terugbetaald bedrag',
      amountIntegralRefunded: 'Het volledig bedrag is terugbetaald aan de klant',
      refundSuccess: 'Met succes terugbetaald bedrag',
      refundManual: 'Bedrag wordt handmatig geretourneerd van de paylike',
      refundAutomat: 'Wilt u het bedrag automatisch terugbetalen? ',
      refundOrder: 'Terugbetalen',
      refundAlreadyDone: 'Al terugbetaald',
      refundConfirmTitle: 'Bestelling terugbetalen?',
      refundConfirmText: 'Het betaalde bedrag wordt via EuPlatesc aan de klant terugbetaald. Deze actie kan niet ongedaan worden gemaakt.',
      refundAskCancel: 'Terugbetaling voltooid. Wilt u de bestelling ook annuleren?',
      refundError: 'Er is een fout opgetreden bij het verwerken van de terugbetaling.',
      orderCloseToDelivery: 'Bestel met een vaste levertijd',
      erorrPaylike: 'Fout van Paylike, er is een fout gemaakt'
    },
    companyOptions: {
      id: 'Id',
      name: 'Name',
      image: 'Image',
      type: 'Type',
      deleteQues: 'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',
      deleteVal: 'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',
      active: 'Active'
    },
    catalogProd: {
      noProducts: 'Geen product geselecteerd',
      single: 'product',
      plural: 'producten',
      generalDetails: 'Algemene details',
      name: 'Naam',
      desc: 'Beschrijving',
      image: 'Afbeelding',
      category: 'Categorie',
      price: 'Prijs',
      oldPrice: 'Oude prijs',
      newPrice: 'Nieuwe prijs',
      useDiscountPrice: 'Gebruik kortingsprijs',
      taxes: 'Toegepaste belastingen',
      status: 'Status',
      posid: 'POS-ID',
      allowUserComments: 'Gebruikerscommentaar toestaan',
      availableInStore: 'Alleen verkrijgbaar in de winkel',
      validFromTo: 'Geldig van - tot',
      prodType: 'Product type',
      singleType: 'single',
      groupType: 'groep',
      rewardPoints: 'Beloningspunten',
      moneySpent: 'Geld voor Punten',
      numberOfYouNeedToSpend: 'Bedrag {valuta} dat de klant moet uitgeven om een loyaliteitspunt te krijgen.',
      points: 'punten',
      soldWith: 'Verkocht met',
      pickAnOption: 'Kies een optie',
      minNoSelected: 'Min aantal geselecteerd',
      maxNoSelected: 'Max aantal geselecteerd',
      optVal: 'Waarde',
      leaveEmpty: 'Laat leeg of zet 0 indien optie geen extra kosten heeft',
      prodDeleted: 'Product succesvol verwijderd',
      prodAdded: 'Product succesvol toegevoegd',
      prodUpdated: 'Product succesvol bijgewerkt',
      prodPhotoError: 'We konden de productfoto niet opslaan, probeer het later opnieuw',
      rewardPossibelValue: 'Mogelijke waarden',
      errorOptions: 'Zorg ervoor dat alle productvelden correct zijn ingevuld.',
      locationSettings: 'Locatie-instellingen',
      availableIn: 'Beschikbaar in',
      deliveryMethodsandHours: 'Bezorgingsmethoden en -uren',
      overrideSettings: 'Overschrijf de instellingen',
      addLocationValidation: 'Sommige productopties zijn niet compatibel met de geselecteerde locaties, als u doorgaat, worden de opties verwijderd, zo niet, dan wordt de locatie niet toegevoegd',
      productAvailableIn: 'Product is beschikbaar in',
      particularLocationSettings: 'Aangepaste instellingen per locatie',
      activateParticularSettings: 'Activeer de aangepaste instellingen',
      withoutThisOptionDefault: '*zonder deze optie te activeren worden de standaardinstellingen gebruikt',
      highlightsProduct: 'Highlight product',
      search: 'Zoeken',
      availability: 'Beschikbaarheid',
      setLimitedAvailability: 'Beperkte beschikbaarheid instellen',
      leaveEmptyAvailability: 'Laat onbeperkt leeg',
      timeOptions: 'Opties voor datumtijd',
      picktimeOptions: 'Kies een optie',
      timeOptionsValues: {
        none: 'Geen',
        dateTimePicker: 'Datum tijdkiezer',
        dateRangePicker: 'Datum bereikkiezer'
      },
      maxQuantityIn: 'Maximum hoeveelheid in',
      unitOfTime: 'tijdseenheid',
      youChoose: 'Je kiest',
      isUsedFor: 'Wordt alleen gebruikt voor de locatie die is ingesteld.',
      isHiddenFromListing: 'Verbergen voor productenlijst',
      isHiddenFromSearch: 'Verbergen voor producten zoeken',
      isHiddenFromQrMenu: 'Hide from Qr menu',
      Monday: 'ma',
      Tuesday: 'di',
      Wednesday: 'wo',
      Thursday: 'do',
      Friday: 'vr',
      Saturday: 'za',
      Sunday: 'zo',
      accesRestricted: 'Sorry, u heeft geen toegang tot dit product',
      changeLocations: 'Change locations',
      includeAllLocationsProducts: 'Include also the products available in all locations',
      bulkLocationsMode: 'Action',
      bulkModeAdd: 'Add',
      bulkModeRemove: 'Remove',
      bulkModeReplace: 'Replace',
      massUpdate: 'Mass update',
      massUpdateSubtitle: 'You are about to update {count} products',
      bulkActionActive: 'Active / Inactive',
      bulkActionPrice: 'Price',
      bulkActionVat: 'VAT',
      bulkActionSection: 'Section',
      bulkActionOptionGroups: 'Option groups',
      bulkActionDelete: 'Delete',
      bulkOverrideDeliveryHint: 'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',
      bulkOverrideLocationsHint: 'Leave empty to use all company locations. Only locations that already belong to each product are applied.',
      bulkOverrideAddIntervalHint: 'Click + to add a schedule interval for this method.',
      bulkPriceDirection: 'Direction',
      bulkPriceIncrease: 'Increase',
      bulkPriceDecrease: 'Decrease',
      bulkPriceMode: 'Type',
      bulkPriceFlat: 'Flat amount',
      bulkPricePercent: 'Percentage (%)',
      bulkPriceAmount: 'Amount',
      bulkPriceBaseOnlyHint: 'Only the base price is changed. The new price will never go below 0.',
      bulkOptionGroupsMode: 'Association mode',
      bulkOptionGroupsModeHint: 'Add keeps existing groups. Replace overwrites them with the selected ones.',
      bulkDeleteWarning: 'This will permanently delete {count} products. This action cannot be undone easily.',
      bulkDeleteEnableLabel: 'Yes, delete the selected products (other mass actions will be ignored)',
      confirmBulkMultiple: 'Apply these changes to {count} {products}:',
      bulkProductSingular: 'product',
      bulkProductPlural: 'products',
      confirmBulkAreYouSure: 'Are you sure?',
      bulkSummaryAddLocations: 'add locations ({value}) to {count} {products}',
      bulkSummaryRemoveLocations: 'remove locations ({value}) from {count} {products}',
      bulkSummarySetActive: 'set {count} {products} as active',
      bulkSummarySetInactive: 'set {count} {products} as inactive',
      bulkSummaryIncreasePriceFlat: 'increase the base price of {count} {products} by {amount} {currency}',
      bulkSummaryIncreasePricePercent: 'increase the base price of {count} {products} by {amount}%',
      bulkSummaryDecreasePriceFlat: 'decrease the base price of {count} {products} by {amount} {currency}',
      bulkSummaryDecreasePricePercent: 'decrease the base price of {count} {products} by {amount}%',
      bulkSummaryAddOptionGroups: 'add option groups ({value}) to {count} {products}',
      bulkSummaryReplaceOptionGroups: 'replace option groups on {count} {products} with ({value})',
      bulkSummarySetVat: 'set VAT {value} on {count} {products}',
      bulkSummarySetSection: 'set section {value} on {count} {products}',
      bulkSummaryEnableOverride: 'enable override settings on {count} {products}',
      bulkSummaryEnableOverrideWithSchedule: 'replace override schedules on {count} {products}',
      bulkSummaryDisableOverride: 'disable override settings on {count} {products}',
      bulkSummaryDelete: 'delete {count} {products}',
      bulkSummaryGeneric: 'update {count} {products}',
      confirmBulkAddLocations: 'Are you sure you want to add locations to {count} products?',
      confirmBulkRemoveLocations: 'Are you sure you want to remove locations from {count} products?',
      confirmBulkSetActive: 'Are you sure you want to set {count} products as active?',
      confirmBulkSetInactive: 'Are you sure you want to set {count} products as inactive?',
      confirmBulkIncreasePriceFlat: 'Are you sure you want to increase the base price of {count} products by {amount}?',
      confirmBulkIncreasePricePercent: 'Are you sure you want to increase the base price of {count} products by {amount}%?',
      confirmBulkDecreasePriceFlat: 'Are you sure you want to decrease the base price of {count} products by {amount}?',
      confirmBulkDecreasePricePercent: 'Are you sure you want to decrease the base price of {count} products by {amount}%?',
      confirmBulkAddOptionGroups: 'Are you sure you want to add option groups to {count} products?',
      confirmBulkReplaceOptionGroups: 'Are you sure you want to replace option groups on {count} products?',
      confirmBulkSetVat: 'Are you sure you want to set VAT on {count} products?',
      confirmBulkSetSection: 'Are you sure you want to set the section on {count} products?',
      confirmBulkDelete: 'Are you sure you want to delete {count} products?',
      confirmBulkGeneric: 'Are you sure you want to update {count} products?',
      bulkLocationsUpdated: 'Updated locations for {updated} products',
      bulkMassUpdated: 'Updated {updated} products',
      couldNotFetchProductOptions: 'Could not fetch product options. Please contact support.'
    },
    catalogProdRewardsHints: {
      hint1: 'Laat leeg om de standaardwaarden van instellingen toe te passen',
      hint2: 'Zet 0 als je geen beloningsprogramma op dit product wilt',
      hint3: 'Voeg een positieve waarde toe om de standaardwaarde van instellingen te overschrijven'
    },
    catalogCateg: {
      single: 'categorie',
      plural: 'categorieën',
      color: 'Culoare',
      name: 'Naam',
      image: 'Afbeelding',
      displayType: 'Weergavetype',
      shortDescription: 'Korte Omschrijving',
      validFromTo: 'Geldig van - tot',
      areYouSure: 'Weet u zeker dat u deze categorie wilt {labelen)?',
      categAdded: 'Categorie is succesvol toegevoegd',
      categUpdated: 'Categorie is succesvol bijgewerkt',
      categDeleted: 'Categorie is met succes verwijderd',
      couldNotSave: 'We konden de foto niet opslaan in deze categorie, probeer het later opnieuw.',
      List: 'Lijst',
      Grid: 'Grid',
      assignTopCategory: 'Toewijzen aan een topcategorie',
      pleaseSelect: 'Selecteer / Niet van toepassing',
      categoriesWithoutParent: 'Categorieën zonder koppeling',
      topCategory: 'Top Categorie',
      overrideSettingsHelp: 'Indien ingeschakeld verschijnt deze categorie alleen in het menu voor de geselecteerde locatie, bezorgmethode, dag en tijdsvenster.',
      schedule: 'Rooster',
      useSchedule: 'Rooster gebruiken',
      scheduleActive: 'Rooster actief',
      scheduleHelp: 'Eén rooster voor deze topcategorie in alle locaties. Buiten deze uren is bestellen uit deze categorie niet beschikbaar in de app.'
    },
    catalogProdOpt: {
      single: 'Optie',
      plural: 'Opties',
      new: 'Nieuwe optie',
      name: 'Naam',
      type: 'Type',
      value: 'Waarde',
      values: 'Waarden',
      posid: 'POS-ID',
      optionSaved: 'Productopties zijn met succes opgeslagen',
      areyouSure: 'Weet u zeker deze optie te willen verwijderen?',
      optLocationError: 'de optie {opt_name} moet {loc_name} bevatten voor beschikbare locaties',
      menuQr: 'QR-menu',
      displayInMenu: 'Weergeven in QR-menu'
    },
    marketingCampaigns: {
      single: 'campagne',
      plural: 'campagnes',
      name: 'Naam',
      nameHelper: 'Deze naam wordt gebruikt als onderwerp voor de emailmeldingen die voor deze campagne worden verzonden',
      image: 'Afbeelding',
      startEnd: 'Begin - Einddatum',
      daysLeft: 'Dagen over',
      timesUsed: 'Gebruikte tijden',
      status: 'Status',
      actions: 'Acties',
      send: 'Verzenden',
      in_queue: 'To be sent',
      sent: 'Total sent',
      notif_sent: 'Notification',
      email_sent: 'E-mail',
      areYouSureNotif: 'Weet u zeker deze meldingen te willen verzenden?',
      notifSent: 'Meldingen zijn verzonden.',
      campaignDeleted: 'Campagne is verwijderd.',
      areYouSureDelete: 'Weet u zeker dat u wilt verwijderen',
      campaignAdded: 'Campagne is succesvol toegevoegd',
      campaignUpdated: 'Campagne is succesvol bijgewerkt',
      campaignPhotoError: 'We konden de campagnefoto niet opslaan, probeer het later opnieuw.',
      campaignDetails: 'Campagnedetails',
      description: 'Omschrijving',
      maxDescription: ' (max. 400 tekens) ',
      characters: 'Karakters',
      validFromTo: 'Geldig van - tot',
      notif: 'Kennisgevingen',
      model: 'Model',
      setHours: 'Uren instellen',
      selectTime: 'Tijd selecteren',
      chooseTarget: 'Kies de doelgroep',
      gender: 'Geslacht',
      age: 'Leeftijd',
      city: 'Stad',
      location: 'Locatie',
      visibleInLocations: 'Zichtbaar op de volgende locaties',
      visibleInLocationsInfo: 'Deze functionaliteit is alleen beschikbaar in de Applicatie',
      ordersAbove: 'Bestelling boven',
      addCoupon: 'Coupon toevoegen',
      applyTo: 'Toepassen op',
      value: 'Waarde',
      code: 'Code',
      addValue: 'Waarde toevoegen',
      minValue: 'minimum te besteden',
      counter_max_usage: 'Hoeveel keer kan iemand deze coupon gebruiken? ',
      counter_max_usage_total: 'Hoe vaak kan deze coupon in totaal worden gebruikt? ',
      counter_max_usage_example: 'Typ een getal in voor het maximale aantal gebruik per persoon. Type 0 voor onbeperkt. ',
      counter_max_usage_total_example: 'Typ een getal in voor het maximale aantal gebruik. Type 0 voor onbeperkt. ',
      generateCode: 'Code genereren',
      Products: 'Producten',
      Shipping: 'Verzending',
      chooseCategProduct: 'Kies categorieën of producten waarop de coupon van toepassing is: ',
      delivery_methods: 'Op welke leveringsmethoden moet de coupon worden toegepast? ',
      order_source_ids: 'Order sources',
      order_source_ids_all: 'All sources',
      order_source_ids_help: 'Leave empty to apply on all order sources.',
      location_ids: 'Op welke locatie moet de coupon worden toegepast? ',
      sendNotificationTo: 'Melding verzenden naar',
      chooseDayForInterval: 'Kies het dageninterval',
      chooseHoursForInterval: 'Kies de intervaluren',
      useInterval: 'Gebruiksinterval',
      intervalMustBeSet: 'Interval moet worden ingesteld',
      isCumulativeCheck: 'Deze coupon is cumulatief geldig',
      isAutoApplyCheck: 'Deze coupon is rechtstreeks van toepassing',
      campaignWasSent: 'Campagne werd verzonden in de laatste 30 minuten',
      isSecondUseCheck: 'Deze coupon is direct geldig na het eerste gebruik',
      groups: 'Klantengroepen',
      freeProduct: 'Gratis product om toe te voegen aan winkelwagen',
      freeProductPlaceholder: 'Selecteer een product',
      freeProductRequired: 'Selecteer een gratis product'
    },
    marketingOffers: {
      single: 'aanbiedingsbanner',
      plural: 'banners aanbieden',
      title: 'Titel',
      status: 'Status',
      image: 'Afbeelding',
      imageWeb: 'Webafbeelding',
      imageBanner: 'Imagine Banner',
      imageLanding: 'Imagine Landing',
      linkType: 'Link type',
      startEndDate: 'Start - Einddatum',
      actions: 'Acties',
      offerAdded: 'Aanbiedingsbanner succesvol toegevoegd',
      offerUpdated: 'Aanbiedingsbanner succesvol bijgewerkt. ',
      offerDeleted: 'Aanbiedingsbanner met succes verwijderd',
      weCouldNot: 'We konden de slider-foto niet opslaan, probeer het later opnieuw',
      validImg: 'Voeg een geldige afbeelding toe. ',
      areYouSure: 'Weet u zeker dat u deze aanbiedingsbanner wilt {labelen}?',
      pageText: 'Paginatekst',
      pickCateg: 'Categorie',
      pickProd: 'Kies Product',
      pickLoc: 'Kies locatie',
      none: 'Geen',
      banners: 'Spandoeken',
      offers: 'Aanbiedingen',
      display: 'Weergave',
      addGroup: 'Groep toevoegen',
      offerSuccess: 'Groepsaanbieding succesvol toegevoegd'
    },
    marketingOffersTypes: {
      category: 'categorie',
      product: 'product',
      page: 'pagina'
    },
    marketingFidelities: {
      fidelities: 'Trouw',
      loyalityPoint: 'Loyaliteitspunten',
      userLabeling: 'Gebruikerslabels',
      name: 'Naam',
      ordersValue: 'Orderwaarde',
      ordersNumber: 'Bestelnummer',
      color: 'Kleur',
      notification: 'Kennisgeving',
      coupon: 'Coupon',
      product: 'Product',
      nameLabel: 'Labelnaam',
      addLabel: 'Label toevoegen',
      noData: 'Geen Data',
      updateUserLabeling: 'Bijgewerkte gebruikerslabels',
      createdUserLabeling: 'Gebruikerslabels gemaakt',
      areYouSureDelete: 'Weet u zeker dat u dit label wilt verwijderen',
      labelDeleted: 'Label is verwijderd',
      orderNumberRequired: 'De ordernummers zijn vereist op dit veld',
      orderValueRequired: 'De orderwaarde is vereist op dit veld',
      yes: 'Ja',
      applyCupon: 'Pas de coupon toe',
      applyproduct: 'Product aanpassen',
      badgeColor: 'Kleur Kaart',
      badgeName: 'Naam Kaart',
      value: 'Waarde',
      number: 'Nummer',
      appliedForLastMonth: 'Labels worden alleen toegepast voor de bestellingen die in de afgelopen 30 dagen zijn geplaatst',
      checkTermsAndConditionFidelities: 'Controleer acties van de info pagina’s',
      labelingPrimaryOption: 'Selecteer de primaire optie voor de labels',
      labelingSuccess: 'De instellingen voor labels zijn met succes bijgewerkt',
      updatePrimaryOption: 'Update optie',
      showLabelOnUser: 'Label weergeven op gebruikers',
      infoAboutShowUserLabelUpdated: 'Info over het gebruikerslabel is bijgewerkt',
      labelingInterval: 'Selecteer het toepasbaarheidsinterval',
      '0': 'Levenslang',
      '30': '30 dagen',
      '60': '60 dagen',
      '90': '90 dagen',
      '120': '120 dagen',
      recurrence: 'Herhaal',
      noReccurence: 'Geen',
      oneDay: '1 dag',
      threeDays: '3 dagen',
      fiveDays: '5 dagen ',
      sevenDays: '7 dagen ',
      tenDays: '10 dagen ',
      fifteenDays: '15 dagen ',
      twentyDays: '20 dagen',
      twentyFiveDays: '25 dagen'
    },
    marketingPromos: {
      title: 'Titel',
      treshold: 'Drempel n',
      category: 'Categorie',
      product: 'Product',
      products: 'Producten',
      none: 'Geen',
      marketingPromos: 'Promotie',
      generateQrCode: 'Qr-code genereren',
      code: 'Code',
      promoDeleted: 'Promotie verwijderd',
      areYouSureDelete: 'Weet je zeker dat je deze promotie wilt verwijderen?',
      promoAdded: 'Promotie toegevoegd',
      promoUpdated: 'Promotie geüpdatet.',
      weCouldNot: 'We konden de gegevens niet opslaan, probeer het later opnieuw.',
      startEndDate: 'Begin - Einddatum',
      image: 'Afbeelding',
      validImg: 'Voeg een geldige afbeelding toe.',
      print: 'Afdrukken',
      firstname: 'Voornaam',
      lastname: 'Achternaam',
      points: 'Punten',
      email: 'E-mail',
      description: 'Beschrijving'
    },
    reports: {
      orderedProducts: 'Bestelde producten',
      giftCardsSoldTotal: 'Total gift cards sold',
      giftCardsSoldAmount: 'Gift cards sold',
      number: 'Order nr',
      average: 'Gemiddeld',
      trends: 'Trends',
      clients: 'Klanten',
      products: 'Producten',
      marketing: 'Marketing',
      today: 'Vandaag',
      orderChart: 'Bestellingen',
      clientsChart: 'Klanten',
      completed: 'Voltooid',
      canceled: 'Geannuleerd',
      salesChart: 'Verkoop',
      salesIn: 'Verkoop in',
      customersChart: 'Klanten',
      appInstalls: 'App installeert',
      custWithAcc: 'Klanten met een account',
      top10Chart: 'Top 10 producten',
      top5Chart: 'Top 5 producten',
      orderingChart: 'Besteltypes',
      nrOfOrders: 'Aantal bestellingen',
      customersAge: 'Klanten leeftijd',
      customersGender: 'Geslacht van klant',
      name: 'Naam',
      appInstalled: 'App geïnstalleerd',
      gender: 'Geslacht',
      location: 'Locatie',
      partnerCode: 'Partnercode',
      email: 'Email',
      phone: 'Telefoon',
      age: 'Leeftijd',
      filter: 'Filter',
      label: 'Etiket',
      userDetails: 'Klantgegevensv',
      salesDetails: 'Verkoopgegevens',
      salesProductNr: 'Productverkoopnummer',
      totalAmount: 'Totaal producten',
      totalProducts: 'Σύνολο προϊόντων',
      ordersNumber: 'Bestellingen',
      minAmount: 'Minimum Totaal bedrag',
      minOrders: 'Minimum bestellingen',
      maxOrders: 'Maximum bestellingen',
      itemsSold: 'Verkochte artikelen',
      campaign: 'Campagne',
      couponsTimesUsed: 'Aantal coupons gebruik',
      revenue: 'Ontvangsten',
      total: 'Totaal',
      paymentType: 'Betalingswijze',
      date: 'Datum',
      salesReport: 'Verkooprapport',
      salesReportBeta: 'Verkooprapport BETA',
      order: 'Bestellen',
      export: 'Export',
      cash: 'Contant',
      card: 'Kaart',
      pos: 'POS',
      tips: 'Fooien',
      totalSum: 'Totaal bedrag',
      search: 'Zoeken',
      searchFilter: 'Zoeken (naam, e-mail, telefoon) ',
      discount: 'Korting',
      totalDiscount: 'Totale korting',
      ordersWithDiscount: 'Bestellingen met Korting',
      ordersWithFidelity: 'Bestellingen met Fideliteit',
      totalFidelityDiscount: 'Totale Fideliteitskorting',
      newCustomers: 'Nieuwe klanten',
      clientsWOrders: 'Klanten met bestellingen',
      emailSend: 'Verzonden emails in de afgelopen 6 maanden',
      emailTotal: 'Totaal aantal verzonden emails',
      newCustomersChart: 'Nieuwe klanten',
      productsSalesReport: 'Productverkooprapport',
      pricePerUnit: 'Prijs per eenheid',
      quantity: 'Aantal',
      productName: 'Productnaam',
      couponCode: 'Coupon',
      checkOrder: 'Gebruik bestelling',
      donationReport: 'Donatie Rapport'
    },
    feedback: {
      sigle: 'terugkoppeling',
      type: 'Type',
      sentBy: 'Verzonden door',
      text: 'Tekst',
      seen: 'Gezien',
      sentAt: 'Verzonden op',
      search: 'Zoeken',
      comment: 'Commentaar'
    },
    feedbackTypes: {
      feedback: 'Terugkoppeling',
      issue: 'Probleem',
      suggestion: 'Suggestie'
    },
    settings: {},
    blogPage: {
      categories: 'Categorieën',
      categoriesHint: 'Optioneel — artikelen kunnen ook zonder categorie.',
      categoryName: 'Categorienaam',
      noCategories: 'Nog geen categorieën.',
      articles: 'Artikelen',
      addArticle: 'Artikel toevoegen',
      editArticle: 'Artikel bewerken',
      allCategories: 'Alle categorieën',
      noCategory: 'Geen categorie',
      allStatuses: 'Alle statussen',
      searchByTitle: 'Zoeken op titel',
      noArticles: 'Geen artikelen gevonden.',
      cover: 'Omslag',
      coverHint: 'aanbevolen 1200x630px, max 5MB',
      imageAlt: 'Alt-tekst afbeelding (SEO)',
      title: 'Titel',
      slug: 'Artikellink (slug)',
      slugHint: 'Wordt uit de titel gegenereerd als leeg.',
      shortDescription: 'Korte beschrijving (onder de titel)',
      content: 'Inhoud',
      category: 'Categorie',
      author: 'Auteur',
      publishedAt: 'Publicatiedatum',
      publishedAtHint: 'Indien leeg, wordt bij publicatie de huidige datum gebruikt.',
      status: 'Status',
      published: 'Gepubliceerd',
      draft: 'Concept',
      scheduled: 'Gepland',
      seo: 'SEO',
      metaTitle: 'Metatitel',
      metaDescription: 'Metabeschrijving',
      metaKeywords: 'Trefwoorden (kommagescheiden)',
      titleRequired: 'De titel is verplicht.',
      deleteCategoryConfirm: 'Categorie "{name}" verwijderen? {count} artikel(en) blijven zonder categorie.',
      deleteArticleConfirm: 'Artikel "{name}" verwijderen?'
    },
    settingsPages: {
      homepageSections: 'Homepage secties',
      interactiveTour: 'Interactieve tour',
      blog: 'Blog',
      interactiveTourFirstLogin: 'Gebruik interactieve tour bij eerste aanmelding',
      interactiveTourAlways: 'Gebruik interactieve tour altijd',
      interactiveTourDisplayMode: 'Weergavemodus afbeelding',
      interactiveTourDisplayContain: 'Contain',
      interactiveTourDisplayCover: 'Cover',
      interactiveTourDisplayFullPage: 'Volledige pagina',
      userSettings: 'Gebruikers instellingen',
      myProfile: 'Mijn Profiel',
      users: 'Gebruikers',
      general: 'Algemeen',
      companyDetails: 'Bedrijfsgegevens',
      dateTime: 'Datum & Tijd',
      currency: 'Valuta',
      accounting: 'Boekhouding',
      tax: 'Belasting',
      payment: 'Betaling',
      orderingMng: 'Orderbeheer',
      loyalty: 'Loyaliteits programma',
      push: 'Pushmeldingen',
      tips: 'Tips',
      subscription: 'Abonnement',
      myPlan: 'Mijn Plan',
      infoPages: 'Info pagina’s',
      taxLabeling: 'Belasting etikettering',
      deliveryMethods: 'Locaties en leveringsmethoden',
      filters: 'Filters',
      filterProducts: 'Filters Producten'
    },
    settingUsers: {
      single: 'Gebruiker',
      fn: 'Voornaam',
      ln: 'Achternaam',
      email: 'Email',
      username: 'Gebruikersnaam',
      lang: 'Interface taal',
      langMsg: 'Dit is de taal waarin u het administratiegebied ziet',
      avatar: 'Avatar',
      role: 'Rol',
      locations: 'Toegangsorders vanaf locaties',
      locations_helptext: 'Belangrijk: Als er geen locatie is geselecteerd, heeft deze gebruiker toegang tot alle locaties.',
      resetPass: 'Wachtwoord opnieuw instellen',
      password: 'Wachtwoord',
      pass: 'Wachtwoord',
      confPass: 'Wachtwoord bevestingen',
      userAdded: 'Er is een nieuwe gebruiker toegevoegd',
      userUpdated: 'De gebruiker is bijgewerkt',
      userPicError: 'We konden de gebruikers avatar niet opslaan, probeer het later opnieuw',
      USER: 'GEBRUIKER',
      DRIVER: 'STUURPROGRAMMA',
      LOCATION_ADMIN: 'LOCATIEBEHEERDER',
      MARKETER: 'MARKETEER'
    },
    settingCompany: {
      title: 'Bedrijf',
      location: 'Locatie',
      name: 'Naam',
      lang: 'Toepassingstaal',
      bussLoc: 'Locatie bedrijf',
      deliveryLabels: 'Leveringstypes',
      deliveryType: 'Leveringsmethode',
      pick_up: 'Ophalen',
      meet_half: 'Ontmoet me halverwege',
      delivery: 'Levering',
      eat_location: 'Reserveer een tafel',
      self_ordering: 'Self Ordering',
      phone: 'Telefoon',
      street: 'Straat',
      number: 'Nr. ',
      latitude: 'Breedtegraad',
      longitude: 'Lengtegraad',
      email: 'Email',
      city: 'Stad',
      country: 'Land',
      state: 'Staat',
      availableDaysHrs: 'BESCHIKBARE DAGEN EN UREN',
      from: 'van',
      to: 'to',
      preOrder: 'reservering van',
      allowPreOrder: 'reservering toestaan',
      cardPaymentDetails: 'Betalingsinstellingen voor kaarten',
      paylikeKeys: 'Paylike gebruikte sleutels',
      posDiscount: 'POS-ID voor korting',
      userTaxes: 'TOEGEPASTE BELASTINGEN',
      noTaxMsg: 'Info: U heeft wijzigingen aangebracht in belastingen, vergeet ze niet op te slaan. ',
      areYouSureDelete: 'Weet u zeker dat u deze locatie wilt verwijderen? Met deze actie worden ook de bestelinstellingen voor deze locatie verwijderd.',
      pickLocationToCopy: 'Kies een locatie waaruit u de producten wilt kopiëren',
      areYouSureTax: 'Weet u zeker dat u deze belasting uit de belastinglijst wilt verwijderen? Vergeet niet de wijzigingen op te slaan! ',
      companyUpdated: 'Bedrijfsgegevens zijn succesvol bijgewerkt.',
      companyProdCopied: 'Producten werden met succes gekopieerd.',
      wrongAddress: 'Het adres van de locatie {locatie} is niet correct.',
      deleteLocationValidation: 'Deze locatie is in gebruik. U mag het niet verwijderen. U moet het eerst verwijderen uit de producten waar het in gebruik is. ',
      email_feedback: 'Emails waarin u de feedback ontvangt die bij de gebruikers van mobiele apps is geplaatst',
      email_feedback_helptext: 'U kunt meerdere emailadressen toevoegen, gescheiden door komma\'s.',
      printSettings: 'Afdrukinstellingen',
      automatPrintOrder: 'A4 Web print order automatisch',
      autoSendOrderToPrinter: '80 mm printorder',
      autoPrintLocalServer: 'Automatisch sectiebon printen vanaf de lokale server (nieuwe of in verwerking zijnde bestellingen)',
      printerIp: 'Printer IP/Host',
      printerPort: 'Printerpoort',
      copyProductsFrom: 'Producten kopiëren van',
      overEighteen: 'Beperking voor gebruikers jonger dan 18 jaar (verplicht om alcohol te verkopen via de applicatie) ',
      setRadiusArea: 'Drempelgebied instellen',
      setDrawArea: 'Tekengebied instellen',
      jump_to_menu: 'Ga naar het menu',
      jump_to_categories_menu: 'Geeft directe toegang tot het menu in de applicatie, voordat u de leveringsmethoden invoert. ',
      allow_fiscal_print: 'Sta toe om bonnetjes te printen',
      useProdTimeOpt: 'Gebruik tijdopties voor producten (alleen op reservering/boekmethode) ',
      allowPlaceUntilCloseHour: 'Sta gebruiker toe bestellingen te plaatsen tot het sluitingsuur',
      sortProductsMethods: 'Sorteer product methoden',
      alphabetic_asc: 'Na naam naar boven',
      alphabetic_desc: 'Na naam naar beneden',
      price: 'Na prijs',
      custom: 'Aangepast',
      infoCustomSort: '(aangepaste sortering wordt gemaakt in elke bewerkte categorie sectie)',
      filters: 'Filters',
      allowSoundAtStatusNew: 'Sta geluid toe voor bestellingen met de status NIEUW',
      allowSoundAtStatusProcessing: 'Sta geluid toe voor bestellingen met de status PROCESSING',
      allowToOrderUnderMinValueWithCoupon: 'Toestaan om bestelling te plaatsen onder min waarde bij het toepassen van coupon',
      allowSoundForMehods: 'Staat geluid toe voor de volgende bezorgmethoden'
    },
    settingDateTime: {
      timezone: 'Tijdzone',
      timeFormat: 'Tijdnotatie',
      dateFormat: 'Datumnotatie',
      saveMsg: 'Tijdinstellingen succesvol opgeslagen'
    },
    settingCurrency: {
      currency: 'Winkelvaluta',
      saveMsg: 'Valutagegevens succesvol opgeslagen'
    },
    settingTaxes: {
      single: 'Belasting',
      name: 'Naam',
      type: 'Type',
      amount: 'Bedrag',
      notice: 'Info: Bij \'Tax Labeling\' hoeft u alleen een labelnaam voor de belasting te definiëren om te kunnen worden toegepast. Om de belastinggegevens te definiëren, zoals waarde of type, moet u naar',
      notice2: 'bedrijfgegevens',
      singleTaxLabel: 'Belastinglabel',
      notice3: 'Info: In de sectie \'Gebruikte belastingen\' definieert u de belasting die wordt toegepast, details zoals waarde of type, als u een belastinglabel wilt maken, gaat u naar',
      notice4: 'belasting etikettering'
    },
    settingsPayment: {
      publicKey: 'Openbare sleutel',
      privateKey: 'Privésleutel'
    },
    settingsOrdering: {
      offnoPreorders: 'You must have offset 0 and period 1 to work',
      noPreorders: 'We do not accept pre-orders',
      isAlwaysOpen: 'Always open',
      isAlwaysOpenPreorderHours: 'Preorder hours',
      reservationTaxesTitle: 'Add meal plan',
      reservationTaxesTitleEmpty: 'No program added yet',
      reservationTaxAdvanceConsumption: 'This amount is an advance on consumption',
      infoBoxTitle: 'Adauga informatii extra',
      infoBoxRadioCheck: 'Modifica optiunea',
      infoBoxRadio: 'O singura optiune',
      infoBoxCheck: 'Mai multe optiuni',
      enabled: 'Ingeschakeld',
      paymentOptions: 'Betalingsopties',
      paymentOptionsErr: 'Het veld betalingsoptie is vereist.',
      waitingTime: 'Standaard wachttijd',
      minimumOrderValue: 'Minimale bestelwaarde',
      minutes: 'min. ',
      shippingCost: 'Verzendkosten',
      deliveryRange: 'Standaard wachttijd',
      deliveryRangeUnit: 'm',
      posId: 'Verzendkosten POS-ID',
      shippingTax: 'Verzendkosten',
      locations: 'Locaties',
      street: 'Straat',
      city: 'Stad',
      country: 'Land',
      state: 'Staat',
      availableDays: 'Dagen en uren beschikbaar',
      availableDaysErr: 'Het optieveld beschikbare dagen en uren is vereist. ',
      notice: 'Controleer de fout in de tabbladen met ingeschakelde bestelmethoden en probeer vervolgens het formulier opnieuw op te slaan',
      saveSuccess: 'Bestelgegevens gegevens succesvol opgeslagen',
      deliveryRules: 'Leveringsregels',
      addRange: 'Regel toevoegen',
      shippingCities: 'Steden / Dorpen',
      shippingNeighborhoods: 'Buurten',
      citiesValidationError: 'Zorg ervoor dat de stadswaarden uniek zijn voor elk leveringsbereik. ',
      deactivateDeliveryHours: 'Deactiveer bezorgtijden',
      addZone: 'Zone toevoegen',
      newZone: 'Nieuwe zone'
    },
    settingsZone: {
      edit: 'Zonenaam',
      deleteBtn: 'Zone verwijderen',
      deleteShape: 'Verwijder conditie om een andere te creëren',
      overridePayment: 'Betaalmethode overschrijven',
      acceptCash: 'Contant accepteren',
      acceptCard: 'Kaart accepteren',
      acceptPos: 'POS bij levering (onbetaald)'
    },
    settingsInfoPages: {
      single: 'pagina',
      noPage: 'Nog geen pagina\'s toegevoegd.',
      title: 'Pagina Titel',
      content: 'Pagina-inhoud',
      newPage: 'Nieuwe pagina',
      showInHeader: 'Weergeven in koptekst',
      showInFooter: 'Weergeven in voettekst',
      addedSuccess: 'Pagina succesvol opgeslagen. ',
      deletedSuccess: 'Pagina met succes verwijderd',
      deleteMsg: 'Weet u zeker dat u deze pagina wilt verwijderen? ',
      TERMS_CONDITIONS: 'Algemene Voorwaarden',
      PRIVACY_POLICY: 'Privacybeleid',
      CONTACT_DETAILS: 'Contact details',
      FIDELITIES_PROMOTIONS: 'Vaste klant Promoties',
      CUSTOM: 'Klant'
    },
    settingsRewards: {
      single: 'punt',
      plural: 'punten',
      state: 'Staat',
      points: 'punten',
      moneySpent: 'Geld besteed aan punten',
      pointsTo: 'Punten voor geld',
      numberOfcurrencyNeedToSpend: 'Bedrag dat klant moet uitgeven om 1 punt te verdienen.',
      numberOfpointsToReward: 'Aantal punten dat de klant nodig heeft wanneer hij wil betalen met de loyaliteitspunten.',
      timeInterval: 'Tijdslot.',
      fromTime: 'Van',
      toTime: 'To',
      rewardSuccess: 'Loyaliteits programma gegevens succesvol opgeslagen'
    },
    settingsPushNotif: {
      order_new: 'Bericht nieuwe bestelling',
      order_completed_pickup: 'Voltooid bestelbericht – Ophalen. ',
      order_completed_meet: 'Voltooid bestelbericht - Ontmoet me halverwege',
      order_completed_delivery: 'Voltooid bestelbericht - Bezorging',
      order_completed_eat: 'Voltooid bestelbericht - Eten op locatie',
      order_canceled: 'Geannuleerd bestelbericht',
      notifUpdated: 'Pushmeldingen gegevens succesvol opgeslagen',
      preview: 'Voorbeeld',
      time: 'tijd',
      dateTime: 'datum en tijd',
      persons: 'persoonsnummer',
      timePrev: '11:30(binnen 30 minuten)',
      personsPrev: '3',
      dateTimePrev: 'dinsdag 15 februari 2019, om 18.00 uur',
      info: 'Als u de getoonde levertijd niet nodig heeft, laat dan het laatste veld leeg.',
      selectedLocations: 'Geselecteerde locaties:'
    },
    settingsTips: {
      tipsTaxes: 'Tips belastingen',
      state: 'Tips gebruiken',
      tipsSuccess: 'Tips succesvol opgeslagen'
    },
    settingsPlans: {
      plan1Title: 'Maandelijks',
      plan1Rate: '160€ / maand',
      plan1Description: 'Ga aan de slag met een maandelijks vast bedrag, ongeacht de hoeveelheid verkopen die je via de app doet.',
      plan2Title: 'Verkooppercentage',
      plan2Rate: '10%',
      plan2Description: 'Betaal als je verkoopt. Kies het verkooppercentage en betaal een maandelijks bedrag in verhouding tot het bedrag dat u via de app verkoopt.',
      current: 'Huidig abonnement',
      switch: 'Schakelaar'
    },
    filter: {
      filter: 'Filter',
      action: 'Actie',
      create: 'Filter gemaakt',
      update: 'Filter Updated',
      areYouSureDelete: 'Weet u zeker dat u dit filter wilt verwijderen',
      yes: 'Ja',
      deleted: 'Filter verwijderd',
      noFilters: 'Geen filter',
      name: 'Naam',
      addFilter: 'Filter toevoegen',
      filters: 'Filters',
      value: 'Waarde',
      filterProducts: 'Filter producten',
      filterName: 'Filternaam',
      val: 'Valuta',
      filterUpdated: 'Filter bijgewerkt',
      minOneFilterValueRequired: 'Minimaal één filterwaarde per filter vereist',
      filterType: 'Filtertype',
      type_exists: 'Filtertype bestaat al',
      filter_value_exists: 'Filterwaarde bestaat al',
      some_filter_applied: 'De update is met succes uitgevoerd, maar sommige filters of waarden worden toegepast op producten en kunnen niet worden verwijderd'
    },
    ordersSource: {
      1: 'Kiosk',
      2: 'Qr',
      3: 'Pos',
      4: 'App',
      5: 'Website',
      6: 'Glovo',
      7: 'Wolt',
      8: 'Bolt'
    },
    checkbox: 'Hiermee kunt u meerdere productopties selecteren',
    radio: 'Hiermee kunt u slechts één optie op het product kiezen',
    ...nlLocale
  },
  it: {
    btPayments: btPayments.en,
    marketplace: marketplace.it,
    general: {
      search: 'Cerca',
      home: 'Home',
      add: 'Inserisci',
      edit: 'Modifica',
      delete: 'Cancella',
      remove: 'Rimuovi',
      save: 'Salva',
      update: 'Aggiorna',
      cancel: 'Annulla',
      continue: 'Continua',
      activate: 'Attiva',
      deactivate: 'Disattiva',
      active: 'Attivo',
      inactive: 'Disattivo',
      removePhoto: 'Troppe immagini caricate',
      yes: 'Sì',
      no: 'No',
      success: 'Successo',
      required: 'Richiesto',
      back: 'Indietro',
      next: 'Avanti',
      finish: 'Fine',
      duplicate: 'Duplica',
      select: 'Seleziona',
      all: 'Tutto',
      reset: 'Ripristina',
      export: 'Esporta',
      loadMore: 'Carica di più',
      viewDetails: 'Visualizza Dettagli',
      showing: 'Mostra (lunghezza) risultato(i)',
      enable: 'Abilita',
      disable: 'Disabilita',
      product: 'Prodotto',
      cancelCourier: 'Annulla corriere',
      logout: 'Esci',
      from: 'da',
      to: 'a',
      agree: 'Sono d\'accordo',
      agreePopupMessage: 'Per permettere al browser di riprodurre l\'audio è necessario cliccare su "Sono d\'accordo". Questo riprodurrà un suono di prova per attivare la riproduzione audio.',
      notCompleted: 'Non completato',
      saveChanges: 'Salva modifiche',
      doYouWantToLogout: 'Sei sicuro di voler uscire?',
      deliveryMethod: 'Metodi di consegna',
      customSort: 'L\'azienda usa l\'ordinamento personalizzato"',
      none: 'Nessuno',
      unset: 'Non impostato'
    },
    menuLink: {
      alias: 'Alias',
      title: 'Titolo',
      updated: 'aggiornato',
      areYouSure: 'Sei sicuro di {etichetta} nel menu link ?',
      deleted: 'Cancellato',
      couldNotUpdate: 'Non aggiornato',
      cancel: 'annulla',
      delete: 'cancella',
      added: 'Menu link aggiunto',
      promotions: 'Promozioni',
      history: 'Cronologia',
      orders: 'Ordini',
      reservations: 'Reservations',
      favorite_orders: 'Ordini preferiti',
      tutorial: 'Tutorial',
      personal_info: 'Informazioni personali',
      single: 'Menu link',
      linkFor: 'Link per',
      externUrl: 'URL esterno',
      custom: 'Personalizzato',
      day: 'giorno',
      couldNotSave: 'Impossibile salvare il collegamento del menu'
    },
    pages: {
      login: 'Accedi',
      register: 'Registrati',
      recoverPassword: 'Recupera Password',
      resetPassword: 'Reimposta password',
      dashboard: 'Pannello di controllo',
      orderingManagement: 'Gestione degli ordini',
      customerDetails: 'Dettagli cliente',
      customers: 'Clienti',
      customersGroups: 'Gruppi',
      orders: 'Ordini',
      reservations: 'Reservations',
      products: 'Prodotti',
      catalog: 'Catalogo',
      categories: 'Categorie',
      productOptions: 'Opzioni prodotto',
      marketing: 'Marketing',
      campaigns: 'Campagne',
      donationCampaigns: 'Campagne di Donazione',
      raffleCampaigns: 'Campagne lotteria',
      spinningWheelCampaigns: 'Spinning Wheel',
      offersSlider: 'Slides offerte',
      reports: 'Reports',
      feedback: 'Feedback',
      settings: 'Impostazioni',
      logout: 'Esci',
      fidelities: 'Fedeltà',
      topCategory: 'Categorie Top',
      infoPagesCustom: 'Pagine personalizzate',
      menuLinks: 'Menu link',
      infoPages: 'Pagine informative',
      productFilters: 'Filtri prodotto',
      promos: 'Promozioni',
      menus: 'Menù',
      clientOrderView: 'Mostra ritiro'
    },
    infoPages: {
      single: 'pagina',
      title: 'Titolo',
      shortDescription: 'Descrizione breve',
      updated: 'Aggiornato',
      areYouSure: 'Sei sicuro di voler eliminare questa pagina?',
      deleted: 'Eliminato',
      couldNotUpdate: 'Impossibile aggiornare',
      added: 'Pagina informativa personalizzata aggiunta',
      changeLinkTab: 'Nel caso in cui venga aggiunto un link, cambiare la casella di testo con TAB per il prossimo e SHIFT + TAB per il precedente.',
      infoPages: 'Pagine Informative'
    },
    ordersStatus: {
      bill: 'Bill',
      AWAITING_TRANSPORT: 'In attesa del trasporto',
      CANCELED: 'Annullato',
      DELIVERED: 'Consegnato',
      DRAFT: 'Bozza',
      NEW: 'Nuovo',
      ON_HOLD: 'In attesa',
      POSTPONED: 'Rinviato',
      NOT_DELIVERED: 'Non consegnato',
      PICKED_UP_BY_DELIVERY: 'Pronto per la consegna',
      PROCESSING: 'In Elaborazione',
      PREPARED: 'Preparato',
      TRANSPORT: 'In trasporto',
      RESERVED: 'Riservato',
      COMPLETED: 'Completato',
      FINISH: 'Completato',
      reservedReady: 'Riservato / Pronto',
      completedReady: 'Completato / Pronto',
      deliveredReady: 'Consegnato / Pronto',
      canceledForever: 'Vuoi annullare? Questa azione è irreversibile'
    },
    ordersTypes: {
      GROUP: 'Gruppo',
      SINGLE: 'Singolo'
    },
    paymentTypes: {
      CASH: 'Contanti',
      CARD: 'Online (Carta)'
    },
    paymentStatus: {
      notPaid: 'Autorizzato (Importo bloccato)',
      notPaidDetails: 'L\'importo sarà addebitato una volta che l\'ordine è contrassegnato come Consegnato.',
      paid: 'Pagato',
      notOk: 'Rifiutato'
    },
    campaignsModes: {
      AUTO: 'Automatica',
      MANUAL: 'Manuale'
    },
    campaignsNotificationTypes: {
      EMAIL: 'E-mail',
      PUSH: 'Notifica Push'
    },
    days: {
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      sunday: 'Domenica'
    },
    daysShort: {
      Mon: 'Lun',
      Tue: 'Mar',
      Wed: 'Mer',
      Thu: 'Gio',
      Fri: 'Ven',
      Sat: 'Sab',
      Sun: 'Dom'
    },
    gender: {
      selectGender: 'Seleziona Genere',
      male: 'maschio',
      female: 'femmina',
      Male: 'Maschio',
      Female: 'Femmina',
      Other: 'Altro'
    },
    reportsAgesGroups: {
      selectAge: 'Seleziona Età',
      '20': 'Sotto i 20',
      'Under 20': 'Sopra i 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50',
      '50+': '50+',
      Unspecified: 'Non specificato'
    },
    deliveryTypes: {
      DELIVERY: 'Consegna a domicilio',
      EAT_LOCATION: 'Prenota un tavolo',
      MEET_HALF: 'Incontro a metà strada',
      PICK_UP: 'Ritiro in negozio'
    },
    couponsTypes: {
      FIXED: 'Fisso',
      PERCENTAGE: 'Percentuale',
      FREE_PRODUCT: 'Prodotto gratuito'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Fissa (inclusa)',
      PERCENTAGE_INCLUDED: 'Percentuale (inclusa)',
      FIXED_EXCLUDED: 'Fissa',
      PERCENTAGE_EXCLUDED: 'Percentuale'
    },
    productOptions: {
      checkbox: 'Permette di selezionare più opzioni sul prodotto',
      radio: 'Permette di selezionare solo un\'opzione'
    },
    validations: {
      areYouSureYouWantTo: 'Sei sicuro di volere',
      areYouSure: 'Sei sicuro di volere aggiornare lo stato a',
      wentWrong: 'Qualcosa è andato storto, per favore riprova più tardi...',
      pictureSize: 'file jpg/png con una dimensione inferiore a 5MB',
      pictureSizeExceed: 'La dimensione dell\'immagine non può superare i 5MB!',
      removePhoto: 'Si prega di rimuovere il file corrente per poterne aggiungere uno nuovo',
      dataCouldNotBeSaved: 'Non è stato possibile salvare i dati, riprova più tardi.',
      passReq: 'Richiesto campo password ID',
      passMin: 'La Password deve essere almeno di 6 caratteri',
      passConf: 'La password e la conferma della password non corrispondono',
      validPoinsNo: 'Si prega di aggiungere un importo di denaro valido e un commento',
      imageResolution: ', risoluzione consigliata 300px di altezza e 820px di larghezza.',
      imageResolutionWeb: ', risoluzione consigliata 300px di altezza e 1920px di larghezza.',
      doYouWantTo: 'Vuoi',
      hourIsSmallerThanCreated: 'L\'ora impostata è inferiore all\'ora inserita',
      vatPrinterIdRange: '0–10 only.',
      vatPrinterIdNumeric: 'Numbers only.'
    },
    dashboard: {
      selectLocation: 'Località:',
      selectMethod: 'Metodo',
      tile1Title: 'Nuovi Ordini',
      tile2Title: 'Ordini totali',
      tile3Title: 'Ricavi',
      tile4Title: 'Nuovi utenti registrati',
      today: 'Oggi',
      orderChart: 'Ordini',
      completed: 'Numero di ordini',
      canceled: 'Annullato',
      salesChart: 'Vendite',
      salesIn: 'Vendite in',
      top5Chart: 'Top 5 prodotti',
      orderingChart: 'Tipi di ordinazione',
      nrOfOrders: 'Numero di ordini',
      nrOfEmails: 'Numero di emails'
    },
    customers: {
      noCustomer: 'Nessun cliente selezionato',
      single: 'cliente',
      plural: 'clienti',
      title: 'DETTAGLI CLIENTE',
      pointsTitle: 'Punti fedeltà del cliente',
      currentPoints: 'Punti attuali',
      pointsAddTitle: 'Aggiungi Punti',
      pay: 'Pay Type',
      id: 'ID',
      name: 'Nome e Cognome',
      email: 'Email',
      phone: 'Telefono',
      use_calling_phone: 'Preia numar telefon',
      gender: 'Genere',
      birth: 'Data di nascita',
      location: 'Località',
      address: 'Indirizzo',
      number: 'Numero',
      dateCreated: 'Data di creazione',
      delivery: 'Consegna',
      type: 'Tipo',
      status: 'Stato',
      total: 'Totale',
      allTimeSale: 'Totale venduto',
      none: 'Nessuno',
      pointsLabel: 'Soldi spesi',
      pointsLabelInPoints: 'Points earned',
      pointsAdjustmentHelp: 'Inserisci un valore positivo per aggiungere punti o un valore negativo (ad es. -100) per sottrarre punti dal saldo del cliente.',
      points: 'points',
      point: 'point',
      clientCanUse: 'Customer can use',
      commentsLabel: 'Commento',
      pointsSuccess: 'Punti fedeltà aggiunti con successo.',
      pointsError: 'Non è stato possibile aggiungere i punti al cliente.',
      addCommentPerClient: 'Aggiungi commento per cliente',
      newCommentAdded: 'Il commento è stato aggiornato',
      filters: {
        withOrders: 'Con gli Ordini',
        withoutOrders: 'Senza Ordini'
      },
      addGroup: 'Aggiungere gruppo',
      deleteGroup: 'Gruppo eliminato con successo.',
      saveGroup: 'Il gruppo è stato aggiunto con successo',
      updateGroup: 'Il gruppo è stato aggiornato correttamente'
    },
    orders: {
      counterPerCustomer: 'Numero di ordini',
      noOrders: 'Nessun ordine selezionato',
      single: 'Ordine',
      the_order: 'Ordine',
      plural: 'ordini',
      status: 'Stato',
      location: 'Località',
      updateStatus: 'Aggiornamento dello stato',
      editOrder: 'Edit Order',
      ordDetails: 'Dettagli dell\'Ordine',
      date: 'Data',
      madeAt: 'Ordine effettuato alle',
      pickupTime: 'Consegna / Ritiro alle',
      preorder: 'PREORDINE',
      preorderFilter: 'Preordini',
      allOrders: 'Tutti gli ordini',
      pendingPreorders: 'Preordini in attesa',
      withoutPendingPreorders: 'Senza preordini in attesa',
      reservationTime: 'Orario di prenotazione',
      reservationSeats: 'Prenotazione posti',
      rating: 'Valutazione',
      meetupLocation: 'Luogo dell\'incontro',
      ordLocation: 'Località dell\'ordine',
      delivery: 'Consegna',
      type: 'Tipo',
      payment: 'Pagamento',
      name: 'Nome',
      qty: 'Qtà',
      unit: 'Prezzo Unitario',
      unit_price: 'Prezzo unitario',
      final_price: 'Prezzo finale',
      total: 'Totale',
      totals_subtotals: 'Subtotale',
      totals_discount: 'Sconto',
      totals_discount_loyalty_points: 'Sconto dai punti fedeltà',
      totals_grandtotal: 'Totale',
      totals_shipping: 'Spedizione',
      totals_extras: 'Sacchetto',
      totals_extras_27: 'Tassa sull\'imballaggio',
      totals_extras_30: 'Sacchetto',
      totals_extras_38: 'Sacchetto',
      totals_extras_40: 'Sacchetto',
      totals_extras_50: 'Ambalaj',
      totals_tip: 'Mance',
      totals_donation: 'Donazione',
      custComments: 'Commento del cliente',
      adminComments: 'Commento dell\'Amministratore',
      custDetails: 'Dettagli del Cliente',
      shipping: 'Indirizzo di spedizione',
      billing: 'Indirizzo di fatturazione',
      orderStatusSuccess: 'Stato dell\'ordine aggiornato con successo',
      orderPrinterError: ',ma c\'è stato un errore nella connessione con la stampante.',
      orderCommnetSuccess: 'Commento dell\'ordine aggiornato con successo',
      orderHourSuccess: 'Ora di consegna/ritiro dell\'ordine aggiornato con successo',
      orderHourError: 'Prego fornire un\'ora valida.',
      none: 'Nessun commento',
      at: 'in',
      filtersApplied: 'Filtri applicati - clicca sul pulsante del filtro per vederne altri',
      customFilters: 'Filtri personalizzati applicati',
      resetFilters: 'clicca qui per ripristinare e vedere i dati in tempo reale',
      note: 'Nota',
      orderNoArticulate: 'Ordine',
      print: 'Stampa (A4)',
      printerPrint: 'Stampa (80mm)',
      printerSuccess: 'Ordine stampato con successo',
      printerErrror: 'C\'è stato un errore nella connessione con la stampante.',
      callCourier: 'Chiama il corriere',
      callHioCourier: 'Hio',
      callCourierCancel: 'Sei sicuro di voler annullare la chiamata del corriere?',
      orderSentSuccess: 'La chiamata al corriere è stata inviata con successo',
      orderCancelSuccess: 'La chiamata al corriere è stata annullata',
      packageDetails: 'Seleziona i dettagli del pacchetto',
      packageSize: 'Dimensione del pacchetto:',
      courierTime: 'Orario di ritiro del corriere: ',
      now: 'Adesso',
      addTime: 'Aggiungi tempo',
      orderCloseToDelivery: 'Ordina con l\'ora di consegna più vicina',
      amountRefunded: 'Importo rimborsato',
      amountIntegralRefunded: 'L\'importo è stato rimborsato integralmente al cliente',
      refundSuccess: 'Importo rimborsato con successo',
      refundManual: 'L\'importo sarà restituito dal manuale paylike',
      refundAutomat: 'Vuoi rimborsare l\'importo automaticamente?',
      refundOrder: 'Rimborsa',
      refundAlreadyDone: 'Già rimborsato',
      refundConfirmTitle: 'Rimborsare l\'ordine?',
      refundConfirmText: 'L\'importo pagato sarà restituito al cliente tramite EuPlatesc. Questa azione non può essere annullata.',
      refundAskCancel: 'Rimborso effettuato. Vuoi annullare anche l\'ordine?',
      refundError: 'Si è verificato un errore durante l\'elaborazione del rimborso.',
      erorrPaylike: 'Errore da Paylike, accesso errato'
    },
    companyOptions: {
      id: 'Id',
      name: 'Name',
      image: 'Image',
      type: 'Type',
      deleteQues: 'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',
      deleteVal: 'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',
      active: 'Active'
    },
    catalogProd: {
      noProducts: 'Nessun prodotto selezionato',
      single: 'prodotto',
      plural: 'prodotti',
      generalDetails: 'Dettagli Generali',
      aditionalInfo: 'Informazioni aggiuntive',
      name: 'Nome',
      desc: 'Descrizione',
      image: 'Immagine',
      imageMore: 'Altre immagini',
      video: 'Video',
      category: 'Categoria',
      partialPay: 'Plata partiala',
      secondaryCategory: 'Secondary categories',
      price: 'Prezzo',
      taxes: 'Tasse applicate',
      status: 'Stato',
      posid: 'POS ID',
      allowUserComments: 'Consenti i commenti degli utenti',
      validFromTo: 'Valido da - a',
      prodType: 'Tipo Prodotto',
      singleType: 'singolo',
      groupType: 'gruppo',
      rewardPoints: 'Punti premio',
      moneySpent: 'Soldi in punti',
      numberOfYouNeedToSpend: 'Numero di {valuta} che il cliente deve spendere per ottenere un punto.',
      points: 'punti',
      soldWith: 'Venduto con',
      pickAnOption: 'Scegli un\'opzione',
      minNoSelected: 'N. minimo selezionato',
      maxNoSelected: 'N. massimo selezionato',
      optVal: 'Valore',
      leaveEmpty: 'Lasciare vuoto o mettere 0 se l\'opzione non costa extra',
      prodDeleted: 'Prodotto eliminato con successo',
      prodAdded: 'Prodotto aggiunto con successo',
      prodUpdated: 'Prodotto aggiornato con successo',
      prodPhotoError: 'Non è stato possibile salvare la foto del prodotto, si prega di riprovare più tardi.',
      rewardPossibelValue: 'Possibili valori',
      errorOptions: 'Si prega di controllare tutte le opzioni del prodotto, alcune potrebbero non essere compilate.',
      locationSettings: 'Impostazioni Località',
      availableIn: 'Disponibili in',
      deliveryMethodsandHours: 'Metodi e orari di consegna',
      overrideSettings: 'Impostazioni sovrascritte',
      addLocationValidation: 'Alcune opzioni del prodotto non sono compatibili con le località selezionate, se si continua, le opzioni saranno rimosse, altrimenti la località non sarà aggiunta',
      highlightsProduct: 'Prodotto in evidenza',
      search: 'Cerca',
      isHiddenFromListing: 'Nascondere dall\'elenco dei prodotti',
      isHiddenFromSearch: 'Nascondere dalla ricerca dei prodotti',
      isHiddenFromQrMenu: 'Hide from Qr menu',
      Monday: 'Lun',
      Tuesday: 'Mar',
      Wednesday: 'Mer',
      Thursday: 'Gio',
      Friday: 'Ven',
      Saturday: 'Sab',
      Sunday: 'Dom',
      accesRestricted: 'Spiacente, non hai accesso a questo prodotto',
      changeLocations: 'Change locations',
      includeAllLocationsProducts: 'Include also the products available in all locations',
      bulkLocationsMode: 'Action',
      bulkModeAdd: 'Add',
      bulkModeRemove: 'Remove',
      bulkModeReplace: 'Replace',
      massUpdate: 'Mass update',
      massUpdateSubtitle: 'You are about to update {count} products',
      bulkActionActive: 'Active / Inactive',
      bulkActionPrice: 'Price',
      bulkActionVat: 'VAT',
      bulkActionSection: 'Section',
      bulkActionOptionGroups: 'Option groups',
      bulkActionDelete: 'Delete',
      bulkOverrideDeliveryHint: 'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',
      bulkOverrideLocationsHint: 'Leave empty to use all company locations. Only locations that already belong to each product are applied.',
      bulkOverrideAddIntervalHint: 'Click + to add a schedule interval for this method.',
      bulkPriceDirection: 'Direction',
      bulkPriceIncrease: 'Increase',
      bulkPriceDecrease: 'Decrease',
      bulkPriceMode: 'Type',
      bulkPriceFlat: 'Flat amount',
      bulkPricePercent: 'Percentage (%)',
      bulkPriceAmount: 'Amount',
      bulkPriceBaseOnlyHint: 'Only the base price is changed. The new price will never go below 0.',
      bulkOptionGroupsMode: 'Association mode',
      bulkOptionGroupsModeHint: 'Add keeps existing groups. Replace overwrites them with the selected ones.',
      bulkDeleteWarning: 'This will permanently delete {count} products. This action cannot be undone easily.',
      bulkDeleteEnableLabel: 'Yes, delete the selected products (other mass actions will be ignored)',
      confirmBulkMultiple: 'Apply these changes to {count} {products}:',
      bulkProductSingular: 'product',
      bulkProductPlural: 'products',
      confirmBulkAreYouSure: 'Are you sure?',
      bulkSummaryAddLocations: 'add locations ({value}) to {count} {products}',
      bulkSummaryRemoveLocations: 'remove locations ({value}) from {count} {products}',
      bulkSummarySetActive: 'set {count} {products} as active',
      bulkSummarySetInactive: 'set {count} {products} as inactive',
      bulkSummaryIncreasePriceFlat: 'increase the base price of {count} {products} by {amount} {currency}',
      bulkSummaryIncreasePricePercent: 'increase the base price of {count} {products} by {amount}%',
      bulkSummaryDecreasePriceFlat: 'decrease the base price of {count} {products} by {amount} {currency}',
      bulkSummaryDecreasePricePercent: 'decrease the base price of {count} {products} by {amount}%',
      bulkSummaryAddOptionGroups: 'add option groups ({value}) to {count} {products}',
      bulkSummaryReplaceOptionGroups: 'replace option groups on {count} {products} with ({value})',
      bulkSummarySetVat: 'set VAT {value} on {count} {products}',
      bulkSummarySetSection: 'set section {value} on {count} {products}',
      bulkSummaryEnableOverride: 'enable override settings on {count} {products}',
      bulkSummaryEnableOverrideWithSchedule: 'replace override schedules on {count} {products}',
      bulkSummaryDisableOverride: 'disable override settings on {count} {products}',
      bulkSummaryDelete: 'delete {count} {products}',
      bulkSummaryGeneric: 'update {count} {products}',
      confirmBulkAddLocations: 'Are you sure you want to add locations to {count} products?',
      confirmBulkRemoveLocations: 'Are you sure you want to remove locations from {count} products?',
      confirmBulkSetActive: 'Are you sure you want to set {count} products as active?',
      confirmBulkSetInactive: 'Are you sure you want to set {count} products as inactive?',
      confirmBulkIncreasePriceFlat: 'Are you sure you want to increase the base price of {count} products by {amount}?',
      confirmBulkIncreasePricePercent: 'Are you sure you want to increase the base price of {count} products by {amount}%?',
      confirmBulkDecreasePriceFlat: 'Are you sure you want to decrease the base price of {count} products by {amount}?',
      confirmBulkDecreasePricePercent: 'Are you sure you want to decrease the base price of {count} products by {amount}%?',
      confirmBulkAddOptionGroups: 'Are you sure you want to add option groups to {count} products?',
      confirmBulkReplaceOptionGroups: 'Are you sure you want to replace option groups on {count} products?',
      confirmBulkSetVat: 'Are you sure you want to set VAT on {count} products?',
      confirmBulkSetSection: 'Are you sure you want to set the section on {count} products?',
      confirmBulkDelete: 'Are you sure you want to delete {count} products?',
      confirmBulkGeneric: 'Are you sure you want to update {count} products?',
      bulkLocationsUpdated: 'Updated locations for {updated} products',
      bulkMassUpdated: 'Updated {updated} products',
      couldNotFetchProductOptions: 'Could not fetch product options. Please contact support.'
    },
    catalogProdRewardsHints: {
      hint1: 'Lasciare vuoto per applicare il valore predefinito dalle impostazioni',
      hint2: 'Metti 0 per non applicare il programma premi su questo prodotto',
      hint3: 'Aggiungi un valore positivo per modificare il valore predefinito dalle impostazioni'
    },
    catalogCateg: {
      single: 'categoria',
      plural: 'categorie',
      color: 'Culoare',
      name: 'Nome',
      image: 'Immagine',
      displayType: 'Visualizzazione Display',
      shortDescription: 'Descrizione breve',
      validFromTo: 'Valido da - a',
      areYouSure: 'Sei sicuro di voler {etichetta} questa categoria?',
      categAdded: 'Categoria aggiunta con successo',
      categUpdated: 'Categoria aggiornata con successo',
      categDeleted: 'Categoria rimossa con successo',
      couldNotSave: 'Non è stato possibile salvare la foto della categoria, riprova più tardi.',
      List: 'Elenco',
      Grid: 'Griglia',
      assignTopCategory: 'Assegna la categoria top',
      pleaseSelect: 'Si prega di selezionare / Non applicabile',
      categoriesWithoutParent: 'Categorie indipendenti',
      topCategory: 'Categoria Top',
      forceMethod: 'Unico metodo di consegna',
      selectMethod: 'Seleziona metodi',
      enableMethod: '(Per abilitare la rimozione della categoria top)',
      overrideSettingsHelp: 'Se abilitata, questa categoria appare nel menu solo per la località, il metodo di consegna, il giorno e la fascia oraria selezionati.',
      schedule: 'Orario',
      useSchedule: 'Usa orario',
      scheduleActive: 'Orario attivo',
      scheduleHelp: 'Un unico orario per questa categoria top in tutte le sedi. Al di fuori di queste ore, gli ordini da questa categoria non sono disponibili nell\'app.'
    },
    catalogProdOpt: {
      single: 'Opzione',
      plural: 'optioni',
      new: 'Nuova Opzione',
      name: 'Nome',
      type: 'Tipo',
      value: 'Valore',
      values: 'Valori',
      posid: 'POS ID',
      optionSaved: 'Opzioni prodotto salvate con successo.',
      areyouSure: 'Sei sicuro di voler eliminare questa opzione?',
      optLocationError: 'L\'opzione {opz_nome} deve includere {loc_nome} per i luoghi disponibili',
      menuQr: 'Menù QR',
      displayInMenu: 'Visualizza nel menu QR'
    },
    marketingCampaigns: {
      single: 'campagna',
      plural: 'campagne',
      name: 'Nome',
      nameHelper: 'Questo nome sarà usato come soggetto per le notifiche e-mail inviate per questa campagna.',
      image: 'Immagine',
      startEnd: 'Data di inizio e fine',
      daysLeft: 'Giorni rimanenti',
      timesUsed: 'Tempi di utilizzo',
      status: 'Stato',
      actions: 'Azioni',
      send: 'Invia',
      in_queue: 'To be sent',
      sent: 'Total sent',
      notif_sent: 'Notification',
      email_sent: 'E-mail',
      areYouSureNotif: 'Sei sicuro di voler inviare le notifiche?',
      notifSent: 'Le notifiche sono state inviate.',
      campaignDeleted: 'Campagna rimossa con successo.',
      areYouSureDelete: 'Sei sicuro di voler eliminare ',
      campaignAdded: 'Campagna aggiunta con successo',
      campaignUpdated: 'Campagna caricata con successo',
      campaignPhotoError: 'Non è stato possibile salvare la foto della campagna, riprova più tardi.',
      campaignDetails: 'Dettagli della campagna',
      description: 'Descrizione',
      maxDescription: '(max. 400 caratteri)',
      characters: 'caratteri',
      validFromTo: 'Valida da - a',
      notif: 'Notifiche',
      model: 'Modalità',
      setHours: 'Imposta gli orari',
      selectTime: 'Seleziona l\'ora',
      chooseTarget: 'Scegliere il pubblico di riferimento',
      gender: 'Genere',
      age: 'Età',
      city: 'Città',
      location: 'Luogo',
      visibleInLocations: 'Visibile nelle seguenti località',
      visibleInLocationsInfo: 'Questa funzionalità è disponibile solo nell\'Applicazione',
      ordersAbove: 'Ordini al di sopra',
      ordersBelow: 'Ordini al di sotto',
      addCoupon: 'Aggiungi Coupon',
      applyTo: 'Applica a',
      value: 'Valore',
      code: 'Codice',
      addValue: 'Aggiungi Valore',
      minValue: 'Quantità minima',
      counter_max_usage: 'Quante volte una persona può utilizzare questo coupon?',
      counter_max_usage_total: 'Quante volte può essere utilizzato in totale questo coupon?',
      counter_max_usage_example: 'Digita un numero per impostare il numero massimo di utilizzi per persona. Digitare 0 per illimitato.',
      counter_max_usage_total_example: 'Digita un numero per impostare il numero massimo di utilizzo. Digitare 0 per illimitato.',
      generateCode: 'Genera il codice',
      Products: 'Prodotti',
      Shipping: 'Spedizione,',
      chooseCategProduct: 'Scegli le categorie o i prodotti su cui si applicherà il coupon:',
      delivery_methods: 'Su quali modalità di consegna deve essere applicato il coupon?',
      order_source_ids: 'Order sources',
      order_source_ids_all: 'All sources',
      order_source_ids_help: 'Leave empty to apply on all order sources.',
      location_ids: 'In quale località deve essere applicato il coupon?',
      sendNotificationTo: 'Invia notifiche a',
      campaignWasSent: 'La campagna è stata inviata negli ultimi 30 minuti',
      chooseDayForInterval: 'Scegli il giorno per l\'intervallo',
      chooseHoursForInterval: 'Scegli gli orari per l\'intervallo',
      useInterval: 'Usa intervallo',
      isCumulativeCheck: 'Questo coupon si applica cumulativamente',
      isAutoApplyCheck: 'Questo coupon si applica direttamente',
      intervalMustBeSet: 'L\'intervallo deve essere impostato',
      isSecondUseCheck: 'Questo coupon si applica subito dopo il primo utilizzo',
      groups: 'Gruppi di clienti',
      freeProduct: 'Prodotto gratuito da aggiungere al carrello',
      freeProductPlaceholder: 'Seleziona un prodotto',
      freeProductRequired: 'Seleziona un prodotto gratuito'
    },
    marketingOffers: {
      single: 'offerta banner',
      plural: 'offerte banner',
      title: 'Titolo',
      status: 'Stato',
      image: 'Immagine',
      imageWeb: 'Immagine Web',
      imageBanner: 'Immagine Banner',
      imageLanding: 'Immagine Landing',
      linkType: 'Tipo Link',
      startEndDate: 'Data di inizio e fine',
      actions: 'Azioni',
      offerAdded: 'Banner dell\'offerta aggiunto con successo.',
      offerUpdated: 'Banner dell\'offerta aggiornato con successo.',
      offerDeleted: 'Banner dell\'offerta rimosso con successo.',
      weCouldNot: 'Non è stato possibile salvare la foto della slide, riprova più tardi.',
      validImg: 'Si prega di aggiungere un\'immagine valida.',
      areYouSure: 'Sei sicuro di voler {etichetta} questo banner dell\'offerta?',
      pageText: 'Pagina Testo',
      pickCateg: 'Scegli Categoria',
      pickProd: 'Scegli Prodotto',
      pickLoc: 'Scegli la posizione',
      none: 'Nessuno',
      banners: 'Banner',
      offers: 'Offerte',
      display: 'Schermo',
      addGroup: 'Aggiungere gruppo',
      offerSuccess: 'Offerta di gruppo aggiunta con successo'
    },
    marketingOffersTypes: {
      category: 'categoria',
      product: 'prodotto',
      page: 'pagina'
    },
    marketingFidelities: {
      fidelities: 'fedeltà',
      loyalityPoint: 'Punti fedeltà',
      userLabeling: 'Etichetta Utente',
      name: 'Nome',
      ordersValue: 'Valore ordini',
      ordersNumber: 'Numero ordini',
      color: 'Colore',
      notification: 'Notifica',
      coupon: 'Coupon',
      product: 'Prodotto',
      nameLabel: 'Nome etichetta',
      addLabel: 'Aggiungi etichetta',
      noData: 'Nessun dato',
      updateUserLabeling: 'Etichetta utente aggiornata',
      createdUserLabeling: 'Etichetta utente creata',
      areYouSureDelete: 'Sei sicuro di voler rimuovere questa etichetta',
      labelDeleted: 'Etichetta rimossa',
      orderNumberRequired: 'Questo campo o i numeri d\'ordine sono obbligatori',
      orderValueRequired: 'Questo campo o valore dell\'ordine è obbligatorio',
      yes: 'Sì',
      applyCupon: 'Applica coupon',
      applyproduct: 'Applica prodotto',
      badgeColor: 'Colore Badge',
      badgeName: 'Nome Badge',
      value: 'Valore',
      number: 'Numero',
      appliedForLastMonth: 'Le etichette sono applicate solo per gli ordini degli ultimi 30 giorni,',
      checkTermsAndConditionFidelities: 'Controlla le promozioni fedeltà dalle pagine informative',
      labelingPrimaryOption: 'Seleziona l\'opzione principale per le etichette',
      labelingSuccess: 'Le impostazioni per le etichette sono state aggiornate con successo!',
      updatePrimaryOption: 'Aggiorna l\'opzione',
      showLabelOnUser: 'Mostra l\'etichetta sugli utenti',
      infoAboutShowUserLabelUpdated: 'L\'informazione \'Mostra l\'etichetta sugli utenti\' è stata aggiornata',
      labelingInterval: 'Seleziona intervallo da applicare',
      '0': 'Sempre',
      '30': '30 giorni',
      '60': '60 giorni',
      '90': '90 giorni',
      '120': '120 giorni',
      recurrence: 'Ricorrenza',
      noReccurence: 'Nessuna',
      oneDay: '1 Giorno',
      threeDays: '3 Giorni',
      fiveDays: '5 Giorni',
      sevenDays: '7 Giorni',
      tenDays: '10 Giorni',
      fifteenDays: '15 Giorni',
      twentyDays: '20 Giorni',
      twentyFiveDays: '25 Giorni'
    },
    marketingPromos: {
      title: 'Titolo',
      treshold: 'Soglia n',
      category: 'Categoria',
      product: 'Prodotto',
      products: 'Prodotti',
      none: 'Nessuno',
      marketingPromos: 'Promo',
      generateQrCode: 'Genera codice QR',
      code: 'Codice',
      promoDeleted: 'Promozione eliminata',
      areYouSureDelete: 'Sei sicuro di voler eliminare questa promozione?',
      promoAdded: 'Promo aggiunta.',
      promoUpdated: 'Promozione aggiornata correttamente.',
      weCouldNot: 'Non è stato possibile salvare i dati, riprova più tardi.',
      startEndDate: 'Inizio - Data di fine',
      image: 'Immagine',
      validImg: 'Si prega di aggiungere un\'immagine valida.',
      print: 'Stampa',
      firstname: 'Nome di battesimo',
      lastname: 'Cognome',
      points: 'Punti',
      email: 'E-mail',
      description: 'Descrizione'
    },
    reports: {
      orderedProducts: 'Prodotti ordinati',
      giftCardsSoldTotal: 'Total gift cards sold',
      giftCardsSoldAmount: 'Gift cards sold',
      number: 'Order nr',
      trends: 'Tendenze',
      clients: 'Clienti',
      products: 'Prodotti',
      marketing: 'Marketing',
      today: 'Oggi',
      orderChart: 'Ordini',
      clientsChart: 'Clienti',
      completed: 'Completato',
      canceled: 'Annullato',
      salesChart: 'Vendite',
      salesIn: 'Vendite in',
      customersChart: 'Clienti',
      appInstalls: 'Installazioni di app',
      custWithAcc: 'Clienti con account',
      top10Chart: 'Top 10 prodotti',
      top5Chart: 'Top 5 prodotti',
      orderingChart: 'Tipi di ordine',
      nrOfOrders: 'Numero di ordini',
      customersAge: 'Età dei clienti',
      customersGender: 'Genere dei clienti',
      name: 'Nome e Cognome',
      appInstalled: 'App Installate',
      gender: 'Genere',
      location: 'Luogo',
      partnerCode: 'Codice partner',
      email: 'Email',
      phone: 'Telefono',
      age: 'Età',
      filter: 'Filtro',
      label: 'Etichetta',
      userDetails: 'Dettagli Cliente',
      salesDetails: 'Dettagli Vendite',
      salesProductNr: 'Numero di vendite del prodotto',
      totalAmount: 'Importo totale',
      totalProducts: 'Prodotti totali',
      ordersNumber: 'Ordini',
      minAmount: 'Importo totale Minimo',
      minOrders: 'Ordini Minimi',
      maxOrders: 'Ordini Massimi',
      itemsSold: 'Articoli venduti',
      campaign: 'Campagna',
      couponsTimesUsed: 'Tempi di utilizzo dei coupon',
      revenue: 'Ricavi',
      total: 'Totale',
      paymentType: 'Modalità di pagamento',
      date: 'Data',
      salesReport: 'Report delle vendite',
      salesReportBeta: 'Report delle vendite BETA',
      order: 'Ordine',
      export: 'Esporta',
      cash: 'Contanti',
      card: 'Carta',
      pos: 'POS',
      tips: 'Mancia',
      totalSum: 'Importo Totale',
      search: 'Cerca',
      searchFilter: 'Cerca(nome, email, telefono)',
      discount: 'Sconto',
      tax: 'Tassa',
      shipping: 'Livrare',
      delivery_type: 'Metodo di consegna',
      zone: 'Zona',
      totalDiscount: 'Sconto Totale',
      ordersWithDiscount: 'Ordini con Sconto',
      ordersWithFidelity: 'Ordini con Fedeltà',
      totalFidelityDiscount: 'Sconto Totale Fedeltà',
      totalTax: 'Tasse Totali',
      avarageOrderValue: 'Valore medio dell\'ordine',
      clientsWOrders: 'Clienti con ordini',
      emailSend: 'Email inviate negli ultimi 6 mesi',
      emailTotal: 'Totali email inviate: ',
      newCustomersChart: 'Nuovi Clienti',
      productsSalesReport: 'Report sulle vendite del prodotto',
      pricePerUnit: 'Prezzo per unità',
      quantity: 'Quantità',
      productName: 'Nome Prodotto',
      couponCode: 'Buono',
      checkOrder: 'Usa ordine',
      donationReport: 'Rapporto Donazioni'
    },
    feedback: {
      sigle: 'feedback',
      type: 'Tipo',
      sentBy: 'Inviato da',
      text: 'Testo',
      seen: 'Visto',
      sentAt: 'Inviato a',
      search: 'Cerca',
      comment: 'Commento'
    },
    feedbackTypes: {
      feedback: 'Feedback',
      issue: 'Problema',
      suggestion: 'Suggerimento'
    },
    blogPage: {
      categories: 'Categorie',
      categoriesHint: 'Facoltativo — gli articoli possono anche non avere una categoria.',
      categoryName: 'Nome categoria',
      noCategories: 'Ancora nessuna categoria.',
      articles: 'Articoli',
      addArticle: 'Aggiungi articolo',
      editArticle: 'Modifica articolo',
      allCategories: 'Tutte le categorie',
      noCategory: 'Nessuna categoria',
      allStatuses: 'Tutti gli stati',
      searchByTitle: 'Cerca per titolo',
      noArticles: 'Nessun articolo trovato.',
      cover: 'Copertina',
      coverHint: 'consigliato 1200x630px, max 5MB',
      imageAlt: 'Testo alternativo immagine (SEO)',
      title: 'Titolo',
      slug: 'Link articolo (slug)',
      slugHint: 'Generato dal titolo se lasciato vuoto.',
      shortDescription: 'Descrizione breve (sotto il titolo)',
      content: 'Contenuto',
      category: 'Categoria',
      author: 'Autore',
      publishedAt: 'Data di pubblicazione',
      publishedAtHint: 'Se vuota, alla pubblicazione viene usata la data corrente.',
      status: 'Stato',
      published: 'Pubblicato',
      draft: 'Bozza',
      scheduled: 'Programmato',
      seo: 'SEO',
      metaTitle: 'Meta titolo',
      metaDescription: 'Meta descrizione',
      metaKeywords: 'Parole chiave (separate da virgola)',
      titleRequired: 'Il titolo è obbligatorio.',
      deleteCategoryConfirm: 'Eliminare la categoria "{name}"? {count} articolo/i resteranno senza categoria.',
      deleteArticleConfirm: 'Eliminare l\'articolo "{name}"?'
    },
    settingsPages: {
      homepageSections: 'Sezioni Homepage',
      interactiveTour: 'Tour interattivo',
      blog: 'Blog',
      interactiveTourFirstLogin: 'Usa il tour interattivo al primo accesso',
      interactiveTourAlways: 'Usa sempre il tour interattivo',
      interactiveTourDisplayMode: 'Modalità di visualizzazione immagine',
      interactiveTourDisplayContain: 'Contain',
      interactiveTourDisplayCover: 'Cover',
      interactiveTourDisplayFullPage: 'Pagina intera',
      userSettings: 'Impostazioni Utente',
      myProfile: 'Il mio profilo',
      users: 'Utenti',
      general: 'Generale',
      companyDetails: 'Dettagli Azienda',
      dateTime: 'Data e ora',
      currency: 'Valuta',
      accounting: 'Contabilità',
      tax: 'Tassa',
      payment: 'Pagamento',
      orderingMng: 'Gestione degli ordini',
      loyalty: 'Programma fedeltà',
      push: 'Notifiche push',
      tips: 'Mance',
      locationGroups: 'Gruppi di località',
      locationGroupsName: 'Nome',
      locationGroupsDescription: 'Descrizione',
      locationGroupsPhoto: 'Foto',
      locationGroupsAdded: 'Nuovi gruppi di località aggiunti con successo',
      locationGroupsUpdated: 'Gruppi di località aggiornati con successo',
      locationGroupsPicError: 'Non è stato possibile salvare la foto dei gruppi di località, riprova più tardi.',
      locationGroupsDelete: 'Elimina gruppo di località',
      locationGroupsAreYouSure: 'Sei sicuro di voler eliminare questo gruppo di località?',
      locationGroupsSelect: 'Seleziona il gruppo di località a cui appartiene:',
      subscription: 'Sottoscrizione',
      myPlan: 'Il mio piano',
      infoPages: 'Pagine informative',
      taxLabeling: 'Etichettatura delle tasse',
      deliveryMethods: 'Luoghi e metodi di consegna',
      filters: 'Filtri',
      filterProducts: 'Filtri Prodotto'
    },
    settingUsers: {
      single: 'utente',
      fn: 'Nome',
      ln: 'Cognome',
      email: 'Email',
      username: 'Username',
      lang: 'Linguaggio d\'interfaccia',
      langMsg: 'Questa è la lingua in cui visualizzerai l\'area di amministrazione.',
      avatar: 'Avatar',
      role: 'Ruolo',
      locations: 'Accedi agli ordini dalle sedi',
      locations_helptext: 'Importante: se non viene selezionata alcuna località, questo utente avrà accesso a tutte le località.',
      resetPass: 'Reimposta Password',
      password: 'Password',
      pass: 'Password',
      confPass: 'Conferma Password',
      userAdded: 'Nuovo utente aggiunto con successo',
      userUpdated: 'Nuovo utente aggiornato con successo',
      userPicError: 'Non è stato possibile salvare l\'avatar dell\'utente, riprova più tardi.',
      USER: 'UTENTE',
      DRIVER: 'RIDER',
      LOCATION_ADMIN: 'AMMINISTRAZIONE LOCALITÀ',
      MARKETER: 'MARKETER'
    },
    settingCompany: {
      title: 'Azienda',
      location: 'Luogo',
      name: 'Nome',
      lang: 'Lingua dell\'applicazione',
      bussLoc: 'Sede dell\'attività',
      deliveryLabels: 'Etichette dei tipi di consegna',
      pick_up: 'Ritiro in negozio',
      meet_half: 'Incontro a metà strada',
      delivery: 'Consegna a domicilio',
      eat_location: 'Prenota un tavolo',
      self_ordering: 'Self Ordering',
      phone: 'Telefono',
      street: 'Strada',
      number: 'N.',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      email: 'Email',
      city: 'Città',
      country: 'Paese',
      state: 'Stato',
      availableDaysHrs: 'GIORNI E ORARI DISPONIBILI',
      from: 'da',
      to: 'a',
      preOrder: 'pre-ordine da',
      allowPreOrder: 'Consenti Pre-ordine',
      cardPaymentDetails: 'Impostazioni di pagamento con carta',
      paylikeKeys: 'Chiavi usate di Paylike',
      posDiscount: 'POS id per lo sconto',
      userTaxes: 'TASSE UTILIZZATE',
      noTaxMsg: 'Info: Hai fatto delle modifiche alle tasse, non dimenticare di salvarle',
      areYouSureDelete: 'Sei sicuro di voler eliminare questa località? Questa azione eliminerà anche le impostazioni di ordinazione per questa località',
      pickLocationToCopy: 'Scegli una località da cui desideri copiare i prodotti',
      areYouSureTax: 'Sei sicuro di voler rimuovere questa tassa dall\'elenco delle tasse? Non dimenticare di salvare le modifiche!',
      companyUpdated: 'Dati dell\'azienda aggiornati con successo.',
      companyProdCopied: 'Prodotti copiati con successo.',
      wrongAddress: 'L\'indirizzo della "{località}" non è corretto.',
      deleteLocationValidation: 'Questa località è in uso. Non puoi eliminarla. Devi prima rimuoverla dai prodotti in cui è in uso.',
      email_feedback: 'E-mail per ricevere feedback dalle app mobili',
      email_feedback_helptext: 'Puoi utilizzare più indirizzi e-mail separati da virgole.',
      printSettings: 'Impostazioni di stampa',
      automatPrintOrder: 'Ordine di stampa Web A4 automatico',
      autoSendOrderToPrinter: '80 mm ordine di stampa',
      autoPrintLocalServer: 'Stampa automatica della nota di sezione dal server locale (ordini nuovi o in elaborazione)',
      printerIp: 'IP/Host della stampante',
      printerPort: 'Porta della stampante',
      copyProductsFrom: 'Copia prodotti da',
      overEighteen: 'Limitare gli utenti sotto i 18 anni (necessario per vendere alcolici attraverso l\'applicazione)',
      setRadiusArea: 'Imposta il raggio dell\'area',
      setDrawArea: 'Imposta area di disegno',
      jump_to_menu: 'Vai al menu',
      jump_to_categories_menu: 'Permette l\'accesso diretto al menu nell\'applicazione, prima dei metodi di consegna.',
      allow_fiscal_print: 'Consenti la stampa delle ricevute',
      allowPlaceUntilCloseHour: 'Permettere di fare ordini fino all\'orario di chiusura',
      sortProductsMethods: 'Metodo di ordinamento dei prodotti',
      alphabetic_asc: 'In ordine alfabetico ascendente',
      alphabetic_desc: 'In ordine alfabetico discendente',
      price: 'In ordine di prezzo',
      custom: 'Personalizzato',
      infoCustomSort: '(l\'ordinamento personalizzato viene effettuato in ogni sezione di modifica della categoria)',
      allowSoundAtStatusNew: 'Consenti l\'audio per lo stato degli ordini NUOVO',
      allowSoundAtStatusProcessing: 'Consenti l\'audio per lo stato degli ordini IN ELABORAZIONE',
      allowSoundAtStatusProcessingV1: 'Consente l\'audio in base al tempo di attesa predefinito',
      allowSoundAtStatusProcessingV2: 'Consente l\'audio in base a 1/4 del tempo di attesa predefinito',
      allowSoundAtStatusProcessingV3: 'Consente l\'audio in base a 1/2 del tempo di attesa predefinito',
      allowSoundAtStatusProcessingV0: 'Nessun suono',
      allowToOrderUnderMinValueWithCoupon: 'Consenti di effettuare l\'ordine con un valore minimo quando si applica il coupon',
      filters: 'Filtri',
      allowSoundForMehods: 'Consente il suono per i seguenti metodi di consegna'
    },
    settingDateTime: {
      timezone: 'Fuso orario',
      timeFormat: 'Formato orario',
      dateFormat: 'Formato data',
      saveMsg: 'Impostazioni di data e ora salvate con successo'
    },
    settingCurrency: {
      currency: 'Valuta del negozio',
      saveMsg: 'Dati valuta salvati con successo'
    },
    settingTaxes: {
      single: 'Tassa',
      name: 'Nome',
      type: 'Tipo',
      amount: 'Importo',
      notice: 'Informazioni: in "Etichettatura delle tasse" si definisce solo un nome di etichetta per l\'imposta da applicare. Per definire i dettagli fiscali come valore o tipo è necessario andare su ',
      notice2: 'dettagli azienda',
      singleTaxLabel: 'Etichetta tassa',
      notice3: 'Informazioni: nella sezione "Tasse utilizzate" si definiscono le tasse che vengono applicate, dettagli come valore o tipo, se si desidera creare un\'etichetta fiscale vai a',
      notice4: 'etichettatura delle tasse'
    },
    settingsPayment: {
      publicKey: 'Chiave pubblica',
      privateKey: 'Chiave privata'
    },
    settingsOrdering: {
      offnoPreorders: 'You must have offset 0 and period 1 to work',
      noPreorders: 'We do not accept pre-orders',
      isAlwaysOpen: 'Sempre aperto',
      isAlwaysOpenPreorderHours: 'Ore preordine',
      infoBoxTitle: 'Aggiungi ulteriori informazioni',
      infoBoxRadioCheck: 'Modifica opzione',
      infoBoxRadio: 'Una sola opzione',
      infoBoxCheck: 'Più opzioni',
      enabled: 'Abilitato',
      paymentOptions: 'Opzioni di pagamento',
      paymentOptionsErr: 'Il campo dell\'opzione di pagamento è obbligatorio.',
      waitingTime: 'Tempo di attesa predefinito',
      minimumOrderValue: 'Valore minimo di ordine',
      minutes: 'min',
      shippingCost: 'Costo di spedizione',
      deliveryRange: 'Raggio di consegne',
      deliveryRangeUnit: 'm',
      posId: 'Costo di spedizione ID POS',
      shippingTax: 'Tassa di spedizione',
      locations: 'Località',
      street: 'Via',
      city: 'Città',
      country: 'Paese',
      state: 'Stato',
      availableDays: 'Giorni e orari disponibili',
      availableDaysErr: 'Il campo opzione giorni e orari disponibili è obbligatorio.',
      notice: 'Si prega di controllare l\'errore nelle schede dei metodi di ordinazione abilitati e poi provare a salvare di nuovo il modulo',
      saveSuccess: 'Dati dei dettagli ordine salvati con successo',
      deliveryRules: 'Regole di consegna',
      addRange: 'Aggiungi regola',
      shippingCities: 'Città',
      shippingNeighborhoods: 'Quartieri',
      citiesValidationError: 'Assicurati che i valori delle città siano univoci per ogni raggio di consegna.',
      hourAndDate: 'Ora e Data',
      justDate: 'solo data',
      deactivateDeliveryHours: 'Disattiva ora e data',
      offset: 'Periodo di ritardo',
      period: 'Periodo',
      addZone: 'Aggiungi Zona',
      newZone: 'Nuova Zona'
    },
    settingsZone: {
      edit: 'Nome zona',
      deleteBtn: 'Elimina Zona',
      deleteShape: 'Elimina forma per crearne un\'altra',
      overridePayment: 'Sovrascrivi metodo di pagamento',
      acceptCash: 'Accetta contanti',
      acceptCard: 'Accetta carta',
      acceptPos: 'POS alla consegna (non pagato)'
    },
    settingsInfoPages: {
      single: 'pagina',
      noPage: 'Nessuna pagina ancora aggiunta.',
      title: 'Titolo pagina',
      content: 'Contenuto Pagina',
      newPage: 'Nuova Pagina',
      showInHeader: 'Mostra nell\'intestazione',
      showInFooter: 'Mostra nel piè di pagina',
      addedSuccess: 'Pagina salvata con successo.',
      deletedSuccess: 'Pagina rimossa con successo.',
      deleteMsg: 'Sei sicuro di voler eliminare questa pagina?',
      TERMS_CONDITIONS: 'Termini e Condizioni',
      PRIVACY_POLICY: 'Politica sulla Privacy',
      CONTACT_DETAILS: 'Dettagli contatto',
      FIDELITIES_PROMOTIONS: 'Promozioni Fedeltà',
      CUSTOM: 'Personalizzato'
    },
    settingsRewards: {
      single: 'punto',
      plural: 'punti',
      state: 'Stato',
      points: 'punto(i)',
      moneySpent: 'Soldi spesi in punti',
      pointsTo: 'Punti in denaro',
      numberOfcurrencyNeedToSpend: 'Importo di denaro che il cliente deve spendere per guadagnare 1 punto.',
      numberOfpointsToReward: 'Quantità di punti di cui il cliente ha bisogno quando vuole pagare utilizzando i punti.',
      timeInterval: 'Fascia oraria.',
      fromTime: 'Da ora',
      toTime: 'A ora',
      rewardSuccess: 'Dati del programma fedeltà salvati con successo'
    },
    settingsPushNotif: {
      order_new: 'Nuovo messaggio d\'ordine',
      order_completed_pickup: 'Messaggio d\'ordine completato - Ritiro',
      order_completed_meet: 'Messaggio d\'ordine completato - Incontro a metà strada',
      order_completed_delivery: 'Messaggio d\'ordine completato - Consegna',
      order_completed_eat: 'Messaggio d\'ordine completato - Mangia sul posto',
      order_canceled: 'Messaggio di ordine annullato',
      notifUpdated: 'Dati delle notifiche push salvati con successo',
      preview: 'Anteprima',
      time: 'orario',
      dateTime: 'data e ora',
      persons: 'numero di persone',
      timePrev: '11:30 (in 30 minuti)',
      personsPrev: '3',
      dateTimePrev: 'Martedì, 15 Febbraio 2019, alle 18:00',
      info: '*Nel caso in cui non sia necessario visualizzare l\'orario di consegna, lasciare vuoto l\'ultimo campo.*',
      selectedLocations: 'Località selezionate:'
    },
    settingsTips: {
      tipsTaxes: 'Mance tasse',
      state: 'Utilizza Mance',
      tipsSuccess: 'Mance salvate con successo'
    },
    settingsPlans: {
      plan1Title: 'Mensile',
      plan1Rate: '160€ / mese',
      plan1Description: 'Inizia con una tariffa fissa mensile, indipendentemente dall\'importo delle vendite effettuate tramite l\'app.',
      plan2Title: 'Percentuale Vendite',
      plan2Rate: '10%',
      plan2Description: 'Paga come vendi. Scegli la Percentuale di vendita e paga un canone mensile in relazione all\'importo che vendi tramite l\'app.',
      current: 'Abbonamento attuale',
      switch: 'Switch'
    },
    filter: {
      filter: 'Filtro',
      action: 'Azione',
      create: 'Filtro Creato',
      update: 'Filtro Aggiornato',
      areYouSureDelete: 'Sei sicuro di voler eliminare questo filtro?',
      yes: 'Sì',
      deleted: 'Filtro rimosso',
      noFilters: 'Nessun filtro',
      name: 'Nome',
      addFilter: 'Aggiungi Filtro',
      filters: 'Filtri',
      value: 'Valore',
      filterProducts: 'Filtri Prodotti',
      filterName: 'Nomi Filtri',
      val: 'Val',
      filterUpdated: 'Filtri Aggiornati',
      minOneFilterValueRequired: 'È richiesto almeno un valore per ogni filtro',
      filterType: 'Tipo di Filtro',
      type_exists: 'Il tipo di filtro esiste',
      filter_value_exists: 'Il valore del filtro esiste',
      some_filter_applied: 'Aggiornato con successo, ma alcuni filtri o valori sono applicati ai prodotti e non possono essere eliminati'
    },
    ordersSource: {
      1: 'Kiosk',
      2: 'Qr',
      3: 'Pos',
      4: 'App',
      5: 'Website',
      6: 'Glovo',
      7: 'Wolt',
      8: 'Bolt'
    },
    checkbox: 'Consente di selezionare più opzioni sul prodotto',
    radio: 'Consente di selezionare una sola opzione sul prodotto',
    ...itLocale
  },
  de: {
    btPayments: btPayments.en,
    marketplace: marketplace.de,
    general: {
      search: 'Suche',
      home: 'Startseite',
      add: 'Hinzufügen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      remove: 'Entfernen',
      save: 'Speichern',
      update: 'Aktualisieren',
      cancel: 'Abbrechen',
      continue: 'Fortfahren',
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      active: 'aktiv',
      inactive: 'inaktiv',
      removePhoto: 'Zu viele Fotos hochgeladen',
      yes: 'Ja',
      no: 'Nein',
      success: 'Erfolg',
      required: 'erforderlich',
      back: 'Zurück',
      next: 'Nächste',
      finish: 'Fertigstellen',
      duplicate: 'Duplizieren',
      select: 'Auswählen',
      all: 'Alle',
      reset: 'Zurücksetzen',
      export: 'Exportieren',
      loadMore: 'Mehr anzeigen',
      viewDetails: 'Details anzeigen',
      showing: '{length} Ergebnis(se) anzeigen',
      enable: 'aktivieren',
      disable: 'deaktivieren',
      product: 'Produkt',
      cancelCourier: 'Lieferant stornieren',
      logout: 'Abmelden',
      from: 'von',
      to: 'bis',
      agree: 'Zustimmen',
      agreePopupMessage: 'Klicken Sie auf "Zustimmen", um dem Browser die Audiowiedergabe zu erlauben. Anschließend wird ein Testton abgespielt, um die Audiowiedergabe zu aktivieren.',
      notCompleted: 'nicht abgeschlossen',
      saveChanges: 'Änderungen speichern',
      doYouWantToLogout: 'Möchten Sie sich abmelden?',
      deliveryMethod: 'Lieferoptionen',
      customSort: 'Unternehmen verwendet benutzerdefinierte Sortierung',
      none: 'Keine',
      unset: 'Nicht gesetzt'
    },
    menuLink: {
      alias: 'Alias',
      title: 'Titel',
      updated: 'aktualisiert',
      areYouSure: 'Möchten Sie die Verknüpfung wirklich {label}?',
      deleted: 'Gelöscht',
      couldNotUpdate: 'Konnte nicht aktualisiert werden',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      added: 'Verknüpfung hinzugefügt',
      promotions: 'Angebote',
      history: 'Historie',
      orders: 'Bestellungen',
      reservations: 'Reservations',
      favorite_orders: 'Beliebteste Bestellungen',
      tutorial: 'Anleitung',
      personal_info: 'Persönliche Informationen',
      single: 'Verknüpfung',
      linkFor: 'Verknüpfung für',
      externUrl: 'Externe URL',
      custom: 'benutzerdefiniert',
      day: 'Tag',
      couldNotSave: 'Der Menülink konnte nicht gespeichert werden'
    },
    pages: {
      login: 'Anmelden',
      register: 'Registrieren',
      recoverPassword: 'Passwort wiederherstellen',
      resetPassword: 'Passwort zurücksetzen',
      dashboard: 'Dashboard',
      orderingManagement: 'Verwaltung der Bestellungen',
      customerDetails: 'Kundendaten',
      customers: 'Kunden',
      customersGroups: 'Gruppen',
      orders: 'Bestellungen',
      reservations: 'Reservations',
      products: 'Produkte',
      catalog: 'Produktkatalog',
      categories: 'Kategorien',
      productOptions: 'Produkt Optionen',
      marketing: 'Marketing',
      campaigns: 'Kampagnen',
      donationCampaigns: 'Spendenkampagnen',
      raffleCampaigns: 'Verlosungskampagnen',
      spinningWheelCampaigns: 'Glücksrad',
      offersSlider: 'Angebotsbanner',
      reports: 'Berichte',
      feedback: 'Feedback',
      settings: 'Einstellungen',
      logout: 'Abmelden',
      fidelities: 'Treueprogramm',
      topCategory: 'Überkategorie',
      infoPagesCustom: 'Benutzerdefinierte Seiten',
      menuLinks: 'Verknüpfungen',
      infoPages: 'Informationen',
      productFilters: 'Produkt Filter',
      promos: 'Werbeaktionen',
      menus: 'Speisekarte',
      clientOrderView: 'Abholung anzeigen'
    },
    infoPages: {
      single: 'Seite',
      title: 'Titel',
      shortDescription: 'Kurzbeschreibung',
      updated: 'Aktualisiert',
      areYouSure: 'Möchten Sie die Seite wirklich löschen?',
      deleted: 'Gelöscht',
      couldNotUpdate: 'Seite konnte nicht aktualisiert werden',
      added: 'Informationsseite hinzugefügt',
      changeLinkTab: 'Um einen weiteren Link hinzuzufügen, wechseln Sie die Zeile mit TAB und gelangen zur vorherigen mit SHIFT + TAB',
      infoPages: 'Informationen'
    },
    ordersStatus: {
      bill: 'Bill',
      AWAITING_TRANSPORT: 'Warten auf Lieferung',
      CANCELED: 'Storniert',
      DELIVERED: 'Geliefert',
      DRAFT: 'Entwurf',
      NEW: 'Neu',
      ON_HOLD: 'In Wartestellung',
      POSTPONED: 'Verschoben',
      NOT_DELIVERED: 'Nicht geliefert',
      PICKED_UP_BY_DELIVERY: 'Zur Lieferung abgeholt',
      PROCESSING: 'In Bearbeitung',
      PREPARED: 'Zubereitet',
      TRANSPORT: 'Wird geliefert',
      RESERVED: 'Reserviert',
      COMPLETED: 'Abgeschlossen',
      FINISH: 'Abgeschlossen',
      reservedReady: 'Reserviert / Fertig',
      completedReady: 'Abgeschlossen / Fertig',
      deliveredReady: 'Geliefert / Fertig',
      canceledForever: 'Stornieren? Diese Aktion ist unwiderruflich'
    },
    ordersTypes: {
      GROUP: 'Gruppe',
      SINGLE: 'Einzel'
    },
    paymentTypes: {
      CASH: 'Bar',
      CARD: 'Karte'
    },
    paymentStatus: {
      notPaid: 'Autorisiert (Betrag vorgemerkt)',
      notPaidDetails: 'Der Betrag wird abgebucht, sobald die Bestellung geliefert wurde.',
      paid: 'Bezahlt',
      notOk: 'Abgelehnt'
    },
    campaignsModes: {
      AUTO: 'Automatisch',
      MANUAL: 'Manuell'
    },
    campaignsNotificationTypes: {
      EMAIL: 'E-Mail',
      PUSH: 'Push-Benachrichtigung'
    },
    days: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag'
    },
    daysShort: {
      Mon: 'Mo',
      Tue: 'Di',
      Wed: 'Mi',
      Thu: 'Do',
      Fri: 'Fr',
      Sat: 'Sa',
      Sun: 'So'
    },
    gender: {
      selectGender: 'Geschlecht',
      male: 'männlich',
      female: 'weiblich',
      Male: 'Mann',
      Female: 'Frau',
      Other: 'Sonstiges'
    },
    reportsAgesGroups: {
      selectAge: 'Alter',
      '20': 'Unter 20',
      'Under 20': 'Unter 20',
      '20-30': '20 - 30',
      '30-40': '30 - 40',
      '40-50': '40 - 50',
      '50': '50+',
      '50+': '50+',
      Unspecified: 'Unbestimmt'
    },
    deliveryTypes: {
      DELIVERY: 'Lieferung',
      EAT_LOCATION: 'Tisch reservieren',
      MEET_HALF: 'Komm mir entgegen',
      PICK_UP: 'Abholung'
    },
    couponsTypes: {
      FIXED: 'Fest',
      PERCENTAGE: 'Prozentuell',
      FREE_PRODUCT: 'Gratisprodukt'
    },
    taxTypes: {
      FIXED_INCLUDED: 'Fest (inbegriffen)',
      PERCENTAGE_INCLUDED: 'Prozentuell (inbegriffen)',
      FIXED_EXCLUDED: 'Fest',
      PERCENTAGE_EXCLUDED: 'Prozentuell'
    },
    productOptions: {
      checkbox: 'Ermöglicht die Auswahl mehrerer Optionen für ein Produkt',
      radio: 'Ermöglicht die Auswahl von nur einer Option für ein Produkt'
    },
    validations: {
      areYouSureYouWantTo: 'Möchten Sie wirklich ',
      areYouSure: 'Möchten Sie den Status ändern zu ',
      wentWrong: 'Etwas ist fehlgeschlagen. Versuchen Sie es später bitte erneut...',
      pictureSize: 'jpg/png Dateien mit einer Dateigröße kleiner als 5MB ',
      pictureSizeExceed: 'Dateigröße darf 5MB nicht übersteigen!',
      removePhoto: 'Entfernen Sie die aktuelle Datei, um eine neue hinzuzufügen',
      dataCouldNotBeSaved: 'Daten konnten nicht gespeichert werden. Versuchen Sie es später bitte erneut.',
      passReq: 'Passwort erforderlich.',
      passMin: 'Das Passwort muss mind. 6 Zeichen lang sein.',
      passConf: 'Passwort und Passwortbestätigung stimmen nicht überein.',
      validPoinsNo: 'Bitte geben Sie einen gültigen Betrag in € und einen Kommentar an.',
      imageResolution: ', Empfohlene Auflösung: 300 x 820 Pixel (H x B).',
      imageResolutionWeb: ', Empfohlene Auflösung: 300 x 1920 Pixel (H x B).',
      doYouWantTo: 'Möchten Sie ',
      hourIsSmallerThanCreated: 'Die von Ihnen eingestellte Uhrzeit ist vor der Uhrzeit der Bestellung',
      vatPrinterIdRange: '0–10 only.',
      vatPrinterIdNumeric: 'Numbers only.'
    },
    dashboard: {
      selectLocation: 'Standort:',
      selectMethod: 'Methode:',
      tile1Title: 'Neue Bestellungen',
      tile2Title: 'Alle Bestellungen',
      tile3Title: 'Umsatz',
      tile4Title: 'Neu registrierte Kunden',
      today: 'Heute',
      orderChart: 'Bestellungen',
      completed: 'Anzahl der Bestellungen',
      canceled: 'Storniert',
      salesChart: 'Verkäufe',
      salesIn: 'Verkäufe in',
      top5Chart: 'Top 5 Produkte',
      orderingChart: 'Art der Bestellungen',
      nrOfOrders: 'Anzahl der Bestellungen',
      nrOfEmails: 'Anzahl der E-Mails'
    },
    customers: {
      noCustomer: 'Kein Kunde ausgewählt',
      single: 'Kunde',
      plural: 'Kunden',
      title: 'Kundendaten',
      pointsTitle: 'Treuepunkte des Kunden',
      currentPoints: 'Aktuelle Punkte',
      pointsAddTitle: 'Punkte hinzufügen',
      pay: 'Pay Type',
      id: 'ID',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      use_calling_phone: 'Preia numar telefon',
      gender: 'Geschlecht',
      birth: 'Geburtsdatum',
      location: 'Standort',
      address: 'Adresse',
      number: 'Nummer',
      dateCreated: 'Erstelldatum',
      delivery: 'Lieferung',
      type: 'Art',
      status: 'Status',
      total: 'Gesamt',
      allTimeSale: 'Gesamtverkäufe',
      none: 'Keine',
      pointsLabel: 'Ausgegebenes Geld',
      pointsLabelInPoints: 'Points earned',
      pointsAdjustmentHelp: 'Geben Sie einen positiven Wert ein, um Punkte hinzuzufügen, oder einen negativen Wert (z. B. -100), um Punkte vom Kundenkonto abzuziehen.',
      points: 'points',
      point: 'point',
      clientCanUse: 'Customer can use',
      commentsLabel: 'Kommentar',
      pointsSuccess: 'Treuepunkte erfolgreich hinzugefügt.',
      pointsError: 'Die Treuepunkte konnten dem Kunden nicht gutgeschrieben werden.',
      addCommentPerClient: 'Kommentar für Kunden hinzufügen',
      newCommentAdded: 'Der Kommentar wurde hinzugefügt',
      filters: {
        withOrders: 'Mit Bestellungen',
        withoutOrders: 'Ohne Befehle'
      },
      addGroup: 'Gruppe hinzufügen',
      deleteGroup: 'Gruppe erfolgreich gelöscht.',
      saveGroup: 'Gruppe wurde erfolgreich hinzugefügt',
      updateGroup: 'Gruppe wurde erfolgreich aktualisiert'
    },
    orders: {
      counterPerCustomer: 'Anzahl der Bestellungen',
      noOrders: 'Keine Bestellung ausgewählt',
      single: 'Bestellung',
      the_order: 'Bestellung',
      plural: 'Bestellungen',
      status: 'Status',
      location: 'Standort',
      updateStatus: 'Status',
      editOrder: 'Edit Order',
      ordDetails: 'Bestelldetails',
      date: 'Datum',
      madeAt: 'Bestellung aufgegeben um',
      pickupTime: 'Lieferung / Abholung um',
      preorder: 'VORBESTELLUNG',
      preorderFilter: 'Vorbestellungen',
      allOrders: 'Alle Bestellungen',
      pendingPreorders: 'Ausstehende Vorbestellungen',
      withoutPendingPreorders: 'Ohne ausstehende Vorbestellungen',
      reservationTime: 'Reservierungszeit',
      reservationSeats: 'Reservierte Plätze',
      rating: 'Bewertung',
      meetupLocation: 'Treffpunkt',
      ordLocation: 'Standort der Bestellung',
      delivery: 'Lieferung',
      type: 'Art',
      payment: 'Bezahlung',
      name: 'Name',
      qty: 'Menge',
      unit: 'Stückpreis',
      unit_price: 'Stückpreis',
      final_price: 'Endpreis',
      total: 'Gesamt',
      totals_subtotals: 'Zwischensumme',
      totals_discount: 'Rabatt',
      totals_discount_loyalty_points: 'Rabatt durch Treuepunkte',
      totals_grandtotal: 'Gesamt',
      totals_shipping: 'Lieferung',
      totals_extras: 'Einkaufstasche',
      totals_extras_27: 'Verpackungsgebühr',
      totals_extras_30: 'Einkaufstasche',
      totals_extras_38: 'Einkaufstasche',
      totals_extras_40: 'Einkaufstasche',
      totals_extras_50: 'Ambalaj',
      totals_tip: 'Trinkgeld',
      totals_donation: 'Spende',
      custComments: 'Kundenkommentar',
      adminComments: 'Adminkommentar',
      custDetails: 'Kundendaten',
      shipping: 'Lieferadresse',
      billing: 'Rechnungsadresse',
      orderStatusSuccess: 'Bestellstatus erfolgreich aktualisiert',
      orderPrinterError: ', die Verbindung zum Drucker ist fehlgeschlagen.',
      orderCommnetSuccess: 'Kommentar erfolgreich hinzugefügt',
      orderHourSuccess: 'Liefer- / Abholzeit erfolgreich aktualisiert',
      orderHourError: 'Bitte geben Sie eine gültige Uhrzeit ein.',
      none: 'Kein Kommentar',
      at: 'um',
      filtersApplied: 'Filter angewandt - tippen Sie auf das Filtersymbol, um mehr zu sehen',
      customFilters: 'Personalisierte Filter angewandt',
      resetFilters: 'Tippen Sie hier, um die Filter zurückzusetzen und aktuelle Daten zu sehen',
      note: 'Notiz',
      orderNoArticulate: 'Bestellung',
      print: 'Drucken (A4)',
      printerPrint: 'Drucken (80mm)',
      printerSuccess: 'Bestellung erfolgreich ausgedruckt.',
      printerErrror: 'Die Verbindung zum Drucker ist fehlgeschlagen.',
      callCourier: 'Lieferanten-Ruf',
      callHioCourier: 'Hio',
      callCourierCancel: 'Möchten Sie den Lieferanten-Ruf abbrechen?',
      orderSentSuccess: 'Lieferanten-Ruf wurde erfolgreich gesendet',
      orderCancelSuccess: 'Lieferanten-Ruf wurde abgebrochen',
      packageDetails: 'Verpackungsdetails auswählen',
      packageSize: 'Verpackungsgröße: ',
      courierTime: 'Abholzeit für den Lieferanten: ',
      now: 'Jetzt',
      addTime: 'Zeit hinzufügen',
      orderCloseToDelivery: 'Bestellung näher an Lieferzeit',
      amountRefunded: 'Betrag erstattet',
      amountIntegralRefunded: 'Der gesamte Betrag wurde dem Kunden erstattet',
      refundSuccess: 'Betrag erfolgreich erstattet',
      refundManual: 'Der Betrag wird von dem Zahlungsdienst erstattet',
      refundAutomat: 'Möchten Sie den Betrag automatisch erstatten lassen ?',
      refundOrder: 'Erstatten',
      refundAlreadyDone: 'Bereits erstattet',
      refundConfirmTitle: 'Bestellung erstatten?',
      refundConfirmText: 'Der bezahlte Betrag wird dem Kunden über EuPlatesc erstattet. Diese Aktion kann nicht rückgängig gemacht werden.',
      refundAskCancel: 'Erstattung abgeschlossen. Möchten Sie die Bestellung ebenfalls stornieren?',
      refundError: 'Bei der Verarbeitung der Erstattung ist ein Fehler aufgetreten.',
      erorrPaylike: 'Störung von Paylike, Zahlungsprozess fehlerhaft'
    },
    companyOptions: {
      id: 'Id',
      name: 'Name',
      image: 'Image',
      prod_image: 'Product Image',
      type: 'Type',
      deleteQues: 'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',
      deleteVal: 'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',
      active: 'Active'
    },
    catalogProd: {
      noProducts: 'Kein Produkt ausgewählt',
      single: 'Produkt',
      plural: 'Produkte',
      generalDetails: 'Allgemeine Informationen',
      aditionalInfo: 'Zusätzliche Informationen',
      name: 'Name',
      desc: 'Beschreibung',
      image: 'Bilder',
      imageMore: 'Mehr Bilder',
      video: 'Video',
      category: 'Kategorie',
      partialPay: 'Plata partiala',
      secondaryCategory: 'Secondary categories',
      price: 'Preis',
      taxes: 'Angewandte Steuern',
      status: 'Status',
      posid: 'POS ID',
      allowUserComments: 'Kundenkommentare zulassen',
      validFromTo: 'Gültig von - bis',
      prodType: 'Produkttyp',
      singleType: 'Einzel',
      groupType: 'Gruppe',
      rewardPoints: 'Treuepunkte',
      moneySpent: 'Geld in Punkte',
      numberOfYouNeedToSpend: 'Anzahl an {currency} die der Kunde ausgeben muss, um einen Punkt zu erhalten.',
      points: 'Punkte',
      soldWith: 'Verkauft mit',
      pickAnOption: 'Wähle eine Option',
      minNoSelected: 'Minimal auszuwählende Anzahl',
      maxNoSelected: 'Maximal auszuwählende Anzahl',
      optVal: 'Zutat',
      leaveEmpty: 'Leer lassen oder 0 eintippen, wenn die Option kostenfrei ist',
      prodDeleted: 'Produkt erfolgreich gelöscht',
      prodAdded: 'Produkt erfolgreich hinzugefügt',
      prodUpdated: 'Produkt erfolgreich aktualisiert',
      prodPhotoError: 'Produktbild konnte nicht gespeichert werden. Versuchen Sie es später erneut.',
      rewardPossibelValue: 'Mögliche Werte',
      errorOptions: 'Überprüfen Sie bitte alle Produktoptionen, einige sind nicht ausgefüllt.',
      locationSettings: 'Standort Einstellungen',
      availableIn: 'Verfügbar in',
      deliveryMethodsandHours: 'Lieferarten und -zeiten',
      overrideSettings: 'Einstellungen überschreiben',
      addLocationValidation: 'Einige Produktoptionen sind an dem gewählten Standort nicht verfügbar. Wenn Sie fortfahren, werden die Optionen entfernt, wenn Sie nicht fortfahren, wird der Standort nicht ausgewählt.',
      highlightsProduct: 'Produkt hervorheben',
      search: 'Suche',
      isHiddenFromListing: 'Aus der Produktliste ausblenden',
      isHiddenFromSearch: 'Bei der Produktsuche ausblenden',
      isHiddenFromQrMenu: 'Hide from Qr menu',
      Monday: 'Mo',
      Tuesday: 'Di',
      Wednesday: 'Mi',
      Thursday: 'Do',
      Friday: 'Fr',
      Saturday: 'Sa',
      Sunday: 'So',
      accesRestricted: 'Sie haben leider keinen Zugang zu diesem Produkt',
      changeLocations: 'Change locations',
      includeAllLocationsProducts: 'Include also the products available in all locations',
      bulkLocationsMode: 'Action',
      bulkModeAdd: 'Add',
      bulkModeRemove: 'Remove',
      bulkModeReplace: 'Replace',
      massUpdate: 'Mass update',
      massUpdateSubtitle: 'You are about to update {count} products',
      bulkActionActive: 'Active / Inactive',
      bulkActionPrice: 'Price',
      bulkActionVat: 'VAT',
      bulkActionSection: 'Section',
      bulkActionOptionGroups: 'Option groups',
      bulkActionDelete: 'Delete',
      bulkOverrideDeliveryHint: 'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',
      bulkOverrideLocationsHint: 'Leave empty to use all company locations. Only locations that already belong to each product are applied.',
      bulkOverrideAddIntervalHint: 'Click + to add a schedule interval for this method.',
      bulkPriceDirection: 'Direction',
      bulkPriceIncrease: 'Increase',
      bulkPriceDecrease: 'Decrease',
      bulkPriceMode: 'Type',
      bulkPriceFlat: 'Flat amount',
      bulkPricePercent: 'Percentage (%)',
      bulkPriceAmount: 'Amount',
      bulkPriceBaseOnlyHint: 'Only the base price is changed. The new price will never go below 0.',
      bulkOptionGroupsMode: 'Association mode',
      bulkOptionGroupsModeHint: 'Add keeps existing groups. Replace overwrites them with the selected ones.',
      bulkDeleteWarning: 'This will permanently delete {count} products. This action cannot be undone easily.',
      bulkDeleteEnableLabel: 'Yes, delete the selected products (other mass actions will be ignored)',
      confirmBulkMultiple: 'Apply these changes to {count} {products}:',
      bulkProductSingular: 'product',
      bulkProductPlural: 'products',
      confirmBulkAreYouSure: 'Are you sure?',
      bulkSummaryAddLocations: 'add locations ({value}) to {count} {products}',
      bulkSummaryRemoveLocations: 'remove locations ({value}) from {count} {products}',
      bulkSummarySetActive: 'set {count} {products} as active',
      bulkSummarySetInactive: 'set {count} {products} as inactive',
      bulkSummaryIncreasePriceFlat: 'increase the base price of {count} {products} by {amount} {currency}',
      bulkSummaryIncreasePricePercent: 'increase the base price of {count} {products} by {amount}%',
      bulkSummaryDecreasePriceFlat: 'decrease the base price of {count} {products} by {amount} {currency}',
      bulkSummaryDecreasePricePercent: 'decrease the base price of {count} {products} by {amount}%',
      bulkSummaryAddOptionGroups: 'add option groups ({value}) to {count} {products}',
      bulkSummaryReplaceOptionGroups: 'replace option groups on {count} {products} with ({value})',
      bulkSummarySetVat: 'set VAT {value} on {count} {products}',
      bulkSummarySetSection: 'set section {value} on {count} {products}',
      bulkSummaryEnableOverride: 'enable override settings on {count} {products}',
      bulkSummaryEnableOverrideWithSchedule: 'replace override schedules on {count} {products}',
      bulkSummaryDisableOverride: 'disable override settings on {count} {products}',
      bulkSummaryDelete: 'delete {count} {products}',
      bulkSummaryGeneric: 'update {count} {products}',
      confirmBulkAddLocations: 'Are you sure you want to add locations to {count} products?',
      confirmBulkRemoveLocations: 'Are you sure you want to remove locations from {count} products?',
      confirmBulkSetActive: 'Are you sure you want to set {count} products as active?',
      confirmBulkSetInactive: 'Are you sure you want to set {count} products as inactive?',
      confirmBulkIncreasePriceFlat: 'Are you sure you want to increase the base price of {count} products by {amount}?',
      confirmBulkIncreasePricePercent: 'Are you sure you want to increase the base price of {count} products by {amount}%?',
      confirmBulkDecreasePriceFlat: 'Are you sure you want to decrease the base price of {count} products by {amount}?',
      confirmBulkDecreasePricePercent: 'Are you sure you want to decrease the base price of {count} products by {amount}%?',
      confirmBulkAddOptionGroups: 'Are you sure you want to add option groups to {count} products?',
      confirmBulkReplaceOptionGroups: 'Are you sure you want to replace option groups on {count} products?',
      confirmBulkSetVat: 'Are you sure you want to set VAT on {count} products?',
      confirmBulkSetSection: 'Are you sure you want to set the section on {count} products?',
      confirmBulkDelete: 'Are you sure you want to delete {count} products?',
      confirmBulkGeneric: 'Are you sure you want to update {count} products?',
      bulkLocationsUpdated: 'Updated locations for {updated} products',
      bulkMassUpdated: 'Updated {updated} products',
      couldNotFetchProductOptions: 'Could not fetch product options. Please contact support.'
    },
    catalogProdRewardsHints: {
      hint1: 'Leer lassen, um den Standardwert aus den Einstellungen zu übernehmen',
      hint2: 'Tippen Sie 0 ein, um das Treueprogramm nicht auf dieses Produkt anzuwenden',
      hint3: 'Fügen Sie einen positiven Wert ein, um den Standardwert aus den Einstellungen zu überschreiben'
    },
    catalogCateg: {
      single: 'Kategorie',
      plural: 'Kategorien',
      color: 'Culoare',
      name: 'Name',
      image: 'Bild',
      displayType: 'Darstellungsansicht',
      shortDescription: 'Kurzbeschreibung',
      validFromTo: 'Gültig von - bis',
      areYouSure: 'Sind Sie sicher, dass Sie diese Kategorie {label} möchten?',
      categAdded: 'Kategorie erfolgreich hinzugefügt',
      categUpdated: 'Kategorie erfolgreich aktualisiert',
      categDeleted: 'Kategorie erfolgreich gelöscht',
      couldNotSave: 'Kategoriebild konnte nicht gespeichert werden. Versuchen Sie es später erneut.',
      List: 'Liste',
      Grid: 'Raster',
      assignTopCategory: 'Überkategorie hinzufügen',
      pleaseSelect: 'Bitte auswählen / Nicht anwendbar',
      categoriesWithoutParent: 'Kategorien ohne Überkategorie',
      topCategory: 'Überkategorie',
      forceMethod: 'Liefermethode notwendig',
      selectMethod: 'Methode auswählen',
      enableMethod: '(um zu aktivieren, Überkategorie entfernen)',
      overrideSettingsHelp: 'Wenn aktiviert, erscheint diese Kategorie im Menü nur für den ausgewählten Standort, die Lieferart, den Tag und das Zeitfenster.',
      schedule: 'Zeitplan',
      useSchedule: 'Zeitplan verwenden',
      scheduleActive: 'Zeitplan aktiv',
      scheduleHelp: 'Ein Zeitplan für diese Überkategorie in allen Standorten. Außerhalb dieser Zeiten ist die Bestellung aus dieser Kategorie in der App nicht verfügbar.'
    },
    catalogProdOpt: {
      single: 'Option',
      plural: 'Optionen',
      new: 'Neue Option',
      name: 'Name',
      type: 'Typ',
      value: 'Zutat',
      values: 'Zutaten',
      posid: 'POS ID',
      optionSaved: 'Produktoptionen erfolgreich gespeichert.',
      areyouSure: 'Möchten Sie diese Option wirklich löschen?',
      optLocationError: 'Die Option {opt_name} muss an dem Standort {loc_name} verfügbar sein',
      menuQr: 'QR-Menü',
      displayInMenu: 'Anzeige im QR-Menü'
    },
    marketingCampaigns: {
      single: 'Kampagne',
      plural: 'Kampagnen',
      name: 'Titel',
      nameHelper: 'Dieser Titel wird als Betreff für versendete E-Mail Benachrichtigungen bezüglich dieser Kampagne verwendet.',
      image: 'Bild',
      startEnd: 'Start - Enddatum',
      daysLeft: 'verbleibende Tage',
      timesUsed: 'Anzahl der Verwendung',
      status: 'Status',
      actions: 'Aktionen',
      send: 'Senden',
      in_queue: 'To be sent',
      sent: 'Total sent',
      notif_sent: 'Notification',
      email_sent: 'E-mail',
      areYouSureNotif: 'Möchten Sie die Benachrichtigungen versenden?',
      notifSent: 'Benachrichtigungen wurden versendet.',
      campaignDeleted: 'Kampagne erfolgreich gelöscht.',
      areYouSureDelete: 'Möchten Sie ... wirklich löschen?',
      campaignAdded: 'Kampagne erfolgreich hinzugefügt',
      campaignUpdated: 'Kampagne erfolgreich aktualisiert',
      campaignPhotoError: 'Bild konnte nicht gespeichert werden. Versuchen Sie es später erneut.',
      campaignDetails: 'Kampagnen Details',
      description: 'Beschreibung',
      maxDescription: '(max. 400 Zeichen)',
      characters: 'Zeichen',
      validFromTo: 'Gültig von - bis',
      notif: 'Benachrichtigungen',
      model: 'Benachrichtigungsweise',
      setHours: 'Stunden festlegen',
      selectTime: 'Zeit auswählen',
      chooseTarget: 'Zielgruppe auswählen',
      gender: 'Geschlecht',
      age: 'Alter',
      city: 'Stadt',
      location: 'Standort',
      visibleInLocations: 'Sichtbar an folgenden Standorten',
      visibleInLocationsInfo: 'Diese Funktionalität ist nur in der Anwendung verfügbar',
      ordersAbove: 'Bestellungen über',
      ordersBelow: 'Bestellungen unter',
      addCoupon: 'Gutschein hinzufügen',
      applyTo: 'Anwenden auf',
      value: 'Prozent',
      code: 'Code',
      addValue: 'Kenndaten hinzufügen',
      minValue: 'Minimale Menge',
      counter_max_usage: 'Wie oft kann ein Kunde diesen Gutschein anwenden?',
      counter_max_usage_total: 'Wie oft kann dieser Gutschein insgesamt angewendet werden?',
      counter_max_usage_example: 'Geben Sie eine Zahl für die maximale Anwendung pro Person an. Geben Sie 0 für unbegrenzte Anwendung an.',
      counter_max_usage_total_example: 'Geben Sie eine Zahl für die maximale gesamte Anwendung an. Geben Sie 0 für unbegrenzte Anwendung an.',
      generateCode: 'Code generieren',
      Products: 'Produkte',
      Shipping: 'Lieferung',
      chooseCategProduct: 'Wählen Sie Kategorien oder Produkte aus, auf die der Gutschein anwendbar ist:',
      delivery_methods: 'Auf welche Liefermöglichkeiten soll dieser Gutschein angewendet werden?',
      order_source_ids: 'Order sources',
      order_source_ids_all: 'All sources',
      order_source_ids_help: 'Leave empty to apply on all order sources.',
      location_ids: 'An welchem Standort soll dieser Gutschein anwendbar sein?',
      sendNotificationTo: 'Benachrichtigung senden an',
      campaignWasSent: 'Kampagne wurde innerhalb der letzten 30 Minuten versendet',
      chooseDayForInterval: 'Wähle Tag(e) für das Intervall',
      chooseHoursForInterval: 'Wähle Zeiten für das Intervall',
      useInterval: 'Nutze Intervall für wiederkehrenden Gutschein',
      isCumulativeCheck: 'Dieser Gutschein wird kumulativ angewendet',
      isAutoApplyCheck: 'Dieser Gutschein wird exklusiv angewendet',
      intervalMustBeSet: 'Intervall muss festgelegt sein',
      isSecondUseCheck: 'Dieser Gutschein gilt direkt nach der ersten Nutzung',
      groups: 'Kundengruppen',
      freeProduct: 'Gratisprodukt für den Warenkorb',
      freeProductPlaceholder: 'Produkt auswählen',
      freeProductRequired: 'Bitte ein Gratisprodukt auswählen'
    },
    marketingOffers: {
      single: 'Angebotsbanner',
      plural: 'Angebotsbanner',
      title: 'Titel',
      status: 'Status',
      image: 'Bild',
      imageWeb: 'Web-Bild',
      imageBanner: 'Imagine Banner',
      imageLanding: 'Imagine Landing',
      linkType: 'Verknüpfung',
      startEndDate: 'Start - Enddatum',
      actions: 'Aktionen',
      offerAdded: 'Angebotsbanner erfolgreich hinzugefügt.',
      offerUpdated: 'Angebotsbanner erfolgreich aktualisiert.',
      offerDeleted: 'Angebotsbanner erfolgreich gelöscht.',
      weCouldNot: 'Das Foto konnte nicht hinzugefügt werden. Versuchen Sie es später erneut.',
      validImg: 'Fügen Sie bitte ein gültiges Bild ein.',
      areYouSure: 'Möchten Sie diesen Angebotsbanner {label}?',
      pageText: 'Textseite',
      pickCateg: 'Kategorie auswählen',
      pickProd: 'Produkt auswählen',
      pickLoc: 'Standort auswählen',
      none: 'Keine',
      banners: 'Banner',
      offers: 'Bietet an',
      display: 'Anzeige',
      addGroup: 'Gruppe hinzufügen',
      offerSuccess: 'Gruppenangebot erfolgreich hinzugefügt'
    },
    marketingOffersTypes: {
      category: 'Kategorie',
      product: 'Produkt',
      page: 'Seite'
    },
    marketingFidelities: {
      fidelities: 'Treueprogramm',
      loyalityPoint: 'Treuepunkte',
      userLabeling: 'Kundenstatus',
      name: 'Name',
      ordersValue: 'Bestellwert',
      ordersNumber: 'Anzahl der Bestellungen',
      color: 'Farbe',
      notification: 'Benachrichtigung',
      coupon: 'Gutschein',
      product: 'Produkt',
      nameLabel: 'Kundenstatus',
      addLabel: 'Kundenstatus hinzufügen',
      noData: 'Keine Daten',
      updateUserLabeling: 'Kundenstatus aktualisiert',
      createdUserLabeling: 'Kundenstatus erstellt',
      areYouSureDelete: 'Möchten Sie diesen Kundenstatus wirklich löschen?',
      labelDeleted: 'Kundenstatus gelöscht',
      orderNumberRequired: 'Dieses Feld oder Anzahl der Bestellungen muss ausgefüllt sein',
      orderValueRequired: 'Dieses Feld oder Bestellwert muss ausgefüllt sein',
      yes: 'Ja',
      applyCupon: 'Gutschein',
      applyproduct: 'Produkt',
      badgeColor: 'Statusfarbe',
      badgeName: 'Kundenstatus',
      value: 'Wert',
      number: 'Anzahl',
      appliedForLastMonth: 'Kundenstatus werden nur für Bestellungen der letzten 30 Tage angewendet',
      checkTermsAndConditionFidelities: 'Überprüfen Sie das Treueprogramm auf der Infoseite',
      labelingPrimaryOption: 'Wählen Sie die Primäroption für Kundenstatus',
      labelingSuccess: 'Die Einstellungen für Kundenstatus wurden erfolgreich aktualisiert!',
      updatePrimaryOption: 'Optionen aktualisieren',
      showLabelOnUser: 'Kunden ihren Status anzeigen',
      infoAboutShowUserLabelUpdated: 'Kunden ihren Status anzeigen wurde aktualisiert',
      labelingInterval: 'Anwendbarkeitszeitraum auswählen',
      '0': 'Unbegrenzt',
      '30': '30 Tage',
      '60': '60 Tage',
      '90': '90 Tage',
      '120': '120 Tage',
      recurrence: 'Wiederholung',
      noReccurence: 'Keine',
      oneDay: '1 Tag',
      threeDays: '3 Tage',
      fiveDays: '5 Tage',
      sevenDays: '7 Tage',
      tenDays: '10 Tage',
      fifteenDays: '15 Tage',
      twentyDays: '20 Tage',
      twentyFiveDays: '25 Tage'
    },
    marketingPromos: {
      title: 'Titel',
      treshold: 'Schwelle n',
      category: 'Kategorie',
      product: 'Produkt',
      products: 'Produkte',
      none: 'Keiner',
      marketingPromos: 'Aktion',
      generateQrCode: 'QR-Code generieren',
      code: '',
      promoDeleted: 'Promotion deleted',
      areYouSureDelete: 'Are you sure you want to delete this promotion',
      promoAdded: 'Werbeaktion erfolgreich hinzugefügt.',
      promoUpdated: 'Werbeaktion erfolgreich aktualisiert.',
      weCouldNot: 'Wir konnten die Daten nicht speichern, bitte versuchen Sie es später erneut.',
      startEndDate: 'Start - Enddatum',
      image: 'Bild',
      validImg: 'Bitte fügen Sie ein gültiges Bild hinzu.',
      print: 'Drucken',
      firstname: 'Vorname',
      lastname: 'Nachname',
      points: 'Punkte',
      email: 'Email',
      description: 'Beschreibung'
    },
    reports: {
      orderedProducts: 'Bestellte Produkte',
      giftCardsSoldTotal: 'Total gift cards sold',
      giftCardsSoldAmount: 'Gift cards sold',
      number: 'Order nr',
      trends: 'Trends',
      clients: 'Kunden',
      products: 'Produkte',
      marketing: 'Marketing',
      today: 'Heute',
      orderChart: 'Bestellungen',
      clientsChart: 'Kunden',
      completed: 'Abgeschlossen',
      canceled: 'Storniert',
      salesChart: 'Verkäufe',
      salesIn: 'Verkäufe in',
      customersChart: 'Kunden',
      appInstalls: 'App Installationen',
      custWithAcc: 'Kunden mit Account',
      top10Chart: 'Top 10 Produkte',
      top5Chart: 'Top 5 Produkte',
      orderingChart: 'Bestellarten',
      nrOfOrders: 'Anzahl der Bestellungen',
      customersAge: 'Alter der Kunden',
      customersGender: 'Geschlecht der Kunden',
      name: 'Name',
      appInstalled: 'App installiert',
      gender: 'Geschlecht',
      location: 'Standort',
      partnerCode: 'Partnercode',
      email: 'E-Mail',
      phone: 'Telefon',
      age: 'Alter',
      filter: 'Filter',
      label: 'Kundenstatus',
      userDetails: 'Kundendaten',
      salesDetails: 'Verkaufsdaten',
      salesProductNr: 'Anzahl der verkauften Produkte',
      totalAmount: 'Gesamtmenge',
      totalProducts: 'Produkte insgesamt',
      ordersNumber: 'Bestellungen',
      minAmount: 'Minimale Gesamtmenge',
      minOrders: 'Minimale Anzahl an Bestellungen',
      maxOrders: 'Maximale Anzahl an Bestellungen',
      itemsSold: 'Verkaufte Produkte',
      campaign: 'Kampagne',
      couponsTimesUsed: 'Verwendungshäufigkeit der Gutscheine',
      revenue: 'Umsatz',
      total: 'Gesamt',
      paymentType: 'Zahlungsart',
      date: 'Datum',
      salesReport: 'Verkaufsbericht',
      salesReportBeta: 'Verkaufsbericht BETA',
      order: 'Bestellung',
      export: 'Exportieren',
      cash: 'Bar',
      card: 'Karte',
      pos: 'POS',
      tips: 'Trinkgeld',
      totalSum: 'Gesamtbetrag',
      search: 'Suche',
      searchFilter: 'Suche (Name, E-Mail, Telefon)',
      discount: 'Rabatt',
      tax: 'Steuer',
      shipping: 'Total Livrare',
      delivery_type: 'Lieferart',
      zone: 'Zone',
      totalDiscount: 'Gesamtrabatt',
      ordersWithDiscount: 'Bestellungen mit Rabatt',
      ordersWithFidelity: 'Bestellungen mit Treue',
      totalFidelityDiscount: 'Gesamt-Treuerabatt',
      totalTax: 'Gesamtsteuern',
      avarageOrderValue: 'Durchschnittlicher Bestellwert',
      clientsWOrders: 'Kunden mit Bestellungen',
      emailSend: 'Gesendete E-Mails der letzten 6 Monate',
      emailTotal: 'Gesamte gesendete E-Mails: ',
      newCustomersChart: 'Neue Kunden',
      productsSalesReport: 'Produktverkaufsbericht',
      orderStatus: 'Auftragsstatusbericht',
      pricePerUnit: 'Preis pro Einheit',
      quantity: 'Menge',
      productName: 'Produktname',
      couponCode: 'Coupon',
      checkOrder: 'Reihenfolge verwenden',
      donationReport: 'Spendenbericht'
    },
    feedback: {
      sigle: 'Feedback',
      type: 'Art',
      sentBy: 'Gesendet von',
      text: 'Text',
      seen: 'Gelesen',
      sentAt: 'Datum',
      search: 'Suche',
      comment: 'Kommentar'
    },
    feedbackTypes: {
      feedback: 'Feedback',
      issue: 'Problem',
      suggestion: 'Vorschlag'
    },
    settings: {},
    blogPage: {
      categories: 'Kategorien',
      categoriesHint: 'Optional — Artikel können auch ohne Kategorie sein.',
      categoryName: 'Kategoriename',
      noCategories: 'Noch keine Kategorien.',
      articles: 'Artikel',
      addArticle: 'Artikel hinzufügen',
      editArticle: 'Artikel bearbeiten',
      allCategories: 'Alle Kategorien',
      noCategory: 'Keine Kategorie',
      allStatuses: 'Alle Status',
      searchByTitle: 'Nach Titel suchen',
      noArticles: 'Keine Artikel gefunden.',
      cover: 'Titelbild',
      coverHint: 'empfohlen 1200x630px, max. 5MB',
      imageAlt: 'Alt-Text des Bildes (SEO)',
      title: 'Titel',
      slug: 'Artikel-Link (Slug)',
      slugHint: 'Wird aus dem Titel erzeugt, wenn leer.',
      shortDescription: 'Kurzbeschreibung (unter dem Titel)',
      content: 'Inhalt',
      category: 'Kategorie',
      author: 'Autor',
      publishedAt: 'Veröffentlichungsdatum',
      publishedAtHint: 'Wenn leer, wird beim Veröffentlichen das aktuelle Datum verwendet.',
      status: 'Status',
      published: 'Veröffentlicht',
      draft: 'Entwurf',
      scheduled: 'Geplant',
      seo: 'SEO',
      metaTitle: 'Meta-Titel',
      metaDescription: 'Meta-Beschreibung',
      metaKeywords: 'Schlüsselwörter (durch Komma getrennt)',
      titleRequired: 'Der Titel ist erforderlich.',
      deleteCategoryConfirm: 'Kategorie "{name}" löschen? {count} Artikel bleiben ohne Kategorie.',
      deleteArticleConfirm: 'Artikel "{name}" löschen?'
    },
    settingsPages: {
      homepageSections: 'Startseiten-Abschnitte',
      interactiveTour: 'Interaktive Tour',
      blog: 'Blog',
      interactiveTourFirstLogin: 'Interaktive Tour bei erster Anmeldung verwenden',
      interactiveTourAlways: 'Interaktive Tour immer verwenden',
      interactiveTourDisplayMode: 'Bildanzeigemodus',
      interactiveTourDisplayContain: 'Contain',
      interactiveTourDisplayCover: 'Cover',
      interactiveTourDisplayFullPage: 'Ganze Seite',
      userSettings: 'Benutzereinstellungen',
      myProfile: 'Mein Profil',
      users: 'Benutzer',
      general: 'Allgemein',
      companyDetails: 'Unternehmensdetails',
      dateTime: 'Datum & Zeit',
      currency: 'Währung',
      accounting: 'Buchführung',
      tax: 'Steuer',
      delivery_type: 'Versandart',
      payment: 'Zahlung',
      orderingMng: 'Bestellmanagement',
      loyalty: 'Treueprogramm',
      push: 'Push-Benachrichtigungen',
      tips: 'Trinkgeld',
      locationGroups: 'Standort-Gruppen',
      locationGroupsName: 'Name',
      locationGroupsDescription: 'Beschreibung',
      locationGroupsPhoto: 'Foto',
      locationGroupsAdded: 'Neue Standort-Gruppe erfolgreich hinzugefügt',
      locationGroupsUpdated: 'Standort-Gruppe erfolgreich aktualisiert',
      locationGroupsPicError: 'Standort-Gruppe konnte nicht gespeichert werden. Versuchen Sie es später erneut.',
      locationGroupsDelete: 'Standort-Gruppe löschen',
      locationGroupsAreYouSure: 'Möchten Sie diese Standort-Gruppe wirklich löschen?',
      locationGroupsSelect: 'Wählen Sie die zugehörige Standort-Gruppe:',
      subscription: 'Abonnement',
      myPlan: 'Mein Plan',
      infoPages: 'Informationen',
      taxLabeling: 'Steuerbezeichnung',
      deliveryMethods: 'Standorte und Lieferarten',
      filters: 'Filter',
      filterProducts: 'Produkte filtern'
    },
    settingUsers: {
      single: 'Benutzer',
      fn: 'Vorname',
      ln: 'Nachname',
      email: 'E-Mail',
      username: 'Benutzername',
      lang: 'Sprache der Benutzeroberfläche',
      langMsg: 'In dieser Sprache werden Sie die Benutzeroberfläche sehen.',
      avatar: 'Avatar',
      role: 'Rolle',
      locations: 'Zugang zu Bestellungen der Standorte',
      locations_helptext: 'Wichtig: Wenn kein Standort ausgewählt ist, hat der Benutzer Zugang zu allen Standorten.',
      resetPass: 'Passwort zurücksetzen',
      password: 'Passwort',
      pass: 'Passwort',
      confPass: 'Passwort bestätigen',
      userAdded: 'Neuer Benutzer erfolgreich hinzugefügt',
      userUpdated: 'Benutzer erfolgreich aktualisiert',
      userPicError: 'Der Avatar konnte nicht gespeichert werden. Versuchen Sie es später erneut.',
      USER: 'NUTZER',
      DRIVER: 'FAHRER',
      LOCATION_ADMIN: 'STANDORT ADMINISTRATOR',
      MARKETER: 'VERMARKTER'
    },
    settingCompany: {
      title: 'Unternehmen',
      location: 'Standort',
      name: 'Name',
      lang: 'App-Sprache',
      bussLoc: 'Unternehmensstandort',
      deliveryLabels: 'Bezeichnung der Lieferarten',
      pick_up: 'Abholung',
      meet_half: 'Komm mir entgegen',
      delivery: 'Lieferung',
      eat_location: 'Tisch reservieren',
      self_ordering: 'Self Ordering',
      phone: 'Telefon',
      street: 'Straße',
      number: 'Nr.',
      latitude: 'Breitengrad',
      longitude: 'Längengrad',
      email: 'E-Mail',
      city: 'Stadt',
      country: 'Land',
      state: 'Bundesland',
      availableDaysHrs: 'Öffnungszeiten',
      from: 'von',
      to: 'bis',
      preOrder: 'Vorbestellung von',
      allowPreOrder: 'Vorbestellung ermöglichen',
      cardPaymentDetails: 'Einstellungen für die Kartenzahlung',
      paylikeKeys: 'Bezeichnung bei Paylike',
      posDiscount: 'POS ID für Rabatt',
      userTaxes: 'Angewandte Steuern',
      noTaxMsg: 'Info: Sie haben Änderungen an den Steuern vorgenommen, vergessen Sie nicht, diese zu speichern.',
      areYouSureDelete: 'Möchten Sie diesen Standort wirklich löschen? Somit werden auch die Bestelleinstellungen des Standortes gelöscht.',
      pickLocationToCopy: 'Wählen Sie einen Standort aus, von dem die Produkte kopiert werden sollen',
      areYouSureTax: 'Möchten Sie diesen Steuertyp wirklich von der Steuerliste löschen? Vergessen Sie nicht, die Änderungen zu speichern!',
      companyUpdated: 'Unternehmensdetails erfolgreich aktualisiert.',
      companyProdCopied: 'Produkte erfolgreich kopiert.',
      wrongAddress: 'Die Adresse von dem Standort "{location}" ist nicht korrekt.',
      deleteLocationValidation: 'Dieser Standort wird verwendet. Er kann nicht gelöscht werden. Zuerst müssen die Verknüpfungen zu den Produkten entfernt werden.',
      email_feedback: 'E-Mails um Feedback aus der App zu erhalten',
      email_feedback_helptext: 'Sie können mehrere E-Mail Adressen hinterlegen, indem Sie diese durch Kommata trennen.',
      printSettings: 'Drucker Einstellungen',
      automatPrintOrder: 'Bestellung automatisch in A4 drucken',
      autoSendOrderToPrinter: 'Bestellung automatisch mit 80 mm-Drucker drucken',
      autoPrintLocalServer: 'Abschnittsbeleg automatisch vom lokalen Server drucken (neue oder in Bearbeitung befindliche Bestellungen)',
      printerIp: 'Drucker IP/Host',
      printerPort: 'Drucker Schnittstelle',
      copyProductsFrom: 'Kopiere Produkte von ',
      overEighteen: 'Nutzer unter 18 einschränken (notwendig, um Alkohol über die App zu verkaufen)',
      setRadiusArea: 'Radius festlegen',
      setDrawArea: 'Zeichenbereich festlegen',
      jump_to_menu: 'Springe zum Menü',
      jump_to_categories_menu: 'Ermöglicht direkten Zugang zum Menü in der App, ohne vorher die Liefermethode auszuwählen.',
      allow_fiscal_print: 'Belegdruck zulassen',
      allowPlaceUntilCloseHour: 'Ermöglicht das Aufgeben von Bestellungen bis zur Schließungszeit',
      sortProductsMethods: 'Sortieren der Produkte',
      alphabetic_asc: 'Nach Namen aufsteigend',
      alphabetic_desc: 'Nach Namen absteigend',
      price: 'Nach Preis',
      custom: 'Benutzerdefiniert',
      infoCustomSort: '(benutzerdefinierte Sortierung wird in jeder Kategorieerstellung gemacht)',
      allowSoundAtStatusNew: 'Ton für Bestellungen mit dem Status NEU',
      allowSoundAtStatusProcessing: 'Ton für Bestellungen mit dem Status IN BEARBEITUNG',
      allowSoundAtStatusProcessingV1: 'Ton bei Erreichen der voreingestellten Wartezeit',
      allowSoundAtStatusProcessingV2: 'Ton bei Erreichen von 1/4 der voreingestellten Wartezeit',
      allowSoundAtStatusProcessingV3: 'Ton bei Erreichen von 1/2 der voreingestellten Wartezeit',
      allowSoundAtStatusProcessingV0: 'Kein Ton',
      allowToOrderUnderMinValueWithCoupon: 'Ermöglicht Bestellungen unter dem Mindestbestellwert, wenn Gutschein verwendet wird',
      filters: 'Filter',
      allowSoundForMehods: 'Ermöglicht Ton für die folgenden Übermittlungsmethoden'
    },
    settingDateTime: {
      timezone: 'Zeitzone',
      timeFormat: 'Zeitformat',
      dateFormat: 'Datumsformat',
      saveMsg: 'Datums- & Zeiteinstellungen erfolgreich gespeichert'
    },
    settingCurrency: {
      currency: 'Einkaufs-Währung',
      saveMsg: 'Währungsdaten erfolgreich gespeichert'
    },
    settingTaxes: {
      single: 'Steuer',
      name: 'Name',
      type: 'Typ',
      amount: 'Betrag',
      notice: 'Info: Unter "Steuerbezeichnung" erstellen Sie nur die Bezeichnung der angewandten Steuer. Um die Steuerdetails wie Steuerwert und -typ zu definieren, gehen Sie zu',
      notice2: 'Unternehmensdetails',
      singleTaxLabel: 'Steuerbezeichnung',
      notice3: 'Info: Unter "Angewandte Steuern" definieren Sie die Steuerdetails wie Steuerwert und -typ. Um eine Steuerbezeichnung zu erstellen, gehen Sie zu',
      notice4: 'Steuerbezeichnung'
    },
    settingsPayment: {
      publicKey: 'Public key',
      privateKey: 'Private key'
    },
    settingsOrdering: {
      offnoPreorders: 'You must have offset 0 and period 1 to work',
      noPreorders: 'We do not accept pre-orders',
      isAlwaysOpen: 'Immer geöffnet',
      isAlwaysOpenPreorderHours: 'Vorbestellstunden',
      infoBoxTitle: 'Zusatzinformationen hinzufügen',
      infoBoxRadioCheck: 'Optionen ändern',
      infoBoxRadio: 'Nur eine Option zulässig',
      infoBoxCheck: 'Mehrere Optionen zulässig',
      enabled: 'Aktiviert',
      paymentOptions: 'Zahlungsmöglichkeiten',
      paymentOptionsErr: 'Das Feld Zahlungsmöglichkeiten muss ausgefüllt sein.',
      waitingTime: 'Voraussichtliche Wartezeit',
      minimumOrderValue: 'Mindestbestellwert',
      minutes: 'Min',
      shippingCost: 'Lieferkosten',
      deliveryRange: 'Lieferradius',
      deliveryRangeUnit: 'm',
      posId: 'Lieferkosten POS ID',
      shippingTax: 'Liefersteuer',
      locations: 'Standorte',
      street: 'Straße',
      city: 'Stadt',
      country: 'Land',
      state: 'Bundesland',
      availableDays: 'Öffnungszeiten',
      availableDaysErr: 'Das Feld Öffnungszeiten muss ausgefüllt sein.',
      notice: 'Überprüfen Sie bitte den Fehler bei den aktivierten Bestellmethoden und versuchen Sie das Speichern erneut',
      saveSuccess: 'Bestelldetails erfolgreich gespeichert',
      deliveryRules: 'Lieferdetails',
      addRange: 'Lieferdetail hinzufügen',
      shippingCities: 'Städte / Orte',
      shippingNeighborhoods: 'Stadtteile',
      citiesValidationError: 'Stellen Sie sicher, dass sich die Städte der einzelnen Lieferradien unterscheiden.',
      hourAndDate: 'Uhrzeit und Datum',
      justDate: 'Nur Datum',
      deactivateDeliveryHours: 'Uhrzeit und Datum deaktivieren',
      offset: 'Abweichung',
      period: 'Periode',
      addZone: 'Zone hinzufügen',
      newZone: 'Neue Zone'
    },
    settingsZone: {
      edit: 'Name der Zone',
      deleteBtn: 'Zone löschen',
      deleteShape: 'Form löschen, um eine neue zu erstellen',
      overridePayment: 'Zahlungsmethode überschreiben',
      acceptCash: 'Bargeld akzeptieren',
      acceptCard: 'Karte akzeptieren',
      acceptPos: 'POS bei Lieferung (unbezahlt)'
    },
    settingsInfoPages: {
      single: 'Seite',
      noPage: 'Noch keine Seite hinzugefügt.',
      title: 'Titel der Seite',
      content: 'Inhalt der Seite',
      newPage: 'Neue Seite',
      showInHeader: 'Im Header anzeigen',
      showInFooter: 'Im Footer anzeigen',
      addedSuccess: 'Seite erfolgreich gespeichert.',
      deletedSuccess: 'Seite erfolgreich gelöscht',
      deleteMsg: 'Möchten Sie diese Seite wirklich löschen?',
      TERMS_CONDITIONS: 'Bedingungen und Konditionen',
      PRIVACY_POLICY: 'Datenschutzerklärung',
      CONTACT_DETAILS: 'Kontaktinformationen',
      FIDELITIES_PROMOTIONS: 'Treueprogramm',
      CUSTOM: 'Benutzerdefiniert'
    },
    settingsRewards: {
      single: 'Punkt',
      plural: 'Punkte',
      state: 'Status',
      points: 'Punkt(e)',
      moneySpent: 'Ausgegebenes Geld in Punkten',
      pointsTo: 'Punkte in Geld',
      numberOfcurrencyNeedToSpend: 'Geldbetrag, den der Kunde zahlen muss, um einen Punkt zu erhalten.',
      numberOfpointsToReward: 'Anzahl der Punkte, die der Kunde braucht, um damit zu bezahlen.',
      timeInterval: 'Zeitfenster',
      fromTime: 'Von Stunde',
      toTime: 'Zur Stunde',
      rewardSuccess: 'Daten des Treueprogramms erfolgreich gespeichert'
    },
    settingsPushNotif: {
      order_new: 'Nachricht Neue Bestellung',
      order_completed_pickup: 'Nachricht Bestellung zubereitet - Abholen',
      order_completed_meet: 'Nachricht Bestellung zubereitet - Komm mir entgegen',
      order_completed_delivery: 'Nachricht Bestellung zubereitet - Lieferung',
      order_completed_eat: 'Nachricht Bestellung zubereitet - vor Ort',
      order_canceled: 'Nachricht Bestellung storniert',
      notifUpdated: 'Daten der Push-Benachrichtigung erfolgreich gespeichert',
      preview: 'Vorschau',
      time: 'Uhrzeit',
      dateTime: 'Datum und Uhrzeit',
      persons: 'Anzahl der Personen',
      timePrev: '11:30 Uhr (in 30 Minuten)',
      personsPrev: '3',
      dateTimePrev: 'Dienstag, 15. Februar, 2022, um 18 Uhr',
      info: '* Falls die Lieferzeit nicht angezeigt werden soll, lassen Sie das letzte Feld frei.',
      selectedLocations: 'Ausgewählte Standorte:'
    },
    settingsTips: {
      tipsTaxes: 'Trinkgeld Steuer',
      state: 'Trinkgeld akzeptieren',
      tipsSuccess: 'Daten zum Trinkgeld erfolgreich gespeichert'
    },
    settingsPlans: {
      plan1Title: 'Monatlicher Festbetrag',
      plan1Rate: '160€ / Monat',
      plan1Description: 'Starten Sie mit einer festen monatlichen Gebühr, unabhängig von der Umsatzhöhe in der App.',
      plan2Title: 'Prozentsatz der Verkäufe',
      plan2Rate: '10%',
      plan2Description: 'Zahlen Sie abhängig davon, wie viel Sie verkaufen. Wählen Sie die Option Prozentsatz der Verkäufe und zahlen Sie eine monatliche Gebühr abhängig von der Umsatzhöhe in der App.',
      current: 'Aktuelles Abonnement',
      switch: 'Wechseln'
    },
    filter: {
      filter: 'Filter',
      action: 'Aktion',
      create: 'Filter erstellt',
      update: 'Filter aktualisiert',
      areYouSureDelete: 'Möchten Sie diesen Filter wirklich löschen',
      yes: 'Ja',
      deleted: 'Filter gelöscht',
      noFilters: 'Keine Filter',
      name: 'Name',
      addFilter: 'Filter hinzufügen',
      filters: 'Filter',
      value: 'Wert',
      filterProducts: 'Produkte filtern',
      filterName: 'Filtername',
      val: 'Wert',
      filterUpdated: 'Filter aktualisiert',
      minOneFilterValueRequired: 'Mindestens ein Filterwert pro Filter benötigt',
      filterType: 'Filtertyp',
      type_exists: 'Filtertyp existiert bereits',
      filter_value_exists: 'Filterwert existiert bereits',
      some_filter_applied: 'Erfolgreich aktualisiert. Einige Filter oder Werte sind auf Produkte angewendet und können (nicht) gelöscht werden'
    },
    ordersSource: {
      1: 'Kiosk',
      2: 'Qr',
      3: 'Pos',
      4: 'App',
      5: 'Website',
      6: 'Glovo',
      7: 'Wolt',
      8: 'Bolt'
    },
    checkbox: 'Ermöglicht, mehrere Optionen für das Produkt auszuwählen',
    radio: 'Ermöglicht, nur eine Option für das Produkt auszuwählen',
    ...deLocale
  }
}
export default messages



// WEBPACK FOOTER //
// ./src/lang/lang.js